//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.6.3.0 (NJsonSchema v11.5.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

export class AppPagesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getContents(limit?: number | undefined, search?: string | null | undefined, types?: ElementType[] | null | undefined, excludeTypes?: ElementType[] | null | undefined, projectIds?: string[] | null | undefined, containerIds?: string[] | null | undefined, excludeContainerIds?: string[] | null | undefined, contentIds?: string[] | null | undefined, signal?: AbortSignal): Promise<ContentDto[]> {
        let url_ = this.baseUrl + "/api/v1/app-pages/contents?";
        if (limit === null)
            throw new globalThis.Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (types !== undefined && types !== null)
            types && types.forEach(item => { url_ += "types=" + encodeURIComponent("" + item) + "&"; });
        if (excludeTypes !== undefined && excludeTypes !== null)
            excludeTypes && excludeTypes.forEach(item => { url_ += "excludeTypes=" + encodeURIComponent("" + item) + "&"; });
        if (projectIds !== undefined && projectIds !== null)
            projectIds && projectIds.forEach(item => { url_ += "projectIds=" + encodeURIComponent("" + item) + "&"; });
        if (containerIds !== undefined && containerIds !== null)
            containerIds && containerIds.forEach(item => { url_ += "containerIds=" + encodeURIComponent("" + item) + "&"; });
        if (excludeContainerIds !== undefined && excludeContainerIds !== null)
            excludeContainerIds && excludeContainerIds.forEach(item => { url_ += "excludeContainerIds=" + encodeURIComponent("" + item) + "&"; });
        if (contentIds !== undefined && contentIds !== null)
            contentIds && contentIds.forEach(item => { url_ += "contentIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetContents(_response);
        });
    }

    protected processGetContents(response: Response): Promise<ContentDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ContentDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ContentDto[]>(null as any);
    }

    getAppPages(pageNumber?: number | undefined, pageSize?: number | undefined, sorting?: SortingParameter[] | null | undefined, states?: PublicationState[] | null | undefined, search?: string | null | undefined, projectId?: string | null | undefined, showHidden?: boolean | undefined, signal?: AbortSignal): Promise<PaginatedListOfAppPageListItemDto> {
        let url_ = this.baseUrl + "/api/v1/app-pages?";
        if (pageNumber === null)
            throw new globalThis.Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sorting !== undefined && sorting !== null)
            sorting && sorting.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "sorting[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (states !== undefined && states !== null)
            states && states.forEach(item => { url_ += "states=" + encodeURIComponent("" + item) + "&"; });
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (projectId !== undefined && projectId !== null)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        if (showHidden === null)
            throw new globalThis.Error("The parameter 'showHidden' cannot be null.");
        else if (showHidden !== undefined)
            url_ += "showHidden=" + encodeURIComponent("" + showHidden) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAppPages(_response);
        });
    }

    protected processGetAppPages(response: Response): Promise<PaginatedListOfAppPageListItemDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfAppPageListItemDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfAppPageListItemDto>(null as any);
    }

    createAppPage(command: CreateAppPageCommand, signal?: AbortSignal): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/app-pages";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateAppPage(_response);
        });
    }

    protected processCreateAppPage(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    getAppPagesTree(projectId?: string | null | undefined, showHidden?: boolean | undefined, signal?: AbortSignal): Promise<AppPageDto[]> {
        let url_ = this.baseUrl + "/api/v1/app-pages/tree?";
        if (projectId !== undefined && projectId !== null)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        if (showHidden === null)
            throw new globalThis.Error("The parameter 'showHidden' cannot be null.");
        else if (showHidden !== undefined)
            url_ += "showHidden=" + encodeURIComponent("" + showHidden) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAppPagesTree(_response);
        });
    }

    protected processGetAppPagesTree(response: Response): Promise<AppPageDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AppPageDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AppPageDto[]>(null as any);
    }

    getAppPage(appPageId: string, signal?: AbortSignal): Promise<AppPageDetailsDto> {
        let url_ = this.baseUrl + "/api/v1/app-pages/{appPageId}";
        if (appPageId === undefined || appPageId === null)
            throw new globalThis.Error("The parameter 'appPageId' must be defined.");
        url_ = url_.replace("{appPageId}", encodeURIComponent("" + appPageId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAppPage(_response);
        });
    }

    protected processGetAppPage(response: Response): Promise<AppPageDetailsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppPageDetailsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AppPageDetailsDto>(null as any);
    }

    updateAppPage(appPageId: string, command: UpdateAppPageCommand, signal?: AbortSignal): Promise<AppPageDetailsDto> {
        let url_ = this.baseUrl + "/api/v1/app-pages/{appPageId}";
        if (appPageId === undefined || appPageId === null)
            throw new globalThis.Error("The parameter 'appPageId' must be defined.");
        url_ = url_.replace("{appPageId}", encodeURIComponent("" + appPageId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateAppPage(_response);
        });
    }

    protected processUpdateAppPage(response: Response): Promise<AppPageDetailsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppPageDetailsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AppPageDetailsDto>(null as any);
    }

    deleteAppPage(appPageId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/app-pages/{appPageId}";
        if (appPageId === undefined || appPageId === null)
            throw new globalThis.Error("The parameter 'appPageId' must be defined.");
        url_ = url_.replace("{appPageId}", encodeURIComponent("" + appPageId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteAppPage(_response);
        });
    }

    protected processDeleteAppPage(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    moveAppPage(appPageId: string, command: MoveAppPageCommand, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/app-pages/{appPageId}/move";
        if (appPageId === undefined || appPageId === null)
            throw new globalThis.Error("The parameter 'appPageId' must be defined.");
        url_ = url_.replace("{appPageId}", encodeURIComponent("" + appPageId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMoveAppPage(_response);
        });
    }

    protected processMoveAppPage(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    hideAppPage(appPageId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/app-pages/{appPageId}/hide";
        if (appPageId === undefined || appPageId === null)
            throw new globalThis.Error("The parameter 'appPageId' must be defined.");
        url_ = url_.replace("{appPageId}", encodeURIComponent("" + appPageId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHideAppPage(_response);
        });
    }

    protected processHideAppPage(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    publishAppPage(appPageId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/app-pages/{appPageId}/publish";
        if (appPageId === undefined || appPageId === null)
            throw new globalThis.Error("The parameter 'appPageId' must be defined.");
        url_ = url_.replace("{appPageId}", encodeURIComponent("" + appPageId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPublishAppPage(_response);
        });
    }

    protected processPublishAppPage(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    unpublishAppPage(appPageId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/app-pages/{appPageId}/unpublish";
        if (appPageId === undefined || appPageId === null)
            throw new globalThis.Error("The parameter 'appPageId' must be defined.");
        url_ = url_.replace("{appPageId}", encodeURIComponent("" + appPageId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUnpublishAppPage(_response);
        });
    }

    protected processUnpublishAppPage(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getAppPageHistory(appPageId: string, pageNumber?: number | undefined, pageSize?: number | undefined, from?: Date | null | undefined, until?: Date | null | undefined, userIds?: string[] | null | undefined, signal?: AbortSignal): Promise<PaginatedListOfHistoricalContentDto> {
        let url_ = this.baseUrl + "/api/v1/app-pages/{appPageId}/history?";
        if (appPageId === undefined || appPageId === null)
            throw new globalThis.Error("The parameter 'appPageId' must be defined.");
        url_ = url_.replace("{appPageId}", encodeURIComponent("" + appPageId));
        if (pageNumber === null)
            throw new globalThis.Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (from !== undefined && from !== null)
            url_ += "from=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (until !== undefined && until !== null)
            url_ += "until=" + encodeURIComponent(until ? "" + until.toISOString() : "") + "&";
        if (userIds !== undefined && userIds !== null)
            userIds && userIds.forEach(item => { url_ += "userIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAppPageHistory(_response);
        });
    }

    protected processGetAppPageHistory(response: Response): Promise<PaginatedListOfHistoricalContentDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfHistoricalContentDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfHistoricalContentDto>(null as any);
    }

    getAppPageHistoryDetails(appPageId: string, appPageVersion: number, signal?: AbortSignal): Promise<HistoricalContentDetailsDto> {
        let url_ = this.baseUrl + "/api/v1/app-pages/{appPageId}/history/{appPageVersion}";
        if (appPageId === undefined || appPageId === null)
            throw new globalThis.Error("The parameter 'appPageId' must be defined.");
        url_ = url_.replace("{appPageId}", encodeURIComponent("" + appPageId));
        if (appPageVersion === undefined || appPageVersion === null)
            throw new globalThis.Error("The parameter 'appPageVersion' must be defined.");
        url_ = url_.replace("{appPageVersion}", encodeURIComponent("" + appPageVersion));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAppPageHistoryDetails(_response);
        });
    }

    protected processGetAppPageHistoryDetails(response: Response): Promise<HistoricalContentDetailsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HistoricalContentDetailsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HistoricalContentDetailsDto>(null as any);
    }
}

export class AppsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getApps(pageNumber?: number | undefined, pageSize?: number | undefined, sorting?: SortingParameter[] | null | undefined, search?: string | null | undefined, signal?: AbortSignal): Promise<PaginatedListOfAppDto> {
        let url_ = this.baseUrl + "/api/v1/apps?";
        if (pageNumber === null)
            throw new globalThis.Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sorting !== undefined && sorting !== null)
            sorting && sorting.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "sorting[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetApps(_response);
        });
    }

    protected processGetApps(response: Response): Promise<PaginatedListOfAppDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfAppDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfAppDto>(null as any);
    }

    createApp(command: CreateAppCommand, signal?: AbortSignal): Promise<AppDetailsDto> {
        let url_ = this.baseUrl + "/api/v1/apps";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateApp(_response);
        });
    }

    protected processCreateApp(response: Response): Promise<AppDetailsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppDetailsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AppDetailsDto>(null as any);
    }

    getApp(appId: string, signal?: AbortSignal): Promise<AppDetailsDto> {
        let url_ = this.baseUrl + "/api/v1/apps/{appId}";
        if (appId === undefined || appId === null)
            throw new globalThis.Error("The parameter 'appId' must be defined.");
        url_ = url_.replace("{appId}", encodeURIComponent("" + appId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetApp(_response);
        });
    }

    protected processGetApp(response: Response): Promise<AppDetailsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppDetailsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AppDetailsDto>(null as any);
    }

    updateApp(appId: string, command: UpdateAppCommand, signal?: AbortSignal): Promise<AppDetailsDto> {
        let url_ = this.baseUrl + "/api/v1/apps/{appId}";
        if (appId === undefined || appId === null)
            throw new globalThis.Error("The parameter 'appId' must be defined.");
        url_ = url_.replace("{appId}", encodeURIComponent("" + appId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateApp(_response);
        });
    }

    protected processUpdateApp(response: Response): Promise<AppDetailsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppDetailsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AppDetailsDto>(null as any);
    }

    deleteApp(appId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/apps/{appId}";
        if (appId === undefined || appId === null)
            throw new globalThis.Error("The parameter 'appId' must be defined.");
        url_ = url_.replace("{appId}", encodeURIComponent("" + appId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteApp(_response);
        });
    }

    protected processDeleteApp(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Creates a new consent template for the specified app.
     * @param appId The ID of the app for which the consent template should be created.
     * @param command The consent template to create.
     * @return The created consent template.
     */
    createConsentTemplate(appId: string, command: CreateClientConsentTemplateCommand, signal?: AbortSignal): Promise<ConsentTemplateDto> {
        let url_ = this.baseUrl + "/api/v1/apps/{appId}/consent-template";
        if (appId === undefined || appId === null)
            throw new globalThis.Error("The parameter 'appId' must be defined.");
        url_ = url_.replace("{appId}", encodeURIComponent("" + appId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateConsentTemplate(_response);
        });
    }

    protected processCreateConsentTemplate(response: Response): Promise<ConsentTemplateDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConsentTemplateDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConsentTemplateDto>(null as any);
    }
}

export class AssetsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getAssets(pageNumber?: number | undefined, pageSize?: number | undefined, sorting?: SortingParameter[] | null | undefined, search?: string | null | undefined, assetIds?: string[] | null | undefined, signal?: AbortSignal): Promise<PaginatedListOfAssetDto> {
        let url_ = this.baseUrl + "/api/v1/assets?";
        if (pageNumber === null)
            throw new globalThis.Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sorting !== undefined && sorting !== null)
            sorting && sorting.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "sorting[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (assetIds !== undefined && assetIds !== null)
            assetIds && assetIds.forEach(item => { url_ += "assetIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAssets(_response);
        });
    }

    protected processGetAssets(response: Response): Promise<PaginatedListOfAssetDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfAssetDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfAssetDto>(null as any);
    }

    createAsset(command: CreateAssetCommand, signal?: AbortSignal): Promise<AssetDto> {
        let url_ = this.baseUrl + "/api/v1/assets";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateAsset(_response);
        });
    }

    protected processCreateAsset(response: Response): Promise<AssetDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssetDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssetDto>(null as any);
    }

    getAsset(assetId: string, signal?: AbortSignal): Promise<AssetDto> {
        let url_ = this.baseUrl + "/api/v1/assets/{assetId}";
        if (assetId === undefined || assetId === null)
            throw new globalThis.Error("The parameter 'assetId' must be defined.");
        url_ = url_.replace("{assetId}", encodeURIComponent("" + assetId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAsset(_response);
        });
    }

    protected processGetAsset(response: Response): Promise<AssetDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssetDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssetDto>(null as any);
    }

    updateAsset(assetId: string, command: UpdateAssetCommand, signal?: AbortSignal): Promise<AssetDto> {
        let url_ = this.baseUrl + "/api/v1/assets/{assetId}";
        if (assetId === undefined || assetId === null)
            throw new globalThis.Error("The parameter 'assetId' must be defined.");
        url_ = url_.replace("{assetId}", encodeURIComponent("" + assetId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateAsset(_response);
        });
    }

    protected processUpdateAsset(response: Response): Promise<AssetDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssetDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssetDto>(null as any);
    }

    deleteAsset(assetId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/assets/{assetId}";
        if (assetId === undefined || assetId === null)
            throw new globalThis.Error("The parameter 'assetId' must be defined.");
        url_ = url_.replace("{assetId}", encodeURIComponent("" + assetId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteAsset(_response);
        });
    }

    protected processDeleteAsset(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getAssetFile(assetId: string, size?: number | null | undefined, width?: number | null | undefined, height?: number | null | undefined, x?: number | null | undefined, y?: number | null | undefined, webp?: boolean | null | undefined, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/assets/{assetId}/file?";
        if (assetId === undefined || assetId === null)
            throw new globalThis.Error("The parameter 'assetId' must be defined.");
        url_ = url_.replace("{assetId}", encodeURIComponent("" + assetId));
        if (size !== undefined && size !== null)
            url_ += "size=" + encodeURIComponent("" + size) + "&";
        if (width !== undefined && width !== null)
            url_ += "w=" + encodeURIComponent("" + width) + "&";
        if (height !== undefined && height !== null)
            url_ += "h=" + encodeURIComponent("" + height) + "&";
        if (x !== undefined && x !== null)
            url_ += "x=" + encodeURIComponent("" + x) + "&";
        if (y !== undefined && y !== null)
            url_ += "y=" + encodeURIComponent("" + y) + "&";
        if (webp !== undefined && webp !== null)
            url_ += "webp=" + encodeURIComponent("" + webp) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAssetFile(_response);
        });
    }

    protected processGetAssetFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getAssetFoldersRoot(signal?: AbortSignal): Promise<AssetFolderDetailsDto> {
        let url_ = this.baseUrl + "/api/v1/assets/folders/root";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAssetFoldersRoot(_response);
        });
    }

    protected processGetAssetFoldersRoot(response: Response): Promise<AssetFolderDetailsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssetFolderDetailsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssetFolderDetailsDto>(null as any);
    }

    getAssetFolder(assetFolderId: string, signal?: AbortSignal): Promise<AssetFolderDetailsDto> {
        let url_ = this.baseUrl + "/api/v1/assets/folders/{assetFolderId}";
        if (assetFolderId === undefined || assetFolderId === null)
            throw new globalThis.Error("The parameter 'assetFolderId' must be defined.");
        url_ = url_.replace("{assetFolderId}", encodeURIComponent("" + assetFolderId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAssetFolder(_response);
        });
    }

    protected processGetAssetFolder(response: Response): Promise<AssetFolderDetailsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssetFolderDetailsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssetFolderDetailsDto>(null as any);
    }

    updateAssetFolder(assetFolderId: string, command: UpdateAssetFolderCommand, signal?: AbortSignal): Promise<AssetFolderDto> {
        let url_ = this.baseUrl + "/api/v1/assets/folders/{assetFolderId}";
        if (assetFolderId === undefined || assetFolderId === null)
            throw new globalThis.Error("The parameter 'assetFolderId' must be defined.");
        url_ = url_.replace("{assetFolderId}", encodeURIComponent("" + assetFolderId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateAssetFolder(_response);
        });
    }

    protected processUpdateAssetFolder(response: Response): Promise<AssetFolderDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssetFolderDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssetFolderDto>(null as any);
    }

    deleteAssetFolder(assetFolderId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/assets/folders/{assetFolderId}";
        if (assetFolderId === undefined || assetFolderId === null)
            throw new globalThis.Error("The parameter 'assetFolderId' must be defined.");
        url_ = url_.replace("{assetFolderId}", encodeURIComponent("" + assetFolderId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteAssetFolder(_response);
        });
    }

    protected processDeleteAssetFolder(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    createAssetFolder(command: CreateAssetFolderCommand, signal?: AbortSignal): Promise<AssetFolderDto> {
        let url_ = this.baseUrl + "/api/v1/assets/folders";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateAssetFolder(_response);
        });
    }

    protected processCreateAssetFolder(response: Response): Promise<AssetFolderDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssetFolderDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssetFolderDto>(null as any);
    }

    moveAsset(assetId: string, command: MoveAssetCommand, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/assets/{assetId}/move";
        if (assetId === undefined || assetId === null)
            throw new globalThis.Error("The parameter 'assetId' must be defined.");
        url_ = url_.replace("{assetId}", encodeURIComponent("" + assetId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMoveAsset(_response);
        });
    }

    protected processMoveAsset(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    moveAssetFolder(assetFolderId: string, command: MoveAssetFolderCommand, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/assets/folders/{assetFolderId}/move";
        if (assetFolderId === undefined || assetFolderId === null)
            throw new globalThis.Error("The parameter 'assetFolderId' must be defined.");
        url_ = url_.replace("{assetFolderId}", encodeURIComponent("" + assetFolderId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMoveAssetFolder(_response);
        });
    }

    protected processMoveAssetFolder(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class AuditClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getAuditEvents(pageNumber?: number | undefined, pageSize?: number | undefined, sorting?: SortingParameter[] | null | undefined, search?: string | null | undefined, signal?: AbortSignal): Promise<PaginatedListOfAuditEventDto> {
        let url_ = this.baseUrl + "/api/v1/audit?";
        if (pageNumber === null)
            throw new globalThis.Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sorting !== undefined && sorting !== null)
            sorting && sorting.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "sorting[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAuditEvents(_response);
        });
    }

    protected processGetAuditEvents(response: Response): Promise<PaginatedListOfAuditEventDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfAuditEventDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfAuditEventDto>(null as any);
    }

    getAuditEvent(auditEventId: number, signal?: AbortSignal): Promise<AuditEventDetailsDto> {
        let url_ = this.baseUrl + "/api/v1/audit/{auditEventId}";
        if (auditEventId === undefined || auditEventId === null)
            throw new globalThis.Error("The parameter 'auditEventId' must be defined.");
        url_ = url_.replace("{auditEventId}", encodeURIComponent("" + auditEventId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAuditEvent(_response);
        });
    }

    protected processGetAuditEvent(response: Response): Promise<AuditEventDetailsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditEventDetailsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AuditEventDetailsDto>(null as any);
    }
}

export class BackupsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getTenantBackup(signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/backups/tenant";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTenantBackup(_response);
        });
    }

    protected processGetTenantBackup(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    restoreTenantBackup(file?: FileParameter | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/backups/tenant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new globalThis.Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRestoreTenantBackup(_response);
        });
    }

    protected processRestoreTenantBackup(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getProjectBackup(projectId: string, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/backups/projects/{projectId}";
        if (projectId === undefined || projectId === null)
            throw new globalThis.Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetProjectBackup(_response);
        });
    }

    protected processGetProjectBackup(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getContainerBackup(containerId: string, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/backups/containers/{containerId}";
        if (containerId === undefined || containerId === null)
            throw new globalThis.Error("The parameter 'containerId' must be defined.");
        url_ = url_.replace("{containerId}", encodeURIComponent("" + containerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetContainerBackup(_response);
        });
    }

    protected processGetContainerBackup(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getContainerGroupBackup(containerGroupId: string, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/backups/container-groups/{containerGroupId}";
        if (containerGroupId === undefined || containerGroupId === null)
            throw new globalThis.Error("The parameter 'containerGroupId' must be defined.");
        url_ = url_.replace("{containerGroupId}", encodeURIComponent("" + containerGroupId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetContainerGroupBackup(_response);
        });
    }

    protected processGetContainerGroupBackup(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    restoreProjectBackup(targetEntityStrategy?: RestoreImportStrategy | undefined, uniqueLabelStrategy?: RestoreUniqueLabelStrategy | undefined, uniqueLabelPrefix?: string | null | undefined, uniqueLabelSuffix?: string | null | undefined, file?: FileParameter | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/backups/projects?";
        if (targetEntityStrategy === null)
            throw new globalThis.Error("The parameter 'targetEntityStrategy' cannot be null.");
        else if (targetEntityStrategy !== undefined)
            url_ += "targetEntityStrategy=" + encodeURIComponent("" + targetEntityStrategy) + "&";
        if (uniqueLabelStrategy === null)
            throw new globalThis.Error("The parameter 'uniqueLabelStrategy' cannot be null.");
        else if (uniqueLabelStrategy !== undefined)
            url_ += "uniqueLabelStrategy=" + encodeURIComponent("" + uniqueLabelStrategy) + "&";
        if (uniqueLabelPrefix !== undefined && uniqueLabelPrefix !== null)
            url_ += "uniqueLabelPrefix=" + encodeURIComponent("" + uniqueLabelPrefix) + "&";
        if (uniqueLabelSuffix !== undefined && uniqueLabelSuffix !== null)
            url_ += "uniqueLabelSuffix=" + encodeURIComponent("" + uniqueLabelSuffix) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new globalThis.Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRestoreProjectBackup(_response);
        });
    }

    protected processRestoreProjectBackup(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    restoreContainerBackup(projectId: string, targetEntityStrategy?: RestoreImportStrategy | undefined, uniqueLabelStrategy?: RestoreUniqueLabelStrategy | undefined, uniqueLabelPrefix?: string | null | undefined, uniqueLabelSuffix?: string | null | undefined, file?: FileParameter | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/backups/projects/{projectId}/containers?";
        if (projectId === undefined || projectId === null)
            throw new globalThis.Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (targetEntityStrategy === null)
            throw new globalThis.Error("The parameter 'targetEntityStrategy' cannot be null.");
        else if (targetEntityStrategy !== undefined)
            url_ += "targetEntityStrategy=" + encodeURIComponent("" + targetEntityStrategy) + "&";
        if (uniqueLabelStrategy === null)
            throw new globalThis.Error("The parameter 'uniqueLabelStrategy' cannot be null.");
        else if (uniqueLabelStrategy !== undefined)
            url_ += "uniqueLabelStrategy=" + encodeURIComponent("" + uniqueLabelStrategy) + "&";
        if (uniqueLabelPrefix !== undefined && uniqueLabelPrefix !== null)
            url_ += "uniqueLabelPrefix=" + encodeURIComponent("" + uniqueLabelPrefix) + "&";
        if (uniqueLabelSuffix !== undefined && uniqueLabelSuffix !== null)
            url_ += "uniqueLabelSuffix=" + encodeURIComponent("" + uniqueLabelSuffix) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new globalThis.Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRestoreContainerBackup(_response);
        });
    }

    protected processRestoreContainerBackup(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    restoreContainerGroupBackup(projectId: string, targetEntityStrategy?: RestoreImportStrategy | undefined, includedEntityStrategy?: RestoreImportStrategy | undefined, uniqueLabelStrategy?: RestoreUniqueLabelStrategy | undefined, uniqueLabelPrefix?: string | null | undefined, uniqueLabelSuffix?: string | null | undefined, file?: FileParameter | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/backups/projects/{projectId}/container-groups?";
        if (projectId === undefined || projectId === null)
            throw new globalThis.Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (targetEntityStrategy === null)
            throw new globalThis.Error("The parameter 'targetEntityStrategy' cannot be null.");
        else if (targetEntityStrategy !== undefined)
            url_ += "targetEntityStrategy=" + encodeURIComponent("" + targetEntityStrategy) + "&";
        if (includedEntityStrategy === null)
            throw new globalThis.Error("The parameter 'includedEntityStrategy' cannot be null.");
        else if (includedEntityStrategy !== undefined)
            url_ += "includedEntityStrategy=" + encodeURIComponent("" + includedEntityStrategy) + "&";
        if (uniqueLabelStrategy === null)
            throw new globalThis.Error("The parameter 'uniqueLabelStrategy' cannot be null.");
        else if (uniqueLabelStrategy !== undefined)
            url_ += "uniqueLabelStrategy=" + encodeURIComponent("" + uniqueLabelStrategy) + "&";
        if (uniqueLabelPrefix !== undefined && uniqueLabelPrefix !== null)
            url_ += "uniqueLabelPrefix=" + encodeURIComponent("" + uniqueLabelPrefix) + "&";
        if (uniqueLabelSuffix !== undefined && uniqueLabelSuffix !== null)
            url_ += "uniqueLabelSuffix=" + encodeURIComponent("" + uniqueLabelSuffix) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new globalThis.Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRestoreContainerGroupBackup(_response);
        });
    }

    protected processRestoreContainerGroupBackup(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getTerminologyBackup(terminologyId: string, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/backups/terminologies/{terminologyId}";
        if (terminologyId === undefined || terminologyId === null)
            throw new globalThis.Error("The parameter 'terminologyId' must be defined.");
        url_ = url_.replace("{terminologyId}", encodeURIComponent("" + terminologyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTerminologyBackup(_response);
        });
    }

    protected processGetTerminologyBackup(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    restoreTerminologyBackup(projectId: string, targetEntityStrategy?: RestoreImportStrategy | undefined, includedEntityStrategy?: RestoreImportStrategy | undefined, uniqueLabelStrategy?: RestoreUniqueLabelStrategy | undefined, uniqueLabelPrefix?: string | null | undefined, uniqueLabelSuffix?: string | null | undefined, file?: FileParameter | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/backups/projects/{projectId}/terminologies?";
        if (projectId === undefined || projectId === null)
            throw new globalThis.Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (targetEntityStrategy === null)
            throw new globalThis.Error("The parameter 'targetEntityStrategy' cannot be null.");
        else if (targetEntityStrategy !== undefined)
            url_ += "targetEntityStrategy=" + encodeURIComponent("" + targetEntityStrategy) + "&";
        if (includedEntityStrategy === null)
            throw new globalThis.Error("The parameter 'includedEntityStrategy' cannot be null.");
        else if (includedEntityStrategy !== undefined)
            url_ += "includedEntityStrategy=" + encodeURIComponent("" + includedEntityStrategy) + "&";
        if (uniqueLabelStrategy === null)
            throw new globalThis.Error("The parameter 'uniqueLabelStrategy' cannot be null.");
        else if (uniqueLabelStrategy !== undefined)
            url_ += "uniqueLabelStrategy=" + encodeURIComponent("" + uniqueLabelStrategy) + "&";
        if (uniqueLabelPrefix !== undefined && uniqueLabelPrefix !== null)
            url_ += "uniqueLabelPrefix=" + encodeURIComponent("" + uniqueLabelPrefix) + "&";
        if (uniqueLabelSuffix !== undefined && uniqueLabelSuffix !== null)
            url_ += "uniqueLabelSuffix=" + encodeURIComponent("" + uniqueLabelSuffix) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new globalThis.Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRestoreTerminologyBackup(_response);
        });
    }

    protected processRestoreTerminologyBackup(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ConsentTemplatesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Returns a paginated list of consent templates, applying optional sorting and search criteria.
     * @param pageNumber (optional) The page number (default: 1).
     * @param pageSize (optional) The number of items per page (default: 10).
     * @param sorting (optional) Optional sorting definitions.
     * @param search (optional) Optional search term.
     * @return A paginated list of consent templates.
     */
    getConsentTemplates(pageNumber?: number | undefined, pageSize?: number | undefined, sorting?: SortingParameter[] | null | undefined, search?: string | null | undefined, signal?: AbortSignal): Promise<PaginatedListOfConsentTemplateDto> {
        let url_ = this.baseUrl + "/api/v1/consent-templates?";
        if (pageNumber === null)
            throw new globalThis.Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sorting !== undefined && sorting !== null)
            sorting && sorting.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "sorting[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetConsentTemplates(_response);
        });
    }

    protected processGetConsentTemplates(response: Response): Promise<PaginatedListOfConsentTemplateDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfConsentTemplateDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfConsentTemplateDto>(null as any);
    }

    /**
     * Retrieves a specific consent template.
     * @param consentTemplateId The ID of the consent template to retrieve.
     * @return A specific consent template.
     */
    getConsentTemplate(consentTemplateId: string, signal?: AbortSignal): Promise<ConsentTemplateDto> {
        let url_ = this.baseUrl + "/api/v1/consent-templates/{consentTemplateId}";
        if (consentTemplateId === undefined || consentTemplateId === null)
            throw new globalThis.Error("The parameter 'consentTemplateId' must be defined.");
        url_ = url_.replace("{consentTemplateId}", encodeURIComponent("" + consentTemplateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetConsentTemplate(_response);
        });
    }

    protected processGetConsentTemplate(response: Response): Promise<ConsentTemplateDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConsentTemplateDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConsentTemplateDto>(null as any);
    }

    /**
     * Updates an existing consent template.
     * @param consentTemplateId The ID of the consent template to update.
     * @param command The updated consent template data.
     * @return The updated consent template.
     */
    updateConsentTemplate(consentTemplateId: string, command: UpdateConsentTemplateCommand, signal?: AbortSignal): Promise<ConsentTemplateDto> {
        let url_ = this.baseUrl + "/api/v1/consent-templates/{consentTemplateId}";
        if (consentTemplateId === undefined || consentTemplateId === null)
            throw new globalThis.Error("The parameter 'consentTemplateId' must be defined.");
        url_ = url_.replace("{consentTemplateId}", encodeURIComponent("" + consentTemplateId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateConsentTemplate(_response);
        });
    }

    protected processUpdateConsentTemplate(response: Response): Promise<ConsentTemplateDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConsentTemplateDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConsentTemplateDto>(null as any);
    }

    /**
     * Deletes a consent template.
     * @param consentTemplateId The ID of the consent template to delete.
     */
    deleteConsentTemplate(consentTemplateId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/consent-templates/{consentTemplateId}";
        if (consentTemplateId === undefined || consentTemplateId === null)
            throw new globalThis.Error("The parameter 'consentTemplateId' must be defined.");
        url_ = url_.replace("{consentTemplateId}", encodeURIComponent("" + consentTemplateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteConsentTemplate(_response);
        });
    }

    protected processDeleteConsentTemplate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Creates a new version of an existing consent template.
     * @param consentTemplateId The ID of the consent template.
     * @return The created consent template version.
     */
    createConsentTemplateVersion(consentTemplateId: string, signal?: AbortSignal): Promise<ConsentTemplateVersionDetailsDto> {
        let url_ = this.baseUrl + "/api/v1/consent-templates/{consentTemplateId}/versions";
        if (consentTemplateId === undefined || consentTemplateId === null)
            throw new globalThis.Error("The parameter 'consentTemplateId' must be defined.");
        url_ = url_.replace("{consentTemplateId}", encodeURIComponent("" + consentTemplateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateConsentTemplateVersion(_response);
        });
    }

    protected processCreateConsentTemplateVersion(response: Response): Promise<ConsentTemplateVersionDetailsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConsentTemplateVersionDetailsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConsentTemplateVersionDetailsDto>(null as any);
    }

    /**
     * Returns a specific version of a consent template.
     * @param consentTemplateId The ID of the consent template.
     * @param versionNumber The version number.
     * @return The requested consent template version.
     */
    getConsentTemplateVersion(consentTemplateId: string, versionNumber: number, signal?: AbortSignal): Promise<ConsentTemplateVersionDetailsDto> {
        let url_ = this.baseUrl + "/api/v1/consent-templates/{consentTemplateId}/versions/{versionNumber}";
        if (consentTemplateId === undefined || consentTemplateId === null)
            throw new globalThis.Error("The parameter 'consentTemplateId' must be defined.");
        url_ = url_.replace("{consentTemplateId}", encodeURIComponent("" + consentTemplateId));
        if (versionNumber === undefined || versionNumber === null)
            throw new globalThis.Error("The parameter 'versionNumber' must be defined.");
        url_ = url_.replace("{versionNumber}", encodeURIComponent("" + versionNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetConsentTemplateVersion(_response);
        });
    }

    protected processGetConsentTemplateVersion(response: Response): Promise<ConsentTemplateVersionDetailsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConsentTemplateVersionDetailsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConsentTemplateVersionDetailsDto>(null as any);
    }

    /**
     * Updates a specific version of a consent template.
     * @param consentTemplateId The ID of the consent template.
     * @param versionNumber The version number.
     * @param command The updated consent template version data.
     * @return The updated consent template version.
     */
    updateConsentTemplateVersion(consentTemplateId: string, versionNumber: number, command: UpdateConsentTemplateVersionCommand, signal?: AbortSignal): Promise<ConsentTemplateVersionDetailsDto> {
        let url_ = this.baseUrl + "/api/v1/consent-templates/{consentTemplateId}/versions/{versionNumber}";
        if (consentTemplateId === undefined || consentTemplateId === null)
            throw new globalThis.Error("The parameter 'consentTemplateId' must be defined.");
        url_ = url_.replace("{consentTemplateId}", encodeURIComponent("" + consentTemplateId));
        if (versionNumber === undefined || versionNumber === null)
            throw new globalThis.Error("The parameter 'versionNumber' must be defined.");
        url_ = url_.replace("{versionNumber}", encodeURIComponent("" + versionNumber));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateConsentTemplateVersion(_response);
        });
    }

    protected processUpdateConsentTemplateVersion(response: Response): Promise<ConsentTemplateVersionDetailsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConsentTemplateVersionDetailsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConsentTemplateVersionDetailsDto>(null as any);
    }

    /**
     * Publishes a specific version of a consent template.
     * @param consentTemplateId The ID of the consent template.
     * @param versionNumber The version number.
     */
    publishConsentTemplateVersion(consentTemplateId: string, versionNumber: number, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/consent-templates/{consentTemplateId}/versions/{versionNumber}/publish";
        if (consentTemplateId === undefined || consentTemplateId === null)
            throw new globalThis.Error("The parameter 'consentTemplateId' must be defined.");
        url_ = url_.replace("{consentTemplateId}", encodeURIComponent("" + consentTemplateId));
        if (versionNumber === undefined || versionNumber === null)
            throw new globalThis.Error("The parameter 'versionNumber' must be defined.");
        url_ = url_.replace("{versionNumber}", encodeURIComponent("" + versionNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPublishConsentTemplateVersion(_response);
        });
    }

    protected processPublishConsentTemplateVersion(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Unpublishes a specific version of a consent template.
     * @param consentTemplateId The ID of the consent template.
     * @param versionNumber The version number.
     */
    unpublishConsentTemplateVersion(consentTemplateId: string, versionNumber: number, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/consent-templates/{consentTemplateId}/versions/{versionNumber}/unpublish";
        if (consentTemplateId === undefined || consentTemplateId === null)
            throw new globalThis.Error("The parameter 'consentTemplateId' must be defined.");
        url_ = url_.replace("{consentTemplateId}", encodeURIComponent("" + consentTemplateId));
        if (versionNumber === undefined || versionNumber === null)
            throw new globalThis.Error("The parameter 'versionNumber' must be defined.");
        url_ = url_.replace("{versionNumber}", encodeURIComponent("" + versionNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUnpublishConsentTemplateVersion(_response);
        });
    }

    protected processUnpublishConsentTemplateVersion(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Hides (soft-deletes) a specific version of a consent template.
     * @param consentTemplateId The ID of the consent template.
     * @param versionNumber The version number.
     */
    hideConsentTemplateVersion(consentTemplateId: string, versionNumber: number, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/consent-templates/{consentTemplateId}/versions/{versionNumber}/hide";
        if (consentTemplateId === undefined || consentTemplateId === null)
            throw new globalThis.Error("The parameter 'consentTemplateId' must be defined.");
        url_ = url_.replace("{consentTemplateId}", encodeURIComponent("" + consentTemplateId));
        if (versionNumber === undefined || versionNumber === null)
            throw new globalThis.Error("The parameter 'versionNumber' must be defined.");
        url_ = url_.replace("{versionNumber}", encodeURIComponent("" + versionNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHideConsentTemplateVersion(_response);
        });
    }

    protected processHideConsentTemplateVersion(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Returns a paginated list of consents, applying optional sorting and filter criteria.
     * @param pageNumber (optional) The page number (default: 1).
     * @param pageSize (optional) The number of items per page (default: 10).
     * @param sorting (optional) Optional sorting definitions.
     * @param search (optional) Optional search term.
     * @param consentTemplateIds (optional) Optional consent template IDs used to filter the consents.
     * @param consentTemplateVersionIds (optional) Optional consent template version IDs used to filter the consents.
     * @param clientIds (optional) Optional client application IDs used to filter client-related consents.
     * @param projectIds (optional) Optional project IDs used to filter project-related consents.
     * @param participantIds (optional) Optional participant IDs to filter by.
     * @param withdrawn (optional) Optional withdrawal filter. Use true for withdrawn consents and false for active consents.
     * @return A paginated list of consents.
     */
    getConsents(pageNumber?: number | undefined, pageSize?: number | undefined, sorting?: SortingParameter[] | null | undefined, search?: string | null | undefined, consentTemplateIds?: string[] | null | undefined, consentTemplateVersionIds?: string[] | null | undefined, clientIds?: string[] | null | undefined, projectIds?: string[] | null | undefined, participantIds?: string[] | null | undefined, withdrawn?: boolean | null | undefined, signal?: AbortSignal): Promise<PaginatedListOfConsentDto> {
        let url_ = this.baseUrl + "/api/v1/consent-templates/consents?";
        if (pageNumber === null)
            throw new globalThis.Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sorting !== undefined && sorting !== null)
            sorting && sorting.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "sorting[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (consentTemplateIds !== undefined && consentTemplateIds !== null)
            consentTemplateIds && consentTemplateIds.forEach(item => { url_ += "consentTemplateIds=" + encodeURIComponent("" + item) + "&"; });
        if (consentTemplateVersionIds !== undefined && consentTemplateVersionIds !== null)
            consentTemplateVersionIds && consentTemplateVersionIds.forEach(item => { url_ += "consentTemplateVersionIds=" + encodeURIComponent("" + item) + "&"; });
        if (clientIds !== undefined && clientIds !== null)
            clientIds && clientIds.forEach(item => { url_ += "clientIds=" + encodeURIComponent("" + item) + "&"; });
        if (projectIds !== undefined && projectIds !== null)
            projectIds && projectIds.forEach(item => { url_ += "projectIds=" + encodeURIComponent("" + item) + "&"; });
        if (participantIds !== undefined && participantIds !== null)
            participantIds && participantIds.forEach(item => { url_ += "participantIds=" + encodeURIComponent("" + item) + "&"; });
        if (withdrawn !== undefined && withdrawn !== null)
            url_ += "withdrawn=" + encodeURIComponent("" + withdrawn) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetConsents(_response);
        });
    }

    protected processGetConsents(response: Response): Promise<PaginatedListOfConsentDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfConsentDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfConsentDto>(null as any);
    }

    /**
     * Returns a specific consent.
     * @param consentId The ID of the consent.
     * @return The requested consent.
     */
    getConsent(consentId: string, signal?: AbortSignal): Promise<ConsentDto> {
        let url_ = this.baseUrl + "/api/v1/consent-templates/consents/{consentId}";
        if (consentId === undefined || consentId === null)
            throw new globalThis.Error("The parameter 'consentId' must be defined.");
        url_ = url_.replace("{consentId}", encodeURIComponent("" + consentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetConsent(_response);
        });
    }

    protected processGetConsent(response: Response): Promise<ConsentDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConsentDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConsentDto>(null as any);
    }
}

export class ContainerGroupsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getContainerGroups(pageNumber?: number | undefined, pageSize?: number | undefined, sorting?: SortingParameter[] | null | undefined, search?: string | null | undefined, projectIds?: string[] | null | undefined, showHidden?: boolean | undefined, containerGroupTypes?: ContainerGroupType[] | null | undefined, signal?: AbortSignal): Promise<PaginatedListOfContainerGroupDto> {
        let url_ = this.baseUrl + "/api/v1/container-groups?";
        if (pageNumber === null)
            throw new globalThis.Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sorting !== undefined && sorting !== null)
            sorting && sorting.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "sorting[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (projectIds !== undefined && projectIds !== null)
            projectIds && projectIds.forEach(item => { url_ += "projectIds=" + encodeURIComponent("" + item) + "&"; });
        if (showHidden === null)
            throw new globalThis.Error("The parameter 'showHidden' cannot be null.");
        else if (showHidden !== undefined)
            url_ += "showHidden=" + encodeURIComponent("" + showHidden) + "&";
        if (containerGroupTypes !== undefined && containerGroupTypes !== null)
            containerGroupTypes && containerGroupTypes.forEach(item => { url_ += "containerGroupTypes=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetContainerGroups(_response);
        });
    }

    protected processGetContainerGroups(response: Response): Promise<PaginatedListOfContainerGroupDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfContainerGroupDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfContainerGroupDto>(null as any);
    }

    createContainerGroup(command: CreateContainerGroupCommand, signal?: AbortSignal): Promise<ContainerGroupDto> {
        let url_ = this.baseUrl + "/api/v1/container-groups";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateContainerGroup(_response);
        });
    }

    protected processCreateContainerGroup(response: Response): Promise<ContainerGroupDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContainerGroupDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ContainerGroupDto>(null as any);
    }

    getContainerGroup(containerGroupId: string, signal?: AbortSignal): Promise<ContainerGroupDetailsDto> {
        let url_ = this.baseUrl + "/api/v1/container-groups/{containerGroupId}";
        if (containerGroupId === undefined || containerGroupId === null)
            throw new globalThis.Error("The parameter 'containerGroupId' must be defined.");
        url_ = url_.replace("{containerGroupId}", encodeURIComponent("" + containerGroupId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetContainerGroup(_response);
        });
    }

    protected processGetContainerGroup(response: Response): Promise<ContainerGroupDetailsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContainerGroupDetailsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ContainerGroupDetailsDto>(null as any);
    }

    updateContainerGroup(containerGroupId: string, command: UpdateContainerGroupCommand, signal?: AbortSignal): Promise<ContainerGroupDetailsDto> {
        let url_ = this.baseUrl + "/api/v1/container-groups/{containerGroupId}";
        if (containerGroupId === undefined || containerGroupId === null)
            throw new globalThis.Error("The parameter 'containerGroupId' must be defined.");
        url_ = url_.replace("{containerGroupId}", encodeURIComponent("" + containerGroupId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateContainerGroup(_response);
        });
    }

    protected processUpdateContainerGroup(response: Response): Promise<ContainerGroupDetailsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContainerGroupDetailsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ContainerGroupDetailsDto>(null as any);
    }

    createIntervention(command: CreateInterventionCommand, signal?: AbortSignal): Promise<ContainerGroupDto> {
        let url_ = this.baseUrl + "/api/v1/container-groups/interventions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateIntervention(_response);
        });
    }

    protected processCreateIntervention(response: Response): Promise<ContainerGroupDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContainerGroupDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ContainerGroupDto>(null as any);
    }

    createChapter(command: CreateChapterCommand, signal?: AbortSignal): Promise<ContainerGroupDto> {
        let url_ = this.baseUrl + "/api/v1/container-groups/chapters";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateChapter(_response);
        });
    }

    protected processCreateChapter(response: Response): Promise<ContainerGroupDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContainerGroupDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ContainerGroupDto>(null as any);
    }

    hideContainerGroup(containerGroupId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/container-groups/{containerGroupId}/hide";
        if (containerGroupId === undefined || containerGroupId === null)
            throw new globalThis.Error("The parameter 'containerGroupId' must be defined.");
        url_ = url_.replace("{containerGroupId}", encodeURIComponent("" + containerGroupId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHideContainerGroup(_response);
        });
    }

    protected processHideContainerGroup(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    deleteContainerGroup(containerGroupId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/container-groups/{containerGroupId}/permanent";
        if (containerGroupId === undefined || containerGroupId === null)
            throw new globalThis.Error("The parameter 'containerGroupId' must be defined.");
        url_ = url_.replace("{containerGroupId}", encodeURIComponent("" + containerGroupId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteContainerGroup(_response);
        });
    }

    protected processDeleteContainerGroup(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    publishContainerGroup(containerGroupId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/container-groups/{containerGroupId}/publish";
        if (containerGroupId === undefined || containerGroupId === null)
            throw new globalThis.Error("The parameter 'containerGroupId' must be defined.");
        url_ = url_.replace("{containerGroupId}", encodeURIComponent("" + containerGroupId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPublishContainerGroup(_response);
        });
    }

    protected processPublishContainerGroup(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    unpublishContainerGroup(containerGroupId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/container-groups/{containerGroupId}/unpublish";
        if (containerGroupId === undefined || containerGroupId === null)
            throw new globalThis.Error("The parameter 'containerGroupId' must be defined.");
        url_ = url_.replace("{containerGroupId}", encodeURIComponent("" + containerGroupId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUnpublishContainerGroup(_response);
        });
    }

    protected processUnpublishContainerGroup(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    exportInterventionModuleInstances(containerGroupId: string, interventionModuleInstanceIds?: string[] | null | undefined, states?: ContainerInstanceState[] | null | undefined, from?: Date | null | undefined, until?: Date | null | undefined, includeExecutionInfo?: boolean | undefined, format?: ExportFileFormatParameter | undefined, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/container-groups/{containerGroupId}/intervention-module-instances/export?";
        if (containerGroupId === undefined || containerGroupId === null)
            throw new globalThis.Error("The parameter 'containerGroupId' must be defined.");
        url_ = url_.replace("{containerGroupId}", encodeURIComponent("" + containerGroupId));
        if (interventionModuleInstanceIds !== undefined && interventionModuleInstanceIds !== null)
            interventionModuleInstanceIds && interventionModuleInstanceIds.forEach(item => { url_ += "interventionModuleInstanceIds=" + encodeURIComponent("" + item) + "&"; });
        if (states !== undefined && states !== null)
            states && states.forEach(item => { url_ += "states=" + encodeURIComponent("" + item) + "&"; });
        if (from !== undefined && from !== null)
            url_ += "from=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (until !== undefined && until !== null)
            url_ += "until=" + encodeURIComponent(until ? "" + until.toISOString() : "") + "&";
        if (includeExecutionInfo === null)
            throw new globalThis.Error("The parameter 'includeExecutionInfo' cannot be null.");
        else if (includeExecutionInfo !== undefined)
            url_ += "includeExecutionInfo=" + encodeURIComponent("" + includeExecutionInfo) + "&";
        if (format === null)
            throw new globalThis.Error("The parameter 'format' cannot be null.");
        else if (format !== undefined)
            url_ += "format=" + encodeURIComponent("" + format) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processExportInterventionModuleInstances(_response);
        });
    }

    protected processExportInterventionModuleInstances(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class ContainersClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getContainers(pageNumber?: number | undefined, pageSize?: number | undefined, sorting?: SortingParameter[] | null | undefined, search?: string | null | undefined, projectIds?: string[] | null | undefined, containerTypes?: ContainerType[] | null | undefined, showHidden?: boolean | undefined, signal?: AbortSignal): Promise<PaginatedListOfContainerListItemDto> {
        let url_ = this.baseUrl + "/api/v1/containers?";
        if (pageNumber === null)
            throw new globalThis.Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sorting !== undefined && sorting !== null)
            sorting && sorting.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "sorting[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (projectIds !== undefined && projectIds !== null)
            projectIds && projectIds.forEach(item => { url_ += "projectIds=" + encodeURIComponent("" + item) + "&"; });
        if (containerTypes !== undefined && containerTypes !== null)
            containerTypes && containerTypes.forEach(item => { url_ += "containerTypes=" + encodeURIComponent("" + item) + "&"; });
        if (showHidden === null)
            throw new globalThis.Error("The parameter 'showHidden' cannot be null.");
        else if (showHidden !== undefined)
            url_ += "showHidden=" + encodeURIComponent("" + showHidden) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetContainers(_response);
        });
    }

    protected processGetContainers(response: Response): Promise<PaginatedListOfContainerListItemDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfContainerListItemDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfContainerListItemDto>(null as any);
    }

    getContainer(containerId: string, signal?: AbortSignal): Promise<ContainerListItemDetailsDto> {
        let url_ = this.baseUrl + "/api/v1/containers/{containerId}";
        if (containerId === undefined || containerId === null)
            throw new globalThis.Error("The parameter 'containerId' must be defined.");
        url_ = url_.replace("{containerId}", encodeURIComponent("" + containerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetContainer(_response);
        });
    }

    protected processGetContainer(response: Response): Promise<ContainerListItemDetailsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContainerListItemDetailsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ContainerListItemDetailsDto>(null as any);
    }

    duplicateContainer(containerId: string, command: CopyContainerCommand, signal?: AbortSignal): Promise<ContainerListItemDto> {
        let url_ = this.baseUrl + "/api/v1/containers/{containerId}/duplicate";
        if (containerId === undefined || containerId === null)
            throw new globalThis.Error("The parameter 'containerId' must be defined.");
        url_ = url_.replace("{containerId}", encodeURIComponent("" + containerId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDuplicateContainer(_response);
        });
    }

    protected processDuplicateContainer(response: Response): Promise<ContainerListItemDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContainerListItemDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ContainerListItemDto>(null as any);
    }

    convertContainer(containerId: string, command: CopyContainerCommand, signal?: AbortSignal): Promise<ContainerListItemDto> {
        let url_ = this.baseUrl + "/api/v1/containers/{containerId}/convert";
        if (containerId === undefined || containerId === null)
            throw new globalThis.Error("The parameter 'containerId' must be defined.");
        url_ = url_.replace("{containerId}", encodeURIComponent("" + containerId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processConvertContainer(_response);
        });
    }

    protected processConvertContainer(response: Response): Promise<ContainerListItemDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContainerListItemDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ContainerListItemDto>(null as any);
    }

    previewConversion(containerId: string, targetType: ContainerType, signal?: AbortSignal): Promise<ContainerConversionPreviewDto> {
        let url_ = this.baseUrl + "/api/v1/containers/{containerId}/conversion-preview?";
        if (containerId === undefined || containerId === null)
            throw new globalThis.Error("The parameter 'containerId' must be defined.");
        url_ = url_.replace("{containerId}", encodeURIComponent("" + containerId));
        if (targetType === undefined || targetType === null)
            throw new globalThis.Error("The parameter 'targetType' must be defined and cannot be null.");
        else
            url_ += "targetType=" + encodeURIComponent("" + targetType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPreviewConversion(_response);
        });
    }

    protected processPreviewConversion(response: Response): Promise<ContainerConversionPreviewDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContainerConversionPreviewDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ContainerConversionPreviewDto>(null as any);
    }
}

export class ContextObjectsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getContents(limit?: number | undefined, search?: string | null | undefined, types?: ElementType[] | null | undefined, excludeTypes?: ElementType[] | null | undefined, projectIds?: string[] | null | undefined, containerIds?: string[] | null | undefined, excludeContainerIds?: string[] | null | undefined, contentIds?: string[] | null | undefined, signal?: AbortSignal): Promise<ContentDto[]> {
        let url_ = this.baseUrl + "/api/v1/context-objects/contents?";
        if (limit === null)
            throw new globalThis.Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (types !== undefined && types !== null)
            types && types.forEach(item => { url_ += "types=" + encodeURIComponent("" + item) + "&"; });
        if (excludeTypes !== undefined && excludeTypes !== null)
            excludeTypes && excludeTypes.forEach(item => { url_ += "excludeTypes=" + encodeURIComponent("" + item) + "&"; });
        if (projectIds !== undefined && projectIds !== null)
            projectIds && projectIds.forEach(item => { url_ += "projectIds=" + encodeURIComponent("" + item) + "&"; });
        if (containerIds !== undefined && containerIds !== null)
            containerIds && containerIds.forEach(item => { url_ += "containerIds=" + encodeURIComponent("" + item) + "&"; });
        if (excludeContainerIds !== undefined && excludeContainerIds !== null)
            excludeContainerIds && excludeContainerIds.forEach(item => { url_ += "excludeContainerIds=" + encodeURIComponent("" + item) + "&"; });
        if (contentIds !== undefined && contentIds !== null)
            contentIds && contentIds.forEach(item => { url_ += "contentIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetContents(_response);
        });
    }

    protected processGetContents(response: Response): Promise<ContentDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ContentDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ContentDto[]>(null as any);
    }

    getContextObjects(pageNumber?: number | undefined, pageSize?: number | undefined, sorting?: SortingParameter[] | null | undefined, search?: string | null | undefined, projectIds?: string[] | null | undefined, showHidden?: boolean | undefined, signal?: AbortSignal): Promise<PaginatedListOfContextObjectDto> {
        let url_ = this.baseUrl + "/api/v1/context-objects?";
        if (pageNumber === null)
            throw new globalThis.Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sorting !== undefined && sorting !== null)
            sorting && sorting.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "sorting[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (projectIds !== undefined && projectIds !== null)
            projectIds && projectIds.forEach(item => { url_ += "projectIds=" + encodeURIComponent("" + item) + "&"; });
        if (showHidden === null)
            throw new globalThis.Error("The parameter 'showHidden' cannot be null.");
        else if (showHidden !== undefined)
            url_ += "showHidden=" + encodeURIComponent("" + showHidden) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetContextObjects(_response);
        });
    }

    protected processGetContextObjects(response: Response): Promise<PaginatedListOfContextObjectDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfContextObjectDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfContextObjectDto>(null as any);
    }

    createContextObject(command: CreateContextObjectCommand, signal?: AbortSignal): Promise<ContextObjectDto> {
        let url_ = this.baseUrl + "/api/v1/context-objects";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateContextObject(_response);
        });
    }

    protected processCreateContextObject(response: Response): Promise<ContextObjectDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContextObjectDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ContextObjectDto>(null as any);
    }

    getContextObject(contextObjectId: string, signal?: AbortSignal): Promise<ContextObjectDetailsDto> {
        let url_ = this.baseUrl + "/api/v1/context-objects/{contextObjectId}";
        if (contextObjectId === undefined || contextObjectId === null)
            throw new globalThis.Error("The parameter 'contextObjectId' must be defined.");
        url_ = url_.replace("{contextObjectId}", encodeURIComponent("" + contextObjectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetContextObject(_response);
        });
    }

    protected processGetContextObject(response: Response): Promise<ContextObjectDetailsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContextObjectDetailsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ContextObjectDetailsDto>(null as any);
    }

    updateContextObject(contextObjectId: string, command: UpdateContextObjectCommand, signal?: AbortSignal): Promise<ContextObjectDetailsDto> {
        let url_ = this.baseUrl + "/api/v1/context-objects/{contextObjectId}";
        if (contextObjectId === undefined || contextObjectId === null)
            throw new globalThis.Error("The parameter 'contextObjectId' must be defined.");
        url_ = url_.replace("{contextObjectId}", encodeURIComponent("" + contextObjectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateContextObject(_response);
        });
    }

    protected processUpdateContextObject(response: Response): Promise<ContextObjectDetailsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContextObjectDetailsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ContextObjectDetailsDto>(null as any);
    }

    hideContextObject(contextObjectId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/context-objects/{contextObjectId}/hide";
        if (contextObjectId === undefined || contextObjectId === null)
            throw new globalThis.Error("The parameter 'contextObjectId' must be defined.");
        url_ = url_.replace("{contextObjectId}", encodeURIComponent("" + contextObjectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHideContextObject(_response);
        });
    }

    protected processHideContextObject(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    deleteContextObject(contextObjectId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/context-objects/{contextObjectId}/permanent";
        if (contextObjectId === undefined || contextObjectId === null)
            throw new globalThis.Error("The parameter 'contextObjectId' must be defined.");
        url_ = url_.replace("{contextObjectId}", encodeURIComponent("" + contextObjectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteContextObject(_response);
        });
    }

    protected processDeleteContextObject(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    publishContextObject(contextObjectId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/context-objects/{contextObjectId}/publish";
        if (contextObjectId === undefined || contextObjectId === null)
            throw new globalThis.Error("The parameter 'contextObjectId' must be defined.");
        url_ = url_.replace("{contextObjectId}", encodeURIComponent("" + contextObjectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPublishContextObject(_response);
        });
    }

    protected processPublishContextObject(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    unpublishContextObject(contextObjectId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/context-objects/{contextObjectId}/unpublish";
        if (contextObjectId === undefined || contextObjectId === null)
            throw new globalThis.Error("The parameter 'contextObjectId' must be defined.");
        url_ = url_.replace("{contextObjectId}", encodeURIComponent("" + contextObjectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUnpublishContextObject(_response);
        });
    }

    protected processUnpublishContextObject(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getContextObjectHistory(contextObjectId: string, pageNumber?: number | undefined, pageSize?: number | undefined, from?: Date | null | undefined, until?: Date | null | undefined, userIds?: string[] | null | undefined, signal?: AbortSignal): Promise<PaginatedListOfHistoricalContentDto> {
        let url_ = this.baseUrl + "/api/v1/context-objects/{contextObjectId}/history?";
        if (contextObjectId === undefined || contextObjectId === null)
            throw new globalThis.Error("The parameter 'contextObjectId' must be defined.");
        url_ = url_.replace("{contextObjectId}", encodeURIComponent("" + contextObjectId));
        if (pageNumber === null)
            throw new globalThis.Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (from !== undefined && from !== null)
            url_ += "from=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (until !== undefined && until !== null)
            url_ += "until=" + encodeURIComponent(until ? "" + until.toISOString() : "") + "&";
        if (userIds !== undefined && userIds !== null)
            userIds && userIds.forEach(item => { url_ += "userIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetContextObjectHistory(_response);
        });
    }

    protected processGetContextObjectHistory(response: Response): Promise<PaginatedListOfHistoricalContentDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfHistoricalContentDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfHistoricalContentDto>(null as any);
    }

    getContextObjectHistoryDetails(contextObjectId: string, contextObjectVersion: number, signal?: AbortSignal): Promise<HistoricalContentDetailsDto> {
        let url_ = this.baseUrl + "/api/v1/context-objects/{contextObjectId}/history/{contextObjectVersion}";
        if (contextObjectId === undefined || contextObjectId === null)
            throw new globalThis.Error("The parameter 'contextObjectId' must be defined.");
        url_ = url_.replace("{contextObjectId}", encodeURIComponent("" + contextObjectId));
        if (contextObjectVersion === undefined || contextObjectVersion === null)
            throw new globalThis.Error("The parameter 'contextObjectVersion' must be defined.");
        url_ = url_.replace("{contextObjectVersion}", encodeURIComponent("" + contextObjectVersion));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetContextObjectHistoryDetails(_response);
        });
    }

    protected processGetContextObjectHistoryDetails(response: Response): Promise<HistoricalContentDetailsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HistoricalContentDetailsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HistoricalContentDetailsDto>(null as any);
    }

    getContextObjectInstances(contextObjectId: string, pageNumber?: number | undefined, pageSize?: number | undefined, sorting?: SortingParameter[] | null | undefined, search?: string | null | undefined, projectIds?: string[] | null | undefined, showHidden?: boolean | undefined, signal?: AbortSignal): Promise<PaginatedListOfContextObjectInstanceDto> {
        let url_ = this.baseUrl + "/api/v1/context-objects/{contextObjectId}/instances?";
        if (contextObjectId === undefined || contextObjectId === null)
            throw new globalThis.Error("The parameter 'contextObjectId' must be defined.");
        url_ = url_.replace("{contextObjectId}", encodeURIComponent("" + contextObjectId));
        if (pageNumber === null)
            throw new globalThis.Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sorting !== undefined && sorting !== null)
            sorting && sorting.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "sorting[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (projectIds !== undefined && projectIds !== null)
            projectIds && projectIds.forEach(item => { url_ += "projectIds=" + encodeURIComponent("" + item) + "&"; });
        if (showHidden === null)
            throw new globalThis.Error("The parameter 'showHidden' cannot be null.");
        else if (showHidden !== undefined)
            url_ += "showHidden=" + encodeURIComponent("" + showHidden) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetContextObjectInstances(_response);
        });
    }

    protected processGetContextObjectInstances(response: Response): Promise<PaginatedListOfContextObjectInstanceDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfContextObjectInstanceDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfContextObjectInstanceDto>(null as any);
    }

    getContextObjectInstance(contextObjectId: string, contextObjectInstanceId: string, signal?: AbortSignal): Promise<ContextObjectInstanceDetailsDto> {
        let url_ = this.baseUrl + "/api/v1/context-objects/{contextObjectId}/instances/{contextObjectInstanceId}";
        if (contextObjectId === undefined || contextObjectId === null)
            throw new globalThis.Error("The parameter 'contextObjectId' must be defined.");
        url_ = url_.replace("{contextObjectId}", encodeURIComponent("" + contextObjectId));
        if (contextObjectInstanceId === undefined || contextObjectInstanceId === null)
            throw new globalThis.Error("The parameter 'contextObjectInstanceId' must be defined.");
        url_ = url_.replace("{contextObjectInstanceId}", encodeURIComponent("" + contextObjectInstanceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetContextObjectInstance(_response);
        });
    }

    protected processGetContextObjectInstance(response: Response): Promise<ContextObjectInstanceDetailsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContextObjectInstanceDetailsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ContextObjectInstanceDetailsDto>(null as any);
    }

    hideContextObjectInstances(contextObjectInstanceIds: string[], signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/context-objects/instances/hide?";
        if (contextObjectInstanceIds === undefined || contextObjectInstanceIds === null)
            throw new globalThis.Error("The parameter 'contextObjectInstanceIds' must be defined and cannot be null.");
        else
            contextObjectInstanceIds && contextObjectInstanceIds.forEach(item => { url_ += "contextObjectInstanceIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHideContextObjectInstances(_response);
        });
    }

    protected processHideContextObjectInstances(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    deleteContextObjectInstances(contextObjectInstanceIds: string[], signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/context-objects/instances?";
        if (contextObjectInstanceIds === undefined || contextObjectInstanceIds === null)
            throw new globalThis.Error("The parameter 'contextObjectInstanceIds' must be defined and cannot be null.");
        else
            contextObjectInstanceIds && contextObjectInstanceIds.forEach(item => { url_ += "contextObjectInstanceIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteContextObjectInstances(_response);
        });
    }

    protected processDeleteContextObjectInstances(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class CurrentUserClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    currentUserExists(signal?: AbortSignal): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/current-user/exists";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCurrentUserExists(_response);
        });
    }

    protected processCurrentUserExists(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class DevicesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getDevices(pageNumber?: number | undefined, pageSize?: number | undefined, sorting?: SortingParameter[] | null | undefined, ownerIds?: string[] | null | undefined, deviceIdentifiers?: string[] | null | undefined, search?: string | null | undefined, signal?: AbortSignal): Promise<PaginatedListOfDeviceDto> {
        let url_ = this.baseUrl + "/api/v1/devices?";
        if (pageNumber === null)
            throw new globalThis.Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sorting !== undefined && sorting !== null)
            sorting && sorting.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "sorting[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (ownerIds !== undefined && ownerIds !== null)
            ownerIds && ownerIds.forEach(item => { url_ += "ownerIds=" + encodeURIComponent("" + item) + "&"; });
        if (deviceIdentifiers !== undefined && deviceIdentifiers !== null)
            deviceIdentifiers && deviceIdentifiers.forEach(item => { url_ += "deviceIdentifiers=" + encodeURIComponent("" + item) + "&"; });
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDevices(_response);
        });
    }

    protected processGetDevices(response: Response): Promise<PaginatedListOfDeviceDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfDeviceDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfDeviceDto>(null as any);
    }

    getDevice(deviceId: string, signal?: AbortSignal): Promise<DeviceDetailsDto> {
        let url_ = this.baseUrl + "/api/v1/devices/{deviceId}";
        if (deviceId === undefined || deviceId === null)
            throw new globalThis.Error("The parameter 'deviceId' must be defined.");
        url_ = url_.replace("{deviceId}", encodeURIComponent("" + deviceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDevice(_response);
        });
    }

    protected processGetDevice(response: Response): Promise<DeviceDetailsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeviceDetailsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeviceDetailsDto>(null as any);
    }
}

export class FilesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    createFile(file?: FileParameter | undefined, signal?: AbortSignal): Promise<FileDto> {
        let url_ = this.baseUrl + "/api/v1/files";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new globalThis.Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateFile(_response);
        });
    }

    protected processCreateFile(response: Response): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileDto>(null as any);
    }

    createFileFromBase64(command: CreateFileFromBase64Command, signal?: AbortSignal): Promise<FileDto> {
        let url_ = this.baseUrl + "/api/v1/files/base64";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateFileFromBase64(_response);
        });
    }

    protected processCreateFileFromBase64(response: Response): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileDto>(null as any);
    }

    createFileFromUrl(command: CreateFileFromUrlCommand, signal?: AbortSignal): Promise<FileDto> {
        let url_ = this.baseUrl + "/api/v1/files/url";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateFileFromUrl(_response);
        });
    }

    protected processCreateFileFromUrl(response: Response): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileDto>(null as any);
    }

    getFile(fileId: string, size?: number | null | undefined, width?: number | null | undefined, height?: number | null | undefined, x?: number | null | undefined, y?: number | null | undefined, webp?: boolean | null | undefined, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/files/{fileId}?";
        if (fileId === undefined || fileId === null)
            throw new globalThis.Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        if (size !== undefined && size !== null)
            url_ += "size=" + encodeURIComponent("" + size) + "&";
        if (width !== undefined && width !== null)
            url_ += "w=" + encodeURIComponent("" + width) + "&";
        if (height !== undefined && height !== null)
            url_ += "h=" + encodeURIComponent("" + height) + "&";
        if (x !== undefined && x !== null)
            url_ += "x=" + encodeURIComponent("" + x) + "&";
        if (y !== undefined && y !== null)
            url_ += "y=" + encodeURIComponent("" + y) + "&";
        if (webp !== undefined && webp !== null)
            url_ += "webp=" + encodeURIComponent("" + webp) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFile(_response);
        });
    }

    protected processGetFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getFileDto(fileId: string, signal?: AbortSignal): Promise<FileDto> {
        let url_ = this.baseUrl + "/api/v1/files/{fileId}/dto";
        if (fileId === undefined || fileId === null)
            throw new globalThis.Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFileDto(_response);
        });
    }

    protected processGetFileDto(response: Response): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileDto>(null as any);
    }
}

export class InterventionModulesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getInterventionModules(pageNumber?: number | undefined, pageSize?: number | undefined, sorting?: SortingParameter[] | null | undefined, search?: string | null | undefined, projectIds?: string[] | null | undefined, showHidden?: boolean | undefined, signal?: AbortSignal): Promise<PaginatedListOfInterventionModuleDto> {
        let url_ = this.baseUrl + "/api/v1/intervention-modules?";
        if (pageNumber === null)
            throw new globalThis.Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sorting !== undefined && sorting !== null)
            sorting && sorting.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "sorting[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (projectIds !== undefined && projectIds !== null)
            projectIds && projectIds.forEach(item => { url_ += "projectIds=" + encodeURIComponent("" + item) + "&"; });
        if (showHidden === null)
            throw new globalThis.Error("The parameter 'showHidden' cannot be null.");
        else if (showHidden !== undefined)
            url_ += "showHidden=" + encodeURIComponent("" + showHidden) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetInterventionModules(_response);
        });
    }

    protected processGetInterventionModules(response: Response): Promise<PaginatedListOfInterventionModuleDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfInterventionModuleDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfInterventionModuleDto>(null as any);
    }

    createInterventionModule(command: CreateInterventionModuleCommand, signal?: AbortSignal): Promise<InterventionModuleDto> {
        let url_ = this.baseUrl + "/api/v1/intervention-modules";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateInterventionModule(_response);
        });
    }

    protected processCreateInterventionModule(response: Response): Promise<InterventionModuleDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InterventionModuleDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InterventionModuleDto>(null as any);
    }

    getInterventionModule(interventionModuleId: string, signal?: AbortSignal): Promise<InterventionModuleDetailsDto> {
        let url_ = this.baseUrl + "/api/v1/intervention-modules/{interventionModuleId}";
        if (interventionModuleId === undefined || interventionModuleId === null)
            throw new globalThis.Error("The parameter 'interventionModuleId' must be defined.");
        url_ = url_.replace("{interventionModuleId}", encodeURIComponent("" + interventionModuleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetInterventionModule(_response);
        });
    }

    protected processGetInterventionModule(response: Response): Promise<InterventionModuleDetailsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InterventionModuleDetailsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InterventionModuleDetailsDto>(null as any);
    }

    updateInterventionModule(interventionModuleId: string, command: UpdateInterventionModuleCommand, signal?: AbortSignal): Promise<InterventionModuleDetailsDto> {
        let url_ = this.baseUrl + "/api/v1/intervention-modules/{interventionModuleId}";
        if (interventionModuleId === undefined || interventionModuleId === null)
            throw new globalThis.Error("The parameter 'interventionModuleId' must be defined.");
        url_ = url_.replace("{interventionModuleId}", encodeURIComponent("" + interventionModuleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateInterventionModule(_response);
        });
    }

    protected processUpdateInterventionModule(response: Response): Promise<InterventionModuleDetailsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InterventionModuleDetailsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InterventionModuleDetailsDto>(null as any);
    }

    deleteInterventionModule(interventionModuleId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/intervention-modules/{interventionModuleId}";
        if (interventionModuleId === undefined || interventionModuleId === null)
            throw new globalThis.Error("The parameter 'interventionModuleId' must be defined.");
        url_ = url_.replace("{interventionModuleId}", encodeURIComponent("" + interventionModuleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteInterventionModule(_response);
        });
    }

    protected processDeleteInterventionModule(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    hideInterventionModule(interventionModuleId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/intervention-modules/{interventionModuleId}/hide";
        if (interventionModuleId === undefined || interventionModuleId === null)
            throw new globalThis.Error("The parameter 'interventionModuleId' must be defined.");
        url_ = url_.replace("{interventionModuleId}", encodeURIComponent("" + interventionModuleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHideInterventionModule(_response);
        });
    }

    protected processHideInterventionModule(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    publishInterventionModule(interventionModuleId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/intervention-modules/{interventionModuleId}/publish";
        if (interventionModuleId === undefined || interventionModuleId === null)
            throw new globalThis.Error("The parameter 'interventionModuleId' must be defined.");
        url_ = url_.replace("{interventionModuleId}", encodeURIComponent("" + interventionModuleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPublishInterventionModule(_response);
        });
    }

    protected processPublishInterventionModule(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    unpublishInterventionModule(interventionModuleId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/intervention-modules/{interventionModuleId}/unpublish";
        if (interventionModuleId === undefined || interventionModuleId === null)
            throw new globalThis.Error("The parameter 'interventionModuleId' must be defined.");
        url_ = url_.replace("{interventionModuleId}", encodeURIComponent("" + interventionModuleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUnpublishInterventionModule(_response);
        });
    }

    protected processUnpublishInterventionModule(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getInterventionModuleHistory(interventionModuleId: string, pageNumber?: number | undefined, pageSize?: number | undefined, from?: Date | null | undefined, until?: Date | null | undefined, userIds?: string[] | null | undefined, signal?: AbortSignal): Promise<PaginatedListOfHistoricalContentDto> {
        let url_ = this.baseUrl + "/api/v1/intervention-modules/{interventionModuleId}/history?";
        if (interventionModuleId === undefined || interventionModuleId === null)
            throw new globalThis.Error("The parameter 'interventionModuleId' must be defined.");
        url_ = url_.replace("{interventionModuleId}", encodeURIComponent("" + interventionModuleId));
        if (pageNumber === null)
            throw new globalThis.Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (from !== undefined && from !== null)
            url_ += "from=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (until !== undefined && until !== null)
            url_ += "until=" + encodeURIComponent(until ? "" + until.toISOString() : "") + "&";
        if (userIds !== undefined && userIds !== null)
            userIds && userIds.forEach(item => { url_ += "userIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetInterventionModuleHistory(_response);
        });
    }

    protected processGetInterventionModuleHistory(response: Response): Promise<PaginatedListOfHistoricalContentDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfHistoricalContentDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfHistoricalContentDto>(null as any);
    }

    getInterventionModuleHistoryDetails(interventionModuleId: string, interventionModuleVersion: number, signal?: AbortSignal): Promise<HistoricalContentDetailsDto> {
        let url_ = this.baseUrl + "/api/v1/intervention-modules/{interventionModuleId}/history/{interventionModuleVersion}";
        if (interventionModuleId === undefined || interventionModuleId === null)
            throw new globalThis.Error("The parameter 'interventionModuleId' must be defined.");
        url_ = url_.replace("{interventionModuleId}", encodeURIComponent("" + interventionModuleId));
        if (interventionModuleVersion === undefined || interventionModuleVersion === null)
            throw new globalThis.Error("The parameter 'interventionModuleVersion' must be defined.");
        url_ = url_.replace("{interventionModuleVersion}", encodeURIComponent("" + interventionModuleVersion));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetInterventionModuleHistoryDetails(_response);
        });
    }

    protected processGetInterventionModuleHistoryDetails(response: Response): Promise<HistoricalContentDetailsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HistoricalContentDetailsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HistoricalContentDetailsDto>(null as any);
    }

    /**
     * Returns a paginated list of intervention module instances, applying optional filtering, sorting, and search criteria.
     * @param pageNumber (optional) The page number (default: 1).
     * @param pageSize (optional) The number of items per page (default: 10).
     * @param sorting (optional) Optional sorting definitions.
     * @param search (optional) Optional search term.
     * @param from (optional) Optional start date for filtering.
     * @param until (optional) Optional end date for filtering.
     * @param projectIds (optional) Optional project IDs to filter by.
     * @param interventionModuleIds (optional) Optional intervention module IDs to filter by.
     * @param participantIds (optional) Optional participant IDs to filter by.
     * @param states (optional) Optional states to filter by.
     * @param showHidden (optional) Whether to include hidden instances (default: false).
     * @return A paginated list of intervention module instances.
     */
    getInterventionModuleInstances(pageNumber?: number | undefined, pageSize?: number | undefined, sorting?: SortingParameter[] | null | undefined, search?: string | null | undefined, from?: Date | null | undefined, until?: Date | null | undefined, projectIds?: string[] | null | undefined, interventionModuleIds?: string[] | null | undefined, participantIds?: string[] | null | undefined, states?: ContainerInstanceState[] | null | undefined, showHidden?: boolean | undefined, signal?: AbortSignal): Promise<PaginatedListOfInterventionModuleInstanceDto> {
        let url_ = this.baseUrl + "/api/v1/intervention-modules/instances?";
        if (pageNumber === null)
            throw new globalThis.Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sorting !== undefined && sorting !== null)
            sorting && sorting.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "sorting[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (from !== undefined && from !== null)
            url_ += "from=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (until !== undefined && until !== null)
            url_ += "until=" + encodeURIComponent(until ? "" + until.toISOString() : "") + "&";
        if (projectIds !== undefined && projectIds !== null)
            projectIds && projectIds.forEach(item => { url_ += "projectIds=" + encodeURIComponent("" + item) + "&"; });
        if (interventionModuleIds !== undefined && interventionModuleIds !== null)
            interventionModuleIds && interventionModuleIds.forEach(item => { url_ += "interventionModuleIds=" + encodeURIComponent("" + item) + "&"; });
        if (participantIds !== undefined && participantIds !== null)
            participantIds && participantIds.forEach(item => { url_ += "participantIds=" + encodeURIComponent("" + item) + "&"; });
        if (states !== undefined && states !== null)
            states && states.forEach(item => { url_ += "states=" + encodeURIComponent("" + item) + "&"; });
        if (showHidden === null)
            throw new globalThis.Error("The parameter 'showHidden' cannot be null.");
        else if (showHidden !== undefined)
            url_ += "showHidden=" + encodeURIComponent("" + showHidden) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetInterventionModuleInstances(_response);
        });
    }

    protected processGetInterventionModuleInstances(response: Response): Promise<PaginatedListOfInterventionModuleInstanceDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfInterventionModuleInstanceDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfInterventionModuleInstanceDto>(null as any);
    }

    /**
     * Hard-deletes a list of intervention module instances.
     * @param interventionModuleInstanceIds A list of unique identifiers for the intervention module instances to be deleted.
     * @return A task that represents the asynchronous operation. No content is returned.
     */
    deleteInterventionModuleInstances(interventionModuleInstanceIds: string[], signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/intervention-modules/instances?";
        if (interventionModuleInstanceIds === undefined || interventionModuleInstanceIds === null)
            throw new globalThis.Error("The parameter 'interventionModuleInstanceIds' must be defined and cannot be null.");
        else
            interventionModuleInstanceIds && interventionModuleInstanceIds.forEach(item => { url_ += "interventionModuleInstanceIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteInterventionModuleInstances(_response);
        });
    }

    protected processDeleteInterventionModuleInstances(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Retrieves the details of a specific intervention module instance.
     * @param interventionModuleInstanceId The unique identifier of the intervention module instance to retrieve.
     * @return The details of the specified intervention module instance.
     */
    getInterventionModuleInstance(interventionModuleInstanceId: string, signal?: AbortSignal): Promise<InterventionModuleInstanceDetailsDto> {
        let url_ = this.baseUrl + "/api/v1/intervention-modules/instances/{interventionModuleInstanceId}";
        if (interventionModuleInstanceId === undefined || interventionModuleInstanceId === null)
            throw new globalThis.Error("The parameter 'interventionModuleInstanceId' must be defined.");
        url_ = url_.replace("{interventionModuleInstanceId}", encodeURIComponent("" + interventionModuleInstanceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetInterventionModuleInstance(_response);
        });
    }

    protected processGetInterventionModuleInstance(response: Response): Promise<InterventionModuleInstanceDetailsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InterventionModuleInstanceDetailsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InterventionModuleInstanceDetailsDto>(null as any);
    }

    /**
     * Exports intervention module instances as a downloadable file.
     * @param interventionModuleId ID of the intervention module whose instances are exported.
     * @param interventionModuleInstanceIds (optional) Optional filter for specific instance IDs.
     * @param states (optional) Optional filter for instance states.
     * @param from (optional) Optional start date for filtering instances.
     * @param until (optional) Optional end date for filtering instances.
     * @param includeExecutionInfo (optional) Whether to include execution details in the export.
     * @param format (optional) Optional export file format (e.g. xlsx or csv). Defaults to Xlsx.
     * @return A file containing the exported intervention module instances in the selected format.
     */
    exportInterventionModuleInstances(interventionModuleId: string, interventionModuleInstanceIds?: string[] | null | undefined, states?: ContainerInstanceState[] | null | undefined, from?: Date | null | undefined, until?: Date | null | undefined, includeExecutionInfo?: boolean | undefined, format?: ExportFileFormatParameter | undefined, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/intervention-modules/{interventionModuleId}/instances/export?";
        if (interventionModuleId === undefined || interventionModuleId === null)
            throw new globalThis.Error("The parameter 'interventionModuleId' must be defined.");
        url_ = url_.replace("{interventionModuleId}", encodeURIComponent("" + interventionModuleId));
        if (interventionModuleInstanceIds !== undefined && interventionModuleInstanceIds !== null)
            interventionModuleInstanceIds && interventionModuleInstanceIds.forEach(item => { url_ += "interventionModuleInstanceIds=" + encodeURIComponent("" + item) + "&"; });
        if (states !== undefined && states !== null)
            states && states.forEach(item => { url_ += "states=" + encodeURIComponent("" + item) + "&"; });
        if (from !== undefined && from !== null)
            url_ += "from=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (until !== undefined && until !== null)
            url_ += "until=" + encodeURIComponent(until ? "" + until.toISOString() : "") + "&";
        if (includeExecutionInfo === null)
            throw new globalThis.Error("The parameter 'includeExecutionInfo' cannot be null.");
        else if (includeExecutionInfo !== undefined)
            url_ += "includeExecutionInfo=" + encodeURIComponent("" + includeExecutionInfo) + "&";
        if (format === null)
            throw new globalThis.Error("The parameter 'format' cannot be null.");
        else if (format !== undefined)
            url_ += "format=" + encodeURIComponent("" + format) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processExportInterventionModuleInstances(_response);
        });
    }

    protected processExportInterventionModuleInstances(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Soft-deletes a collection of intervention module instances by marking them as hidden in the system.
     * @param interventionModuleInstanceIds A list of unique identifiers for the intervention module instances to hide.
     * @return A task representing the asynchronous operation. No content is returned.
     */
    hideInterventionModuleInstances(interventionModuleInstanceIds: string[], signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/intervention-modules/instances/hide?";
        if (interventionModuleInstanceIds === undefined || interventionModuleInstanceIds === null)
            throw new globalThis.Error("The parameter 'interventionModuleInstanceIds' must be defined and cannot be null.");
        else
            interventionModuleInstanceIds && interventionModuleInstanceIds.forEach(item => { url_ += "interventionModuleInstanceIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHideInterventionModuleInstances(_response);
        });
    }

    protected processHideInterventionModuleInstances(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class LanguagesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getLanguages(pageNumber?: number | undefined, pageSize?: number | undefined, sorting?: SortingParameter[] | null | undefined, search?: string | null | undefined, signal?: AbortSignal): Promise<PaginatedListOfTenantLanguageDto> {
        let url_ = this.baseUrl + "/api/v1/languages?";
        if (pageNumber === null)
            throw new globalThis.Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sorting !== undefined && sorting !== null)
            sorting && sorting.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "sorting[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLanguages(_response);
        });
    }

    protected processGetLanguages(response: Response): Promise<PaginatedListOfTenantLanguageDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfTenantLanguageDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfTenantLanguageDto>(null as any);
    }

    createLanguage(command: CreateLanguageCommand, signal?: AbortSignal): Promise<TenantLanguageDto> {
        let url_ = this.baseUrl + "/api/v1/languages";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateLanguage(_response);
        });
    }

    protected processCreateLanguage(response: Response): Promise<TenantLanguageDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantLanguageDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TenantLanguageDto>(null as any);
    }

    getLanguage(languageId: string, signal?: AbortSignal): Promise<TenantLanguageDto> {
        let url_ = this.baseUrl + "/api/v1/languages/{languageId}";
        if (languageId === undefined || languageId === null)
            throw new globalThis.Error("The parameter 'languageId' must be defined.");
        url_ = url_.replace("{languageId}", encodeURIComponent("" + languageId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLanguage(_response);
        });
    }

    protected processGetLanguage(response: Response): Promise<TenantLanguageDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantLanguageDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TenantLanguageDto>(null as any);
    }

    updateLanguage(languageId: string, command: UpdateLanguageCommand, signal?: AbortSignal): Promise<TenantLanguageDto> {
        let url_ = this.baseUrl + "/api/v1/languages/{languageId}";
        if (languageId === undefined || languageId === null)
            throw new globalThis.Error("The parameter 'languageId' must be defined.");
        url_ = url_.replace("{languageId}", encodeURIComponent("" + languageId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateLanguage(_response);
        });
    }

    protected processUpdateLanguage(response: Response): Promise<TenantLanguageDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantLanguageDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TenantLanguageDto>(null as any);
    }

    deleteLanguage(languageId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/languages/{languageId}";
        if (languageId === undefined || languageId === null)
            throw new globalThis.Error("The parameter 'languageId' must be defined.");
        url_ = url_.replace("{languageId}", encodeURIComponent("" + languageId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteLanguage(_response);
        });
    }

    protected processDeleteLanguage(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getDefaultLanguage(signal?: AbortSignal): Promise<TenantLanguageDto> {
        let url_ = this.baseUrl + "/api/v1/languages/default";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDefaultLanguage(_response);
        });
    }

    protected processGetDefaultLanguage(response: Response): Promise<TenantLanguageDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantLanguageDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TenantLanguageDto>(null as any);
    }

    setDefaultLanguage(command: SetDefaultLanguageCommand, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/languages/default";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetDefaultLanguage(_response);
        });
    }

    protected processSetDefaultLanguage(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    translate(command: TranslateCommand, signal?: AbortSignal): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/languages/translate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTranslate(_response);
        });
    }

    protected processTranslate(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class LicensesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getLicenses(pageNumber?: number | undefined, pageSize?: number | undefined, sorting?: SortingParameter[] | null | undefined, search?: string | null | undefined, showHidden?: boolean | undefined, signal?: AbortSignal): Promise<PaginatedListOfLicenseDto> {
        let url_ = this.baseUrl + "/api/v1/licenses?";
        if (pageNumber === null)
            throw new globalThis.Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sorting !== undefined && sorting !== null)
            sorting && sorting.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "sorting[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (showHidden === null)
            throw new globalThis.Error("The parameter 'showHidden' cannot be null.");
        else if (showHidden !== undefined)
            url_ += "showHidden=" + encodeURIComponent("" + showHidden) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLicenses(_response);
        });
    }

    protected processGetLicenses(response: Response): Promise<PaginatedListOfLicenseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfLicenseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfLicenseDto>(null as any);
    }

    createLicense(command: CreateLicenseCommand, signal?: AbortSignal): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/licenses";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateLicense(_response);
        });
    }

    protected processCreateLicense(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    getLicense(licenseId: string, signal?: AbortSignal): Promise<LicenseDto> {
        let url_ = this.baseUrl + "/api/v1/licenses/{licenseId}";
        if (licenseId === undefined || licenseId === null)
            throw new globalThis.Error("The parameter 'licenseId' must be defined.");
        url_ = url_.replace("{licenseId}", encodeURIComponent("" + licenseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLicense(_response);
        });
    }

    protected processGetLicense(response: Response): Promise<LicenseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LicenseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LicenseDto>(null as any);
    }

    updateLicense(licenseId: string, command: UpdateLicenseCommand, signal?: AbortSignal): Promise<LicenseDto> {
        let url_ = this.baseUrl + "/api/v1/licenses/{licenseId}";
        if (licenseId === undefined || licenseId === null)
            throw new globalThis.Error("The parameter 'licenseId' must be defined.");
        url_ = url_.replace("{licenseId}", encodeURIComponent("" + licenseId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateLicense(_response);
        });
    }

    protected processUpdateLicense(response: Response): Promise<LicenseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LicenseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LicenseDto>(null as any);
    }

    deleteLicense(licenseId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/licenses/{licenseId}";
        if (licenseId === undefined || licenseId === null)
            throw new globalThis.Error("The parameter 'licenseId' must be defined.");
        url_ = url_.replace("{licenseId}", encodeURIComponent("" + licenseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteLicense(_response);
        });
    }

    protected processDeleteLicense(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    hideLicense(licenseId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/licenses/{licenseId}/hide";
        if (licenseId === undefined || licenseId === null)
            throw new globalThis.Error("The parameter 'licenseId' must be defined.");
        url_ = url_.replace("{licenseId}", encodeURIComponent("" + licenseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHideLicense(_response);
        });
    }

    protected processHideLicense(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    exportLicenses(format: ExportFileFormatParameter, licenseIds?: string[] | null | undefined, fromValidity?: Date | null | undefined, untilValidity?: Date | null | undefined, includeMetadata?: boolean | undefined, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/licenses/export?";
        if (format === undefined || format === null)
            throw new globalThis.Error("The parameter 'format' must be defined and cannot be null.");
        else
            url_ += "format=" + encodeURIComponent("" + format) + "&";
        if (licenseIds !== undefined && licenseIds !== null)
            licenseIds && licenseIds.forEach(item => { url_ += "licenseIds=" + encodeURIComponent("" + item) + "&"; });
        if (fromValidity !== undefined && fromValidity !== null)
            url_ += "fromValidity=" + encodeURIComponent(fromValidity ? "" + fromValidity.toISOString() : "") + "&";
        if (untilValidity !== undefined && untilValidity !== null)
            url_ += "untilValidity=" + encodeURIComponent(untilValidity ? "" + untilValidity.toISOString() : "") + "&";
        if (includeMetadata === null)
            throw new globalThis.Error("The parameter 'includeMetadata' cannot be null.");
        else if (includeMetadata !== undefined)
            url_ += "includeMetadata=" + encodeURIComponent("" + includeMetadata) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processExportLicenses(_response);
        });
    }

    protected processExportLicenses(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getLicenseInstances(licenseId: string, pageNumber?: number | undefined, pageSize?: number | undefined, sorting?: SortingParameter[] | null | undefined, search?: string | null | undefined, showHidden?: boolean | undefined, signal?: AbortSignal): Promise<PaginatedListOfLicenseInstanceDto> {
        let url_ = this.baseUrl + "/api/v1/licenses/{licenseId}/instances?";
        if (licenseId === undefined || licenseId === null)
            throw new globalThis.Error("The parameter 'licenseId' must be defined.");
        url_ = url_.replace("{licenseId}", encodeURIComponent("" + licenseId));
        if (pageNumber === null)
            throw new globalThis.Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sorting !== undefined && sorting !== null)
            sorting && sorting.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "sorting[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (showHidden === null)
            throw new globalThis.Error("The parameter 'showHidden' cannot be null.");
        else if (showHidden !== undefined)
            url_ += "showHidden=" + encodeURIComponent("" + showHidden) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLicenseInstances(_response);
        });
    }

    protected processGetLicenseInstances(response: Response): Promise<PaginatedListOfLicenseInstanceDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfLicenseInstanceDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfLicenseInstanceDto>(null as any);
    }

    createLicenseInstances(licenseId: string, command: CreateLicenseInstancesCommand, signal?: AbortSignal): Promise<string[]> {
        let url_ = this.baseUrl + "/api/v1/licenses/{licenseId}/instances";
        if (licenseId === undefined || licenseId === null)
            throw new globalThis.Error("The parameter 'licenseId' must be defined.");
        url_ = url_.replace("{licenseId}", encodeURIComponent("" + licenseId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateLicenseInstances(_response);
        });
    }

    protected processCreateLicenseInstances(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    updateLicenseInstance(licenseId: string, licenseInstanceId: string, command: UpdateLicenseInstanceCommand, signal?: AbortSignal): Promise<LicenseInstanceDto> {
        let url_ = this.baseUrl + "/api/v1/licenses/{licenseId}/instances/{licenseInstanceId}";
        if (licenseId === undefined || licenseId === null)
            throw new globalThis.Error("The parameter 'licenseId' must be defined.");
        url_ = url_.replace("{licenseId}", encodeURIComponent("" + licenseId));
        if (licenseInstanceId === undefined || licenseInstanceId === null)
            throw new globalThis.Error("The parameter 'licenseInstanceId' must be defined.");
        url_ = url_.replace("{licenseInstanceId}", encodeURIComponent("" + licenseInstanceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateLicenseInstance(_response);
        });
    }

    protected processUpdateLicenseInstance(response: Response): Promise<LicenseInstanceDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LicenseInstanceDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LicenseInstanceDto>(null as any);
    }

    hideLicenseInstances(licenseInstanceIds: string[], signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/licenses/instances/hide?";
        if (licenseInstanceIds === undefined || licenseInstanceIds === null)
            throw new globalThis.Error("The parameter 'licenseInstanceIds' must be defined and cannot be null.");
        else
            licenseInstanceIds && licenseInstanceIds.forEach(item => { url_ += "licenseInstanceIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHideLicenseInstances(_response);
        });
    }

    protected processHideLicenseInstances(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    deleteLicenseInstances(licenseInstanceIds: string[], signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/licenses/instances?";
        if (licenseInstanceIds === undefined || licenseInstanceIds === null)
            throw new globalThis.Error("The parameter 'licenseInstanceIds' must be defined and cannot be null.");
        else
            licenseInstanceIds && licenseInstanceIds.forEach(item => { url_ += "licenseInstanceIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteLicenseInstances(_response);
        });
    }

    protected processDeleteLicenseInstances(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    exportLicenseInstances(licenseId: string, format?: ExportFileFormatParameter | undefined, licenseInstanceIds?: string[] | null | undefined, fromValidity?: Date | null | undefined, untilValidity?: Date | null | undefined, includeActivated?: boolean | undefined, includeRevoked?: boolean | undefined, includeHidden?: boolean | undefined, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/licenses/{licenseId}/instances/export?";
        if (licenseId === undefined || licenseId === null)
            throw new globalThis.Error("The parameter 'licenseId' must be defined.");
        url_ = url_.replace("{licenseId}", encodeURIComponent("" + licenseId));
        if (format === null)
            throw new globalThis.Error("The parameter 'format' cannot be null.");
        else if (format !== undefined)
            url_ += "format=" + encodeURIComponent("" + format) + "&";
        if (licenseInstanceIds !== undefined && licenseInstanceIds !== null)
            licenseInstanceIds && licenseInstanceIds.forEach(item => { url_ += "licenseInstanceIds=" + encodeURIComponent("" + item) + "&"; });
        if (fromValidity !== undefined && fromValidity !== null)
            url_ += "fromValidity=" + encodeURIComponent(fromValidity ? "" + fromValidity.toISOString() : "") + "&";
        if (untilValidity !== undefined && untilValidity !== null)
            url_ += "untilValidity=" + encodeURIComponent(untilValidity ? "" + untilValidity.toISOString() : "") + "&";
        if (includeActivated === null)
            throw new globalThis.Error("The parameter 'includeActivated' cannot be null.");
        else if (includeActivated !== undefined)
            url_ += "includeActivated=" + encodeURIComponent("" + includeActivated) + "&";
        if (includeRevoked === null)
            throw new globalThis.Error("The parameter 'includeRevoked' cannot be null.");
        else if (includeRevoked !== undefined)
            url_ += "includeRevoked=" + encodeURIComponent("" + includeRevoked) + "&";
        if (includeHidden === null)
            throw new globalThis.Error("The parameter 'includeHidden' cannot be null.");
        else if (includeHidden !== undefined)
            url_ += "includeHidden=" + encodeURIComponent("" + includeHidden) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processExportLicenseInstances(_response);
        });
    }

    protected processExportLicenseInstances(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class QuestionnairesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getContents(limit?: number | undefined, search?: string | null | undefined, types?: ElementType[] | null | undefined, excludeTypes?: ElementType[] | null | undefined, projectIds?: string[] | null | undefined, containerIds?: string[] | null | undefined, excludeContainerIds?: string[] | null | undefined, contentIds?: string[] | null | undefined, signal?: AbortSignal): Promise<ContentDto[]> {
        let url_ = this.baseUrl + "/api/v1/questionnaires/contents?";
        if (limit === null)
            throw new globalThis.Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (types !== undefined && types !== null)
            types && types.forEach(item => { url_ += "types=" + encodeURIComponent("" + item) + "&"; });
        if (excludeTypes !== undefined && excludeTypes !== null)
            excludeTypes && excludeTypes.forEach(item => { url_ += "excludeTypes=" + encodeURIComponent("" + item) + "&"; });
        if (projectIds !== undefined && projectIds !== null)
            projectIds && projectIds.forEach(item => { url_ += "projectIds=" + encodeURIComponent("" + item) + "&"; });
        if (containerIds !== undefined && containerIds !== null)
            containerIds && containerIds.forEach(item => { url_ += "containerIds=" + encodeURIComponent("" + item) + "&"; });
        if (excludeContainerIds !== undefined && excludeContainerIds !== null)
            excludeContainerIds && excludeContainerIds.forEach(item => { url_ += "excludeContainerIds=" + encodeURIComponent("" + item) + "&"; });
        if (contentIds !== undefined && contentIds !== null)
            contentIds && contentIds.forEach(item => { url_ += "contentIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetContents(_response);
        });
    }

    protected processGetContents(response: Response): Promise<ContentDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ContentDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ContentDto[]>(null as any);
    }

    getQuestionnaires(pageNumber?: number | undefined, pageSize?: number | undefined, sorting?: SortingParameter[] | null | undefined, search?: string | null | undefined, projectIds?: string[] | null | undefined, showHidden?: boolean | undefined, signal?: AbortSignal): Promise<PaginatedListOfQuestionnaireDto> {
        let url_ = this.baseUrl + "/api/v1/questionnaires?";
        if (pageNumber === null)
            throw new globalThis.Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sorting !== undefined && sorting !== null)
            sorting && sorting.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "sorting[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (projectIds !== undefined && projectIds !== null)
            projectIds && projectIds.forEach(item => { url_ += "projectIds=" + encodeURIComponent("" + item) + "&"; });
        if (showHidden === null)
            throw new globalThis.Error("The parameter 'showHidden' cannot be null.");
        else if (showHidden !== undefined)
            url_ += "showHidden=" + encodeURIComponent("" + showHidden) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetQuestionnaires(_response);
        });
    }

    protected processGetQuestionnaires(response: Response): Promise<PaginatedListOfQuestionnaireDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfQuestionnaireDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfQuestionnaireDto>(null as any);
    }

    createQuestionnaire(command: CreateQuestionnaireCommand, signal?: AbortSignal): Promise<QuestionnaireDto> {
        let url_ = this.baseUrl + "/api/v1/questionnaires";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateQuestionnaire(_response);
        });
    }

    protected processCreateQuestionnaire(response: Response): Promise<QuestionnaireDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QuestionnaireDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QuestionnaireDto>(null as any);
    }

    getQuestionnaire(questionnaireId: string, signal?: AbortSignal): Promise<QuestionnaireDetailsDto> {
        let url_ = this.baseUrl + "/api/v1/questionnaires/{questionnaireId}";
        if (questionnaireId === undefined || questionnaireId === null)
            throw new globalThis.Error("The parameter 'questionnaireId' must be defined.");
        url_ = url_.replace("{questionnaireId}", encodeURIComponent("" + questionnaireId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetQuestionnaire(_response);
        });
    }

    protected processGetQuestionnaire(response: Response): Promise<QuestionnaireDetailsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QuestionnaireDetailsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QuestionnaireDetailsDto>(null as any);
    }

    updateQuestionnaire(questionnaireId: string, command: UpdateQuestionnaireCommand, signal?: AbortSignal): Promise<QuestionnaireDetailsDto> {
        let url_ = this.baseUrl + "/api/v1/questionnaires/{questionnaireId}";
        if (questionnaireId === undefined || questionnaireId === null)
            throw new globalThis.Error("The parameter 'questionnaireId' must be defined.");
        url_ = url_.replace("{questionnaireId}", encodeURIComponent("" + questionnaireId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateQuestionnaire(_response);
        });
    }

    protected processUpdateQuestionnaire(response: Response): Promise<QuestionnaireDetailsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QuestionnaireDetailsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QuestionnaireDetailsDto>(null as any);
    }

    deleteQuestionnaire(questionnaireId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/questionnaires/{questionnaireId}";
        if (questionnaireId === undefined || questionnaireId === null)
            throw new globalThis.Error("The parameter 'questionnaireId' must be defined.");
        url_ = url_.replace("{questionnaireId}", encodeURIComponent("" + questionnaireId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteQuestionnaire(_response);
        });
    }

    protected processDeleteQuestionnaire(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    translateQuestionnaire(questionnaireId: string, command: TranslateQuestionnaireCommand, signal?: AbortSignal): Promise<QuestionnaireDetailsDto> {
        let url_ = this.baseUrl + "/api/v1/questionnaires/{questionnaireId}/translate";
        if (questionnaireId === undefined || questionnaireId === null)
            throw new globalThis.Error("The parameter 'questionnaireId' must be defined.");
        url_ = url_.replace("{questionnaireId}", encodeURIComponent("" + questionnaireId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTranslateQuestionnaire(_response);
        });
    }

    protected processTranslateQuestionnaire(response: Response): Promise<QuestionnaireDetailsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QuestionnaireDetailsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QuestionnaireDetailsDto>(null as any);
    }

    hideQuestionnaire(questionnaireId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/questionnaires/{questionnaireId}/hide";
        if (questionnaireId === undefined || questionnaireId === null)
            throw new globalThis.Error("The parameter 'questionnaireId' must be defined.");
        url_ = url_.replace("{questionnaireId}", encodeURIComponent("" + questionnaireId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHideQuestionnaire(_response);
        });
    }

    protected processHideQuestionnaire(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    publishQuestionnaire(questionnaireId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/questionnaires/{questionnaireId}/publish";
        if (questionnaireId === undefined || questionnaireId === null)
            throw new globalThis.Error("The parameter 'questionnaireId' must be defined.");
        url_ = url_.replace("{questionnaireId}", encodeURIComponent("" + questionnaireId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPublishQuestionnaire(_response);
        });
    }

    protected processPublishQuestionnaire(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    unpublishQuestionnaire(questionnaireId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/questionnaires/{questionnaireId}/unpublish";
        if (questionnaireId === undefined || questionnaireId === null)
            throw new globalThis.Error("The parameter 'questionnaireId' must be defined.");
        url_ = url_.replace("{questionnaireId}", encodeURIComponent("" + questionnaireId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUnpublishQuestionnaire(_response);
        });
    }

    protected processUnpublishQuestionnaire(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getQuestionnaireHistory(questionnaireId: string, pageNumber?: number | undefined, pageSize?: number | undefined, from?: Date | null | undefined, until?: Date | null | undefined, userIds?: string[] | null | undefined, signal?: AbortSignal): Promise<PaginatedListOfHistoricalContentDto> {
        let url_ = this.baseUrl + "/api/v1/questionnaires/{questionnaireId}/history?";
        if (questionnaireId === undefined || questionnaireId === null)
            throw new globalThis.Error("The parameter 'questionnaireId' must be defined.");
        url_ = url_.replace("{questionnaireId}", encodeURIComponent("" + questionnaireId));
        if (pageNumber === null)
            throw new globalThis.Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (from !== undefined && from !== null)
            url_ += "from=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (until !== undefined && until !== null)
            url_ += "until=" + encodeURIComponent(until ? "" + until.toISOString() : "") + "&";
        if (userIds !== undefined && userIds !== null)
            userIds && userIds.forEach(item => { url_ += "userIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetQuestionnaireHistory(_response);
        });
    }

    protected processGetQuestionnaireHistory(response: Response): Promise<PaginatedListOfHistoricalContentDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfHistoricalContentDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfHistoricalContentDto>(null as any);
    }

    getQuestionnaireHistoryDetails(questionnaireId: string, questionnaireVersion: number, signal?: AbortSignal): Promise<HistoricalContentDetailsDto> {
        let url_ = this.baseUrl + "/api/v1/questionnaires/{questionnaireId}/history/{questionnaireVersion}";
        if (questionnaireId === undefined || questionnaireId === null)
            throw new globalThis.Error("The parameter 'questionnaireId' must be defined.");
        url_ = url_.replace("{questionnaireId}", encodeURIComponent("" + questionnaireId));
        if (questionnaireVersion === undefined || questionnaireVersion === null)
            throw new globalThis.Error("The parameter 'questionnaireVersion' must be defined.");
        url_ = url_.replace("{questionnaireVersion}", encodeURIComponent("" + questionnaireVersion));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetQuestionnaireHistoryDetails(_response);
        });
    }

    protected processGetQuestionnaireHistoryDetails(response: Response): Promise<HistoricalContentDetailsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HistoricalContentDetailsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HistoricalContentDetailsDto>(null as any);
    }

    getQuestionnaireInstances(pageNumber?: number | undefined, pageSize?: number | undefined, sorting?: SortingParameter[] | null | undefined, search?: string | null | undefined, from?: Date | null | undefined, until?: Date | null | undefined, projectIds?: string[] | null | undefined, questionnaireIds?: string[] | null | undefined, participantIds?: string[] | null | undefined, states?: ContainerInstanceState[] | null | undefined, showHidden?: boolean | undefined, signal?: AbortSignal): Promise<PaginatedListOfQuestionnaireInstanceDto> {
        let url_ = this.baseUrl + "/api/v1/questionnaires/instances?";
        if (pageNumber === null)
            throw new globalThis.Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sorting !== undefined && sorting !== null)
            sorting && sorting.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "sorting[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (from !== undefined && from !== null)
            url_ += "from=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (until !== undefined && until !== null)
            url_ += "until=" + encodeURIComponent(until ? "" + until.toISOString() : "") + "&";
        if (projectIds !== undefined && projectIds !== null)
            projectIds && projectIds.forEach(item => { url_ += "projectIds=" + encodeURIComponent("" + item) + "&"; });
        if (questionnaireIds !== undefined && questionnaireIds !== null)
            questionnaireIds && questionnaireIds.forEach(item => { url_ += "questionnaireIds=" + encodeURIComponent("" + item) + "&"; });
        if (participantIds !== undefined && participantIds !== null)
            participantIds && participantIds.forEach(item => { url_ += "participantIds=" + encodeURIComponent("" + item) + "&"; });
        if (states !== undefined && states !== null)
            states && states.forEach(item => { url_ += "states=" + encodeURIComponent("" + item) + "&"; });
        if (showHidden === null)
            throw new globalThis.Error("The parameter 'showHidden' cannot be null.");
        else if (showHidden !== undefined)
            url_ += "showHidden=" + encodeURIComponent("" + showHidden) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetQuestionnaireInstances(_response);
        });
    }

    protected processGetQuestionnaireInstances(response: Response): Promise<PaginatedListOfQuestionnaireInstanceDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfQuestionnaireInstanceDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfQuestionnaireInstanceDto>(null as any);
    }

    deleteQuestionnaireInstances(questionnaireInstanceIds: string[], signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/questionnaires/instances?";
        if (questionnaireInstanceIds === undefined || questionnaireInstanceIds === null)
            throw new globalThis.Error("The parameter 'questionnaireInstanceIds' must be defined and cannot be null.");
        else
            questionnaireInstanceIds && questionnaireInstanceIds.forEach(item => { url_ += "questionnaireInstanceIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteQuestionnaireInstances(_response);
        });
    }

    protected processDeleteQuestionnaireInstances(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getQuestionnaireInstance(questionnaireInstanceId: string, signal?: AbortSignal): Promise<QuestionnaireInstanceDetailsDto> {
        let url_ = this.baseUrl + "/api/v1/questionnaires/instances/{questionnaireInstanceId}";
        if (questionnaireInstanceId === undefined || questionnaireInstanceId === null)
            throw new globalThis.Error("The parameter 'questionnaireInstanceId' must be defined.");
        url_ = url_.replace("{questionnaireInstanceId}", encodeURIComponent("" + questionnaireInstanceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetQuestionnaireInstance(_response);
        });
    }

    protected processGetQuestionnaireInstance(response: Response): Promise<QuestionnaireInstanceDetailsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QuestionnaireInstanceDetailsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QuestionnaireInstanceDetailsDto>(null as any);
    }

    exportQuestionnaireInstances(questionnaireId: string, questionnaireInstanceIds?: string[] | null | undefined, states?: ContainerInstanceState[] | null | undefined, from?: Date | null | undefined, until?: Date | null | undefined, includeExecutionInfo?: boolean | undefined, format?: ExportFileFormatParameter | undefined, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/questionnaires/{questionnaireId}/instances/export?";
        if (questionnaireId === undefined || questionnaireId === null)
            throw new globalThis.Error("The parameter 'questionnaireId' must be defined.");
        url_ = url_.replace("{questionnaireId}", encodeURIComponent("" + questionnaireId));
        if (questionnaireInstanceIds !== undefined && questionnaireInstanceIds !== null)
            questionnaireInstanceIds && questionnaireInstanceIds.forEach(item => { url_ += "questionnaireInstanceIds=" + encodeURIComponent("" + item) + "&"; });
        if (states !== undefined && states !== null)
            states && states.forEach(item => { url_ += "states=" + encodeURIComponent("" + item) + "&"; });
        if (from !== undefined && from !== null)
            url_ += "from=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (until !== undefined && until !== null)
            url_ += "until=" + encodeURIComponent(until ? "" + until.toISOString() : "") + "&";
        if (includeExecutionInfo === null)
            throw new globalThis.Error("The parameter 'includeExecutionInfo' cannot be null.");
        else if (includeExecutionInfo !== undefined)
            url_ += "includeExecutionInfo=" + encodeURIComponent("" + includeExecutionInfo) + "&";
        if (format === null)
            throw new globalThis.Error("The parameter 'format' cannot be null.");
        else if (format !== undefined)
            url_ += "format=" + encodeURIComponent("" + format) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processExportQuestionnaireInstances(_response);
        });
    }

    protected processExportQuestionnaireInstances(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    hideQuestionnaireInstances(questionnaireInstanceIds: string[], signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/questionnaires/instances/hide?";
        if (questionnaireInstanceIds === undefined || questionnaireInstanceIds === null)
            throw new globalThis.Error("The parameter 'questionnaireInstanceIds' must be defined and cannot be null.");
        else
            questionnaireInstanceIds && questionnaireInstanceIds.forEach(item => { url_ += "questionnaireInstanceIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHideQuestionnaireInstances(_response);
        });
    }

    protected processHideQuestionnaireInstances(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class SchedulesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getSchedules(pageNumber?: number | undefined, pageSize?: number | undefined, sorting?: SortingParameter[] | null | undefined, search?: string | null | undefined, projectIds?: string[] | null | undefined, signal?: AbortSignal): Promise<PaginatedListOfScheduleDto> {
        let url_ = this.baseUrl + "/api/v1/schedules?";
        if (pageNumber === null)
            throw new globalThis.Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sorting !== undefined && sorting !== null)
            sorting && sorting.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "sorting[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (projectIds !== undefined && projectIds !== null)
            projectIds && projectIds.forEach(item => { url_ += "projectIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSchedules(_response);
        });
    }

    protected processGetSchedules(response: Response): Promise<PaginatedListOfScheduleDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfScheduleDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfScheduleDto>(null as any);
    }

    createSchedule(command: CreateScheduleCommand, signal?: AbortSignal): Promise<ScheduleDto> {
        let url_ = this.baseUrl + "/api/v1/schedules";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateSchedule(_response);
        });
    }

    protected processCreateSchedule(response: Response): Promise<ScheduleDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScheduleDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ScheduleDto>(null as any);
    }

    getSchedule(scheduleId: string, signal?: AbortSignal): Promise<ScheduleDetailsDto> {
        let url_ = this.baseUrl + "/api/v1/schedules/{scheduleId}";
        if (scheduleId === undefined || scheduleId === null)
            throw new globalThis.Error("The parameter 'scheduleId' must be defined.");
        url_ = url_.replace("{scheduleId}", encodeURIComponent("" + scheduleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSchedule(_response);
        });
    }

    protected processGetSchedule(response: Response): Promise<ScheduleDetailsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScheduleDetailsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ScheduleDetailsDto>(null as any);
    }

    updateSchedule(scheduleId: string, command: UpdateScheduleCommand, signal?: AbortSignal): Promise<ScheduleDetailsDto> {
        let url_ = this.baseUrl + "/api/v1/schedules/{scheduleId}";
        if (scheduleId === undefined || scheduleId === null)
            throw new globalThis.Error("The parameter 'scheduleId' must be defined.");
        url_ = url_.replace("{scheduleId}", encodeURIComponent("" + scheduleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateSchedule(_response);
        });
    }

    protected processUpdateSchedule(response: Response): Promise<ScheduleDetailsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScheduleDetailsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ScheduleDetailsDto>(null as any);
    }

    deleteSchedule(scheduleId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/schedules/{scheduleId}";
        if (scheduleId === undefined || scheduleId === null)
            throw new globalThis.Error("The parameter 'scheduleId' must be defined.");
        url_ = url_.replace("{scheduleId}", encodeURIComponent("" + scheduleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteSchedule(_response);
        });
    }

    protected processDeleteSchedule(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    activateSchedule(scheduleId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/schedules/{scheduleId}/activate";
        if (scheduleId === undefined || scheduleId === null)
            throw new globalThis.Error("The parameter 'scheduleId' must be defined.");
        url_ = url_.replace("{scheduleId}", encodeURIComponent("" + scheduleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processActivateSchedule(_response);
        });
    }

    protected processActivateSchedule(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    deactivateSchedule(scheduleId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/schedules/{scheduleId}/deactivate";
        if (scheduleId === undefined || scheduleId === null)
            throw new globalThis.Error("The parameter 'scheduleId' must be defined.");
        url_ = url_.replace("{scheduleId}", encodeURIComponent("" + scheduleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeactivateSchedule(_response);
        });
    }

    protected processDeactivateSchedule(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class StatisticsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getStudyStatistics(projectIds?: string[] | null | undefined, signal?: AbortSignal): Promise<StudyStatisticsDto> {
        let url_ = this.baseUrl + "/api/v1/statistics/studies?";
        if (projectIds !== undefined && projectIds !== null)
            projectIds && projectIds.forEach(item => { url_ += "projectIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetStudyStatistics(_response);
        });
    }

    protected processGetStudyStatistics(response: Response): Promise<StudyStatisticsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StudyStatisticsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StudyStatisticsDto>(null as any);
    }

    getQuestionnaireStatistics(projectIds?: string[] | null | undefined, questionnaireIds?: string[] | null | undefined, signal?: AbortSignal): Promise<QuestionnaireStatisticsDto> {
        let url_ = this.baseUrl + "/api/v1/statistics/questionnaires?";
        if (projectIds !== undefined && projectIds !== null)
            projectIds && projectIds.forEach(item => { url_ += "projectIds=" + encodeURIComponent("" + item) + "&"; });
        if (questionnaireIds !== undefined && questionnaireIds !== null)
            questionnaireIds && questionnaireIds.forEach(item => { url_ += "questionnaireIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetQuestionnaireStatistics(_response);
        });
    }

    protected processGetQuestionnaireStatistics(response: Response): Promise<QuestionnaireStatisticsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QuestionnaireStatisticsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QuestionnaireStatisticsDto>(null as any);
    }

    getParticipantStatistics(projectIds?: string[] | null | undefined, participantIds?: string[] | null | undefined, signal?: AbortSignal): Promise<ParticipantStatisticsDto> {
        let url_ = this.baseUrl + "/api/v1/statistics/participants?";
        if (projectIds !== undefined && projectIds !== null)
            projectIds && projectIds.forEach(item => { url_ += "projectIds=" + encodeURIComponent("" + item) + "&"; });
        if (participantIds !== undefined && participantIds !== null)
            participantIds && participantIds.forEach(item => { url_ += "participantIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetParticipantStatistics(_response);
        });
    }

    protected processGetParticipantStatistics(response: Response): Promise<ParticipantStatisticsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ParticipantStatisticsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ParticipantStatisticsDto>(null as any);
    }

    getQuestionnaireInstanceStatistics(query: GetQuestionnaireInstanceStatisticsQuery, signal?: AbortSignal): Promise<QuestionnaireInstanceStatisticsDto> {
        let url_ = this.baseUrl + "/api/v1/statistics/questionnaire-instances";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetQuestionnaireInstanceStatistics(_response);
        });
    }

    protected processGetQuestionnaireInstanceStatistics(response: Response): Promise<QuestionnaireInstanceStatisticsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QuestionnaireInstanceStatisticsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QuestionnaireInstanceStatisticsDto>(null as any);
    }

    getQuestionStatistics(query: GetQuestionStatisticsQuery, signal?: AbortSignal): Promise<QuestionStatisticsDto> {
        let url_ = this.baseUrl + "/api/v1/statistics/questions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetQuestionStatistics(_response);
        });
    }

    protected processGetQuestionStatistics(response: Response): Promise<QuestionStatisticsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QuestionStatisticsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QuestionStatisticsDto>(null as any);
    }
}

export class StudiesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getStudies(pageNumber?: number | undefined, pageSize?: number | undefined, sorting?: SortingParameter[] | null | undefined, search?: string | null | undefined, signal?: AbortSignal): Promise<PaginatedListOfStudyDto> {
        let url_ = this.baseUrl + "/api/v1/studies?";
        if (pageNumber === null)
            throw new globalThis.Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sorting !== undefined && sorting !== null)
            sorting && sorting.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "sorting[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetStudies(_response);
        });
    }

    protected processGetStudies(response: Response): Promise<PaginatedListOfStudyDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfStudyDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfStudyDto>(null as any);
    }

    createStudy(command: CreateStudyCommand, signal?: AbortSignal): Promise<StudyDto> {
        let url_ = this.baseUrl + "/api/v1/studies";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateStudy(_response);
        });
    }

    protected processCreateStudy(response: Response): Promise<StudyDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StudyDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StudyDto>(null as any);
    }

    getStudy(studyId: string, signal?: AbortSignal): Promise<StudyDetailsDto> {
        let url_ = this.baseUrl + "/api/v1/studies/{studyId}";
        if (studyId === undefined || studyId === null)
            throw new globalThis.Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetStudy(_response);
        });
    }

    protected processGetStudy(response: Response): Promise<StudyDetailsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StudyDetailsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StudyDetailsDto>(null as any);
    }

    updateStudy(studyId: string, command: UpdateStudyCommand, signal?: AbortSignal): Promise<StudyDetailsDto> {
        let url_ = this.baseUrl + "/api/v1/studies/{studyId}";
        if (studyId === undefined || studyId === null)
            throw new globalThis.Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateStudy(_response);
        });
    }

    protected processUpdateStudy(response: Response): Promise<StudyDetailsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StudyDetailsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StudyDetailsDto>(null as any);
    }

    deleteStudy(studyId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/studies/{studyId}";
        if (studyId === undefined || studyId === null)
            throw new globalThis.Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteStudy(_response);
        });
    }

    protected processDeleteStudy(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    publishStudy(studyId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/studies/{studyId}/publish";
        if (studyId === undefined || studyId === null)
            throw new globalThis.Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPublishStudy(_response);
        });
    }

    protected processPublishStudy(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    unpublishStudy(studyId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/studies/{studyId}/unpublish";
        if (studyId === undefined || studyId === null)
            throw new globalThis.Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUnpublishStudy(_response);
        });
    }

    protected processUnpublishStudy(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    generateJoinParticipantGroupQrCode(studyId: string, participantGroupId: string, appId: string, signal?: AbortSignal): Promise<QrCodeDto> {
        let url_ = this.baseUrl + "/api/v1/studies/{studyId}/use-join-group-qr-code?";
        if (studyId === undefined || studyId === null)
            throw new globalThis.Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        if (participantGroupId === undefined || participantGroupId === null)
            throw new globalThis.Error("The parameter 'participantGroupId' must be defined and cannot be null.");
        else
            url_ += "participantGroupId=" + encodeURIComponent("" + participantGroupId) + "&";
        if (appId === undefined || appId === null)
            throw new globalThis.Error("The parameter 'appId' must be defined and cannot be null.");
        else
            url_ += "appId=" + encodeURIComponent("" + appId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGenerateJoinParticipantGroupQrCode(_response);
        });
    }

    protected processGenerateJoinParticipantGroupQrCode(response: Response): Promise<QrCodeDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QrCodeDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QrCodeDto>(null as any);
    }

    getParticipants(studyId: string, pageNumber?: number | undefined, pageSize?: number | undefined, sorting?: SortingParameter[] | null | undefined, search?: string | null | undefined, signal?: AbortSignal): Promise<PaginatedListOfProjectParticipantDto> {
        let url_ = this.baseUrl + "/api/v1/studies/{studyId}/participants?";
        if (studyId === undefined || studyId === null)
            throw new globalThis.Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        if (pageNumber === null)
            throw new globalThis.Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sorting !== undefined && sorting !== null)
            sorting && sorting.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "sorting[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetParticipants(_response);
        });
    }

    protected processGetParticipants(response: Response): Promise<PaginatedListOfProjectParticipantDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfProjectParticipantDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfProjectParticipantDto>(null as any);
    }

    exportParticipants(studyId: string, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/studies/{studyId}/participants/export";
        if (studyId === undefined || studyId === null)
            throw new globalThis.Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processExportParticipants(_response);
        });
    }

    protected processExportParticipants(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getParticipant(studyId: string, userId: string, signal?: AbortSignal): Promise<ProjectParticipantDto> {
        let url_ = this.baseUrl + "/api/v1/studies/{studyId}/participants/{userId}";
        if (studyId === undefined || studyId === null)
            throw new globalThis.Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetParticipant(_response);
        });
    }

    protected processGetParticipant(response: Response): Promise<ProjectParticipantDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectParticipantDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectParticipantDto>(null as any);
    }

    addParticipant(studyId: string, userId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/studies/{studyId}/participants/{userId}";
        if (studyId === undefined || studyId === null)
            throw new globalThis.Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddParticipant(_response);
        });
    }

    protected processAddParticipant(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getAssignedContainerGroups(studyId: string, userId: string, containerGroupType?: ContainerGroupType | null | undefined, signal?: AbortSignal): Promise<ContainerGroupDto[]> {
        let url_ = this.baseUrl + "/api/v1/studies/{studyId}/participants/{userId}/container-groups?";
        if (studyId === undefined || studyId === null)
            throw new globalThis.Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (containerGroupType !== undefined && containerGroupType !== null)
            url_ += "containerGroupType=" + encodeURIComponent("" + containerGroupType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAssignedContainerGroups(_response);
        });
    }

    protected processGetAssignedContainerGroups(response: Response): Promise<ContainerGroupDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ContainerGroupDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ContainerGroupDto[]>(null as any);
    }

    withdrawParticipant(studyId: string, userId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/studies/{studyId}/participants/{userId}/withdraw";
        if (studyId === undefined || studyId === null)
            throw new globalThis.Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processWithdrawParticipant(_response);
        });
    }

    protected processWithdrawParticipant(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    deleteParticipant(studyId: string, userId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/studies/{studyId}/participants/{userId}/purge";
        if (studyId === undefined || studyId === null)
            throw new globalThis.Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteParticipant(_response);
        });
    }

    protected processDeleteParticipant(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getAdministrators(studyId: string, pageNumber?: number | undefined, pageSize?: number | undefined, sorting?: SortingParameter[] | null | undefined, search?: string | null | undefined, signal?: AbortSignal): Promise<PaginatedListOfProjectAdministratorDto> {
        let url_ = this.baseUrl + "/api/v1/studies/{studyId}/administrators?";
        if (studyId === undefined || studyId === null)
            throw new globalThis.Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        if (pageNumber === null)
            throw new globalThis.Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sorting !== undefined && sorting !== null)
            sorting && sorting.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "sorting[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAdministrators(_response);
        });
    }

    protected processGetAdministrators(response: Response): Promise<PaginatedListOfProjectAdministratorDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfProjectAdministratorDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfProjectAdministratorDto>(null as any);
    }

    getAdministrator(studyId: string, userId: string, signal?: AbortSignal): Promise<ProjectAdministratorDto> {
        let url_ = this.baseUrl + "/api/v1/studies/{studyId}/administrators/{userId}";
        if (studyId === undefined || studyId === null)
            throw new globalThis.Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAdministrator(_response);
        });
    }

    protected processGetAdministrator(response: Response): Promise<ProjectAdministratorDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectAdministratorDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectAdministratorDto>(null as any);
    }

    addAdministrator(studyId: string, userId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/studies/{studyId}/administrators/{userId}";
        if (studyId === undefined || studyId === null)
            throw new globalThis.Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddAdministrator(_response);
        });
    }

    protected processAddAdministrator(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    deleteAdministrator(studyId: string, userId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/studies/{studyId}/administrators/{userId}";
        if (studyId === undefined || studyId === null)
            throw new globalThis.Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteAdministrator(_response);
        });
    }

    protected processDeleteAdministrator(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    updateAdministratorPermissions(studyId: string, userId: string, permissions: Permission[], signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/studies/{studyId}/administrators/{userId}/permissions";
        if (studyId === undefined || studyId === null)
            throw new globalThis.Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(permissions);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateAdministratorPermissions(_response);
        });
    }

    protected processUpdateAdministratorPermissions(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Creates a new consent template for the specified study.
     * @param studyId The ID of the study for which the consent template should be created.
     * @param command The consent template to create.
     * @return The created consent template.
     */
    createConsentTemplate(studyId: string, command: CreateProjectConsentTemplateCommand, signal?: AbortSignal): Promise<ConsentTemplateDto> {
        let url_ = this.baseUrl + "/api/v1/studies/{studyId}/consent-template";
        if (studyId === undefined || studyId === null)
            throw new globalThis.Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateConsentTemplate(_response);
        });
    }

    protected processCreateConsentTemplate(response: Response): Promise<ConsentTemplateDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConsentTemplateDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConsentTemplateDto>(null as any);
    }
}

export class TenantClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getTenant(signal?: AbortSignal): Promise<TenantDetailsDto> {
        let url_ = this.baseUrl + "/api/v1/tenant";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTenant(_response);
        });
    }

    protected processGetTenant(response: Response): Promise<TenantDetailsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantDetailsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TenantDetailsDto>(null as any);
    }

    updateTenant(command: UpdateTenantCommand, signal?: AbortSignal): Promise<TenantDetailsDto> {
        let url_ = this.baseUrl + "/api/v1/tenant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateTenant(_response);
        });
    }

    protected processUpdateTenant(response: Response): Promise<TenantDetailsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantDetailsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TenantDetailsDto>(null as any);
    }

    getDeploymentInformation(signal?: AbortSignal): Promise<DeploymentInformation> {
        let url_ = this.baseUrl + "/api/v1/tenant/information";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDeploymentInformation(_response);
        });
    }

    protected processGetDeploymentInformation(response: Response): Promise<DeploymentInformation> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeploymentInformation.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeploymentInformation>(null as any);
    }

    getAdministrators(pageNumber?: number | undefined, pageSize?: number | undefined, sorting?: SortingParameter[] | null | undefined, search?: string | null | undefined, signal?: AbortSignal): Promise<PaginatedListOfTenantAdministratorDto> {
        let url_ = this.baseUrl + "/api/v1/tenant/administrators?";
        if (pageNumber === null)
            throw new globalThis.Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sorting !== undefined && sorting !== null)
            sorting && sorting.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "sorting[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAdministrators(_response);
        });
    }

    protected processGetAdministrators(response: Response): Promise<PaginatedListOfTenantAdministratorDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfTenantAdministratorDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfTenantAdministratorDto>(null as any);
    }

    getAdministrator(userId: string, signal?: AbortSignal): Promise<TenantAdministratorDto> {
        let url_ = this.baseUrl + "/api/v1/tenant/administrators/{userId}";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAdministrator(_response);
        });
    }

    protected processGetAdministrator(response: Response): Promise<TenantAdministratorDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantAdministratorDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TenantAdministratorDto>(null as any);
    }

    addAdministrator(userId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/tenant/administrators/{userId}";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddAdministrator(_response);
        });
    }

    protected processAddAdministrator(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    deleteAdministrator(userId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/tenant/administrators/{userId}";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteAdministrator(_response);
        });
    }

    protected processDeleteAdministrator(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    updateAdministratorPermissions(userId: string, permissions: Permission[], signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/tenant/administrators/{userId}/permissions";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(permissions);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateAdministratorPermissions(_response);
        });
    }

    protected processUpdateAdministratorPermissions(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getParticipants(pageNumber?: number | undefined, pageSize?: number | undefined, sorting?: SortingParameter[] | null | undefined, search?: string | null | undefined, signal?: AbortSignal): Promise<PaginatedListOfTenantParticipantDto> {
        let url_ = this.baseUrl + "/api/v1/tenant/participants?";
        if (pageNumber === null)
            throw new globalThis.Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sorting !== undefined && sorting !== null)
            sorting && sorting.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "sorting[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetParticipants(_response);
        });
    }

    protected processGetParticipants(response: Response): Promise<PaginatedListOfTenantParticipantDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfTenantParticipantDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfTenantParticipantDto>(null as any);
    }

    getParticipant(userId: string, signal?: AbortSignal): Promise<TenantParticipantDto> {
        let url_ = this.baseUrl + "/api/v1/tenant/participants/{userId}";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetParticipant(_response);
        });
    }

    protected processGetParticipant(response: Response): Promise<TenantParticipantDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantParticipantDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TenantParticipantDto>(null as any);
    }

    addParticipant(userId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/tenant/participants/{userId}";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddParticipant(_response);
        });
    }

    protected processAddParticipant(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    deleteParticipant(userId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/tenant/participants/{userId}";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteParticipant(_response);
        });
    }

    protected processDeleteParticipant(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getLicensingStatus(signal?: AbortSignal): Promise<TenantLicensingStatusDto> {
        let url_ = this.baseUrl + "/api/v1/tenant/licensing-status";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLicensingStatus(_response);
        });
    }

    protected processGetLicensingStatus(response: Response): Promise<TenantLicensingStatusDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantLicensingStatusDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TenantLicensingStatusDto>(null as any);
    }

    getParticipantLicenseInstances(userId: string, pageNumber?: number | undefined, pageSize?: number | undefined, sorting?: SortingParameter[] | null | undefined, search?: string | null | undefined, showHidden?: boolean | undefined, appIds?: string[] | null | undefined, activationServiceTypes?: LicenseActivationServiceType[] | null | undefined, isActive?: boolean | null | undefined, signal?: AbortSignal): Promise<PaginatedListOfTenantParticipantLicenseInstanceDto> {
        let url_ = this.baseUrl + "/api/v1/tenant/participants/{userId}/license-instances?";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (pageNumber === null)
            throw new globalThis.Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sorting !== undefined && sorting !== null)
            sorting && sorting.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "sorting[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (showHidden === null)
            throw new globalThis.Error("The parameter 'showHidden' cannot be null.");
        else if (showHidden !== undefined)
            url_ += "showHidden=" + encodeURIComponent("" + showHidden) + "&";
        if (appIds !== undefined && appIds !== null)
            appIds && appIds.forEach(item => { url_ += "appIds=" + encodeURIComponent("" + item) + "&"; });
        if (activationServiceTypes !== undefined && activationServiceTypes !== null)
            activationServiceTypes && activationServiceTypes.forEach(item => { url_ += "activationServiceTypes=" + encodeURIComponent("" + item) + "&"; });
        if (isActive !== undefined && isActive !== null)
            url_ += "isActive=" + encodeURIComponent("" + isActive) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetParticipantLicenseInstances(_response);
        });
    }

    protected processGetParticipantLicenseInstances(response: Response): Promise<PaginatedListOfTenantParticipantLicenseInstanceDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfTenantParticipantLicenseInstanceDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfTenantParticipantLicenseInstanceDto>(null as any);
    }

    getParticipantPurchaseEvents(userId: string, pageNumber?: number | undefined, pageSize?: number | undefined, sorting?: SortingParameter[] | null | undefined, search?: string | null | undefined, signal?: AbortSignal): Promise<PaginatedListOfTenantParticipantPurchaseEventDto> {
        let url_ = this.baseUrl + "/api/v1/tenant/participants/{userId}/purchase-events?";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (pageNumber === null)
            throw new globalThis.Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sorting !== undefined && sorting !== null)
            sorting && sorting.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "sorting[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetParticipantPurchaseEvents(_response);
        });
    }

    protected processGetParticipantPurchaseEvents(response: Response): Promise<PaginatedListOfTenantParticipantPurchaseEventDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfTenantParticipantPurchaseEventDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfTenantParticipantPurchaseEventDto>(null as any);
    }

    getParticipantStudies(userId: string, signal?: AbortSignal): Promise<TenantParticipantStudyDto[]> {
        let url_ = this.baseUrl + "/api/v1/tenant/participants/{userId}/studies";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetParticipantStudies(_response);
        });
    }

    protected processGetParticipantStudies(response: Response): Promise<TenantParticipantStudyDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TenantParticipantStudyDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TenantParticipantStudyDto[]>(null as any);
    }

    withdrawParticipant(userId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/tenant/participants/{userId}/withdraw";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processWithdrawParticipant(_response);
        });
    }

    protected processWithdrawParticipant(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getLinkConfiguration(platform: Platform, tenantId?: string | null | undefined, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/tenant/link-configuration?";
        if (platform === undefined || platform === null)
            throw new globalThis.Error("The parameter 'platform' must be defined and cannot be null.");
        else
            url_ += "platform=" + encodeURIComponent("" + platform) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLinkConfiguration(_response);
        });
    }

    protected processGetLinkConfiguration(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class TerminologiesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Retrieves a paginated list of terminologies.
     * @param pageNumber (optional) Page number (1-based).
     * @param pageSize (optional) Number of items per page.
     * @param sorting (optional) Optional sorting parameters.
     * @param search (optional) Optional search string to filter by name.
     * @param projectIds (optional) Optional project IDs to filter by.
     * @param showHidden (optional) Whether to include hidden (soft-deleted) terminologies.
     * @return A paginated list of terminologies.
     */
    getTerminologies(pageNumber?: number | undefined, pageSize?: number | undefined, sorting?: SortingParameter[] | null | undefined, search?: string | null | undefined, projectIds?: string[] | null | undefined, showHidden?: boolean | undefined, signal?: AbortSignal): Promise<PaginatedListOfTerminologyDto> {
        let url_ = this.baseUrl + "/api/v1/terminologies?";
        if (pageNumber === null)
            throw new globalThis.Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sorting !== undefined && sorting !== null)
            sorting && sorting.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "sorting[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (projectIds !== undefined && projectIds !== null)
            projectIds && projectIds.forEach(item => { url_ += "projectIds=" + encodeURIComponent("" + item) + "&"; });
        if (showHidden === null)
            throw new globalThis.Error("The parameter 'showHidden' cannot be null.");
        else if (showHidden !== undefined)
            url_ += "showHidden=" + encodeURIComponent("" + showHidden) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTerminologies(_response);
        });
    }

    protected processGetTerminologies(response: Response): Promise<PaginatedListOfTerminologyDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfTerminologyDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfTerminologyDto>(null as any);
    }

    /**
     * Creates a new terminology.
     * @param command The create terminology command with name and initial configuration.
     * @return The created terminology.
     */
    createTerminology(command: CreateTerminologyCommand, signal?: AbortSignal): Promise<TerminologyDto> {
        let url_ = this.baseUrl + "/api/v1/terminologies";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateTerminology(_response);
        });
    }

    protected processCreateTerminology(response: Response): Promise<TerminologyDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TerminologyDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TerminologyDto>(null as any);
    }

    /**
     * Retrieves a single terminology by ID with full details including content structure.
     * @param terminologyId The terminology ID.
     * @return The terminology details.
     */
    getTerminology(terminologyId: string, signal?: AbortSignal): Promise<TerminologyDetailsDto> {
        let url_ = this.baseUrl + "/api/v1/terminologies/{terminologyId}";
        if (terminologyId === undefined || terminologyId === null)
            throw new globalThis.Error("The parameter 'terminologyId' must be defined.");
        url_ = url_.replace("{terminologyId}", encodeURIComponent("" + terminologyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTerminology(_response);
        });
    }

    protected processGetTerminology(response: Response): Promise<TerminologyDetailsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TerminologyDetailsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TerminologyDetailsDto>(null as any);
    }

    /**
     * Updates an existing terminology.
     * @param terminologyId The terminology ID from the URL path.
     * @param command The update command with new terminology data.
     * @return The updated terminology details.
     */
    updateTerminology(terminologyId: string, command: UpdateTerminologyCommand, signal?: AbortSignal): Promise<TerminologyDetailsDto> {
        let url_ = this.baseUrl + "/api/v1/terminologies/{terminologyId}";
        if (terminologyId === undefined || terminologyId === null)
            throw new globalThis.Error("The parameter 'terminologyId' must be defined.");
        url_ = url_.replace("{terminologyId}", encodeURIComponent("" + terminologyId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateTerminology(_response);
        });
    }

    protected processUpdateTerminology(response: Response): Promise<TerminologyDetailsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TerminologyDetailsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TerminologyDetailsDto>(null as any);
    }

    /**
     * Soft-deletes a terminology by setting its hidden flag.
    The terminology can be restored later.
     * @param terminologyId The terminology ID to hide.
     */
    hideTerminology(terminologyId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/terminologies/{terminologyId}/hide";
        if (terminologyId === undefined || terminologyId === null)
            throw new globalThis.Error("The parameter 'terminologyId' must be defined.");
        url_ = url_.replace("{terminologyId}", encodeURIComponent("" + terminologyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHideTerminology(_response);
        });
    }

    protected processHideTerminology(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Permanently deletes a terminology and all its instances.
    This action cannot be undone.
     * @param terminologyId The terminology ID to permanently delete.
     */
    deleteTerminology(terminologyId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/terminologies/{terminologyId}/permanent";
        if (terminologyId === undefined || terminologyId === null)
            throw new globalThis.Error("The parameter 'terminologyId' must be defined.");
        url_ = url_.replace("{terminologyId}", encodeURIComponent("" + terminologyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteTerminology(_response);
        });
    }

    protected processDeleteTerminology(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Publishes a terminology, making it available for use in frontend applications.
     * @param terminologyId The terminology ID to publish.
     */
    publishTerminology(terminologyId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/terminologies/{terminologyId}/publish";
        if (terminologyId === undefined || terminologyId === null)
            throw new globalThis.Error("The parameter 'terminologyId' must be defined.");
        url_ = url_.replace("{terminologyId}", encodeURIComponent("" + terminologyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPublishTerminology(_response);
        });
    }

    protected processPublishTerminology(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Unpublishes a terminology, removing it from frontend availability.
    Existing instances remain but the terminology cannot be used for new instances.
     * @param terminologyId The terminology ID to unpublish.
     */
    unpublishTerminology(terminologyId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/terminologies/{terminologyId}/unpublish";
        if (terminologyId === undefined || terminologyId === null)
            throw new globalThis.Error("The parameter 'terminologyId' must be defined.");
        url_ = url_.replace("{terminologyId}", encodeURIComponent("" + terminologyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUnpublishTerminology(_response);
        });
    }

    protected processUnpublishTerminology(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Retrieves a paginated list of instances for a specific terminology.
     * @param terminologyId The terminology ID to get instances for.
     * @param pageNumber (optional) Page number (1-based).
     * @param pageSize (optional) Number of items per page.
     * @param sorting (optional) Optional sorting parameters.
     * @param search (optional) Optional search string to filter by name.
     * @param projectIds (optional) Optional project IDs to filter by.
     * @param showHidden (optional) Whether to include hidden (soft-deleted) instances.
     * @return A paginated list of terminology instances with their property values.
     */
    getTerminologyInstances(terminologyId: string, pageNumber?: number | undefined, pageSize?: number | undefined, sorting?: SortingParameter[] | null | undefined, search?: string | null | undefined, projectIds?: string[] | null | undefined, showHidden?: boolean | undefined, signal?: AbortSignal): Promise<PaginatedListOfTerminologyInstanceDetailsDto> {
        let url_ = this.baseUrl + "/api/v1/terminologies/{terminologyId}/instances?";
        if (terminologyId === undefined || terminologyId === null)
            throw new globalThis.Error("The parameter 'terminologyId' must be defined.");
        url_ = url_.replace("{terminologyId}", encodeURIComponent("" + terminologyId));
        if (pageNumber === null)
            throw new globalThis.Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sorting !== undefined && sorting !== null)
            sorting && sorting.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "sorting[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (projectIds !== undefined && projectIds !== null)
            projectIds && projectIds.forEach(item => { url_ += "projectIds=" + encodeURIComponent("" + item) + "&"; });
        if (showHidden === null)
            throw new globalThis.Error("The parameter 'showHidden' cannot be null.");
        else if (showHidden !== undefined)
            url_ += "showHidden=" + encodeURIComponent("" + showHidden) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTerminologyInstances(_response);
        });
    }

    protected processGetTerminologyInstances(response: Response): Promise<PaginatedListOfTerminologyInstanceDetailsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfTerminologyInstanceDetailsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfTerminologyInstanceDetailsDto>(null as any);
    }

    /**
     * Creates a new terminology instance.
     * @param terminologyId The terminology ID to create an instance for.
     * @param name (optional) Optional name for the instance. Defaults to the terminology name if not provided.
     * @return The ID of the newly created instance.
     */
    createTerminologyInstance(terminologyId: string, name?: string | null | undefined, signal?: AbortSignal): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/terminologies/{terminologyId}/instances?";
        if (terminologyId === undefined || terminologyId === null)
            throw new globalThis.Error("The parameter 'terminologyId' must be defined.");
        url_ = url_.replace("{terminologyId}", encodeURIComponent("" + terminologyId));
        if (name !== undefined && name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateTerminologyInstance(_response);
        });
    }

    protected processCreateTerminologyInstance(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Retrieves a single terminology instance by ID with full details.
     * @param terminologyId The terminology ID.
     * @param terminologyInstanceId The instance ID.
     * @return The terminology instance details with property values.
     */
    getTerminologyInstance(terminologyId: string, terminologyInstanceId: string, signal?: AbortSignal): Promise<TerminologyInstanceDetailsDto> {
        let url_ = this.baseUrl + "/api/v1/terminologies/{terminologyId}/instances/{terminologyInstanceId}";
        if (terminologyId === undefined || terminologyId === null)
            throw new globalThis.Error("The parameter 'terminologyId' must be defined.");
        url_ = url_.replace("{terminologyId}", encodeURIComponent("" + terminologyId));
        if (terminologyInstanceId === undefined || terminologyInstanceId === null)
            throw new globalThis.Error("The parameter 'terminologyInstanceId' must be defined.");
        url_ = url_.replace("{terminologyInstanceId}", encodeURIComponent("" + terminologyInstanceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTerminologyInstance(_response);
        });
    }

    protected processGetTerminologyInstance(response: Response): Promise<TerminologyInstanceDetailsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TerminologyInstanceDetailsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TerminologyInstanceDetailsDto>(null as any);
    }

    /**
     * Updates an existing terminology instance.
     * @param terminologyId The terminology ID from the URL path.
     * @param terminologyInstanceId The instance ID from the URL path.
     * @param command The update command with new instance data including name, label, and property values.
     * @return The updated terminology instance details.
     */
    updateTerminologyInstance(terminologyId: string, terminologyInstanceId: string, command: UpdateTerminologyInstanceCommand, signal?: AbortSignal): Promise<TerminologyInstanceDetailsDto> {
        let url_ = this.baseUrl + "/api/v1/terminologies/{terminologyId}/instances/{terminologyInstanceId}";
        if (terminologyId === undefined || terminologyId === null)
            throw new globalThis.Error("The parameter 'terminologyId' must be defined.");
        url_ = url_.replace("{terminologyId}", encodeURIComponent("" + terminologyId));
        if (terminologyInstanceId === undefined || terminologyInstanceId === null)
            throw new globalThis.Error("The parameter 'terminologyInstanceId' must be defined.");
        url_ = url_.replace("{terminologyInstanceId}", encodeURIComponent("" + terminologyInstanceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateTerminologyInstance(_response);
        });
    }

    protected processUpdateTerminologyInstance(response: Response): Promise<TerminologyInstanceDetailsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TerminologyInstanceDetailsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TerminologyInstanceDetailsDto>(null as any);
    }

    /**
     * Soft-deletes terminology instances by setting their hidden flag.
    The instances can be restored later using the restore endpoint.
     * @param terminologyInstanceIds List of instance IDs to hide.
     */
    hideTerminologyInstances(terminologyInstanceIds: string[], signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/terminologies/instances/hide?";
        if (terminologyInstanceIds === undefined || terminologyInstanceIds === null)
            throw new globalThis.Error("The parameter 'terminologyInstanceIds' must be defined and cannot be null.");
        else
            terminologyInstanceIds && terminologyInstanceIds.forEach(item => { url_ += "terminologyInstanceIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHideTerminologyInstances(_response);
        });
    }

    protected processHideTerminologyInstances(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Restores previously hidden (soft-deleted) terminology instances.
     * @param terminologyInstanceIds List of instance IDs to restore.
     */
    restoreTerminologyInstances(terminologyInstanceIds: string[], signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/terminologies/instances/restore?";
        if (terminologyInstanceIds === undefined || terminologyInstanceIds === null)
            throw new globalThis.Error("The parameter 'terminologyInstanceIds' must be defined and cannot be null.");
        else
            terminologyInstanceIds && terminologyInstanceIds.forEach(item => { url_ += "terminologyInstanceIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRestoreTerminologyInstances(_response);
        });
    }

    protected processRestoreTerminologyInstances(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Permanently deletes terminology instances from the database.
    This action cannot be undone.
     * @param terminologyInstanceIds List of instance IDs to permanently delete.
     */
    deleteTerminologyInstances(terminologyInstanceIds: string[], signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/terminologies/instances?";
        if (terminologyInstanceIds === undefined || terminologyInstanceIds === null)
            throw new globalThis.Error("The parameter 'terminologyInstanceIds' must be defined and cannot be null.");
        else
            terminologyInstanceIds && terminologyInstanceIds.forEach(item => { url_ += "terminologyInstanceIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteTerminologyInstances(_response);
        });
    }

    protected processDeleteTerminologyInstances(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Exports terminology instances to an Excel file.
    The exported file can be used as a template for importing instances.
     * @param terminologyId The terminology ID to export instances from.
     * @param terminologyInstanceIds (optional) Optional list of specific instance IDs to export. If null, exports all instances.
     * @param showHidden (optional) Whether to include hidden instances in the export.
     * @return An Excel file containing the terminology instances.
     */
    exportTerminologyInstances(terminologyId: string, terminologyInstanceIds?: string[] | null | undefined, showHidden?: boolean | undefined, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/terminologies/{terminologyId}/instances/export?";
        if (terminologyId === undefined || terminologyId === null)
            throw new globalThis.Error("The parameter 'terminologyId' must be defined.");
        url_ = url_.replace("{terminologyId}", encodeURIComponent("" + terminologyId));
        if (terminologyInstanceIds !== undefined && terminologyInstanceIds !== null)
            terminologyInstanceIds && terminologyInstanceIds.forEach(item => { url_ += "terminologyInstanceIds=" + encodeURIComponent("" + item) + "&"; });
        if (showHidden === null)
            throw new globalThis.Error("The parameter 'showHidden' cannot be null.");
        else if (showHidden !== undefined)
            url_ += "showHidden=" + encodeURIComponent("" + showHidden) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processExportTerminologyInstances(_response);
        });
    }

    protected processExportTerminologyInstances(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Imports terminology instances from an Excel file.
    Supports Skip mode (skip existing) and Overwrite mode (update existing).
    Hidden instances with matching IDs will be restored during import.
     * @param terminologyId The terminology ID to import instances into.
     * @param mode (optional) Import mode: Skip (default) skips existing instances, Overwrite updates them.
     * @param file (optional) 
     * @return Import result with counts of created, updated, restored, skipped, and error records.
     */
    importTerminologyInstances(terminologyId: string, mode?: ImportMode | undefined, file?: FileParameter | undefined, signal?: AbortSignal): Promise<ImportTerminologyInstancesResult> {
        let url_ = this.baseUrl + "/api/v1/terminologies/{terminologyId}/instances/import?";
        if (terminologyId === undefined || terminologyId === null)
            throw new globalThis.Error("The parameter 'terminologyId' must be defined.");
        url_ = url_.replace("{terminologyId}", encodeURIComponent("" + terminologyId));
        if (mode === null)
            throw new globalThis.Error("The parameter 'mode' cannot be null.");
        else if (mode !== undefined)
            url_ += "mode=" + encodeURIComponent("" + mode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new globalThis.Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processImportTerminologyInstances(_response);
        });
    }

    protected processImportTerminologyInstances(response: Response): Promise<ImportTerminologyInstancesResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImportTerminologyInstancesResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ImportTerminologyInstancesResult>(null as any);
    }
}

export class UsersClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getUsers(pageNumber?: number | undefined, pageSize?: number | undefined, sorting?: SortingParameter[] | null | undefined, search?: string | null | undefined, signal?: AbortSignal): Promise<PaginatedListOfUserDto> {
        let url_ = this.baseUrl + "/api/v1/users?";
        if (pageNumber === null)
            throw new globalThis.Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sorting !== undefined && sorting !== null)
            sorting && sorting.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "sorting[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUsers(_response);
        });
    }

    protected processGetUsers(response: Response): Promise<PaginatedListOfUserDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfUserDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfUserDto>(null as any);
    }

    createUser(command: CreateUserCommand, signal?: AbortSignal): Promise<UserDto> {
        let url_ = this.baseUrl + "/api/v1/users";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateUser(_response);
        });
    }

    protected processCreateUser(response: Response): Promise<UserDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserDto>(null as any);
    }

    getUser(userId: string, signal?: AbortSignal): Promise<UserDto> {
        let url_ = this.baseUrl + "/api/v1/users/{userId}";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUser(_response);
        });
    }

    protected processGetUser(response: Response): Promise<UserDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserDto>(null as any);
    }

    updateUser(userId: string, command: UpdateUserCommand, signal?: AbortSignal): Promise<UserDto> {
        let url_ = this.baseUrl + "/api/v1/users/{userId}";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateUser(_response);
        });
    }

    protected processUpdateUser(response: Response): Promise<UserDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserDto>(null as any);
    }

    addUser(userId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/users/{userId}";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddUser(_response);
        });
    }

    protected processAddUser(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    deleteUser(userId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/users/{userId}";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteUser(_response);
        });
    }

    protected processDeleteUser(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    exists(userId: string, signal?: AbortSignal): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/users/{userId}/exists";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processExists(_response);
        });
    }

    protected processExists(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    sendRegistrationMail(userId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/users/{userId}/registrationmail";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSendRegistrationMail(_response);
        });
    }

    protected processSendRegistrationMail(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    sendNotification(userId: string, command: SendNotificationCommand, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/users/{userId}/notification";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSendNotification(_response);
        });
    }

    protected processSendNotification(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export abstract class ContentDto implements IContentDto {
    id!: string;
    name!: string;
    customComponentName?: string | undefined;
    elementType!: ElementType;
    condition?: ContentCondition | undefined;

    protected _discriminator: string;

    constructor(data?: IContentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        this._discriminator = "ContentDto";
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.customComponentName = _data["customComponentName"];
            this.elementType = _data["elementType"];
            this.condition = _data["condition"] ? ContentCondition.fromJS(_data["condition"]) : undefined as any;
        }
    }

    static fromJS(data: any): ContentDto {
        data = typeof data === 'object' ? data : {};
        if (data["$type"] === "ContentGroupDto") {
            let result = new ContentGroupDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "ContentPageDto") {
            let result = new ContentPageDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "DisplayDto") {
            throw new Error("The abstract class 'DisplayDto' cannot be instantiated.");
        }
        if (data["$type"] === "ImageDisplayDto") {
            let result = new ImageDisplayDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "TextDisplayDto") {
            let result = new TextDisplayDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "RichTextDisplayDto") {
            let result = new RichTextDisplayDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "QuestionnaireReferenceDisplayDto") {
            let result = new QuestionnaireReferenceDisplayDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "PropertyDto") {
            throw new Error("The abstract class 'PropertyDto' cannot be instantiated.");
        }
        if (data["$type"] === "TextPropertyDto") {
            let result = new TextPropertyDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "NumberPropertyDto") {
            let result = new NumberPropertyDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "DatePropertyDto") {
            let result = new DatePropertyDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "ChoicePropertyDto") {
            let result = new ChoicePropertyDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "ContainerPropertyDto") {
            let result = new ContainerPropertyDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "QuestionDto") {
            throw new Error("The abstract class 'QuestionDto' cannot be instantiated.");
        }
        if (data["$type"] === "LikertQuestionDto") {
            let result = new LikertQuestionDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "MatrixQuestionDto") {
            let result = new MatrixQuestionDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "ChoiceQuestionDto") {
            let result = new ChoiceQuestionDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "ContainerQuestionDto") {
            let result = new ContainerQuestionDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "BoolQuestionDto") {
            let result = new BoolQuestionDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "TextQuestionDto") {
            let result = new TextQuestionDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "NumberQuestionDto") {
            let result = new NumberQuestionDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "DateQuestionDto") {
            let result = new DateQuestionDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "TimeQuestionDto") {
            let result = new TimeQuestionDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "DateTimeQuestionDto") {
            let result = new DateTimeQuestionDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "SliderQuestionDto") {
            let result = new SliderQuestionDto();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'ContentDto' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["$type"] = this._discriminator;
        data["id"] = this.id;
        data["name"] = this.name;
        data["customComponentName"] = this.customComponentName;
        data["elementType"] = this.elementType;
        data["condition"] = this.condition ? this.condition.toJSON() : undefined as any;
        return data;
    }

    clone(): ContentDto {
        throw new Error("The abstract class 'ContentDto' cannot be instantiated.");
    }
}

export interface IContentDto {
    id: string;
    name: string;
    customComponentName?: string | undefined;
    elementType: ElementType;
    condition?: ContentCondition | undefined;
}

export enum ElementType {
    None = "none",
    ContentGroup = "contentGroup",
    ContentPage = "contentPage",
    ChoiceQuestion = "choiceQuestion",
    DateQuestion = "dateQuestion",
    DateTimeQuestion = "dateTimeQuestion",
    LikertQuestion = "likertQuestion",
    MatrixQuestion = "matrixQuestion",
    NumberQuestion = "numberQuestion",
    SliderQuestion = "sliderQuestion",
    TextQuestion = "textQuestion",
    TimeQuestion = "timeQuestion",
    BoolQuestion = "boolQuestion",
    RichTextDisplay = "richTextDisplay",
    ImageDisplay = "imageDisplay",
    TextDisplay = "textDisplay",
    QuestionnaireReferenceDisplay = "questionnaireReferenceDisplay",
    DateProperty = "dateProperty",
    NumberProperty = "numberProperty",
    TextProperty = "textProperty",
    ChoiceProperty = "choiceProperty",
    ContainerQuestion = "containerQuestion",
    ContainerProperty = "containerProperty",
}

export abstract class Condition implements ICondition {
    expression!: string;

    constructor(data?: ICondition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expression = _data["expression"];
        }
    }

    static fromJS(data: any): Condition {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'Condition' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expression"] = this.expression;
        return data;
    }

    clone(): Condition {
        throw new Error("The abstract class 'Condition' cannot be instantiated.");
    }
}

export interface ICondition {
    expression: string;
}

export class ContentCondition extends Condition implements IContentCondition {

    constructor(data?: IContentCondition) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ContentCondition {
        data = typeof data === 'object' ? data : {};
        let result = new ContentCondition();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): ContentCondition {
        const json = this.toJSON();
        let result = new ContentCondition();
        result.init(json);
        return result;
    }
}

export interface IContentCondition extends ICondition {
}

export class ContentGroupDto extends ContentDto implements IContentGroupDto {
    contents!: ContentDto[];

    constructor(data?: IContentGroupDto) {
        super(data);
        if (!data) {
            this.contents = [];
        }
        this._discriminator = "ContentGroupDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["contents"])) {
                this.contents = [] as any;
                for (let item of _data["contents"])
                    this.contents!.push(ContentDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ContentGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContentGroupDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.contents)) {
            data["contents"] = [];
            for (let item of this.contents)
                data["contents"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): ContentGroupDto {
        const json = this.toJSON();
        let result = new ContentGroupDto();
        result.init(json);
        return result;
    }
}

export interface IContentGroupDto extends IContentDto {
    contents: ContentDto[];
}

export class ContentPageDto extends ContentDto implements IContentPageDto {
    title!: InternationalizedString;
    pageRandomizationMode!: PageRandomizationMode;
    contents!: ContentDto[];

    constructor(data?: IContentPageDto) {
        super(data);
        if (!data) {
            this.title = new InternationalizedString();
            this.contents = [];
        }
        this._discriminator = "ContentPageDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.title = _data["title"] ? InternationalizedString.fromJS(_data["title"]) : new InternationalizedString();
            this.pageRandomizationMode = _data["pageRandomizationMode"];
            if (Array.isArray(_data["contents"])) {
                this.contents = [] as any;
                for (let item of _data["contents"])
                    this.contents!.push(ContentDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ContentPageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContentPageDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title ? this.title.toJSON() : undefined as any;
        data["pageRandomizationMode"] = this.pageRandomizationMode;
        if (Array.isArray(this.contents)) {
            data["contents"] = [];
            for (let item of this.contents)
                data["contents"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): ContentPageDto {
        const json = this.toJSON();
        let result = new ContentPageDto();
        result.init(json);
        return result;
    }
}

export interface IContentPageDto extends IContentDto {
    title: InternationalizedString;
    pageRandomizationMode: PageRandomizationMode;
    contents: ContentDto[];
}

export class InternationalizedString implements IInternationalizedString {
    translations!: { [key: string]: string; };

    constructor(data?: IInternationalizedString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.translations = {};
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["translations"]) {
                this.translations = {} as any;
                for (let key in _data["translations"]) {
                    if (_data["translations"].hasOwnProperty(key))
                        (this.translations as any)![key] = _data["translations"][key];
                }
            }
        }
    }

    static fromJS(data: any): InternationalizedString {
        data = typeof data === 'object' ? data : {};
        let result = new InternationalizedString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.translations) {
            data["translations"] = {};
            for (let key in this.translations) {
                if (this.translations.hasOwnProperty(key))
                    (data["translations"] as any)[key] = (this.translations as any)[key];
            }
        }
        return data;
    }

    clone(): InternationalizedString {
        const json = this.toJSON();
        let result = new InternationalizedString();
        result.init(json);
        return result;
    }
}

export interface IInternationalizedString {
    translations: { [key: string]: string; };
}

export enum PageRandomizationMode {
    None = "none",
    RandomizeContents = "randomizeContents",
    RandomizeOrder = "randomizeOrder",
    RandomizeContentsAndOrder = "randomizeContentsAndOrder",
}

export abstract class DisplayDto extends ContentDto implements IDisplayDto {

    constructor(data?: IDisplayDto) {
        super(data);
        this._discriminator = "DisplayDto";
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): DisplayDto {
        data = typeof data === 'object' ? data : {};
        if (data["$type"] === "ImageDisplayDto") {
            let result = new ImageDisplayDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "TextDisplayDto") {
            let result = new TextDisplayDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "RichTextDisplayDto") {
            let result = new RichTextDisplayDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "QuestionnaireReferenceDisplayDto") {
            let result = new QuestionnaireReferenceDisplayDto();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'DisplayDto' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): DisplayDto {
        throw new Error("The abstract class 'DisplayDto' cannot be instantiated.");
    }
}

export interface IDisplayDto extends IContentDto {
}

export class ImageDisplayDto extends DisplayDto implements IImageDisplayDto {
    asset?: AssetDto | undefined;
    description!: InternationalizedString;
    accessibleDescription!: InternationalizedString;

    constructor(data?: IImageDisplayDto) {
        super(data);
        if (!data) {
            this.description = new InternationalizedString();
            this.accessibleDescription = new InternationalizedString();
        }
        this._discriminator = "ImageDisplayDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.asset = _data["asset"] ? AssetDto.fromJS(_data["asset"]) : undefined as any;
            this.description = _data["description"] ? InternationalizedString.fromJS(_data["description"]) : new InternationalizedString();
            this.accessibleDescription = _data["accessibleDescription"] ? InternationalizedString.fromJS(_data["accessibleDescription"]) : new InternationalizedString();
        }
    }

    static override fromJS(data: any): ImageDisplayDto {
        data = typeof data === 'object' ? data : {};
        let result = new ImageDisplayDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["asset"] = this.asset ? this.asset.toJSON() : undefined as any;
        data["description"] = this.description ? this.description.toJSON() : undefined as any;
        data["accessibleDescription"] = this.accessibleDescription ? this.accessibleDescription.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): ImageDisplayDto {
        const json = this.toJSON();
        let result = new ImageDisplayDto();
        result.init(json);
        return result;
    }
}

export interface IImageDisplayDto extends IDisplayDto {
    asset?: AssetDto | undefined;
    description: InternationalizedString;
    accessibleDescription: InternationalizedString;
}

export class TenantEntityDto implements ITenantEntityDto {
    id!: string;
    tenantId!: string;

    constructor(data?: ITenantEntityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): TenantEntityDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantEntityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        return data;
    }

    clone(): TenantEntityDto {
        const json = this.toJSON();
        let result = new TenantEntityDto();
        result.init(json);
        return result;
    }
}

export interface ITenantEntityDto {
    id: string;
    tenantId: string;
}

export class AssetDto extends TenantEntityDto implements IAssetDto {
    file?: FileDto | undefined;
    url?: string | undefined;
    name!: string;
    /** A brief description of the asset. */
    description?: string | undefined;
    /** Width of the asset file in pixels. */
    width?: number | undefined;
    /** Height of the asset file in pixels. */
    height?: number | undefined;
    /** X coordinate of the asset file image detail in pixels. */
    x?: number | undefined;
    /** Y coordinate of the asset file image detail in pixels. */
    y?: number | undefined;
    /** The content type of the asset file. */
    contentType!: string;
    /** Tags associated with the asset, useful for categorization or search. */
    tags?: string[] | undefined;
    /** The URL where the asset was originally sourced from. */
    sourceUrl?: string | undefined;
    licenseType?: LicenseType | undefined;
    /** Restrictions associated with the asset's license. */
    licenseRestriction?: LicenseRestriction[] | undefined;
    /** URL of the license under which the asset is distributed. */
    licenseUrl?: string | undefined;
    /** Copyright information for the asset. */
    copyright?: string | undefined;
    /** Attribution details for the asset, if required. */
    attribution?: string | undefined;
    /** Metadata read from the asset file. */
    metadata?: AssetMetadataDto | undefined;

    constructor(data?: IAssetDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.file = _data["file"] ? FileDto.fromJS(_data["file"]) : undefined as any;
            this.url = _data["url"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.width = _data["width"];
            this.height = _data["height"];
            this.x = _data["x"];
            this.y = _data["y"];
            this.contentType = _data["contentType"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            this.sourceUrl = _data["sourceUrl"];
            this.licenseType = _data["licenseType"];
            if (Array.isArray(_data["licenseRestriction"])) {
                this.licenseRestriction = [] as any;
                for (let item of _data["licenseRestriction"])
                    this.licenseRestriction!.push(item);
            }
            this.licenseUrl = _data["licenseUrl"];
            this.copyright = _data["copyright"];
            this.attribution = _data["attribution"];
            this.metadata = _data["metadata"] ? AssetMetadataDto.fromJS(_data["metadata"]) : undefined as any;
        }
    }

    static override fromJS(data: any): AssetDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["file"] = this.file ? this.file.toJSON() : undefined as any;
        data["url"] = this.url;
        data["name"] = this.name;
        data["description"] = this.description;
        data["width"] = this.width;
        data["height"] = this.height;
        data["x"] = this.x;
        data["y"] = this.y;
        data["contentType"] = this.contentType;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["sourceUrl"] = this.sourceUrl;
        data["licenseType"] = this.licenseType;
        if (Array.isArray(this.licenseRestriction)) {
            data["licenseRestriction"] = [];
            for (let item of this.licenseRestriction)
                data["licenseRestriction"].push(item);
        }
        data["licenseUrl"] = this.licenseUrl;
        data["copyright"] = this.copyright;
        data["attribution"] = this.attribution;
        data["metadata"] = this.metadata ? this.metadata.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): AssetDto {
        const json = this.toJSON();
        let result = new AssetDto();
        result.init(json);
        return result;
    }
}

export interface IAssetDto extends ITenantEntityDto {
    file?: FileDto | undefined;
    url?: string | undefined;
    name: string;
    /** A brief description of the asset. */
    description?: string | undefined;
    /** Width of the asset file in pixels. */
    width?: number | undefined;
    /** Height of the asset file in pixels. */
    height?: number | undefined;
    /** X coordinate of the asset file image detail in pixels. */
    x?: number | undefined;
    /** Y coordinate of the asset file image detail in pixels. */
    y?: number | undefined;
    /** The content type of the asset file. */
    contentType: string;
    /** Tags associated with the asset, useful for categorization or search. */
    tags?: string[] | undefined;
    /** The URL where the asset was originally sourced from. */
    sourceUrl?: string | undefined;
    licenseType?: LicenseType | undefined;
    /** Restrictions associated with the asset's license. */
    licenseRestriction?: LicenseRestriction[] | undefined;
    /** URL of the license under which the asset is distributed. */
    licenseUrl?: string | undefined;
    /** Copyright information for the asset. */
    copyright?: string | undefined;
    /** Attribution details for the asset, if required. */
    attribution?: string | undefined;
    /** Metadata read from the asset file. */
    metadata?: AssetMetadataDto | undefined;
}

export class FileDto implements IFileDto {
    url?: string | undefined;
    id!: string;
    name!: string;

    constructor(data?: IFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"];
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): FileDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }

    clone(): FileDto {
        const json = this.toJSON();
        let result = new FileDto();
        result.init(json);
        return result;
    }
}

export interface IFileDto {
    url?: string | undefined;
    id: string;
    name: string;
}

/** Represents different types of licenses for a piece of content or intellectual property. */
export enum LicenseType {
    Unknown = "unknown",
    PublicDomain = "publicDomain",
    CreativeCommons = "creativeCommons",
    Commercial = "commercial",
    CommercialRoyaltyFree = "commercialRoyaltyFree",
    CommercialRightsManaged = "commercialRightsManaged",
    CommercialExtended = "commercialExtended",
}

/** Represents restrictions or limitations associated with a license. */
export enum LicenseRestriction {
    Attribution = "attribution",
    NoDerivatives = "noDerivatives",
    ShareAlike = "shareAlike",
    NonCommercial = "nonCommercial",
    EditorialUseOnly = "editorialUseOnly",
    ViewerRestriction = "viewerRestriction",
    NoMobileAppUse = "noMobileAppUse",
    NoDesktopAppUse = "noDesktopAppUse",
    NoWebUse = "noWebUse",
    NoPrintUse = "noPrintUse",
    NoBroadcastUse = "noBroadcastUse",
    NoAdvertisingUse = "noAdvertisingUse",
    NoSaaSUse = "noSaaSUse",
}

export class AssetMetadataDto implements IAssetMetadataDto {
    /** Comment set in the metadata. */
    comment?: string | undefined;
    /** Title of the asset. */
    title?: string | undefined;
    /** A brief description of the asset from the metadata. */
    description?: string | undefined;
    /** The original source or creator of the asset. */
    source?: string | undefined;
    /** The orientation of the image. */
    orientation?: ImageOrientation | undefined;
    /** Whether the flash was fired when the asset was taken. */
    flashFired?: boolean | undefined;
    /** The lens model used to take the asset. */
    lensModel?: string | undefined;
    /** The focal length of the camera in millimeters. */
    focalLength?: number | undefined;
    /** Exposure time in seconds. */
    exposureTime?: number | undefined;
    /** The f-number (aperture) of the camera. */
    fNumber?: number | undefined;
    /** ISO speed of the camera. */
    isoSpeedRatings?: number | undefined;
    /** The camera model used to take the asset. */
    cameraModel?: string | undefined;
    /** Latitude where the asset was taken (EXIF data). */
    latitude?: number | undefined;
    /** Longitude where the asset was taken (EXIF data). */
    longitude?: number | undefined;
    /** Altitude where the asset was taken (EXIF data) in meters. */
    altitude?: number | undefined;
    /** Manufacturer of the camera or recording equipment. */
    make?: string | undefined;
    /** Model name of the camera or recording equipment. */
    model?: string | undefined;
    /** Name of the software that created or modified the asset. */
    software?: string | undefined;
    createdDate?: Date | undefined;
    createdBy?: string | undefined;
    /** The duration of the asset, typically for video or audio files, in seconds. */
    duration?: string | undefined;
    /** List of codecs used for encoding the asset. */
    codecs?: string[] | undefined;
    /** The frame rate of the asset, typically for video files, in frames per second. */
    frameRate?: number | undefined;
    /** The bitrate of the asset, typically for video or audio files, in kilobits per second (kbps). */
    bitrate?: number | undefined;
    /** The total number of pages in the asset, applicable to documents. */
    pageCount?: number | undefined;

    constructor(data?: IAssetMetadataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.comment = _data["comment"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.source = _data["source"];
            this.orientation = _data["orientation"];
            this.flashFired = _data["flashFired"];
            this.lensModel = _data["lensModel"];
            this.focalLength = _data["focalLength"];
            this.exposureTime = _data["exposureTime"];
            this.fNumber = _data["fNumber"];
            this.isoSpeedRatings = _data["isoSpeedRatings"];
            this.cameraModel = _data["cameraModel"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.altitude = _data["altitude"];
            this.make = _data["make"];
            this.model = _data["model"];
            this.software = _data["software"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.duration = _data["duration"];
            if (Array.isArray(_data["codecs"])) {
                this.codecs = [] as any;
                for (let item of _data["codecs"])
                    this.codecs!.push(item);
            }
            this.frameRate = _data["frameRate"];
            this.bitrate = _data["bitrate"];
            this.pageCount = _data["pageCount"];
        }
    }

    static fromJS(data: any): AssetMetadataDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetMetadataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["comment"] = this.comment;
        data["title"] = this.title;
        data["description"] = this.description;
        data["source"] = this.source;
        data["orientation"] = this.orientation;
        data["flashFired"] = this.flashFired;
        data["lensModel"] = this.lensModel;
        data["focalLength"] = this.focalLength;
        data["exposureTime"] = this.exposureTime;
        data["fNumber"] = this.fNumber;
        data["isoSpeedRatings"] = this.isoSpeedRatings;
        data["cameraModel"] = this.cameraModel;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["altitude"] = this.altitude;
        data["make"] = this.make;
        data["model"] = this.model;
        data["software"] = this.software;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["duration"] = this.duration;
        if (Array.isArray(this.codecs)) {
            data["codecs"] = [];
            for (let item of this.codecs)
                data["codecs"].push(item);
        }
        data["frameRate"] = this.frameRate;
        data["bitrate"] = this.bitrate;
        data["pageCount"] = this.pageCount;
        return data;
    }

    clone(): AssetMetadataDto {
        const json = this.toJSON();
        let result = new AssetMetadataDto();
        result.init(json);
        return result;
    }
}

export interface IAssetMetadataDto {
    /** Comment set in the metadata. */
    comment?: string | undefined;
    /** Title of the asset. */
    title?: string | undefined;
    /** A brief description of the asset from the metadata. */
    description?: string | undefined;
    /** The original source or creator of the asset. */
    source?: string | undefined;
    /** The orientation of the image. */
    orientation?: ImageOrientation | undefined;
    /** Whether the flash was fired when the asset was taken. */
    flashFired?: boolean | undefined;
    /** The lens model used to take the asset. */
    lensModel?: string | undefined;
    /** The focal length of the camera in millimeters. */
    focalLength?: number | undefined;
    /** Exposure time in seconds. */
    exposureTime?: number | undefined;
    /** The f-number (aperture) of the camera. */
    fNumber?: number | undefined;
    /** ISO speed of the camera. */
    isoSpeedRatings?: number | undefined;
    /** The camera model used to take the asset. */
    cameraModel?: string | undefined;
    /** Latitude where the asset was taken (EXIF data). */
    latitude?: number | undefined;
    /** Longitude where the asset was taken (EXIF data). */
    longitude?: number | undefined;
    /** Altitude where the asset was taken (EXIF data) in meters. */
    altitude?: number | undefined;
    /** Manufacturer of the camera or recording equipment. */
    make?: string | undefined;
    /** Model name of the camera or recording equipment. */
    model?: string | undefined;
    /** Name of the software that created or modified the asset. */
    software?: string | undefined;
    createdDate?: Date | undefined;
    createdBy?: string | undefined;
    /** The duration of the asset, typically for video or audio files, in seconds. */
    duration?: string | undefined;
    /** List of codecs used for encoding the asset. */
    codecs?: string[] | undefined;
    /** The frame rate of the asset, typically for video files, in frames per second. */
    frameRate?: number | undefined;
    /** The bitrate of the asset, typically for video or audio files, in kilobits per second (kbps). */
    bitrate?: number | undefined;
    /** The total number of pages in the asset, applicable to documents. */
    pageCount?: number | undefined;
}

export enum ImageOrientation {
    None = "none",
    TopLeft = "topLeft",
    TopRight = "topRight",
    BottomRight = "bottomRight",
    BottomLeft = "bottomLeft",
    LeftTop = "leftTop",
    RightTop = "rightTop",
    RightBottom = "rightBottom",
    LeftBottom = "leftBottom",
}

export class TextDisplayDto extends DisplayDto implements ITextDisplayDto {
    value!: InternationalizedString;

    constructor(data?: ITextDisplayDto) {
        super(data);
        if (!data) {
            this.value = new InternationalizedString();
        }
        this._discriminator = "TextDisplayDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] ? InternationalizedString.fromJS(_data["value"]) : new InternationalizedString();
        }
    }

    static override fromJS(data: any): TextDisplayDto {
        data = typeof data === 'object' ? data : {};
        let result = new TextDisplayDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): TextDisplayDto {
        const json = this.toJSON();
        let result = new TextDisplayDto();
        result.init(json);
        return result;
    }
}

export interface ITextDisplayDto extends IDisplayDto {
    value: InternationalizedString;
}

export class RichTextDisplayDto extends DisplayDto implements IRichTextDisplayDto {
    value!: InternationalizedDocument;

    constructor(data?: IRichTextDisplayDto) {
        super(data);
        if (!data) {
            this.value = new InternationalizedDocument();
        }
        this._discriminator = "RichTextDisplayDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] ? InternationalizedDocument.fromJS(_data["value"]) : new InternationalizedDocument();
        }
    }

    static override fromJS(data: any): RichTextDisplayDto {
        data = typeof data === 'object' ? data : {};
        let result = new RichTextDisplayDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): RichTextDisplayDto {
        const json = this.toJSON();
        let result = new RichTextDisplayDto();
        result.init(json);
        return result;
    }
}

export interface IRichTextDisplayDto extends IDisplayDto {
    value: InternationalizedDocument;
}

export class InternationalizedDocument implements IInternationalizedDocument {
    translations!: { [key: string]: Node; };

    constructor(data?: IInternationalizedDocument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.translations = {};
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["translations"]) {
                this.translations = {} as any;
                for (let key in _data["translations"]) {
                    if (_data["translations"].hasOwnProperty(key))
                        (this.translations as any)![key] = _data["translations"][key] ? Node.fromJS(_data["translations"][key]) : new Node();
                }
            }
        }
    }

    static fromJS(data: any): InternationalizedDocument {
        data = typeof data === 'object' ? data : {};
        let result = new InternationalizedDocument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.translations) {
            data["translations"] = {};
            for (let key in this.translations) {
                if (this.translations.hasOwnProperty(key))
                    (data["translations"] as any)[key] = this.translations[key] ? this.translations[key].toJSON() : undefined as any;
            }
        }
        return data;
    }

    clone(): InternationalizedDocument {
        const json = this.toJSON();
        let result = new InternationalizedDocument();
        result.init(json);
        return result;
    }
}

export interface IInternationalizedDocument {
    translations: { [key: string]: Node; };
}

export class Node implements INode {
    type!: NodeType;
    attrs?: NodeAttribute | undefined;
    content?: Node[] | undefined;
    marks?: Mark[] | undefined;
    text?: string | undefined;

    constructor(data?: INode) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.attrs = _data["attrs"] ? NodeAttribute.fromJS(_data["attrs"]) : undefined as any;
            if (Array.isArray(_data["content"])) {
                this.content = [] as any;
                for (let item of _data["content"])
                    this.content!.push(Node.fromJS(item));
            }
            if (Array.isArray(_data["marks"])) {
                this.marks = [] as any;
                for (let item of _data["marks"])
                    this.marks!.push(Mark.fromJS(item));
            }
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): Node {
        data = typeof data === 'object' ? data : {};
        let result = new Node();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["attrs"] = this.attrs ? this.attrs.toJSON() : undefined as any;
        if (Array.isArray(this.content)) {
            data["content"] = [];
            for (let item of this.content)
                data["content"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.marks)) {
            data["marks"] = [];
            for (let item of this.marks)
                data["marks"].push(item ? item.toJSON() : undefined as any);
        }
        data["text"] = this.text;
        return data;
    }

    clone(): Node {
        const json = this.toJSON();
        let result = new Node();
        result.init(json);
        return result;
    }
}

export interface INode {
    type: NodeType;
    attrs?: NodeAttribute | undefined;
    content?: Node[] | undefined;
    marks?: Mark[] | undefined;
    text?: string | undefined;
}

export enum NodeType {
    Blockquote = "blockquote",
    BulletList = "bulletList",
    Doc = "doc",
    HardBreak = "hardBreak",
    Heading = "heading",
    HorizontalRule = "horizontalRule",
    ListItem = "listItem",
    OrderedList = "orderedList",
    Paragraph = "paragraph",
    Table = "table",
    TableRow = "tableRow",
    TableHeader = "tableHeader",
    TableCell = "tableCell",
    Text = "text",
    Video = "video",
    Audio = "audio",
    Image = "image",
    Html = "html",
    Details = "details",
    DetailsSummary = "detailsSummary",
    DetailsContent = "detailsContent",
    Figure = "figure",
    Figcaption = "figcaption",
    Panel = "panel",
    Token = "token",
}

export class NodeAttribute implements INodeAttribute {
    display?: string | undefined;
    level?: number | undefined;
    textAlign?: string | undefined;
    colspan?: number | undefined;
    rowspan?: number | undefined;
    colwidth?: number | undefined;
    start?: number | undefined;
    assetId?: string | undefined;
    src?: string | undefined;
    alt?: string | undefined;
    title?: string | undefined;
    caption?: string | undefined;
    html?: string | undefined;
    type?: string | undefined;
    label?: string | undefined;
    id?: string | undefined;

    constructor(data?: INodeAttribute) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.display = _data["display"];
            this.level = _data["level"];
            this.textAlign = _data["textAlign"];
            this.colspan = _data["colspan"];
            this.rowspan = _data["rowspan"];
            this.colwidth = _data["colwidth"];
            this.start = _data["start"];
            this.assetId = _data["assetId"];
            this.src = _data["src"];
            this.alt = _data["alt"];
            this.title = _data["title"];
            this.caption = _data["caption"];
            this.html = _data["html"];
            this.type = _data["type"];
            this.label = _data["label"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): NodeAttribute {
        data = typeof data === 'object' ? data : {};
        let result = new NodeAttribute();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["display"] = this.display;
        data["level"] = this.level;
        data["textAlign"] = this.textAlign;
        data["colspan"] = this.colspan;
        data["rowspan"] = this.rowspan;
        data["colwidth"] = this.colwidth;
        data["start"] = this.start;
        data["assetId"] = this.assetId;
        data["src"] = this.src;
        data["alt"] = this.alt;
        data["title"] = this.title;
        data["caption"] = this.caption;
        data["html"] = this.html;
        data["type"] = this.type;
        data["label"] = this.label;
        data["id"] = this.id;
        return data;
    }

    clone(): NodeAttribute {
        const json = this.toJSON();
        let result = new NodeAttribute();
        result.init(json);
        return result;
    }
}

export interface INodeAttribute {
    display?: string | undefined;
    level?: number | undefined;
    textAlign?: string | undefined;
    colspan?: number | undefined;
    rowspan?: number | undefined;
    colwidth?: number | undefined;
    start?: number | undefined;
    assetId?: string | undefined;
    src?: string | undefined;
    alt?: string | undefined;
    title?: string | undefined;
    caption?: string | undefined;
    html?: string | undefined;
    type?: string | undefined;
    label?: string | undefined;
    id?: string | undefined;
}

export class Mark implements IMark {
    type!: MarkType;
    attrs?: MarkAttribute | undefined;

    constructor(data?: IMark) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.attrs = _data["attrs"] ? MarkAttribute.fromJS(_data["attrs"]) : undefined as any;
        }
    }

    static fromJS(data: any): Mark {
        data = typeof data === 'object' ? data : {};
        let result = new Mark();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["attrs"] = this.attrs ? this.attrs.toJSON() : undefined as any;
        return data;
    }

    clone(): Mark {
        const json = this.toJSON();
        let result = new Mark();
        result.init(json);
        return result;
    }
}

export interface IMark {
    type: MarkType;
    attrs?: MarkAttribute | undefined;
}

export enum MarkType {
    Bold = "bold",
    Italic = "italic",
    Link = "link",
    Strike = "strike",
    Subscript = "subscript",
    Superscript = "superscript",
    Underline = "underline",
    Reference = "reference",
}

export class MarkAttribute implements IMarkAttribute {
    target?: string | undefined;
    title?: string | undefined;
    class?: string | undefined;
    rel?: string | undefined;
    href?: string | undefined;
    fileId?: string | undefined;
    referenceId?: string | undefined;
    referenceType?: ReferenceType | undefined;

    constructor(data?: IMarkAttribute) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.target = _data["target"];
            this.title = _data["title"];
            this.class = _data["class"];
            this.rel = _data["rel"];
            this.href = _data["href"];
            this.fileId = _data["fileId"];
            this.referenceId = _data["referenceId"];
            this.referenceType = _data["referenceType"];
        }
    }

    static fromJS(data: any): MarkAttribute {
        data = typeof data === 'object' ? data : {};
        let result = new MarkAttribute();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["target"] = this.target;
        data["title"] = this.title;
        data["class"] = this.class;
        data["rel"] = this.rel;
        data["href"] = this.href;
        data["fileId"] = this.fileId;
        data["referenceId"] = this.referenceId;
        data["referenceType"] = this.referenceType;
        return data;
    }

    clone(): MarkAttribute {
        const json = this.toJSON();
        let result = new MarkAttribute();
        result.init(json);
        return result;
    }
}

export interface IMarkAttribute {
    target?: string | undefined;
    title?: string | undefined;
    class?: string | undefined;
    rel?: string | undefined;
    href?: string | undefined;
    fileId?: string | undefined;
    referenceId?: string | undefined;
    referenceType?: ReferenceType | undefined;
}

export enum ReferenceType {
    Asset = "asset",
    Page = "page",
}

export class QuestionnaireReferenceDisplayDto extends DisplayDto implements IQuestionnaireReferenceDisplayDto {
    questionnaireId?: string | undefined;

    constructor(data?: IQuestionnaireReferenceDisplayDto) {
        super(data);
        this._discriminator = "QuestionnaireReferenceDisplayDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.questionnaireId = _data["questionnaireId"];
        }
    }

    static override fromJS(data: any): QuestionnaireReferenceDisplayDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionnaireReferenceDisplayDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questionnaireId"] = this.questionnaireId;
        super.toJSON(data);
        return data;
    }

    clone(): QuestionnaireReferenceDisplayDto {
        const json = this.toJSON();
        let result = new QuestionnaireReferenceDisplayDto();
        result.init(json);
        return result;
    }
}

export interface IQuestionnaireReferenceDisplayDto extends IDisplayDto {
    questionnaireId?: string | undefined;
}

export abstract class PropertyDto extends ContentDto implements IPropertyDto {
    text!: InternationalizedString;

    constructor(data?: IPropertyDto) {
        super(data);
        if (!data) {
            this.text = new InternationalizedString();
        }
        this._discriminator = "PropertyDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.text = _data["text"] ? InternationalizedString.fromJS(_data["text"]) : new InternationalizedString();
        }
    }

    static override fromJS(data: any): PropertyDto {
        data = typeof data === 'object' ? data : {};
        if (data["$type"] === "TextPropertyDto") {
            let result = new TextPropertyDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "NumberPropertyDto") {
            let result = new NumberPropertyDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "DatePropertyDto") {
            let result = new DatePropertyDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "ChoicePropertyDto") {
            let result = new ChoicePropertyDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "ContainerPropertyDto") {
            let result = new ContainerPropertyDto();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'PropertyDto' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text ? this.text.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): PropertyDto {
        throw new Error("The abstract class 'PropertyDto' cannot be instantiated.");
    }
}

export interface IPropertyDto extends IContentDto {
    text: InternationalizedString;
}

export class TextPropertyDto extends PropertyDto implements ITextPropertyDto {
    validation!: TextPropertyValidation;
    multiline!: boolean;
    value?: TextValueDto | undefined;

    constructor(data?: ITextPropertyDto) {
        super(data);
        if (!data) {
            this.validation = new TextPropertyValidation();
        }
        this._discriminator = "TextPropertyDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.validation = _data["validation"] ? TextPropertyValidation.fromJS(_data["validation"]) : new TextPropertyValidation();
            this.multiline = _data["multiline"];
            this.value = _data["value"] ? TextValueDto.fromJS(_data["value"]) : undefined as any;
        }
    }

    static override fromJS(data: any): TextPropertyDto {
        data = typeof data === 'object' ? data : {};
        let result = new TextPropertyDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["validation"] = this.validation ? this.validation.toJSON() : undefined as any;
        data["multiline"] = this.multiline;
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): TextPropertyDto {
        const json = this.toJSON();
        let result = new TextPropertyDto();
        result.init(json);
        return result;
    }
}

export interface ITextPropertyDto extends IPropertyDto {
    validation: TextPropertyValidation;
    multiline: boolean;
    value?: TextValueDto | undefined;
}

export abstract class PropertyValidation implements IPropertyValidation {
    required!: boolean;

    protected _discriminator: string;

    constructor(data?: IPropertyValidation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        this._discriminator = "PropertyValidation";
    }

    init(_data?: any) {
        if (_data) {
            this.required = _data["required"];
        }
    }

    static fromJS(data: any): PropertyValidation {
        data = typeof data === 'object' ? data : {};
        if (data["$type"] === "TextPropertyValidation") {
            let result = new TextPropertyValidation();
            result.init(data);
            return result;
        }
        if (data["$type"] === "DatePropertyValidation") {
            let result = new DatePropertyValidation();
            result.init(data);
            return result;
        }
        if (data["$type"] === "NumberPropertyValidation") {
            let result = new NumberPropertyValidation();
            result.init(data);
            return result;
        }
        if (data["$type"] === "ChoicePropertyValidation") {
            let result = new ChoicePropertyValidation();
            result.init(data);
            return result;
        }
        if (data["$type"] === "ContainerPropertyValidation") {
            let result = new ContainerPropertyValidation();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'PropertyValidation' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["$type"] = this._discriminator;
        data["required"] = this.required;
        return data;
    }

    clone(): PropertyValidation {
        throw new Error("The abstract class 'PropertyValidation' cannot be instantiated.");
    }
}

export interface IPropertyValidation {
    required: boolean;
}

export class TextPropertyValidation extends PropertyValidation implements ITextPropertyValidation {
    minLength?: number | undefined;
    maxLength?: number | undefined;
    pattern?: string | undefined;

    constructor(data?: ITextPropertyValidation) {
        super(data);
        this._discriminator = "TextPropertyValidation";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.minLength = _data["minLength"];
            this.maxLength = _data["maxLength"];
            this.pattern = _data["pattern"];
        }
    }

    static override fromJS(data: any): TextPropertyValidation {
        data = typeof data === 'object' ? data : {};
        let result = new TextPropertyValidation();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["minLength"] = this.minLength;
        data["maxLength"] = this.maxLength;
        data["pattern"] = this.pattern;
        super.toJSON(data);
        return data;
    }

    clone(): TextPropertyValidation {
        const json = this.toJSON();
        let result = new TextPropertyValidation();
        result.init(json);
        return result;
    }
}

export interface ITextPropertyValidation extends IPropertyValidation {
    minLength?: number | undefined;
    maxLength?: number | undefined;
    pattern?: string | undefined;
}

export class DatePropertyValidation extends PropertyValidation implements IDatePropertyValidation {
    min?: Date | undefined;
    max?: Date | undefined;

    constructor(data?: IDatePropertyValidation) {
        super(data);
        this._discriminator = "DatePropertyValidation";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.min = _data["min"] ? new Date(_data["min"].toString()) : undefined as any;
            this.max = _data["max"] ? new Date(_data["max"].toString()) : undefined as any;
        }
    }

    static override fromJS(data: any): DatePropertyValidation {
        data = typeof data === 'object' ? data : {};
        let result = new DatePropertyValidation();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["min"] = this.min ? formatDate(this.min) : undefined as any;
        data["max"] = this.max ? formatDate(this.max) : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): DatePropertyValidation {
        const json = this.toJSON();
        let result = new DatePropertyValidation();
        result.init(json);
        return result;
    }
}

export interface IDatePropertyValidation extends IPropertyValidation {
    min?: Date | undefined;
    max?: Date | undefined;
}

export class NumberPropertyValidation extends PropertyValidation implements INumberPropertyValidation {
    min?: number | undefined;
    max?: number | undefined;
    fraction!: boolean;

    constructor(data?: INumberPropertyValidation) {
        super(data);
        this._discriminator = "NumberPropertyValidation";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.min = _data["min"];
            this.max = _data["max"];
            this.fraction = _data["fraction"];
        }
    }

    static override fromJS(data: any): NumberPropertyValidation {
        data = typeof data === 'object' ? data : {};
        let result = new NumberPropertyValidation();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["min"] = this.min;
        data["max"] = this.max;
        data["fraction"] = this.fraction;
        super.toJSON(data);
        return data;
    }

    clone(): NumberPropertyValidation {
        const json = this.toJSON();
        let result = new NumberPropertyValidation();
        result.init(json);
        return result;
    }
}

export interface INumberPropertyValidation extends IPropertyValidation {
    min?: number | undefined;
    max?: number | undefined;
    fraction: boolean;
}

export class ChoicePropertyValidation extends PropertyValidation implements IChoicePropertyValidation {

    constructor(data?: IChoicePropertyValidation) {
        super(data);
        this._discriminator = "ChoicePropertyValidation";
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ChoicePropertyValidation {
        data = typeof data === 'object' ? data : {};
        let result = new ChoicePropertyValidation();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): ChoicePropertyValidation {
        const json = this.toJSON();
        let result = new ChoicePropertyValidation();
        result.init(json);
        return result;
    }
}

export interface IChoicePropertyValidation extends IPropertyValidation {
}

export class ContainerPropertyValidation extends PropertyValidation implements IContainerPropertyValidation {

    constructor(data?: IContainerPropertyValidation) {
        super(data);
        this._discriminator = "ContainerPropertyValidation";
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ContainerPropertyValidation {
        data = typeof data === 'object' ? data : {};
        let result = new ContainerPropertyValidation();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): ContainerPropertyValidation {
        const json = this.toJSON();
        let result = new ContainerPropertyValidation();
        result.init(json);
        return result;
    }
}

export interface IContainerPropertyValidation extends IPropertyValidation {
}

export abstract class ValueDto implements IValueDto {
    propertyId!: string;

    protected _discriminator: string;

    constructor(data?: IValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        this._discriminator = "ValueDto";
    }

    init(_data?: any) {
        if (_data) {
            this.propertyId = _data["propertyId"];
        }
    }

    static fromJS(data: any): ValueDto {
        data = typeof data === 'object' ? data : {};
        if (data["$type"] === "TextValueDto") {
            let result = new TextValueDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "DateValueDto") {
            let result = new DateValueDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "NumberValueDto") {
            let result = new NumberValueDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "ChoiceValueDto") {
            let result = new ChoiceValueDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "ContainerValueDto") {
            let result = new ContainerValueDto();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'ValueDto' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["$type"] = this._discriminator;
        data["propertyId"] = this.propertyId;
        return data;
    }

    clone(): ValueDto {
        throw new Error("The abstract class 'ValueDto' cannot be instantiated.");
    }
}

export interface IValueDto {
    propertyId: string;
}

export class TextValueDto extends ValueDto implements ITextValueDto {
    value?: string | undefined;

    constructor(data?: ITextValueDto) {
        super(data);
        this._discriminator = "TextValueDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"];
        }
    }

    static override fromJS(data: any): TextValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new TextValueDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        super.toJSON(data);
        return data;
    }

    clone(): TextValueDto {
        const json = this.toJSON();
        let result = new TextValueDto();
        result.init(json);
        return result;
    }
}

export interface ITextValueDto extends IValueDto {
    value?: string | undefined;
}

export class DateValueDto extends ValueDto implements IDateValueDto {
    value?: Date | undefined;

    constructor(data?: IDateValueDto) {
        super(data);
        this._discriminator = "DateValueDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] ? new Date(_data["value"].toString()) : undefined as any;
        }
    }

    static override fromJS(data: any): DateValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new DateValueDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? formatDate(this.value) : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): DateValueDto {
        const json = this.toJSON();
        let result = new DateValueDto();
        result.init(json);
        return result;
    }
}

export interface IDateValueDto extends IValueDto {
    value?: Date | undefined;
}

export class NumberValueDto extends ValueDto implements INumberValueDto {
    value?: number | undefined;

    constructor(data?: INumberValueDto) {
        super(data);
        this._discriminator = "NumberValueDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"];
        }
    }

    static override fromJS(data: any): NumberValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new NumberValueDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        super.toJSON(data);
        return data;
    }

    clone(): NumberValueDto {
        const json = this.toJSON();
        let result = new NumberValueDto();
        result.init(json);
        return result;
    }
}

export interface INumberValueDto extends IValueDto {
    value?: number | undefined;
}

export class ChoiceValueDto extends ValueDto implements IChoiceValueDto {
    values?: string[] | undefined;

    constructor(data?: IChoiceValueDto) {
        super(data);
        this._discriminator = "ChoiceValueDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(item);
            }
        }
    }

    static override fromJS(data: any): ChoiceValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChoiceValueDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item);
        }
        super.toJSON(data);
        return data;
    }

    clone(): ChoiceValueDto {
        const json = this.toJSON();
        let result = new ChoiceValueDto();
        result.init(json);
        return result;
    }
}

export interface IChoiceValueDto extends IValueDto {
    values?: string[] | undefined;
}

export class ContainerValueDto extends ValueDto implements IContainerValueDto {
    values?: string[] | undefined;

    constructor(data?: IContainerValueDto) {
        super(data);
        this._discriminator = "ContainerValueDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(item);
            }
        }
    }

    static override fromJS(data: any): ContainerValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContainerValueDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item);
        }
        super.toJSON(data);
        return data;
    }

    clone(): ContainerValueDto {
        const json = this.toJSON();
        let result = new ContainerValueDto();
        result.init(json);
        return result;
    }
}

export interface IContainerValueDto extends IValueDto {
    values?: string[] | undefined;
}

export class NumberPropertyDto extends PropertyDto implements INumberPropertyDto {
    validation!: NumberPropertyValidation;
    value?: NumberValueDto | undefined;

    constructor(data?: INumberPropertyDto) {
        super(data);
        if (!data) {
            this.validation = new NumberPropertyValidation();
        }
        this._discriminator = "NumberPropertyDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.validation = _data["validation"] ? NumberPropertyValidation.fromJS(_data["validation"]) : new NumberPropertyValidation();
            this.value = _data["value"] ? NumberValueDto.fromJS(_data["value"]) : undefined as any;
        }
    }

    static override fromJS(data: any): NumberPropertyDto {
        data = typeof data === 'object' ? data : {};
        let result = new NumberPropertyDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["validation"] = this.validation ? this.validation.toJSON() : undefined as any;
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): NumberPropertyDto {
        const json = this.toJSON();
        let result = new NumberPropertyDto();
        result.init(json);
        return result;
    }
}

export interface INumberPropertyDto extends IPropertyDto {
    validation: NumberPropertyValidation;
    value?: NumberValueDto | undefined;
}

export class DatePropertyDto extends PropertyDto implements IDatePropertyDto {
    validation!: DatePropertyValidation;
    value?: DateValueDto | undefined;

    constructor(data?: IDatePropertyDto) {
        super(data);
        if (!data) {
            this.validation = new DatePropertyValidation();
        }
        this._discriminator = "DatePropertyDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.validation = _data["validation"] ? DatePropertyValidation.fromJS(_data["validation"]) : new DatePropertyValidation();
            this.value = _data["value"] ? DateValueDto.fromJS(_data["value"]) : undefined as any;
        }
    }

    static override fromJS(data: any): DatePropertyDto {
        data = typeof data === 'object' ? data : {};
        let result = new DatePropertyDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["validation"] = this.validation ? this.validation.toJSON() : undefined as any;
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): DatePropertyDto {
        const json = this.toJSON();
        let result = new DatePropertyDto();
        result.init(json);
        return result;
    }
}

export interface IDatePropertyDto extends IPropertyDto {
    validation: DatePropertyValidation;
    value?: DateValueDto | undefined;
}

export class ChoicePropertyDto extends PropertyDto implements IChoicePropertyDto {
    validation!: ChoicePropertyValidation;
    multiSelection!: boolean;
    choices!: SelectionItem[];
    value?: ChoiceValueDto | undefined;

    constructor(data?: IChoicePropertyDto) {
        super(data);
        if (!data) {
            this.validation = new ChoicePropertyValidation();
            this.choices = [];
        }
        this._discriminator = "ChoicePropertyDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.validation = _data["validation"] ? ChoicePropertyValidation.fromJS(_data["validation"]) : new ChoicePropertyValidation();
            this.multiSelection = _data["multiSelection"];
            if (Array.isArray(_data["choices"])) {
                this.choices = [] as any;
                for (let item of _data["choices"])
                    this.choices!.push(SelectionItem.fromJS(item));
            }
            this.value = _data["value"] ? ChoiceValueDto.fromJS(_data["value"]) : undefined as any;
        }
    }

    static override fromJS(data: any): ChoicePropertyDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChoicePropertyDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["validation"] = this.validation ? this.validation.toJSON() : undefined as any;
        data["multiSelection"] = this.multiSelection;
        if (Array.isArray(this.choices)) {
            data["choices"] = [];
            for (let item of this.choices)
                data["choices"].push(item ? item.toJSON() : undefined as any);
        }
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): ChoicePropertyDto {
        const json = this.toJSON();
        let result = new ChoicePropertyDto();
        result.init(json);
        return result;
    }
}

export interface IChoicePropertyDto extends IPropertyDto {
    validation: ChoicePropertyValidation;
    multiSelection: boolean;
    choices: SelectionItem[];
    value?: ChoiceValueDto | undefined;
}

export class SelectionItem implements ISelectionItem {
    id!: string;
    value!: string;
    label!: InternationalizedString;

    constructor(data?: ISelectionItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.label = new InternationalizedString();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.value = _data["value"];
            this.label = _data["label"] ? InternationalizedString.fromJS(_data["label"]) : new InternationalizedString();
        }
    }

    static fromJS(data: any): SelectionItem {
        data = typeof data === 'object' ? data : {};
        let result = new SelectionItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["value"] = this.value;
        data["label"] = this.label ? this.label.toJSON() : undefined as any;
        return data;
    }

    clone(): SelectionItem {
        const json = this.toJSON();
        let result = new SelectionItem();
        result.init(json);
        return result;
    }
}

export interface ISelectionItem {
    id: string;
    value: string;
    label: InternationalizedString;
}

export class ContainerPropertyDto extends PropertyDto implements IContainerPropertyDto {
    validation!: ContainerPropertyValidation;
    multiSelection!: boolean;
    containerType!: ContainerType;
    containerId!: string;
    value?: ContainerValueDto | undefined;

    constructor(data?: IContainerPropertyDto) {
        super(data);
        if (!data) {
            this.validation = new ContainerPropertyValidation();
        }
        this._discriminator = "ContainerPropertyDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.validation = _data["validation"] ? ContainerPropertyValidation.fromJS(_data["validation"]) : new ContainerPropertyValidation();
            this.multiSelection = _data["multiSelection"];
            this.containerType = _data["containerType"];
            this.containerId = _data["containerId"];
            this.value = _data["value"] ? ContainerValueDto.fromJS(_data["value"]) : undefined as any;
        }
    }

    static override fromJS(data: any): ContainerPropertyDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContainerPropertyDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["validation"] = this.validation ? this.validation.toJSON() : undefined as any;
        data["multiSelection"] = this.multiSelection;
        data["containerType"] = this.containerType;
        data["containerId"] = this.containerId;
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): ContainerPropertyDto {
        const json = this.toJSON();
        let result = new ContainerPropertyDto();
        result.init(json);
        return result;
    }
}

export interface IContainerPropertyDto extends IPropertyDto {
    validation: ContainerPropertyValidation;
    multiSelection: boolean;
    containerType: ContainerType;
    containerId: string;
    value?: ContainerValueDto | undefined;
}

export enum ContainerType {
    Questionnaire = "questionnaire",
    ContextObject = "contextObject",
    AppPage = "appPage",
    Terminology = "terminology",
    ContainerGroup = "containerGroup",
    InterventionModule = "interventionModule",
}

export abstract class QuestionDto extends ContentDto implements IQuestionDto {
    text!: InternationalizedString;
    hint?: InternationalizedDocument | undefined;

    constructor(data?: IQuestionDto) {
        super(data);
        if (!data) {
            this.text = new InternationalizedString();
        }
        this._discriminator = "QuestionDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.text = _data["text"] ? InternationalizedString.fromJS(_data["text"]) : new InternationalizedString();
            this.hint = _data["hint"] ? InternationalizedDocument.fromJS(_data["hint"]) : undefined as any;
        }
    }

    static override fromJS(data: any): QuestionDto {
        data = typeof data === 'object' ? data : {};
        if (data["$type"] === "LikertQuestionDto") {
            let result = new LikertQuestionDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "MatrixQuestionDto") {
            let result = new MatrixQuestionDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "ChoiceQuestionDto") {
            let result = new ChoiceQuestionDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "ContainerQuestionDto") {
            let result = new ContainerQuestionDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "BoolQuestionDto") {
            let result = new BoolQuestionDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "TextQuestionDto") {
            let result = new TextQuestionDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "NumberQuestionDto") {
            let result = new NumberQuestionDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "DateQuestionDto") {
            let result = new DateQuestionDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "TimeQuestionDto") {
            let result = new TimeQuestionDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "DateTimeQuestionDto") {
            let result = new DateTimeQuestionDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "SliderQuestionDto") {
            let result = new SliderQuestionDto();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'QuestionDto' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text ? this.text.toJSON() : undefined as any;
        data["hint"] = this.hint ? this.hint.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): QuestionDto {
        throw new Error("The abstract class 'QuestionDto' cannot be instantiated.");
    }
}

export interface IQuestionDto extends IContentDto {
    text: InternationalizedString;
    hint?: InternationalizedDocument | undefined;
}

export class LikertQuestionDto extends QuestionDto implements ILikertQuestionDto {
    validation!: LikertQuestionValidation;
    scale!: LikertScaleItem[];
    answer?: LikertAnswerDto | undefined;

    constructor(data?: ILikertQuestionDto) {
        super(data);
        if (!data) {
            this.validation = new LikertQuestionValidation();
            this.scale = [];
        }
        this._discriminator = "LikertQuestionDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.validation = _data["validation"] ? LikertQuestionValidation.fromJS(_data["validation"]) : new LikertQuestionValidation();
            if (Array.isArray(_data["scale"])) {
                this.scale = [] as any;
                for (let item of _data["scale"])
                    this.scale!.push(LikertScaleItem.fromJS(item));
            }
            this.answer = _data["answer"] ? LikertAnswerDto.fromJS(_data["answer"]) : undefined as any;
        }
    }

    static override fromJS(data: any): LikertQuestionDto {
        data = typeof data === 'object' ? data : {};
        let result = new LikertQuestionDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["validation"] = this.validation ? this.validation.toJSON() : undefined as any;
        if (Array.isArray(this.scale)) {
            data["scale"] = [];
            for (let item of this.scale)
                data["scale"].push(item ? item.toJSON() : undefined as any);
        }
        data["answer"] = this.answer ? this.answer.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): LikertQuestionDto {
        const json = this.toJSON();
        let result = new LikertQuestionDto();
        result.init(json);
        return result;
    }
}

export interface ILikertQuestionDto extends IQuestionDto {
    validation: LikertQuestionValidation;
    scale: LikertScaleItem[];
    answer?: LikertAnswerDto | undefined;
}

export abstract class QuestionValidation implements IQuestionValidation {
    required!: boolean;

    protected _discriminator: string;

    constructor(data?: IQuestionValidation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        this._discriminator = "QuestionValidation";
    }

    init(_data?: any) {
        if (_data) {
            this.required = _data["required"];
        }
    }

    static fromJS(data: any): QuestionValidation {
        data = typeof data === 'object' ? data : {};
        if (data["$type"] === "LikertQuestionValidation") {
            let result = new LikertQuestionValidation();
            result.init(data);
            return result;
        }
        if (data["$type"] === "ChoiceQuestionValidation") {
            let result = new ChoiceQuestionValidation();
            result.init(data);
            return result;
        }
        if (data["$type"] === "DateQuestionValidation") {
            let result = new DateQuestionValidation();
            result.init(data);
            return result;
        }
        if (data["$type"] === "DateTimeQuestionValidation") {
            let result = new DateTimeQuestionValidation();
            result.init(data);
            return result;
        }
        if (data["$type"] === "MatrixQuestionValidation") {
            let result = new MatrixQuestionValidation();
            result.init(data);
            return result;
        }
        if (data["$type"] === "NumberQuestionValidation") {
            let result = new NumberQuestionValidation();
            result.init(data);
            return result;
        }
        if (data["$type"] === "SliderQuestionValidation") {
            let result = new SliderQuestionValidation();
            result.init(data);
            return result;
        }
        if (data["$type"] === "TextQuestionValidation") {
            let result = new TextQuestionValidation();
            result.init(data);
            return result;
        }
        if (data["$type"] === "TimeQuestionValidation") {
            let result = new TimeQuestionValidation();
            result.init(data);
            return result;
        }
        if (data["$type"] === "BoolQuestionValidation") {
            let result = new BoolQuestionValidation();
            result.init(data);
            return result;
        }
        if (data["$type"] === "ContainerQuestionValidation") {
            let result = new ContainerQuestionValidation();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'QuestionValidation' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["$type"] = this._discriminator;
        data["required"] = this.required;
        return data;
    }

    clone(): QuestionValidation {
        throw new Error("The abstract class 'QuestionValidation' cannot be instantiated.");
    }
}

export interface IQuestionValidation {
    required: boolean;
}

export class LikertQuestionValidation extends QuestionValidation implements ILikertQuestionValidation {

    constructor(data?: ILikertQuestionValidation) {
        super(data);
        this._discriminator = "LikertQuestionValidation";
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): LikertQuestionValidation {
        data = typeof data === 'object' ? data : {};
        let result = new LikertQuestionValidation();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): LikertQuestionValidation {
        const json = this.toJSON();
        let result = new LikertQuestionValidation();
        result.init(json);
        return result;
    }
}

export interface ILikertQuestionValidation extends IQuestionValidation {
}

export class ChoiceQuestionValidation extends QuestionValidation implements IChoiceQuestionValidation {

    constructor(data?: IChoiceQuestionValidation) {
        super(data);
        this._discriminator = "ChoiceQuestionValidation";
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ChoiceQuestionValidation {
        data = typeof data === 'object' ? data : {};
        let result = new ChoiceQuestionValidation();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): ChoiceQuestionValidation {
        const json = this.toJSON();
        let result = new ChoiceQuestionValidation();
        result.init(json);
        return result;
    }
}

export interface IChoiceQuestionValidation extends IQuestionValidation {
}

export class DateQuestionValidation extends QuestionValidation implements IDateQuestionValidation {
    min?: Date | undefined;
    max?: Date | undefined;

    constructor(data?: IDateQuestionValidation) {
        super(data);
        this._discriminator = "DateQuestionValidation";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.min = _data["min"] ? new Date(_data["min"].toString()) : undefined as any;
            this.max = _data["max"] ? new Date(_data["max"].toString()) : undefined as any;
        }
    }

    static override fromJS(data: any): DateQuestionValidation {
        data = typeof data === 'object' ? data : {};
        let result = new DateQuestionValidation();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["min"] = this.min ? formatDate(this.min) : undefined as any;
        data["max"] = this.max ? formatDate(this.max) : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): DateQuestionValidation {
        const json = this.toJSON();
        let result = new DateQuestionValidation();
        result.init(json);
        return result;
    }
}

export interface IDateQuestionValidation extends IQuestionValidation {
    min?: Date | undefined;
    max?: Date | undefined;
}

export class DateTimeQuestionValidation extends QuestionValidation implements IDateTimeQuestionValidation {
    min?: Date | undefined;
    max?: Date | undefined;

    constructor(data?: IDateTimeQuestionValidation) {
        super(data);
        this._discriminator = "DateTimeQuestionValidation";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.min = _data["min"] ? new Date(_data["min"].toString()) : undefined as any;
            this.max = _data["max"] ? new Date(_data["max"].toString()) : undefined as any;
        }
    }

    static override fromJS(data: any): DateTimeQuestionValidation {
        data = typeof data === 'object' ? data : {};
        let result = new DateTimeQuestionValidation();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["min"] = this.min ? this.min.toISOString() : undefined as any;
        data["max"] = this.max ? this.max.toISOString() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): DateTimeQuestionValidation {
        const json = this.toJSON();
        let result = new DateTimeQuestionValidation();
        result.init(json);
        return result;
    }
}

export interface IDateTimeQuestionValidation extends IQuestionValidation {
    min?: Date | undefined;
    max?: Date | undefined;
}

export class MatrixQuestionValidation extends QuestionValidation implements IMatrixQuestionValidation {

    constructor(data?: IMatrixQuestionValidation) {
        super(data);
        this._discriminator = "MatrixQuestionValidation";
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): MatrixQuestionValidation {
        data = typeof data === 'object' ? data : {};
        let result = new MatrixQuestionValidation();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): MatrixQuestionValidation {
        const json = this.toJSON();
        let result = new MatrixQuestionValidation();
        result.init(json);
        return result;
    }
}

export interface IMatrixQuestionValidation extends IQuestionValidation {
}

export class NumberQuestionValidation extends QuestionValidation implements INumberQuestionValidation {
    min?: number | undefined;
    max?: number | undefined;
    fraction!: boolean;

    constructor(data?: INumberQuestionValidation) {
        super(data);
        this._discriminator = "NumberQuestionValidation";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.min = _data["min"];
            this.max = _data["max"];
            this.fraction = _data["fraction"];
        }
    }

    static override fromJS(data: any): NumberQuestionValidation {
        data = typeof data === 'object' ? data : {};
        let result = new NumberQuestionValidation();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["min"] = this.min;
        data["max"] = this.max;
        data["fraction"] = this.fraction;
        super.toJSON(data);
        return data;
    }

    clone(): NumberQuestionValidation {
        const json = this.toJSON();
        let result = new NumberQuestionValidation();
        result.init(json);
        return result;
    }
}

export interface INumberQuestionValidation extends IQuestionValidation {
    min?: number | undefined;
    max?: number | undefined;
    fraction: boolean;
}

export class SliderQuestionValidation extends QuestionValidation implements ISliderQuestionValidation {
    min!: number;
    max!: number;

    constructor(data?: ISliderQuestionValidation) {
        super(data);
        this._discriminator = "SliderQuestionValidation";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.min = _data["min"];
            this.max = _data["max"];
        }
    }

    static override fromJS(data: any): SliderQuestionValidation {
        data = typeof data === 'object' ? data : {};
        let result = new SliderQuestionValidation();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["min"] = this.min;
        data["max"] = this.max;
        super.toJSON(data);
        return data;
    }

    clone(): SliderQuestionValidation {
        const json = this.toJSON();
        let result = new SliderQuestionValidation();
        result.init(json);
        return result;
    }
}

export interface ISliderQuestionValidation extends IQuestionValidation {
    min: number;
    max: number;
}

export class TextQuestionValidation extends QuestionValidation implements ITextQuestionValidation {
    minLength?: number | undefined;
    maxLength?: number | undefined;
    pattern?: string | undefined;

    constructor(data?: ITextQuestionValidation) {
        super(data);
        this._discriminator = "TextQuestionValidation";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.minLength = _data["minLength"];
            this.maxLength = _data["maxLength"];
            this.pattern = _data["pattern"];
        }
    }

    static override fromJS(data: any): TextQuestionValidation {
        data = typeof data === 'object' ? data : {};
        let result = new TextQuestionValidation();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["minLength"] = this.minLength;
        data["maxLength"] = this.maxLength;
        data["pattern"] = this.pattern;
        super.toJSON(data);
        return data;
    }

    clone(): TextQuestionValidation {
        const json = this.toJSON();
        let result = new TextQuestionValidation();
        result.init(json);
        return result;
    }
}

export interface ITextQuestionValidation extends IQuestionValidation {
    minLength?: number | undefined;
    maxLength?: number | undefined;
    pattern?: string | undefined;
}

export class TimeQuestionValidation extends QuestionValidation implements ITimeQuestionValidation {
    min?: string | undefined;
    max?: string | undefined;

    constructor(data?: ITimeQuestionValidation) {
        super(data);
        this._discriminator = "TimeQuestionValidation";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.min = _data["min"];
            this.max = _data["max"];
        }
    }

    static override fromJS(data: any): TimeQuestionValidation {
        data = typeof data === 'object' ? data : {};
        let result = new TimeQuestionValidation();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["min"] = this.min;
        data["max"] = this.max;
        super.toJSON(data);
        return data;
    }

    clone(): TimeQuestionValidation {
        const json = this.toJSON();
        let result = new TimeQuestionValidation();
        result.init(json);
        return result;
    }
}

export interface ITimeQuestionValidation extends IQuestionValidation {
    min?: string | undefined;
    max?: string | undefined;
}

export class BoolQuestionValidation extends QuestionValidation implements IBoolQuestionValidation {

    constructor(data?: IBoolQuestionValidation) {
        super(data);
        this._discriminator = "BoolQuestionValidation";
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): BoolQuestionValidation {
        data = typeof data === 'object' ? data : {};
        let result = new BoolQuestionValidation();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): BoolQuestionValidation {
        const json = this.toJSON();
        let result = new BoolQuestionValidation();
        result.init(json);
        return result;
    }
}

export interface IBoolQuestionValidation extends IQuestionValidation {
}

export class ContainerQuestionValidation extends QuestionValidation implements IContainerQuestionValidation {

    constructor(data?: IContainerQuestionValidation) {
        super(data);
        this._discriminator = "ContainerQuestionValidation";
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ContainerQuestionValidation {
        data = typeof data === 'object' ? data : {};
        let result = new ContainerQuestionValidation();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): ContainerQuestionValidation {
        const json = this.toJSON();
        let result = new ContainerQuestionValidation();
        result.init(json);
        return result;
    }
}

export interface IContainerQuestionValidation extends IQuestionValidation {
}

export class LikertScaleItem implements ILikertScaleItem {
    id!: string;
    value!: string;
    label!: InternationalizedString;

    constructor(data?: ILikertScaleItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.label = new InternationalizedString();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.value = _data["value"];
            this.label = _data["label"] ? InternationalizedString.fromJS(_data["label"]) : new InternationalizedString();
        }
    }

    static fromJS(data: any): LikertScaleItem {
        data = typeof data === 'object' ? data : {};
        let result = new LikertScaleItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["value"] = this.value;
        data["label"] = this.label ? this.label.toJSON() : undefined as any;
        return data;
    }

    clone(): LikertScaleItem {
        const json = this.toJSON();
        let result = new LikertScaleItem();
        result.init(json);
        return result;
    }
}

export interface ILikertScaleItem {
    id: string;
    value: string;
    label: InternationalizedString;
}

export abstract class AnswerDto implements IAnswerDto {
    questionId!: string;
    answered?: Date | undefined;

    protected _discriminator: string;

    constructor(data?: IAnswerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        this._discriminator = "AnswerDto";
    }

    init(_data?: any) {
        if (_data) {
            this.questionId = _data["questionId"];
            this.answered = _data["answered"] ? new Date(_data["answered"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): AnswerDto {
        data = typeof data === 'object' ? data : {};
        if (data["$type"] === "LikertAnswerDto") {
            let result = new LikertAnswerDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "ChoiceAnswerDto") {
            let result = new ChoiceAnswerDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "DateAnswerDto") {
            let result = new DateAnswerDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "DateTimeAnswerDto") {
            let result = new DateTimeAnswerDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "MatrixAnswerDto") {
            let result = new MatrixAnswerDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "NumberAnswerDto") {
            let result = new NumberAnswerDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "SliderAnswerDto") {
            let result = new SliderAnswerDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "TextAnswerDto") {
            let result = new TextAnswerDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "TimeAnswerDto") {
            let result = new TimeAnswerDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "ContainerAnswerDto") {
            let result = new ContainerAnswerDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "BoolAnswerDto") {
            let result = new BoolAnswerDto();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'AnswerDto' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["$type"] = this._discriminator;
        data["questionId"] = this.questionId;
        data["answered"] = this.answered ? this.answered.toISOString() : undefined as any;
        return data;
    }

    clone(): AnswerDto {
        throw new Error("The abstract class 'AnswerDto' cannot be instantiated.");
    }
}

export interface IAnswerDto {
    questionId: string;
    answered?: Date | undefined;
}

export class LikertAnswerDto extends AnswerDto implements ILikertAnswerDto {
    value?: string | undefined;

    constructor(data?: ILikertAnswerDto) {
        super(data);
        this._discriminator = "LikertAnswerDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"];
        }
    }

    static override fromJS(data: any): LikertAnswerDto {
        data = typeof data === 'object' ? data : {};
        let result = new LikertAnswerDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        super.toJSON(data);
        return data;
    }

    clone(): LikertAnswerDto {
        const json = this.toJSON();
        let result = new LikertAnswerDto();
        result.init(json);
        return result;
    }
}

export interface ILikertAnswerDto extends IAnswerDto {
    value?: string | undefined;
}

export class ChoiceAnswerDto extends AnswerDto implements IChoiceAnswerDto {
    values?: string[] | undefined;

    constructor(data?: IChoiceAnswerDto) {
        super(data);
        this._discriminator = "ChoiceAnswerDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(item);
            }
        }
    }

    static override fromJS(data: any): ChoiceAnswerDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChoiceAnswerDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item);
        }
        super.toJSON(data);
        return data;
    }

    clone(): ChoiceAnswerDto {
        const json = this.toJSON();
        let result = new ChoiceAnswerDto();
        result.init(json);
        return result;
    }
}

export interface IChoiceAnswerDto extends IAnswerDto {
    values?: string[] | undefined;
}

export class DateAnswerDto extends AnswerDto implements IDateAnswerDto {
    value?: Date | undefined;
    values?: Date[] | undefined;

    constructor(data?: IDateAnswerDto) {
        super(data);
        this._discriminator = "DateAnswerDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] ? new Date(_data["value"].toString()) : undefined as any;
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(new Date(item));
            }
        }
    }

    static override fromJS(data: any): DateAnswerDto {
        data = typeof data === 'object' ? data : {};
        let result = new DateAnswerDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? formatDate(this.value) : undefined as any;
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(formatDate(item));
        }
        super.toJSON(data);
        return data;
    }

    clone(): DateAnswerDto {
        const json = this.toJSON();
        let result = new DateAnswerDto();
        result.init(json);
        return result;
    }
}

export interface IDateAnswerDto extends IAnswerDto {
    value?: Date | undefined;
    values?: Date[] | undefined;
}

export class DateTimeAnswerDto extends AnswerDto implements IDateTimeAnswerDto {
    value?: Date | undefined;

    constructor(data?: IDateTimeAnswerDto) {
        super(data);
        this._discriminator = "DateTimeAnswerDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] ? new Date(_data["value"].toString()) : undefined as any;
        }
    }

    static override fromJS(data: any): DateTimeAnswerDto {
        data = typeof data === 'object' ? data : {};
        let result = new DateTimeAnswerDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toISOString() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): DateTimeAnswerDto {
        const json = this.toJSON();
        let result = new DateTimeAnswerDto();
        result.init(json);
        return result;
    }
}

export interface IDateTimeAnswerDto extends IAnswerDto {
    value?: Date | undefined;
}

export class MatrixAnswerDto extends AnswerDto implements IMatrixAnswerDto {
    values?: { [key: string]: string; } | undefined;

    constructor(data?: IMatrixAnswerDto) {
        super(data);
        this._discriminator = "MatrixAnswerDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (_data["values"]) {
                this.values = {} as any;
                for (let key in _data["values"]) {
                    if (_data["values"].hasOwnProperty(key))
                        (this.values as any)![key] = _data["values"][key];
                }
            }
        }
    }

    static override fromJS(data: any): MatrixAnswerDto {
        data = typeof data === 'object' ? data : {};
        let result = new MatrixAnswerDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.values) {
            data["values"] = {};
            for (let key in this.values) {
                if (this.values.hasOwnProperty(key))
                    (data["values"] as any)[key] = (this.values as any)[key];
            }
        }
        super.toJSON(data);
        return data;
    }

    clone(): MatrixAnswerDto {
        const json = this.toJSON();
        let result = new MatrixAnswerDto();
        result.init(json);
        return result;
    }
}

export interface IMatrixAnswerDto extends IAnswerDto {
    values?: { [key: string]: string; } | undefined;
}

export class NumberAnswerDto extends AnswerDto implements INumberAnswerDto {
    value?: number | undefined;

    constructor(data?: INumberAnswerDto) {
        super(data);
        this._discriminator = "NumberAnswerDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"];
        }
    }

    static override fromJS(data: any): NumberAnswerDto {
        data = typeof data === 'object' ? data : {};
        let result = new NumberAnswerDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        super.toJSON(data);
        return data;
    }

    clone(): NumberAnswerDto {
        const json = this.toJSON();
        let result = new NumberAnswerDto();
        result.init(json);
        return result;
    }
}

export interface INumberAnswerDto extends IAnswerDto {
    value?: number | undefined;
}

export class SliderAnswerDto extends AnswerDto implements ISliderAnswerDto {
    value?: number | undefined;

    constructor(data?: ISliderAnswerDto) {
        super(data);
        this._discriminator = "SliderAnswerDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"];
        }
    }

    static override fromJS(data: any): SliderAnswerDto {
        data = typeof data === 'object' ? data : {};
        let result = new SliderAnswerDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        super.toJSON(data);
        return data;
    }

    clone(): SliderAnswerDto {
        const json = this.toJSON();
        let result = new SliderAnswerDto();
        result.init(json);
        return result;
    }
}

export interface ISliderAnswerDto extends IAnswerDto {
    value?: number | undefined;
}

export class TextAnswerDto extends AnswerDto implements ITextAnswerDto {
    value?: string | undefined;

    constructor(data?: ITextAnswerDto) {
        super(data);
        this._discriminator = "TextAnswerDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"];
        }
    }

    static override fromJS(data: any): TextAnswerDto {
        data = typeof data === 'object' ? data : {};
        let result = new TextAnswerDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        super.toJSON(data);
        return data;
    }

    clone(): TextAnswerDto {
        const json = this.toJSON();
        let result = new TextAnswerDto();
        result.init(json);
        return result;
    }
}

export interface ITextAnswerDto extends IAnswerDto {
    value?: string | undefined;
}

export class TimeAnswerDto extends AnswerDto implements ITimeAnswerDto {
    value?: string | undefined;

    constructor(data?: ITimeAnswerDto) {
        super(data);
        this._discriminator = "TimeAnswerDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"];
        }
    }

    static override fromJS(data: any): TimeAnswerDto {
        data = typeof data === 'object' ? data : {};
        let result = new TimeAnswerDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        super.toJSON(data);
        return data;
    }

    clone(): TimeAnswerDto {
        const json = this.toJSON();
        let result = new TimeAnswerDto();
        result.init(json);
        return result;
    }
}

export interface ITimeAnswerDto extends IAnswerDto {
    value?: string | undefined;
}

export class ContainerAnswerDto extends AnswerDto implements IContainerAnswerDto {
    values?: string[] | undefined;

    constructor(data?: IContainerAnswerDto) {
        super(data);
        this._discriminator = "ContainerAnswerDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(item);
            }
        }
    }

    static override fromJS(data: any): ContainerAnswerDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContainerAnswerDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item);
        }
        super.toJSON(data);
        return data;
    }

    clone(): ContainerAnswerDto {
        const json = this.toJSON();
        let result = new ContainerAnswerDto();
        result.init(json);
        return result;
    }
}

export interface IContainerAnswerDto extends IAnswerDto {
    values?: string[] | undefined;
}

export class BoolAnswerDto extends AnswerDto implements IBoolAnswerDto {
    value?: boolean | undefined;

    constructor(data?: IBoolAnswerDto) {
        super(data);
        this._discriminator = "BoolAnswerDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"];
        }
    }

    static override fromJS(data: any): BoolAnswerDto {
        data = typeof data === 'object' ? data : {};
        let result = new BoolAnswerDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        super.toJSON(data);
        return data;
    }

    clone(): BoolAnswerDto {
        const json = this.toJSON();
        let result = new BoolAnswerDto();
        result.init(json);
        return result;
    }
}

export interface IBoolAnswerDto extends IAnswerDto {
    value?: boolean | undefined;
}

export class MatrixQuestionDto extends QuestionDto implements IMatrixQuestionDto {
    validation!: MatrixQuestionValidation;
    xScale!: SelectionItem[];
    yScale!: SelectionItem[];
    answer?: MatrixAnswerDto | undefined;

    constructor(data?: IMatrixQuestionDto) {
        super(data);
        if (!data) {
            this.validation = new MatrixQuestionValidation();
            this.xScale = [];
            this.yScale = [];
        }
        this._discriminator = "MatrixQuestionDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.validation = _data["validation"] ? MatrixQuestionValidation.fromJS(_data["validation"]) : new MatrixQuestionValidation();
            if (Array.isArray(_data["xScale"])) {
                this.xScale = [] as any;
                for (let item of _data["xScale"])
                    this.xScale!.push(SelectionItem.fromJS(item));
            }
            if (Array.isArray(_data["yScale"])) {
                this.yScale = [] as any;
                for (let item of _data["yScale"])
                    this.yScale!.push(SelectionItem.fromJS(item));
            }
            this.answer = _data["answer"] ? MatrixAnswerDto.fromJS(_data["answer"]) : undefined as any;
        }
    }

    static override fromJS(data: any): MatrixQuestionDto {
        data = typeof data === 'object' ? data : {};
        let result = new MatrixQuestionDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["validation"] = this.validation ? this.validation.toJSON() : undefined as any;
        if (Array.isArray(this.xScale)) {
            data["xScale"] = [];
            for (let item of this.xScale)
                data["xScale"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.yScale)) {
            data["yScale"] = [];
            for (let item of this.yScale)
                data["yScale"].push(item ? item.toJSON() : undefined as any);
        }
        data["answer"] = this.answer ? this.answer.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): MatrixQuestionDto {
        const json = this.toJSON();
        let result = new MatrixQuestionDto();
        result.init(json);
        return result;
    }
}

export interface IMatrixQuestionDto extends IQuestionDto {
    validation: MatrixQuestionValidation;
    xScale: SelectionItem[];
    yScale: SelectionItem[];
    answer?: MatrixAnswerDto | undefined;
}

export class ChoiceQuestionDto extends QuestionDto implements IChoiceQuestionDto {
    validation!: ChoiceQuestionValidation;
    multiSelection!: boolean;
    choices!: SelectionItem[];
    answer?: ChoiceAnswerDto | undefined;

    constructor(data?: IChoiceQuestionDto) {
        super(data);
        if (!data) {
            this.validation = new ChoiceQuestionValidation();
            this.choices = [];
        }
        this._discriminator = "ChoiceQuestionDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.validation = _data["validation"] ? ChoiceQuestionValidation.fromJS(_data["validation"]) : new ChoiceQuestionValidation();
            this.multiSelection = _data["multiSelection"];
            if (Array.isArray(_data["choices"])) {
                this.choices = [] as any;
                for (let item of _data["choices"])
                    this.choices!.push(SelectionItem.fromJS(item));
            }
            this.answer = _data["answer"] ? ChoiceAnswerDto.fromJS(_data["answer"]) : undefined as any;
        }
    }

    static override fromJS(data: any): ChoiceQuestionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChoiceQuestionDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["validation"] = this.validation ? this.validation.toJSON() : undefined as any;
        data["multiSelection"] = this.multiSelection;
        if (Array.isArray(this.choices)) {
            data["choices"] = [];
            for (let item of this.choices)
                data["choices"].push(item ? item.toJSON() : undefined as any);
        }
        data["answer"] = this.answer ? this.answer.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): ChoiceQuestionDto {
        const json = this.toJSON();
        let result = new ChoiceQuestionDto();
        result.init(json);
        return result;
    }
}

export interface IChoiceQuestionDto extends IQuestionDto {
    validation: ChoiceQuestionValidation;
    multiSelection: boolean;
    choices: SelectionItem[];
    answer?: ChoiceAnswerDto | undefined;
}

export class ContainerQuestionDto extends QuestionDto implements IContainerQuestionDto {
    validation!: ContainerQuestionValidation;
    multiSelection!: boolean;
    containerType!: ContainerType;
    containerId!: string;
    answer?: ContainerAnswerDto | undefined;

    constructor(data?: IContainerQuestionDto) {
        super(data);
        if (!data) {
            this.validation = new ContainerQuestionValidation();
        }
        this._discriminator = "ContainerQuestionDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.validation = _data["validation"] ? ContainerQuestionValidation.fromJS(_data["validation"]) : new ContainerQuestionValidation();
            this.multiSelection = _data["multiSelection"];
            this.containerType = _data["containerType"];
            this.containerId = _data["containerId"];
            this.answer = _data["answer"] ? ContainerAnswerDto.fromJS(_data["answer"]) : undefined as any;
        }
    }

    static override fromJS(data: any): ContainerQuestionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContainerQuestionDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["validation"] = this.validation ? this.validation.toJSON() : undefined as any;
        data["multiSelection"] = this.multiSelection;
        data["containerType"] = this.containerType;
        data["containerId"] = this.containerId;
        data["answer"] = this.answer ? this.answer.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): ContainerQuestionDto {
        const json = this.toJSON();
        let result = new ContainerQuestionDto();
        result.init(json);
        return result;
    }
}

export interface IContainerQuestionDto extends IQuestionDto {
    validation: ContainerQuestionValidation;
    multiSelection: boolean;
    containerType: ContainerType;
    containerId: string;
    answer?: ContainerAnswerDto | undefined;
}

export class BoolQuestionDto extends QuestionDto implements IBoolQuestionDto {
    validation!: BoolQuestionValidation;
    trueLabel!: InternationalizedString;
    falseLabel!: InternationalizedString;
    answer?: BoolAnswerDto | undefined;

    constructor(data?: IBoolQuestionDto) {
        super(data);
        if (!data) {
            this.validation = new BoolQuestionValidation();
            this.trueLabel = new InternationalizedString();
            this.falseLabel = new InternationalizedString();
        }
        this._discriminator = "BoolQuestionDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.validation = _data["validation"] ? BoolQuestionValidation.fromJS(_data["validation"]) : new BoolQuestionValidation();
            this.trueLabel = _data["trueLabel"] ? InternationalizedString.fromJS(_data["trueLabel"]) : new InternationalizedString();
            this.falseLabel = _data["falseLabel"] ? InternationalizedString.fromJS(_data["falseLabel"]) : new InternationalizedString();
            this.answer = _data["answer"] ? BoolAnswerDto.fromJS(_data["answer"]) : undefined as any;
        }
    }

    static override fromJS(data: any): BoolQuestionDto {
        data = typeof data === 'object' ? data : {};
        let result = new BoolQuestionDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["validation"] = this.validation ? this.validation.toJSON() : undefined as any;
        data["trueLabel"] = this.trueLabel ? this.trueLabel.toJSON() : undefined as any;
        data["falseLabel"] = this.falseLabel ? this.falseLabel.toJSON() : undefined as any;
        data["answer"] = this.answer ? this.answer.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): BoolQuestionDto {
        const json = this.toJSON();
        let result = new BoolQuestionDto();
        result.init(json);
        return result;
    }
}

export interface IBoolQuestionDto extends IQuestionDto {
    validation: BoolQuestionValidation;
    trueLabel: InternationalizedString;
    falseLabel: InternationalizedString;
    answer?: BoolAnswerDto | undefined;
}

export class TextQuestionDto extends QuestionDto implements ITextQuestionDto {
    validation!: TextQuestionValidation;
    multiline!: boolean;
    answer?: TextAnswerDto | undefined;

    constructor(data?: ITextQuestionDto) {
        super(data);
        if (!data) {
            this.validation = new TextQuestionValidation();
        }
        this._discriminator = "TextQuestionDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.validation = _data["validation"] ? TextQuestionValidation.fromJS(_data["validation"]) : new TextQuestionValidation();
            this.multiline = _data["multiline"];
            this.answer = _data["answer"] ? TextAnswerDto.fromJS(_data["answer"]) : undefined as any;
        }
    }

    static override fromJS(data: any): TextQuestionDto {
        data = typeof data === 'object' ? data : {};
        let result = new TextQuestionDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["validation"] = this.validation ? this.validation.toJSON() : undefined as any;
        data["multiline"] = this.multiline;
        data["answer"] = this.answer ? this.answer.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): TextQuestionDto {
        const json = this.toJSON();
        let result = new TextQuestionDto();
        result.init(json);
        return result;
    }
}

export interface ITextQuestionDto extends IQuestionDto {
    validation: TextQuestionValidation;
    multiline: boolean;
    answer?: TextAnswerDto | undefined;
}

export class NumberQuestionDto extends QuestionDto implements INumberQuestionDto {
    validation!: NumberQuestionValidation;
    answer?: NumberAnswerDto | undefined;

    constructor(data?: INumberQuestionDto) {
        super(data);
        if (!data) {
            this.validation = new NumberQuestionValidation();
        }
        this._discriminator = "NumberQuestionDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.validation = _data["validation"] ? NumberQuestionValidation.fromJS(_data["validation"]) : new NumberQuestionValidation();
            this.answer = _data["answer"] ? NumberAnswerDto.fromJS(_data["answer"]) : undefined as any;
        }
    }

    static override fromJS(data: any): NumberQuestionDto {
        data = typeof data === 'object' ? data : {};
        let result = new NumberQuestionDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["validation"] = this.validation ? this.validation.toJSON() : undefined as any;
        data["answer"] = this.answer ? this.answer.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): NumberQuestionDto {
        const json = this.toJSON();
        let result = new NumberQuestionDto();
        result.init(json);
        return result;
    }
}

export interface INumberQuestionDto extends IQuestionDto {
    validation: NumberQuestionValidation;
    answer?: NumberAnswerDto | undefined;
}

export class DateQuestionDto extends QuestionDto implements IDateQuestionDto {
    validation!: DateQuestionValidation;
    multiSelection!: boolean;
    answer?: DateAnswerDto | undefined;

    constructor(data?: IDateQuestionDto) {
        super(data);
        if (!data) {
            this.validation = new DateQuestionValidation();
        }
        this._discriminator = "DateQuestionDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.validation = _data["validation"] ? DateQuestionValidation.fromJS(_data["validation"]) : new DateQuestionValidation();
            this.multiSelection = _data["multiSelection"];
            this.answer = _data["answer"] ? DateAnswerDto.fromJS(_data["answer"]) : undefined as any;
        }
    }

    static override fromJS(data: any): DateQuestionDto {
        data = typeof data === 'object' ? data : {};
        let result = new DateQuestionDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["validation"] = this.validation ? this.validation.toJSON() : undefined as any;
        data["multiSelection"] = this.multiSelection;
        data["answer"] = this.answer ? this.answer.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): DateQuestionDto {
        const json = this.toJSON();
        let result = new DateQuestionDto();
        result.init(json);
        return result;
    }
}

export interface IDateQuestionDto extends IQuestionDto {
    validation: DateQuestionValidation;
    multiSelection: boolean;
    answer?: DateAnswerDto | undefined;
}

export class TimeQuestionDto extends QuestionDto implements ITimeQuestionDto {
    minuteIncrements?: number | undefined;
    validation!: TimeQuestionValidation;
    answer?: TimeAnswerDto | undefined;

    constructor(data?: ITimeQuestionDto) {
        super(data);
        if (!data) {
            this.validation = new TimeQuestionValidation();
        }
        this._discriminator = "TimeQuestionDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.minuteIncrements = _data["minuteIncrements"];
            this.validation = _data["validation"] ? TimeQuestionValidation.fromJS(_data["validation"]) : new TimeQuestionValidation();
            this.answer = _data["answer"] ? TimeAnswerDto.fromJS(_data["answer"]) : undefined as any;
        }
    }

    static override fromJS(data: any): TimeQuestionDto {
        data = typeof data === 'object' ? data : {};
        let result = new TimeQuestionDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["minuteIncrements"] = this.minuteIncrements;
        data["validation"] = this.validation ? this.validation.toJSON() : undefined as any;
        data["answer"] = this.answer ? this.answer.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): TimeQuestionDto {
        const json = this.toJSON();
        let result = new TimeQuestionDto();
        result.init(json);
        return result;
    }
}

export interface ITimeQuestionDto extends IQuestionDto {
    minuteIncrements?: number | undefined;
    validation: TimeQuestionValidation;
    answer?: TimeAnswerDto | undefined;
}

export class DateTimeQuestionDto extends QuestionDto implements IDateTimeQuestionDto {
    minuteIncrements?: number | undefined;
    validation!: DateTimeQuestionValidation;
    answer?: DateTimeAnswerDto | undefined;

    constructor(data?: IDateTimeQuestionDto) {
        super(data);
        if (!data) {
            this.validation = new DateTimeQuestionValidation();
        }
        this._discriminator = "DateTimeQuestionDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.minuteIncrements = _data["minuteIncrements"];
            this.validation = _data["validation"] ? DateTimeQuestionValidation.fromJS(_data["validation"]) : new DateTimeQuestionValidation();
            this.answer = _data["answer"] ? DateTimeAnswerDto.fromJS(_data["answer"]) : undefined as any;
        }
    }

    static override fromJS(data: any): DateTimeQuestionDto {
        data = typeof data === 'object' ? data : {};
        let result = new DateTimeQuestionDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["minuteIncrements"] = this.minuteIncrements;
        data["validation"] = this.validation ? this.validation.toJSON() : undefined as any;
        data["answer"] = this.answer ? this.answer.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): DateTimeQuestionDto {
        const json = this.toJSON();
        let result = new DateTimeQuestionDto();
        result.init(json);
        return result;
    }
}

export interface IDateTimeQuestionDto extends IQuestionDto {
    minuteIncrements?: number | undefined;
    validation: DateTimeQuestionValidation;
    answer?: DateTimeAnswerDto | undefined;
}

export class SliderQuestionDto extends QuestionDto implements ISliderQuestionDto {
    minLabel!: InternationalizedString;
    maxLabel!: InternationalizedString;
    range!: boolean;
    vertical!: boolean;
    steps?: number | undefined;
    validation!: SliderQuestionValidation;
    answer?: SliderAnswerDto | undefined;

    constructor(data?: ISliderQuestionDto) {
        super(data);
        if (!data) {
            this.minLabel = new InternationalizedString();
            this.maxLabel = new InternationalizedString();
            this.validation = new SliderQuestionValidation();
        }
        this._discriminator = "SliderQuestionDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.minLabel = _data["minLabel"] ? InternationalizedString.fromJS(_data["minLabel"]) : new InternationalizedString();
            this.maxLabel = _data["maxLabel"] ? InternationalizedString.fromJS(_data["maxLabel"]) : new InternationalizedString();
            this.range = _data["range"];
            this.vertical = _data["vertical"];
            this.steps = _data["steps"];
            this.validation = _data["validation"] ? SliderQuestionValidation.fromJS(_data["validation"]) : new SliderQuestionValidation();
            this.answer = _data["answer"] ? SliderAnswerDto.fromJS(_data["answer"]) : undefined as any;
        }
    }

    static override fromJS(data: any): SliderQuestionDto {
        data = typeof data === 'object' ? data : {};
        let result = new SliderQuestionDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["minLabel"] = this.minLabel ? this.minLabel.toJSON() : undefined as any;
        data["maxLabel"] = this.maxLabel ? this.maxLabel.toJSON() : undefined as any;
        data["range"] = this.range;
        data["vertical"] = this.vertical;
        data["steps"] = this.steps;
        data["validation"] = this.validation ? this.validation.toJSON() : undefined as any;
        data["answer"] = this.answer ? this.answer.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): SliderQuestionDto {
        const json = this.toJSON();
        let result = new SliderQuestionDto();
        result.init(json);
        return result;
    }
}

export interface ISliderQuestionDto extends IQuestionDto {
    minLabel: InternationalizedString;
    maxLabel: InternationalizedString;
    range: boolean;
    vertical: boolean;
    steps?: number | undefined;
    validation: SliderQuestionValidation;
    answer?: SliderAnswerDto | undefined;
}

export class PaginatedListOfAppPageListItemDto implements IPaginatedListOfAppPageListItemDto {
    items!: AppPageListItemDto[];
    pageNumber!: number;
    pageSize!: number;
    totalCount!: number;
    totalPages!: number;
    hasPreviousPage!: boolean;
    hasNextPage!: boolean;

    constructor(data?: IPaginatedListOfAppPageListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AppPageListItemDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            this.totalPages = _data["totalPages"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfAppPageListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfAppPageListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["totalPages"] = this.totalPages;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }

    clone(): PaginatedListOfAppPageListItemDto {
        const json = this.toJSON();
        let result = new PaginatedListOfAppPageListItemDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedListOfAppPageListItemDto {
    items: AppPageListItemDto[];
    pageNumber: number;
    pageSize: number;
    totalCount: number;
    totalPages: number;
    hasPreviousPage: boolean;
    hasNextPage: boolean;
}

export abstract class ContainerDto implements IContainerDto {
    id!: string;
    projectId?: string | undefined;
    name!: string;
    uniqueLabel!: string;
    version!: number;
    defaultLanguageId?: string | undefined;
    tags?: string[] | undefined;
    hidden?: Date | undefined;
    published?: Date | undefined;
    created!: Date;
    lastModified!: Date;

    constructor(data?: IContainerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.projectId = _data["projectId"];
            this.name = _data["name"];
            this.uniqueLabel = _data["uniqueLabel"];
            this.version = _data["version"];
            this.defaultLanguageId = _data["defaultLanguageId"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            this.hidden = _data["hidden"] ? new Date(_data["hidden"].toString()) : undefined as any;
            this.published = _data["published"] ? new Date(_data["published"].toString()) : undefined as any;
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ContainerDto {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ContainerDto' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectId"] = this.projectId;
        data["name"] = this.name;
        data["uniqueLabel"] = this.uniqueLabel;
        data["version"] = this.version;
        data["defaultLanguageId"] = this.defaultLanguageId;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["hidden"] = this.hidden ? this.hidden.toISOString() : undefined as any;
        data["published"] = this.published ? this.published.toISOString() : undefined as any;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : undefined as any;
        return data;
    }

    clone(): ContainerDto {
        throw new Error("The abstract class 'ContainerDto' cannot be instantiated.");
    }
}

export interface IContainerDto {
    id: string;
    projectId?: string | undefined;
    name: string;
    uniqueLabel: string;
    version: number;
    defaultLanguageId?: string | undefined;
    tags?: string[] | undefined;
    hidden?: Date | undefined;
    published?: Date | undefined;
    created: Date;
    lastModified: Date;
}

export class AppPageListItemDto extends ContainerDto implements IAppPageListItemDto {
    parentId?: string | undefined;
    order!: number;
    asset?: AssetDto | undefined;
    tags!: string[];
    breadcrumb!: AppPageBreadcrumbItemDto[];
    createdBy?: UserDto | undefined;
    lastModifiedBy?: UserDto | undefined;

    constructor(data?: IAppPageListItemDto) {
        super(data);
        if (!data) {
            this.tags = [];
            this.breadcrumb = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.parentId = _data["parentId"];
            this.order = _data["order"];
            this.asset = _data["asset"] ? AssetDto.fromJS(_data["asset"]) : undefined as any;
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            if (Array.isArray(_data["breadcrumb"])) {
                this.breadcrumb = [] as any;
                for (let item of _data["breadcrumb"])
                    this.breadcrumb!.push(AppPageBreadcrumbItemDto.fromJS(item));
            }
            this.createdBy = _data["createdBy"] ? UserDto.fromJS(_data["createdBy"]) : undefined as any;
            this.lastModifiedBy = _data["lastModifiedBy"] ? UserDto.fromJS(_data["lastModifiedBy"]) : undefined as any;
        }
    }

    static override fromJS(data: any): AppPageListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppPageListItemDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentId"] = this.parentId;
        data["order"] = this.order;
        data["asset"] = this.asset ? this.asset.toJSON() : undefined as any;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        if (Array.isArray(this.breadcrumb)) {
            data["breadcrumb"] = [];
            for (let item of this.breadcrumb)
                data["breadcrumb"].push(item ? item.toJSON() : undefined as any);
        }
        data["createdBy"] = this.createdBy ? this.createdBy.toJSON() : undefined as any;
        data["lastModifiedBy"] = this.lastModifiedBy ? this.lastModifiedBy.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): AppPageListItemDto {
        const json = this.toJSON();
        let result = new AppPageListItemDto();
        result.init(json);
        return result;
    }
}

export interface IAppPageListItemDto extends IContainerDto {
    parentId?: string | undefined;
    order: number;
    asset?: AssetDto | undefined;
    tags: string[];
    breadcrumb: AppPageBreadcrumbItemDto[];
    createdBy?: UserDto | undefined;
    lastModifiedBy?: UserDto | undefined;
}

export class AppPageBreadcrumbItemDto implements IAppPageBreadcrumbItemDto {
    id?: string | undefined;
    name?: string | undefined;

    constructor(data?: IAppPageBreadcrumbItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): AppPageBreadcrumbItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppPageBreadcrumbItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }

    clone(): AppPageBreadcrumbItemDto {
        const json = this.toJSON();
        let result = new AppPageBreadcrumbItemDto();
        result.init(json);
        return result;
    }
}

export interface IAppPageBreadcrumbItemDto {
    id?: string | undefined;
    name?: string | undefined;
}

export class UserDto implements IUserDto {
    id!: string;
    userName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    givenName?: string | undefined;
    familyName?: string | undefined;

    constructor(data?: IUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userName = _data["userName"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.givenName = _data["givenName"];
            this.familyName = _data["familyName"];
        }
    }

    static fromJS(data: any): UserDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userName"] = this.userName;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["givenName"] = this.givenName;
        data["familyName"] = this.familyName;
        return data;
    }

    clone(): UserDto {
        const json = this.toJSON();
        let result = new UserDto();
        result.init(json);
        return result;
    }
}

export interface IUserDto {
    id: string;
    userName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    givenName?: string | undefined;
    familyName?: string | undefined;
}

export class SortingParameter implements ISortingParameter {
    property!: string;
    direction!: SortDirection;

    constructor(data?: ISortingParameter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.property = _data["property"];
            this.direction = _data["direction"];
        }
    }

    static fromJS(data: any): SortingParameter {
        data = typeof data === 'object' ? data : {};
        let result = new SortingParameter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["property"] = this.property;
        data["direction"] = this.direction;
        return data;
    }

    clone(): SortingParameter {
        const json = this.toJSON();
        let result = new SortingParameter();
        result.init(json);
        return result;
    }
}

export interface ISortingParameter {
    property: string;
    direction: SortDirection;
}

export enum SortDirection {
    Ascending = "ascending",
    Descending = "descending",
}

export enum PublicationState {
    Published = "published",
    NotPublished = "notPublished",
}

export class AppPageDto extends ContainerDto implements IAppPageDto {
    parentId?: string | undefined;
    order!: number;
    children!: AppPageDto[];
    asset?: AssetDto | undefined;
    tags!: string[];
    visibility!: ContainerVisibility;

    constructor(data?: IAppPageDto) {
        super(data);
        if (!data) {
            this.children = [];
            this.tags = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.parentId = _data["parentId"];
            this.order = _data["order"];
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(AppPageDto.fromJS(item));
            }
            this.asset = _data["asset"] ? AssetDto.fromJS(_data["asset"]) : undefined as any;
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            this.visibility = _data["visibility"];
        }
    }

    static override fromJS(data: any): AppPageDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppPageDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentId"] = this.parentId;
        data["order"] = this.order;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item ? item.toJSON() : undefined as any);
        }
        data["asset"] = this.asset ? this.asset.toJSON() : undefined as any;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["visibility"] = this.visibility;
        super.toJSON(data);
        return data;
    }

    clone(): AppPageDto {
        const json = this.toJSON();
        let result = new AppPageDto();
        result.init(json);
        return result;
    }
}

export interface IAppPageDto extends IContainerDto {
    parentId?: string | undefined;
    order: number;
    children: AppPageDto[];
    asset?: AssetDto | undefined;
    tags: string[];
    visibility: ContainerVisibility;
}

export enum ContainerVisibility {
    Private = "private",
    Internal = "internal",
    Public = "public",
}

export abstract class ContainerDetailsDto implements IContainerDetailsDto {
    id!: string;
    projectId?: string | undefined;
    name!: string;
    uniqueLabel!: string;
    title!: InternationalizedString;
    description!: InternationalizedDocument;
    version!: number;
    created!: Date;
    lastModified!: Date;
    published?: Date | undefined;
    defaultLanguage!: TenantLanguageDto;
    languages!: TenantLanguageDto[];
    condition?: ContainerCondition | undefined;
    assetFolder?: AssetFolderDto | undefined;
    sharingOptions!: ContainerSharingOptionDto[];

    constructor(data?: IContainerDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.title = new InternationalizedString();
            this.description = new InternationalizedDocument();
            this.defaultLanguage = new TenantLanguageDto();
            this.languages = [];
            this.sharingOptions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.projectId = _data["projectId"];
            this.name = _data["name"];
            this.uniqueLabel = _data["uniqueLabel"];
            this.title = _data["title"] ? InternationalizedString.fromJS(_data["title"]) : new InternationalizedString();
            this.description = _data["description"] ? InternationalizedDocument.fromJS(_data["description"]) : new InternationalizedDocument();
            this.version = _data["version"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : undefined as any;
            this.published = _data["published"] ? new Date(_data["published"].toString()) : undefined as any;
            this.defaultLanguage = _data["defaultLanguage"] ? TenantLanguageDto.fromJS(_data["defaultLanguage"]) : new TenantLanguageDto();
            if (Array.isArray(_data["languages"])) {
                this.languages = [] as any;
                for (let item of _data["languages"])
                    this.languages!.push(TenantLanguageDto.fromJS(item));
            }
            this.condition = _data["condition"] ? ContainerCondition.fromJS(_data["condition"]) : undefined as any;
            this.assetFolder = _data["assetFolder"] ? AssetFolderDto.fromJS(_data["assetFolder"]) : undefined as any;
            if (Array.isArray(_data["sharingOptions"])) {
                this.sharingOptions = [] as any;
                for (let item of _data["sharingOptions"])
                    this.sharingOptions!.push(ContainerSharingOptionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ContainerDetailsDto {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ContainerDetailsDto' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectId"] = this.projectId;
        data["name"] = this.name;
        data["uniqueLabel"] = this.uniqueLabel;
        data["title"] = this.title ? this.title.toJSON() : undefined as any;
        data["description"] = this.description ? this.description.toJSON() : undefined as any;
        data["version"] = this.version;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : undefined as any;
        data["published"] = this.published ? this.published.toISOString() : undefined as any;
        data["defaultLanguage"] = this.defaultLanguage ? this.defaultLanguage.toJSON() : undefined as any;
        if (Array.isArray(this.languages)) {
            data["languages"] = [];
            for (let item of this.languages)
                data["languages"].push(item ? item.toJSON() : undefined as any);
        }
        data["condition"] = this.condition ? this.condition.toJSON() : undefined as any;
        data["assetFolder"] = this.assetFolder ? this.assetFolder.toJSON() : undefined as any;
        if (Array.isArray(this.sharingOptions)) {
            data["sharingOptions"] = [];
            for (let item of this.sharingOptions)
                data["sharingOptions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): ContainerDetailsDto {
        throw new Error("The abstract class 'ContainerDetailsDto' cannot be instantiated.");
    }
}

export interface IContainerDetailsDto {
    id: string;
    projectId?: string | undefined;
    name: string;
    uniqueLabel: string;
    title: InternationalizedString;
    description: InternationalizedDocument;
    version: number;
    created: Date;
    lastModified: Date;
    published?: Date | undefined;
    defaultLanguage: TenantLanguageDto;
    languages: TenantLanguageDto[];
    condition?: ContainerCondition | undefined;
    assetFolder?: AssetFolderDto | undefined;
    sharingOptions: ContainerSharingOptionDto[];
}

export class AppPageDetailsDto extends ContainerDetailsDto implements IAppPageDetailsDto {
    asset?: AssetDto | undefined;
    contents!: ContentDto[];
    tags!: string[];
    visibility!: ContainerVisibility;

    constructor(data?: IAppPageDetailsDto) {
        super(data);
        if (!data) {
            this.contents = [];
            this.tags = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.asset = _data["asset"] ? AssetDto.fromJS(_data["asset"]) : undefined as any;
            if (Array.isArray(_data["contents"])) {
                this.contents = [] as any;
                for (let item of _data["contents"])
                    this.contents!.push(ContentDto.fromJS(item));
            }
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            this.visibility = _data["visibility"];
        }
    }

    static override fromJS(data: any): AppPageDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppPageDetailsDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["asset"] = this.asset ? this.asset.toJSON() : undefined as any;
        if (Array.isArray(this.contents)) {
            data["contents"] = [];
            for (let item of this.contents)
                data["contents"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["visibility"] = this.visibility;
        super.toJSON(data);
        return data;
    }

    clone(): AppPageDetailsDto {
        const json = this.toJSON();
        let result = new AppPageDetailsDto();
        result.init(json);
        return result;
    }
}

export interface IAppPageDetailsDto extends IContainerDetailsDto {
    asset?: AssetDto | undefined;
    contents: ContentDto[];
    tags: string[];
    visibility: ContainerVisibility;
}

export class TenantLanguageDto extends TenantEntityDto implements ITenantLanguageDto {
    name!: string;
    code!: string;
    icon?: AssetDto | undefined;
    fallbackLanguages!: TenantLanguageDto[];

    constructor(data?: ITenantLanguageDto) {
        super(data);
        if (!data) {
            this.fallbackLanguages = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.code = _data["code"];
            this.icon = _data["icon"] ? AssetDto.fromJS(_data["icon"]) : undefined as any;
            if (Array.isArray(_data["fallbackLanguages"])) {
                this.fallbackLanguages = [] as any;
                for (let item of _data["fallbackLanguages"])
                    this.fallbackLanguages!.push(TenantLanguageDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): TenantLanguageDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantLanguageDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["code"] = this.code;
        data["icon"] = this.icon ? this.icon.toJSON() : undefined as any;
        if (Array.isArray(this.fallbackLanguages)) {
            data["fallbackLanguages"] = [];
            for (let item of this.fallbackLanguages)
                data["fallbackLanguages"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): TenantLanguageDto {
        const json = this.toJSON();
        let result = new TenantLanguageDto();
        result.init(json);
        return result;
    }
}

export interface ITenantLanguageDto extends ITenantEntityDto {
    name: string;
    code: string;
    icon?: AssetDto | undefined;
    fallbackLanguages: TenantLanguageDto[];
}

export class ContainerCondition extends Condition implements IContainerCondition {

    constructor(data?: IContainerCondition) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ContainerCondition {
        data = typeof data === 'object' ? data : {};
        let result = new ContainerCondition();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): ContainerCondition {
        const json = this.toJSON();
        let result = new ContainerCondition();
        result.init(json);
        return result;
    }
}

export interface IContainerCondition extends ICondition {
}

export class AssetFolderDto implements IAssetFolderDto {
    id!: string;
    name!: string;
    parentId?: string | undefined;
    isProtected!: boolean;
    icon?: string | undefined;

    constructor(data?: IAssetFolderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.parentId = _data["parentId"];
            this.isProtected = _data["isProtected"];
            this.icon = _data["icon"];
        }
    }

    static fromJS(data: any): AssetFolderDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetFolderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["parentId"] = this.parentId;
        data["isProtected"] = this.isProtected;
        data["icon"] = this.icon;
        return data;
    }

    clone(): AssetFolderDto {
        const json = this.toJSON();
        let result = new AssetFolderDto();
        result.init(json);
        return result;
    }
}

export interface IAssetFolderDto {
    id: string;
    name: string;
    parentId?: string | undefined;
    isProtected: boolean;
    icon?: string | undefined;
}

export class ContainerSharingOptionDto implements IContainerSharingOptionDto {
    id!: string;
    name!: string;
    label!: InternationalizedString;
    type!: ContainerSharingType;
    condition?: SharingCondition | undefined;

    constructor(data?: IContainerSharingOptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.label = new InternationalizedString();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.label = _data["label"] ? InternationalizedString.fromJS(_data["label"]) : new InternationalizedString();
            this.type = _data["type"];
            this.condition = _data["condition"] ? SharingCondition.fromJS(_data["condition"]) : undefined as any;
        }
    }

    static fromJS(data: any): ContainerSharingOptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContainerSharingOptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["label"] = this.label ? this.label.toJSON() : undefined as any;
        data["type"] = this.type;
        data["condition"] = this.condition ? this.condition.toJSON() : undefined as any;
        return data;
    }

    clone(): ContainerSharingOptionDto {
        const json = this.toJSON();
        let result = new ContainerSharingOptionDto();
        result.init(json);
        return result;
    }
}

export interface IContainerSharingOptionDto {
    id: string;
    name: string;
    label: InternationalizedString;
    type: ContainerSharingType;
    condition?: SharingCondition | undefined;
}

export enum ContainerSharingType {
    IndividualInstances = "individualInstances",
    EntireContainer = "entireContainer",
    Automatic = "automatic",
}

export class SharingCondition extends Condition implements ISharingCondition {

    constructor(data?: ISharingCondition) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): SharingCondition {
        data = typeof data === 'object' ? data : {};
        let result = new SharingCondition();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): SharingCondition {
        const json = this.toJSON();
        let result = new SharingCondition();
        result.init(json);
        return result;
    }
}

export interface ISharingCondition extends ICondition {
}

export class CreateAppPageCommand implements ICreateAppPageCommand {
    name!: string;
    projectId?: string | undefined;
    parentPageId?: string | undefined;
    index!: number;

    constructor(data?: ICreateAppPageCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.projectId = _data["projectId"];
            this.parentPageId = _data["parentPageId"];
            this.index = _data["index"];
        }
    }

    static fromJS(data: any): CreateAppPageCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAppPageCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["projectId"] = this.projectId;
        data["parentPageId"] = this.parentPageId;
        data["index"] = this.index;
        return data;
    }

    clone(): CreateAppPageCommand {
        const json = this.toJSON();
        let result = new CreateAppPageCommand();
        result.init(json);
        return result;
    }
}

export interface ICreateAppPageCommand {
    name: string;
    projectId?: string | undefined;
    parentPageId?: string | undefined;
    index: number;
}

export class UpdateAppPageCommand implements IUpdateAppPageCommand {
    appPageId!: string;
    name!: string;
    uniqueLabel!: string;
    title!: InternationalizedString;
    description!: InternationalizedDocument;
    defaultLanguageId!: string;
    languageIds!: string[];
    contents!: ContentDto[];
    condition?: ContainerCondition | undefined;
    tags!: string[];
    visibility!: ContainerVisibility;
    assetId?: string | undefined;

    constructor(data?: IUpdateAppPageCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.title = new InternationalizedString();
            this.description = new InternationalizedDocument();
            this.languageIds = [];
            this.contents = [];
            this.tags = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appPageId = _data["appPageId"];
            this.name = _data["name"];
            this.uniqueLabel = _data["uniqueLabel"];
            this.title = _data["title"] ? InternationalizedString.fromJS(_data["title"]) : new InternationalizedString();
            this.description = _data["description"] ? InternationalizedDocument.fromJS(_data["description"]) : new InternationalizedDocument();
            this.defaultLanguageId = _data["defaultLanguageId"];
            if (Array.isArray(_data["languageIds"])) {
                this.languageIds = [] as any;
                for (let item of _data["languageIds"])
                    this.languageIds!.push(item);
            }
            if (Array.isArray(_data["contents"])) {
                this.contents = [] as any;
                for (let item of _data["contents"])
                    this.contents!.push(ContentDto.fromJS(item));
            }
            this.condition = _data["condition"] ? ContainerCondition.fromJS(_data["condition"]) : undefined as any;
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            this.visibility = _data["visibility"];
            this.assetId = _data["assetId"];
        }
    }

    static fromJS(data: any): UpdateAppPageCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAppPageCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appPageId"] = this.appPageId;
        data["name"] = this.name;
        data["uniqueLabel"] = this.uniqueLabel;
        data["title"] = this.title ? this.title.toJSON() : undefined as any;
        data["description"] = this.description ? this.description.toJSON() : undefined as any;
        data["defaultLanguageId"] = this.defaultLanguageId;
        if (Array.isArray(this.languageIds)) {
            data["languageIds"] = [];
            for (let item of this.languageIds)
                data["languageIds"].push(item);
        }
        if (Array.isArray(this.contents)) {
            data["contents"] = [];
            for (let item of this.contents)
                data["contents"].push(item ? item.toJSON() : undefined as any);
        }
        data["condition"] = this.condition ? this.condition.toJSON() : undefined as any;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["visibility"] = this.visibility;
        data["assetId"] = this.assetId;
        return data;
    }

    clone(): UpdateAppPageCommand {
        const json = this.toJSON();
        let result = new UpdateAppPageCommand();
        result.init(json);
        return result;
    }
}

export interface IUpdateAppPageCommand {
    appPageId: string;
    name: string;
    uniqueLabel: string;
    title: InternationalizedString;
    description: InternationalizedDocument;
    defaultLanguageId: string;
    languageIds: string[];
    contents: ContentDto[];
    condition?: ContainerCondition | undefined;
    tags: string[];
    visibility: ContainerVisibility;
    assetId?: string | undefined;
}

export class MoveAppPageCommand implements IMoveAppPageCommand {
    appPageId!: string;
    parentPageId?: string | undefined;
    index!: number;

    constructor(data?: IMoveAppPageCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appPageId = _data["appPageId"];
            this.parentPageId = _data["parentPageId"];
            this.index = _data["index"];
        }
    }

    static fromJS(data: any): MoveAppPageCommand {
        data = typeof data === 'object' ? data : {};
        let result = new MoveAppPageCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appPageId"] = this.appPageId;
        data["parentPageId"] = this.parentPageId;
        data["index"] = this.index;
        return data;
    }

    clone(): MoveAppPageCommand {
        const json = this.toJSON();
        let result = new MoveAppPageCommand();
        result.init(json);
        return result;
    }
}

export interface IMoveAppPageCommand {
    appPageId: string;
    parentPageId?: string | undefined;
    index: number;
}

export class PaginatedListOfHistoricalContentDto implements IPaginatedListOfHistoricalContentDto {
    items!: HistoricalContentDto[];
    pageNumber!: number;
    pageSize!: number;
    totalCount!: number;
    totalPages!: number;
    hasPreviousPage!: boolean;
    hasNextPage!: boolean;

    constructor(data?: IPaginatedListOfHistoricalContentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(HistoricalContentDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            this.totalPages = _data["totalPages"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfHistoricalContentDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfHistoricalContentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["totalPages"] = this.totalPages;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }

    clone(): PaginatedListOfHistoricalContentDto {
        const json = this.toJSON();
        let result = new PaginatedListOfHistoricalContentDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedListOfHistoricalContentDto {
    items: HistoricalContentDto[];
    pageNumber: number;
    pageSize: number;
    totalCount: number;
    totalPages: number;
    hasPreviousPage: boolean;
    hasNextPage: boolean;
}

export class HistoricalContentDto implements IHistoricalContentDto {
    timestamp!: Date;
    version!: number;
    lastModifiedBy?: UserDto | undefined;

    constructor(data?: IHistoricalContentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timestamp = _data["timestamp"] ? new Date(_data["timestamp"].toString()) : undefined as any;
            this.version = _data["version"];
            this.lastModifiedBy = _data["lastModifiedBy"] ? UserDto.fromJS(_data["lastModifiedBy"]) : undefined as any;
        }
    }

    static fromJS(data: any): HistoricalContentDto {
        data = typeof data === 'object' ? data : {};
        let result = new HistoricalContentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : undefined as any;
        data["version"] = this.version;
        data["lastModifiedBy"] = this.lastModifiedBy ? this.lastModifiedBy.toJSON() : undefined as any;
        return data;
    }

    clone(): HistoricalContentDto {
        const json = this.toJSON();
        let result = new HistoricalContentDto();
        result.init(json);
        return result;
    }
}

export interface IHistoricalContentDto {
    timestamp: Date;
    version: number;
    lastModifiedBy?: UserDto | undefined;
}

export class HistoricalContentDetailsDto implements IHistoricalContentDetailsDto {
    timestamp!: Date;
    version!: number;
    lastModifiedBy?: UserDto | undefined;
    contents!: ContentDto[];

    constructor(data?: IHistoricalContentDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.contents = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timestamp = _data["timestamp"] ? new Date(_data["timestamp"].toString()) : undefined as any;
            this.version = _data["version"];
            this.lastModifiedBy = _data["lastModifiedBy"] ? UserDto.fromJS(_data["lastModifiedBy"]) : undefined as any;
            if (Array.isArray(_data["contents"])) {
                this.contents = [] as any;
                for (let item of _data["contents"])
                    this.contents!.push(ContentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): HistoricalContentDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new HistoricalContentDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : undefined as any;
        data["version"] = this.version;
        data["lastModifiedBy"] = this.lastModifiedBy ? this.lastModifiedBy.toJSON() : undefined as any;
        if (Array.isArray(this.contents)) {
            data["contents"] = [];
            for (let item of this.contents)
                data["contents"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): HistoricalContentDetailsDto {
        const json = this.toJSON();
        let result = new HistoricalContentDetailsDto();
        result.init(json);
        return result;
    }
}

export interface IHistoricalContentDetailsDto {
    timestamp: Date;
    version: number;
    lastModifiedBy?: UserDto | undefined;
    contents: ContentDto[];
}

export class PaginatedListOfAppDto implements IPaginatedListOfAppDto {
    items!: AppDto[];
    pageNumber!: number;
    pageSize!: number;
    totalCount!: number;
    totalPages!: number;
    hasPreviousPage!: boolean;
    hasNextPage!: boolean;

    constructor(data?: IPaginatedListOfAppDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AppDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            this.totalPages = _data["totalPages"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfAppDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfAppDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["totalPages"] = this.totalPages;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }

    clone(): PaginatedListOfAppDto {
        const json = this.toJSON();
        let result = new PaginatedListOfAppDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedListOfAppDto {
    items: AppDto[];
    pageNumber: number;
    pageSize: number;
    totalCount: number;
    totalPages: number;
    hasPreviousPage: boolean;
    hasNextPage: boolean;
}

export abstract class ClientDto extends TenantEntityDto implements IClientDto {
    name!: string;

    protected _discriminator: string;

    constructor(data?: IClientDto) {
        super(data);
        this._discriminator = "ClientDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
        }
    }

    static override fromJS(data: any): ClientDto {
        data = typeof data === 'object' ? data : {};
        if (data["$type"] === "AppDto") {
            let result = new AppDto();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'ClientDto' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["$type"] = this._discriminator;
        data["name"] = this.name;
        super.toJSON(data);
        return data;
    }

    clone(): ClientDto {
        throw new Error("The abstract class 'ClientDto' cannot be instantiated.");
    }
}

export interface IClientDto extends ITenantEntityDto {
    name: string;
}

export class AppDto extends ClientDto implements IAppDto {

    constructor(data?: IAppDto) {
        super(data);
        this._discriminator = "AppDto";
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): AppDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): AppDto {
        const json = this.toJSON();
        let result = new AppDto();
        result.init(json);
        return result;
    }
}

export interface IAppDto extends IClientDto {
}

export abstract class ClientDetailsDto extends TenantEntityDto implements IClientDetailsDto {
    name!: string;
    identifiers!: ClientIdentifierDto[];
    versionPolicies!: ClientVersionPolicyDto[];
    consentTemplate?: ConsentTemplateDto | undefined;

    protected _discriminator: string;

    constructor(data?: IClientDetailsDto) {
        super(data);
        if (!data) {
            this.identifiers = [];
            this.versionPolicies = [];
        }
        this._discriminator = "ClientDetailsDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["identifiers"])) {
                this.identifiers = [] as any;
                for (let item of _data["identifiers"])
                    this.identifiers!.push(ClientIdentifierDto.fromJS(item));
            }
            if (Array.isArray(_data["versionPolicies"])) {
                this.versionPolicies = [] as any;
                for (let item of _data["versionPolicies"])
                    this.versionPolicies!.push(ClientVersionPolicyDto.fromJS(item));
            }
            this.consentTemplate = _data["consentTemplate"] ? ConsentTemplateDto.fromJS(_data["consentTemplate"]) : undefined as any;
        }
    }

    static override fromJS(data: any): ClientDetailsDto {
        data = typeof data === 'object' ? data : {};
        if (data["$type"] === "AppDetailsDto") {
            let result = new AppDetailsDto();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'ClientDetailsDto' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["$type"] = this._discriminator;
        data["name"] = this.name;
        if (Array.isArray(this.identifiers)) {
            data["identifiers"] = [];
            for (let item of this.identifiers)
                data["identifiers"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.versionPolicies)) {
            data["versionPolicies"] = [];
            for (let item of this.versionPolicies)
                data["versionPolicies"].push(item ? item.toJSON() : undefined as any);
        }
        data["consentTemplate"] = this.consentTemplate ? this.consentTemplate.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): ClientDetailsDto {
        throw new Error("The abstract class 'ClientDetailsDto' cannot be instantiated.");
    }
}

export interface IClientDetailsDto extends ITenantEntityDto {
    name: string;
    identifiers: ClientIdentifierDto[];
    versionPolicies: ClientVersionPolicyDto[];
    consentTemplate?: ConsentTemplateDto | undefined;
}

export class AppDetailsDto extends ClientDetailsDto implements IAppDetailsDto {
    qrUrl?: string | undefined;
    firebaseConfiguration?: string | undefined;
    revenueCatConfiguration?: RevenueCatConfigurationDto | undefined;
    isLicenseRequired!: boolean;
    licenses!: LicenseDto[];
    allowedOrigins!: string[];

    constructor(data?: IAppDetailsDto) {
        super(data);
        if (!data) {
            this.licenses = [];
            this.allowedOrigins = [];
        }
        this._discriminator = "AppDetailsDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.qrUrl = _data["qrUrl"];
            this.firebaseConfiguration = _data["firebaseConfiguration"];
            this.revenueCatConfiguration = _data["revenueCatConfiguration"] ? RevenueCatConfigurationDto.fromJS(_data["revenueCatConfiguration"]) : undefined as any;
            this.isLicenseRequired = _data["isLicenseRequired"];
            if (Array.isArray(_data["licenses"])) {
                this.licenses = [] as any;
                for (let item of _data["licenses"])
                    this.licenses!.push(LicenseDto.fromJS(item));
            }
            if (Array.isArray(_data["allowedOrigins"])) {
                this.allowedOrigins = [] as any;
                for (let item of _data["allowedOrigins"])
                    this.allowedOrigins!.push(item);
            }
        }
    }

    static override fromJS(data: any): AppDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppDetailsDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["qrUrl"] = this.qrUrl;
        data["firebaseConfiguration"] = this.firebaseConfiguration;
        data["revenueCatConfiguration"] = this.revenueCatConfiguration ? this.revenueCatConfiguration.toJSON() : undefined as any;
        data["isLicenseRequired"] = this.isLicenseRequired;
        if (Array.isArray(this.licenses)) {
            data["licenses"] = [];
            for (let item of this.licenses)
                data["licenses"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.allowedOrigins)) {
            data["allowedOrigins"] = [];
            for (let item of this.allowedOrigins)
                data["allowedOrigins"].push(item);
        }
        super.toJSON(data);
        return data;
    }

    clone(): AppDetailsDto {
        const json = this.toJSON();
        let result = new AppDetailsDto();
        result.init(json);
        return result;
    }
}

export interface IAppDetailsDto extends IClientDetailsDto {
    qrUrl?: string | undefined;
    firebaseConfiguration?: string | undefined;
    revenueCatConfiguration?: RevenueCatConfigurationDto | undefined;
    isLicenseRequired: boolean;
    licenses: LicenseDto[];
    allowedOrigins: string[];
}

export class RevenueCatConfigurationDto implements IRevenueCatConfigurationDto {
    projectId?: string | undefined;
    publicApiKey?: string | undefined;
    webhookAuthHeader?: string | undefined;
    webhookHmacSecret?: string | undefined;
    allowSandbox!: boolean;

    constructor(data?: IRevenueCatConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.publicApiKey = _data["publicApiKey"];
            this.webhookAuthHeader = _data["webhookAuthHeader"];
            this.webhookHmacSecret = _data["webhookHmacSecret"];
            this.allowSandbox = _data["allowSandbox"];
        }
    }

    static fromJS(data: any): RevenueCatConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new RevenueCatConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["publicApiKey"] = this.publicApiKey;
        data["webhookAuthHeader"] = this.webhookAuthHeader;
        data["webhookHmacSecret"] = this.webhookHmacSecret;
        data["allowSandbox"] = this.allowSandbox;
        return data;
    }

    clone(): RevenueCatConfigurationDto {
        const json = this.toJSON();
        let result = new RevenueCatConfigurationDto();
        result.init(json);
        return result;
    }
}

export interface IRevenueCatConfigurationDto {
    projectId?: string | undefined;
    publicApiKey?: string | undefined;
    webhookAuthHeader?: string | undefined;
    webhookHmacSecret?: string | undefined;
    allowSandbox: boolean;
}

export class LicenseDto implements ILicenseDto {
    id!: string;
    name!: string;
    apps!: AppDto[];
    activationServiceType!: LicenseActivationServiceType;
    validFromDate?: Date | undefined;
    validityInterval?: string | undefined;
    instanceValidityInterval?: string | undefined;
    created?: Date | undefined;
    createdBy?: UserDto | undefined;
    lastModified?: Date | undefined;
    hidden?: Date | undefined;
    tags!: string[];
    metadata!: LicenseMetadataDto;
    licenseConfig?: LicenseConfig | undefined;
    instancesCount!: number;
    activatedInstancesCount!: number;

    constructor(data?: ILicenseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.apps = [];
            this.tags = [];
            this.metadata = new LicenseMetadataDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["apps"])) {
                this.apps = [] as any;
                for (let item of _data["apps"])
                    this.apps!.push(AppDto.fromJS(item));
            }
            this.activationServiceType = _data["activationServiceType"];
            this.validFromDate = _data["validFromDate"] ? new Date(_data["validFromDate"].toString()) : undefined as any;
            this.validityInterval = _data["validityInterval"];
            this.instanceValidityInterval = _data["instanceValidityInterval"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"] ? UserDto.fromJS(_data["createdBy"]) : undefined as any;
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : undefined as any;
            this.hidden = _data["hidden"] ? new Date(_data["hidden"].toString()) : undefined as any;
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            this.metadata = _data["metadata"] ? LicenseMetadataDto.fromJS(_data["metadata"]) : new LicenseMetadataDto();
            this.licenseConfig = _data["licenseConfig"] ? LicenseConfig.fromJS(_data["licenseConfig"]) : undefined as any;
            this.instancesCount = _data["instancesCount"];
            this.activatedInstancesCount = _data["activatedInstancesCount"];
        }
    }

    static fromJS(data: any): LicenseDto {
        data = typeof data === 'object' ? data : {};
        let result = new LicenseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.apps)) {
            data["apps"] = [];
            for (let item of this.apps)
                data["apps"].push(item ? item.toJSON() : undefined as any);
        }
        data["activationServiceType"] = this.activationServiceType;
        data["validFromDate"] = this.validFromDate ? this.validFromDate.toISOString() : undefined as any;
        data["validityInterval"] = this.validityInterval;
        data["instanceValidityInterval"] = this.instanceValidityInterval;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy ? this.createdBy.toJSON() : undefined as any;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : undefined as any;
        data["hidden"] = this.hidden ? this.hidden.toISOString() : undefined as any;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["metadata"] = this.metadata ? this.metadata.toJSON() : undefined as any;
        data["licenseConfig"] = this.licenseConfig ? this.licenseConfig.toJSON() : undefined as any;
        data["instancesCount"] = this.instancesCount;
        data["activatedInstancesCount"] = this.activatedInstancesCount;
        return data;
    }

    clone(): LicenseDto {
        const json = this.toJSON();
        let result = new LicenseDto();
        result.init(json);
        return result;
    }
}

export interface ILicenseDto {
    id: string;
    name: string;
    apps: AppDto[];
    activationServiceType: LicenseActivationServiceType;
    validFromDate?: Date | undefined;
    validityInterval?: string | undefined;
    instanceValidityInterval?: string | undefined;
    created?: Date | undefined;
    createdBy?: UserDto | undefined;
    lastModified?: Date | undefined;
    hidden?: Date | undefined;
    tags: string[];
    metadata: LicenseMetadataDto;
    licenseConfig?: LicenseConfig | undefined;
    instancesCount: number;
    activatedInstancesCount: number;
}

export enum LicenseActivationServiceType {
    OnlineKeyServer = "onlineKeyServer",
    RevenueCat = "revenueCat",
}

export class LicenseMetadataDto implements ILicenseMetadataDto {
    poNumber?: string | undefined;
    distributorName?: string | undefined;

    constructor(data?: ILicenseMetadataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.poNumber = _data["poNumber"];
            this.distributorName = _data["distributorName"];
        }
    }

    static fromJS(data: any): LicenseMetadataDto {
        data = typeof data === 'object' ? data : {};
        let result = new LicenseMetadataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["poNumber"] = this.poNumber;
        data["distributorName"] = this.distributorName;
        return data;
    }

    clone(): LicenseMetadataDto {
        const json = this.toJSON();
        let result = new LicenseMetadataDto();
        result.init(json);
        return result;
    }
}

export interface ILicenseMetadataDto {
    poNumber?: string | undefined;
    distributorName?: string | undefined;
}

export class LicenseConfig implements ILicenseConfig {
    countries?: Country[] | undefined;
    maxDevices?: number | undefined;
    revenueCat?: RevenueCatLicenseConfig | undefined;

    constructor(data?: ILicenseConfig) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["countries"])) {
                this.countries = [] as any;
                for (let item of _data["countries"])
                    this.countries!.push(Country.fromJS(item));
            }
            this.maxDevices = _data["maxDevices"];
            this.revenueCat = _data["revenueCat"] ? RevenueCatLicenseConfig.fromJS(_data["revenueCat"]) : undefined as any;
        }
    }

    static fromJS(data: any): LicenseConfig {
        data = typeof data === 'object' ? data : {};
        let result = new LicenseConfig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.countries)) {
            data["countries"] = [];
            for (let item of this.countries)
                data["countries"].push(item ? item.toJSON() : undefined as any);
        }
        data["maxDevices"] = this.maxDevices;
        data["revenueCat"] = this.revenueCat ? this.revenueCat.toJSON() : undefined as any;
        return data;
    }

    clone(): LicenseConfig {
        const json = this.toJSON();
        let result = new LicenseConfig();
        result.init(json);
        return result;
    }
}

export interface ILicenseConfig {
    countries?: Country[] | undefined;
    maxDevices?: number | undefined;
    revenueCat?: RevenueCatLicenseConfig | undefined;
}

export class Country implements ICountry {
    name!: string;
    isoCode!: string;

    constructor(data?: ICountry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.isoCode = _data["isoCode"];
        }
    }

    static fromJS(data: any): Country {
        data = typeof data === 'object' ? data : {};
        let result = new Country();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["isoCode"] = this.isoCode;
        return data;
    }

    clone(): Country {
        const json = this.toJSON();
        let result = new Country();
        result.init(json);
        return result;
    }
}

export interface ICountry {
    name: string;
    isoCode: string;
}

export class RevenueCatLicenseConfig implements IRevenueCatLicenseConfig {
    entitlementId?: string | undefined;
    nonSubscriptionProductIds!: string[];
    /** Hosted checkout URL containing AppUserIdPlaceholder, which is replaced with the user's id. */
    purchaseLinkTemplate?: string | undefined;

    constructor(data?: IRevenueCatLicenseConfig) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.nonSubscriptionProductIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entitlementId = _data["entitlementId"];
            if (Array.isArray(_data["nonSubscriptionProductIds"])) {
                this.nonSubscriptionProductIds = [] as any;
                for (let item of _data["nonSubscriptionProductIds"])
                    this.nonSubscriptionProductIds!.push(item);
            }
            this.purchaseLinkTemplate = _data["purchaseLinkTemplate"];
        }
    }

    static fromJS(data: any): RevenueCatLicenseConfig {
        data = typeof data === 'object' ? data : {};
        let result = new RevenueCatLicenseConfig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entitlementId"] = this.entitlementId;
        if (Array.isArray(this.nonSubscriptionProductIds)) {
            data["nonSubscriptionProductIds"] = [];
            for (let item of this.nonSubscriptionProductIds)
                data["nonSubscriptionProductIds"].push(item);
        }
        data["purchaseLinkTemplate"] = this.purchaseLinkTemplate;
        return data;
    }

    clone(): RevenueCatLicenseConfig {
        const json = this.toJSON();
        let result = new RevenueCatLicenseConfig();
        result.init(json);
        return result;
    }
}

export interface IRevenueCatLicenseConfig {
    entitlementId?: string | undefined;
    nonSubscriptionProductIds: string[];
    /** Hosted checkout URL containing AppUserIdPlaceholder, which is replaced with the user's id. */
    purchaseLinkTemplate?: string | undefined;
}

export class ClientIdentifierDto implements IClientIdentifierDto {
    platform!: Platform;
    environment!: Environment;
    identifier!: string;
    storeLink?: string | undefined;

    constructor(data?: IClientIdentifierDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.platform = _data["platform"];
            this.environment = _data["environment"];
            this.identifier = _data["identifier"];
            this.storeLink = _data["storeLink"];
        }
    }

    static fromJS(data: any): ClientIdentifierDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClientIdentifierDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["platform"] = this.platform;
        data["environment"] = this.environment;
        data["identifier"] = this.identifier;
        data["storeLink"] = this.storeLink;
        return data;
    }

    clone(): ClientIdentifierDto {
        const json = this.toJSON();
        let result = new ClientIdentifierDto();
        result.init(json);
        return result;
    }
}

export interface IClientIdentifierDto {
    platform: Platform;
    environment: Environment;
    identifier: string;
    storeLink?: string | undefined;
}

export enum Platform {
    Android = "android",
    Ios = "ios",
}

export enum Environment {
    Development = "development",
    Production = "production",
}

export class ClientVersionPolicyDto implements IClientVersionPolicyDto {
    platform!: Platform;
    environment!: Environment;
    minSupportedVersion!: string;
    latestVersion!: string;
    blockedVersions!: string[];

    constructor(data?: IClientVersionPolicyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.blockedVersions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.platform = _data["platform"];
            this.environment = _data["environment"];
            this.minSupportedVersion = _data["minSupportedVersion"];
            this.latestVersion = _data["latestVersion"];
            if (Array.isArray(_data["blockedVersions"])) {
                this.blockedVersions = [] as any;
                for (let item of _data["blockedVersions"])
                    this.blockedVersions!.push(item);
            }
        }
    }

    static fromJS(data: any): ClientVersionPolicyDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClientVersionPolicyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["platform"] = this.platform;
        data["environment"] = this.environment;
        data["minSupportedVersion"] = this.minSupportedVersion;
        data["latestVersion"] = this.latestVersion;
        if (Array.isArray(this.blockedVersions)) {
            data["blockedVersions"] = [];
            for (let item of this.blockedVersions)
                data["blockedVersions"].push(item);
        }
        return data;
    }

    clone(): ClientVersionPolicyDto {
        const json = this.toJSON();
        let result = new ClientVersionPolicyDto();
        result.init(json);
        return result;
    }
}

export interface IClientVersionPolicyDto {
    platform: Platform;
    environment: Environment;
    minSupportedVersion: string;
    latestVersion: string;
    blockedVersions: string[];
}

export class ConsentTemplateDto implements IConsentTemplateDto {
    id!: string;
    clientId?: string | undefined;
    clientName?: string | undefined;
    projectId?: string | undefined;
    projectName?: string | undefined;
    name!: string;
    versions!: ConsentTemplateVersionDto[];

    constructor(data?: IConsentTemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.versions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.clientId = _data["clientId"];
            this.clientName = _data["clientName"];
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.name = _data["name"];
            if (Array.isArray(_data["versions"])) {
                this.versions = [] as any;
                for (let item of _data["versions"])
                    this.versions!.push(ConsentTemplateVersionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ConsentTemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConsentTemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["clientId"] = this.clientId;
        data["clientName"] = this.clientName;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["name"] = this.name;
        if (Array.isArray(this.versions)) {
            data["versions"] = [];
            for (let item of this.versions)
                data["versions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): ConsentTemplateDto {
        const json = this.toJSON();
        let result = new ConsentTemplateDto();
        result.init(json);
        return result;
    }
}

export interface IConsentTemplateDto {
    id: string;
    clientId?: string | undefined;
    clientName?: string | undefined;
    projectId?: string | undefined;
    projectName?: string | undefined;
    name: string;
    versions: ConsentTemplateVersionDto[];
}

export class ConsentTemplateVersionDto implements IConsentTemplateVersionDto {
    id!: string;
    version!: number;
    published?: Date | undefined;
    hidden?: Date | undefined;
    created!: Date;
    lastModified!: Date;

    constructor(data?: IConsentTemplateVersionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.version = _data["version"];
            this.published = _data["published"] ? new Date(_data["published"].toString()) : undefined as any;
            this.hidden = _data["hidden"] ? new Date(_data["hidden"].toString()) : undefined as any;
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ConsentTemplateVersionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConsentTemplateVersionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["version"] = this.version;
        data["published"] = this.published ? this.published.toISOString() : undefined as any;
        data["hidden"] = this.hidden ? this.hidden.toISOString() : undefined as any;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : undefined as any;
        return data;
    }

    clone(): ConsentTemplateVersionDto {
        const json = this.toJSON();
        let result = new ConsentTemplateVersionDto();
        result.init(json);
        return result;
    }
}

export interface IConsentTemplateVersionDto {
    id: string;
    version: number;
    published?: Date | undefined;
    hidden?: Date | undefined;
    created: Date;
    lastModified: Date;
}

export class CreateAppCommand implements ICreateAppCommand {
    name!: string;
    allowedOrigins?: string[] | undefined;

    constructor(data?: ICreateAppCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["allowedOrigins"])) {
                this.allowedOrigins = [] as any;
                for (let item of _data["allowedOrigins"])
                    this.allowedOrigins!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateAppCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAppCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.allowedOrigins)) {
            data["allowedOrigins"] = [];
            for (let item of this.allowedOrigins)
                data["allowedOrigins"].push(item);
        }
        return data;
    }

    clone(): CreateAppCommand {
        const json = this.toJSON();
        let result = new CreateAppCommand();
        result.init(json);
        return result;
    }
}

export interface ICreateAppCommand {
    name: string;
    allowedOrigins?: string[] | undefined;
}

export class UpdateAppCommand implements IUpdateAppCommand {
    appId!: string;
    name!: string;
    qrUrl?: string | undefined;
    firebaseConfiguration?: string | undefined;
    identifiers!: ClientIdentifierDto[];
    versionPolicies!: ClientVersionPolicyDto[];
    isLicenseRequired?: boolean | undefined;
    allowedOrigins?: string[] | undefined;
    revenueCatConfiguration?: RevenueCatConfigurationDto | undefined;

    constructor(data?: IUpdateAppCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.identifiers = [];
            this.versionPolicies = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appId = _data["appId"];
            this.name = _data["name"];
            this.qrUrl = _data["qrUrl"];
            this.firebaseConfiguration = _data["firebaseConfiguration"];
            if (Array.isArray(_data["identifiers"])) {
                this.identifiers = [] as any;
                for (let item of _data["identifiers"])
                    this.identifiers!.push(ClientIdentifierDto.fromJS(item));
            }
            if (Array.isArray(_data["versionPolicies"])) {
                this.versionPolicies = [] as any;
                for (let item of _data["versionPolicies"])
                    this.versionPolicies!.push(ClientVersionPolicyDto.fromJS(item));
            }
            this.isLicenseRequired = _data["isLicenseRequired"];
            if (Array.isArray(_data["allowedOrigins"])) {
                this.allowedOrigins = [] as any;
                for (let item of _data["allowedOrigins"])
                    this.allowedOrigins!.push(item);
            }
            this.revenueCatConfiguration = _data["revenueCatConfiguration"] ? RevenueCatConfigurationDto.fromJS(_data["revenueCatConfiguration"]) : undefined as any;
        }
    }

    static fromJS(data: any): UpdateAppCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAppCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appId"] = this.appId;
        data["name"] = this.name;
        data["qrUrl"] = this.qrUrl;
        data["firebaseConfiguration"] = this.firebaseConfiguration;
        if (Array.isArray(this.identifiers)) {
            data["identifiers"] = [];
            for (let item of this.identifiers)
                data["identifiers"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.versionPolicies)) {
            data["versionPolicies"] = [];
            for (let item of this.versionPolicies)
                data["versionPolicies"].push(item ? item.toJSON() : undefined as any);
        }
        data["isLicenseRequired"] = this.isLicenseRequired;
        if (Array.isArray(this.allowedOrigins)) {
            data["allowedOrigins"] = [];
            for (let item of this.allowedOrigins)
                data["allowedOrigins"].push(item);
        }
        data["revenueCatConfiguration"] = this.revenueCatConfiguration ? this.revenueCatConfiguration.toJSON() : undefined as any;
        return data;
    }

    clone(): UpdateAppCommand {
        const json = this.toJSON();
        let result = new UpdateAppCommand();
        result.init(json);
        return result;
    }
}

export interface IUpdateAppCommand {
    appId: string;
    name: string;
    qrUrl?: string | undefined;
    firebaseConfiguration?: string | undefined;
    identifiers: ClientIdentifierDto[];
    versionPolicies: ClientVersionPolicyDto[];
    isLicenseRequired?: boolean | undefined;
    allowedOrigins?: string[] | undefined;
    revenueCatConfiguration?: RevenueCatConfigurationDto | undefined;
}

export class CreateClientConsentTemplateCommand implements ICreateClientConsentTemplateCommand {
    name!: string;
    clientId!: string;

    constructor(data?: ICreateClientConsentTemplateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.clientId = _data["clientId"];
        }
    }

    static fromJS(data: any): CreateClientConsentTemplateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateClientConsentTemplateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["clientId"] = this.clientId;
        return data;
    }

    clone(): CreateClientConsentTemplateCommand {
        const json = this.toJSON();
        let result = new CreateClientConsentTemplateCommand();
        result.init(json);
        return result;
    }
}

export interface ICreateClientConsentTemplateCommand {
    name: string;
    clientId: string;
}

export class PaginatedListOfAssetDto implements IPaginatedListOfAssetDto {
    items!: AssetDto[];
    pageNumber!: number;
    pageSize!: number;
    totalCount!: number;
    totalPages!: number;
    hasPreviousPage!: boolean;
    hasNextPage!: boolean;

    constructor(data?: IPaginatedListOfAssetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AssetDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            this.totalPages = _data["totalPages"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfAssetDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfAssetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["totalPages"] = this.totalPages;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }

    clone(): PaginatedListOfAssetDto {
        const json = this.toJSON();
        let result = new PaginatedListOfAssetDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedListOfAssetDto {
    items: AssetDto[];
    pageNumber: number;
    pageSize: number;
    totalCount: number;
    totalPages: number;
    hasPreviousPage: boolean;
    hasNextPage: boolean;
}

export class AssetFolderDetailsDto implements IAssetFolderDetailsDto {
    id!: string;
    name!: string;
    description?: string | undefined;
    assets!: AssetDto[];
    parentId?: string | undefined;
    rootLine!: AssetFolderDto[];
    children!: AssetFolderDto[];
    isProtected!: boolean;
    icon?: string | undefined;

    constructor(data?: IAssetFolderDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.assets = [];
            this.rootLine = [];
            this.children = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            if (Array.isArray(_data["assets"])) {
                this.assets = [] as any;
                for (let item of _data["assets"])
                    this.assets!.push(AssetDto.fromJS(item));
            }
            this.parentId = _data["parentId"];
            if (Array.isArray(_data["rootLine"])) {
                this.rootLine = [] as any;
                for (let item of _data["rootLine"])
                    this.rootLine!.push(AssetFolderDto.fromJS(item));
            }
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(AssetFolderDto.fromJS(item));
            }
            this.isProtected = _data["isProtected"];
            this.icon = _data["icon"];
        }
    }

    static fromJS(data: any): AssetFolderDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetFolderDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        if (Array.isArray(this.assets)) {
            data["assets"] = [];
            for (let item of this.assets)
                data["assets"].push(item ? item.toJSON() : undefined as any);
        }
        data["parentId"] = this.parentId;
        if (Array.isArray(this.rootLine)) {
            data["rootLine"] = [];
            for (let item of this.rootLine)
                data["rootLine"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item ? item.toJSON() : undefined as any);
        }
        data["isProtected"] = this.isProtected;
        data["icon"] = this.icon;
        return data;
    }

    clone(): AssetFolderDetailsDto {
        const json = this.toJSON();
        let result = new AssetFolderDetailsDto();
        result.init(json);
        return result;
    }
}

export interface IAssetFolderDetailsDto {
    id: string;
    name: string;
    description?: string | undefined;
    assets: AssetDto[];
    parentId?: string | undefined;
    rootLine: AssetFolderDto[];
    children: AssetFolderDto[];
    isProtected: boolean;
    icon?: string | undefined;
}

export class CreateAssetCommand implements ICreateAssetCommand {
    assetFolderId!: string;
    name!: string;
    fileId!: string;

    constructor(data?: ICreateAssetCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assetFolderId = _data["assetFolderId"];
            this.name = _data["name"];
            this.fileId = _data["fileId"];
        }
    }

    static fromJS(data: any): CreateAssetCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAssetCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assetFolderId"] = this.assetFolderId;
        data["name"] = this.name;
        data["fileId"] = this.fileId;
        return data;
    }

    clone(): CreateAssetCommand {
        const json = this.toJSON();
        let result = new CreateAssetCommand();
        result.init(json);
        return result;
    }
}

export interface ICreateAssetCommand {
    assetFolderId: string;
    name: string;
    fileId: string;
}

export class CreateAssetFolderCommand implements ICreateAssetFolderCommand {
    parentId?: string | undefined;
    name!: string;
    icon?: string | undefined;

    constructor(data?: ICreateAssetFolderCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentId = _data["parentId"];
            this.name = _data["name"];
            this.icon = _data["icon"];
        }
    }

    static fromJS(data: any): CreateAssetFolderCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAssetFolderCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentId"] = this.parentId;
        data["name"] = this.name;
        data["icon"] = this.icon;
        return data;
    }

    clone(): CreateAssetFolderCommand {
        const json = this.toJSON();
        let result = new CreateAssetFolderCommand();
        result.init(json);
        return result;
    }
}

export interface ICreateAssetFolderCommand {
    parentId?: string | undefined;
    name: string;
    icon?: string | undefined;
}

export class UpdateAssetCommand implements IUpdateAssetCommand {
    assetId!: string;
    fileId!: string;
    name!: string;
    description?: string | undefined;
    width?: number | undefined;
    height?: number | undefined;
    x?: number | undefined;
    y?: number | undefined;

    constructor(data?: IUpdateAssetCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assetId = _data["assetId"];
            this.fileId = _data["fileId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.width = _data["width"];
            this.height = _data["height"];
            this.x = _data["x"];
            this.y = _data["y"];
        }
    }

    static fromJS(data: any): UpdateAssetCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAssetCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assetId"] = this.assetId;
        data["fileId"] = this.fileId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["width"] = this.width;
        data["height"] = this.height;
        data["x"] = this.x;
        data["y"] = this.y;
        return data;
    }

    clone(): UpdateAssetCommand {
        const json = this.toJSON();
        let result = new UpdateAssetCommand();
        result.init(json);
        return result;
    }
}

export interface IUpdateAssetCommand {
    assetId: string;
    fileId: string;
    name: string;
    description?: string | undefined;
    width?: number | undefined;
    height?: number | undefined;
    x?: number | undefined;
    y?: number | undefined;
}

export class UpdateAssetFolderCommand implements IUpdateAssetFolderCommand {
    assetFolderId!: string;
    name!: string;
    description?: string | undefined;
    icon?: string | undefined;

    constructor(data?: IUpdateAssetFolderCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assetFolderId = _data["assetFolderId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.icon = _data["icon"];
        }
    }

    static fromJS(data: any): UpdateAssetFolderCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAssetFolderCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assetFolderId"] = this.assetFolderId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["icon"] = this.icon;
        return data;
    }

    clone(): UpdateAssetFolderCommand {
        const json = this.toJSON();
        let result = new UpdateAssetFolderCommand();
        result.init(json);
        return result;
    }
}

export interface IUpdateAssetFolderCommand {
    assetFolderId: string;
    name: string;
    description?: string | undefined;
    icon?: string | undefined;
}

export class MoveAssetCommand implements IMoveAssetCommand {
    assetId!: string;
    assetFolderId!: string;

    constructor(data?: IMoveAssetCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assetId = _data["assetId"];
            this.assetFolderId = _data["assetFolderId"];
        }
    }

    static fromJS(data: any): MoveAssetCommand {
        data = typeof data === 'object' ? data : {};
        let result = new MoveAssetCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assetId"] = this.assetId;
        data["assetFolderId"] = this.assetFolderId;
        return data;
    }

    clone(): MoveAssetCommand {
        const json = this.toJSON();
        let result = new MoveAssetCommand();
        result.init(json);
        return result;
    }
}

export interface IMoveAssetCommand {
    assetId: string;
    assetFolderId: string;
}

export class MoveAssetFolderCommand implements IMoveAssetFolderCommand {
    assetFolderId!: string;
    parentId!: string;

    constructor(data?: IMoveAssetFolderCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assetFolderId = _data["assetFolderId"];
            this.parentId = _data["parentId"];
        }
    }

    static fromJS(data: any): MoveAssetFolderCommand {
        data = typeof data === 'object' ? data : {};
        let result = new MoveAssetFolderCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assetFolderId"] = this.assetFolderId;
        data["parentId"] = this.parentId;
        return data;
    }

    clone(): MoveAssetFolderCommand {
        const json = this.toJSON();
        let result = new MoveAssetFolderCommand();
        result.init(json);
        return result;
    }
}

export interface IMoveAssetFolderCommand {
    assetFolderId: string;
    parentId: string;
}

export class PaginatedListOfAuditEventDto implements IPaginatedListOfAuditEventDto {
    items!: AuditEventDto[];
    pageNumber!: number;
    pageSize!: number;
    totalCount!: number;
    totalPages!: number;
    hasPreviousPage!: boolean;
    hasNextPage!: boolean;

    constructor(data?: IPaginatedListOfAuditEventDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AuditEventDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            this.totalPages = _data["totalPages"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfAuditEventDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfAuditEventDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["totalPages"] = this.totalPages;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }

    clone(): PaginatedListOfAuditEventDto {
        const json = this.toJSON();
        let result = new PaginatedListOfAuditEventDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedListOfAuditEventDto {
    items: AuditEventDto[];
    pageNumber: number;
    pageSize: number;
    totalCount: number;
    totalPages: number;
    hasPreviousPage: boolean;
    hasNextPage: boolean;
}

export class AuditEventDto implements IAuditEventDto {
    id!: number;
    created!: Date;
    lastModified!: Date;
    type!: string;
    responseStatusCode?: number | undefined;
    userId?: string | undefined;
    user?: UserDto | undefined;

    constructor(data?: IAuditEventDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : undefined as any;
            this.type = _data["type"];
            this.responseStatusCode = _data["responseStatusCode"];
            this.userId = _data["userId"];
            this.user = _data["user"] ? UserDto.fromJS(_data["user"]) : undefined as any;
        }
    }

    static fromJS(data: any): AuditEventDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuditEventDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : undefined as any;
        data["type"] = this.type;
        data["responseStatusCode"] = this.responseStatusCode;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        return data;
    }

    clone(): AuditEventDto {
        const json = this.toJSON();
        let result = new AuditEventDto();
        result.init(json);
        return result;
    }
}

export interface IAuditEventDto {
    id: number;
    created: Date;
    lastModified: Date;
    type: string;
    responseStatusCode?: number | undefined;
    userId?: string | undefined;
    user?: UserDto | undefined;
}

export class AuditEventDetailsDto implements IAuditEventDetailsDto {
    id!: number;
    created!: Date;
    lastModified!: Date;
    type!: string;
    userId?: string | undefined;
    userName?: string | undefined;
    data!: AuditEventDataDto;

    constructor(data?: IAuditEventDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.data = new AuditEventDataDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : undefined as any;
            this.type = _data["type"];
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.data = _data["data"] ? AuditEventDataDto.fromJS(_data["data"]) : new AuditEventDataDto();
        }
    }

    static fromJS(data: any): AuditEventDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuditEventDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : undefined as any;
        data["type"] = this.type;
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }

    clone(): AuditEventDetailsDto {
        const json = this.toJSON();
        let result = new AuditEventDetailsDto();
        result.init(json);
        return result;
    }
}

export interface IAuditEventDetailsDto {
    id: number;
    created: Date;
    lastModified: Date;
    type: string;
    userId?: string | undefined;
    userName?: string | undefined;
    data: AuditEventDataDto;
}

export class AuditEventDataDto implements IAuditEventDataDto {
    action!: AuditEventActionDto;
    userId?: string | undefined;
    endDate!: Date;
    duration!: number;
    eventType!: string;
    startDate!: Date;
    environment!: AuditEventEnvironmentDto;

    constructor(data?: IAuditEventDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.action = new AuditEventActionDto();
            this.environment = new AuditEventEnvironmentDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.action = _data["action"] ? AuditEventActionDto.fromJS(_data["action"]) : new AuditEventActionDto();
            this.userId = _data["userId"];
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            this.duration = _data["duration"];
            this.eventType = _data["eventType"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.environment = _data["environment"] ? AuditEventEnvironmentDto.fromJS(_data["environment"]) : new AuditEventEnvironmentDto();
        }
    }

    static fromJS(data: any): AuditEventDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuditEventDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["action"] = this.action ? this.action.toJSON() : undefined as any;
        data["userId"] = this.userId;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        data["duration"] = this.duration;
        data["eventType"] = this.eventType;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["environment"] = this.environment ? this.environment.toJSON() : undefined as any;
        return data;
    }

    clone(): AuditEventDataDto {
        const json = this.toJSON();
        let result = new AuditEventDataDto();
        result.init(json);
        return result;
    }
}

export interface IAuditEventDataDto {
    action: AuditEventActionDto;
    userId?: string | undefined;
    endDate: Date;
    duration: number;
    eventType: string;
    startDate: Date;
    environment: AuditEventEnvironmentDto;
}

export class AuditEventActionDto implements IAuditEventActionDto {
    traceId!: string;
    userName?: string | undefined;
    ipAddress!: string;
    actionName!: string;
    httpMethod!: string;
    requestUrl!: string;
    controllerName!: string;
    responseStatus!: string;
    actionParameters?: any | undefined;
    responseStatusCode?: number | undefined;
    formVariables?: any | undefined;
    exception?: string | undefined;

    constructor(data?: IAuditEventActionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.traceId = _data["traceId"];
            this.userName = _data["userName"];
            this.ipAddress = _data["ipAddress"];
            this.actionName = _data["actionName"];
            this.httpMethod = _data["httpMethod"];
            this.requestUrl = _data["requestUrl"];
            this.controllerName = _data["controllerName"];
            this.responseStatus = _data["responseStatus"];
            this.actionParameters = _data["actionParameters"];
            this.responseStatusCode = _data["responseStatusCode"];
            this.formVariables = _data["formVariables"];
            this.exception = _data["exception"];
        }
    }

    static fromJS(data: any): AuditEventActionDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuditEventActionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["traceId"] = this.traceId;
        data["userName"] = this.userName;
        data["ipAddress"] = this.ipAddress;
        data["actionName"] = this.actionName;
        data["httpMethod"] = this.httpMethod;
        data["requestUrl"] = this.requestUrl;
        data["controllerName"] = this.controllerName;
        data["responseStatus"] = this.responseStatus;
        data["actionParameters"] = this.actionParameters;
        data["responseStatusCode"] = this.responseStatusCode;
        data["formVariables"] = this.formVariables;
        data["exception"] = this.exception;
        return data;
    }

    clone(): AuditEventActionDto {
        const json = this.toJSON();
        let result = new AuditEventActionDto();
        result.init(json);
        return result;
    }
}

export interface IAuditEventActionDto {
    traceId: string;
    userName?: string | undefined;
    ipAddress: string;
    actionName: string;
    httpMethod: string;
    requestUrl: string;
    controllerName: string;
    responseStatus: string;
    actionParameters?: any | undefined;
    responseStatusCode?: number | undefined;
    formVariables?: any | undefined;
    exception?: string | undefined;
}

export class AuditEventEnvironmentDto implements IAuditEventEnvironmentDto {
    culture!: string;
    userName?: string | undefined;
    domainName!: string;
    machineName!: string;
    assemblyName!: string;
    callingMethodName!: string;

    constructor(data?: IAuditEventEnvironmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.culture = _data["culture"];
            this.userName = _data["userName"];
            this.domainName = _data["domainName"];
            this.machineName = _data["machineName"];
            this.assemblyName = _data["assemblyName"];
            this.callingMethodName = _data["callingMethodName"];
        }
    }

    static fromJS(data: any): AuditEventEnvironmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuditEventEnvironmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["culture"] = this.culture;
        data["userName"] = this.userName;
        data["domainName"] = this.domainName;
        data["machineName"] = this.machineName;
        data["assemblyName"] = this.assemblyName;
        data["callingMethodName"] = this.callingMethodName;
        return data;
    }

    clone(): AuditEventEnvironmentDto {
        const json = this.toJSON();
        let result = new AuditEventEnvironmentDto();
        result.init(json);
        return result;
    }
}

export interface IAuditEventEnvironmentDto {
    culture: string;
    userName?: string | undefined;
    domainName: string;
    machineName: string;
    assemblyName: string;
    callingMethodName: string;
}

export enum RestoreImportStrategy {
    RejectOnConflict = "rejectOnConflict",
    CreateNew = "createNew",
    ReuseExisting = "reuseExisting",
}

export enum RestoreUniqueLabelStrategy {
    RejectOnConflict = "rejectOnConflict",
    GenerateNew = "generateNew",
}

export class PaginatedListOfConsentTemplateDto implements IPaginatedListOfConsentTemplateDto {
    items!: ConsentTemplateDto[];
    pageNumber!: number;
    pageSize!: number;
    totalCount!: number;
    totalPages!: number;
    hasPreviousPage!: boolean;
    hasNextPage!: boolean;

    constructor(data?: IPaginatedListOfConsentTemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ConsentTemplateDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            this.totalPages = _data["totalPages"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfConsentTemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfConsentTemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["totalPages"] = this.totalPages;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }

    clone(): PaginatedListOfConsentTemplateDto {
        const json = this.toJSON();
        let result = new PaginatedListOfConsentTemplateDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedListOfConsentTemplateDto {
    items: ConsentTemplateDto[];
    pageNumber: number;
    pageSize: number;
    totalCount: number;
    totalPages: number;
    hasPreviousPage: boolean;
    hasNextPage: boolean;
}

export class UpdateConsentTemplateCommand implements IUpdateConsentTemplateCommand {
    consentTemplateId!: string;
    name!: string;

    constructor(data?: IUpdateConsentTemplateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.consentTemplateId = _data["consentTemplateId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): UpdateConsentTemplateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateConsentTemplateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["consentTemplateId"] = this.consentTemplateId;
        data["name"] = this.name;
        return data;
    }

    clone(): UpdateConsentTemplateCommand {
        const json = this.toJSON();
        let result = new UpdateConsentTemplateCommand();
        result.init(json);
        return result;
    }
}

export interface IUpdateConsentTemplateCommand {
    consentTemplateId: string;
    name: string;
}

export class ConsentTemplateVersionDetailsDto implements IConsentTemplateVersionDetailsDto {
    id!: string;
    consentTemplateId!: string;
    consentTemplateName!: string;
    version!: number;
    published?: Date | undefined;
    hidden?: Date | undefined;
    defaultLanguageId!: string;
    languageIds!: string[];
    versionChangeSummary?: InternationalizedDocument | undefined;
    headerText?: InternationalizedDocument | undefined;
    footerText?: InternationalizedDocument | undefined;
    modules!: ConsentModuleDto[];

    constructor(data?: IConsentTemplateVersionDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.languageIds = [];
            this.modules = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.consentTemplateId = _data["consentTemplateId"];
            this.consentTemplateName = _data["consentTemplateName"];
            this.version = _data["version"];
            this.published = _data["published"] ? new Date(_data["published"].toString()) : undefined as any;
            this.hidden = _data["hidden"] ? new Date(_data["hidden"].toString()) : undefined as any;
            this.defaultLanguageId = _data["defaultLanguageId"];
            if (Array.isArray(_data["languageIds"])) {
                this.languageIds = [] as any;
                for (let item of _data["languageIds"])
                    this.languageIds!.push(item);
            }
            this.versionChangeSummary = _data["versionChangeSummary"] ? InternationalizedDocument.fromJS(_data["versionChangeSummary"]) : undefined as any;
            this.headerText = _data["headerText"] ? InternationalizedDocument.fromJS(_data["headerText"]) : undefined as any;
            this.footerText = _data["footerText"] ? InternationalizedDocument.fromJS(_data["footerText"]) : undefined as any;
            if (Array.isArray(_data["modules"])) {
                this.modules = [] as any;
                for (let item of _data["modules"])
                    this.modules!.push(ConsentModuleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ConsentTemplateVersionDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConsentTemplateVersionDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["consentTemplateId"] = this.consentTemplateId;
        data["consentTemplateName"] = this.consentTemplateName;
        data["version"] = this.version;
        data["published"] = this.published ? this.published.toISOString() : undefined as any;
        data["hidden"] = this.hidden ? this.hidden.toISOString() : undefined as any;
        data["defaultLanguageId"] = this.defaultLanguageId;
        if (Array.isArray(this.languageIds)) {
            data["languageIds"] = [];
            for (let item of this.languageIds)
                data["languageIds"].push(item);
        }
        data["versionChangeSummary"] = this.versionChangeSummary ? this.versionChangeSummary.toJSON() : undefined as any;
        data["headerText"] = this.headerText ? this.headerText.toJSON() : undefined as any;
        data["footerText"] = this.footerText ? this.footerText.toJSON() : undefined as any;
        if (Array.isArray(this.modules)) {
            data["modules"] = [];
            for (let item of this.modules)
                data["modules"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): ConsentTemplateVersionDetailsDto {
        const json = this.toJSON();
        let result = new ConsentTemplateVersionDetailsDto();
        result.init(json);
        return result;
    }
}

export interface IConsentTemplateVersionDetailsDto {
    id: string;
    consentTemplateId: string;
    consentTemplateName: string;
    version: number;
    published?: Date | undefined;
    hidden?: Date | undefined;
    defaultLanguageId: string;
    languageIds: string[];
    versionChangeSummary?: InternationalizedDocument | undefined;
    headerText?: InternationalizedDocument | undefined;
    footerText?: InternationalizedDocument | undefined;
    modules: ConsentModuleDto[];
}

export class ConsentModuleDto implements IConsentModuleDto {
    id!: string;
    name!: string;
    required!: boolean;
    order!: number;
    consentText?: InternationalizedDocument | undefined;
    consentStatement!: InternationalizedDocument;
    policies!: ConsentPolicyDto[];
    referencedAppPages!: ConsentAppPageReferenceDto[];

    constructor(data?: IConsentModuleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.consentStatement = new InternationalizedDocument();
            this.policies = [];
            this.referencedAppPages = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.required = _data["required"];
            this.order = _data["order"];
            this.consentText = _data["consentText"] ? InternationalizedDocument.fromJS(_data["consentText"]) : undefined as any;
            this.consentStatement = _data["consentStatement"] ? InternationalizedDocument.fromJS(_data["consentStatement"]) : new InternationalizedDocument();
            if (Array.isArray(_data["policies"])) {
                this.policies = [] as any;
                for (let item of _data["policies"])
                    this.policies!.push(ConsentPolicyDto.fromJS(item));
            }
            if (Array.isArray(_data["referencedAppPages"])) {
                this.referencedAppPages = [] as any;
                for (let item of _data["referencedAppPages"])
                    this.referencedAppPages!.push(ConsentAppPageReferenceDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ConsentModuleDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConsentModuleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["required"] = this.required;
        data["order"] = this.order;
        data["consentText"] = this.consentText ? this.consentText.toJSON() : undefined as any;
        data["consentStatement"] = this.consentStatement ? this.consentStatement.toJSON() : undefined as any;
        if (Array.isArray(this.policies)) {
            data["policies"] = [];
            for (let item of this.policies)
                data["policies"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.referencedAppPages)) {
            data["referencedAppPages"] = [];
            for (let item of this.referencedAppPages)
                data["referencedAppPages"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): ConsentModuleDto {
        const json = this.toJSON();
        let result = new ConsentModuleDto();
        result.init(json);
        return result;
    }
}

export interface IConsentModuleDto {
    id: string;
    name: string;
    required: boolean;
    order: number;
    consentText?: InternationalizedDocument | undefined;
    consentStatement: InternationalizedDocument;
    policies: ConsentPolicyDto[];
    referencedAppPages: ConsentAppPageReferenceDto[];
}

export class ConsentPolicyDto implements IConsentPolicyDto {
    type!: ConsentPolicyType;
    definition?: CustomConsentPolicyDefinitionDto | undefined;

    constructor(data?: IConsentPolicyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.definition = _data["definition"] ? CustomConsentPolicyDefinitionDto.fromJS(_data["definition"]) : undefined as any;
        }
    }

    static fromJS(data: any): ConsentPolicyDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConsentPolicyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["definition"] = this.definition ? this.definition.toJSON() : undefined as any;
        return data;
    }

    clone(): ConsentPolicyDto {
        const json = this.toJSON();
        let result = new ConsentPolicyDto();
        result.init(json);
        return result;
    }
}

export interface IConsentPolicyDto {
    type: ConsentPolicyType;
    definition?: CustomConsentPolicyDefinitionDto | undefined;
}

export enum ConsentPolicyType {
    Custom = "custom",
    DataProcessing = "dataProcessing",
    ResearchUse = "researchUse",
    AppUsageAnalytics = "appUsageAnalytics",
}

export class CustomConsentPolicyDefinitionDto implements ICustomConsentPolicyDefinitionDto {
    code!: string;
    name!: string;
    description?: InternationalizedDocument | undefined;

    constructor(data?: ICustomConsentPolicyDefinitionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.name = _data["name"];
            this.description = _data["description"] ? InternationalizedDocument.fromJS(_data["description"]) : undefined as any;
        }
    }

    static fromJS(data: any): CustomConsentPolicyDefinitionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomConsentPolicyDefinitionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["description"] = this.description ? this.description.toJSON() : undefined as any;
        return data;
    }

    clone(): CustomConsentPolicyDefinitionDto {
        const json = this.toJSON();
        let result = new CustomConsentPolicyDefinitionDto();
        result.init(json);
        return result;
    }
}

export interface ICustomConsentPolicyDefinitionDto {
    code: string;
    name: string;
    description?: InternationalizedDocument | undefined;
}

export class ConsentAppPageReferenceDto implements IConsentAppPageReferenceDto {
    key!: string;
    name!: string;
    appPageId!: string;
    appPageVersion!: number;

    constructor(data?: IConsentAppPageReferenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.name = _data["name"];
            this.appPageId = _data["appPageId"];
            this.appPageVersion = _data["appPageVersion"];
        }
    }

    static fromJS(data: any): ConsentAppPageReferenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConsentAppPageReferenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["name"] = this.name;
        data["appPageId"] = this.appPageId;
        data["appPageVersion"] = this.appPageVersion;
        return data;
    }

    clone(): ConsentAppPageReferenceDto {
        const json = this.toJSON();
        let result = new ConsentAppPageReferenceDto();
        result.init(json);
        return result;
    }
}

export interface IConsentAppPageReferenceDto {
    key: string;
    name: string;
    appPageId: string;
    appPageVersion: number;
}

export class UpdateConsentTemplateVersionCommand implements IUpdateConsentTemplateVersionCommand {
    consentTemplateId!: string;
    version!: number;
    versionChangeSummary?: InternationalizedDocument | undefined;
    headerText?: InternationalizedDocument | undefined;
    footerText?: InternationalizedDocument | undefined;
    modules!: ConsentModuleDto[];

    constructor(data?: IUpdateConsentTemplateVersionCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.modules = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.consentTemplateId = _data["consentTemplateId"];
            this.version = _data["version"];
            this.versionChangeSummary = _data["versionChangeSummary"] ? InternationalizedDocument.fromJS(_data["versionChangeSummary"]) : undefined as any;
            this.headerText = _data["headerText"] ? InternationalizedDocument.fromJS(_data["headerText"]) : undefined as any;
            this.footerText = _data["footerText"] ? InternationalizedDocument.fromJS(_data["footerText"]) : undefined as any;
            if (Array.isArray(_data["modules"])) {
                this.modules = [] as any;
                for (let item of _data["modules"])
                    this.modules!.push(ConsentModuleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateConsentTemplateVersionCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateConsentTemplateVersionCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["consentTemplateId"] = this.consentTemplateId;
        data["version"] = this.version;
        data["versionChangeSummary"] = this.versionChangeSummary ? this.versionChangeSummary.toJSON() : undefined as any;
        data["headerText"] = this.headerText ? this.headerText.toJSON() : undefined as any;
        data["footerText"] = this.footerText ? this.footerText.toJSON() : undefined as any;
        if (Array.isArray(this.modules)) {
            data["modules"] = [];
            for (let item of this.modules)
                data["modules"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): UpdateConsentTemplateVersionCommand {
        const json = this.toJSON();
        let result = new UpdateConsentTemplateVersionCommand();
        result.init(json);
        return result;
    }
}

export interface IUpdateConsentTemplateVersionCommand {
    consentTemplateId: string;
    version: number;
    versionChangeSummary?: InternationalizedDocument | undefined;
    headerText?: InternationalizedDocument | undefined;
    footerText?: InternationalizedDocument | undefined;
    modules: ConsentModuleDto[];
}

export class PaginatedListOfConsentDto implements IPaginatedListOfConsentDto {
    items!: ConsentDto[];
    pageNumber!: number;
    pageSize!: number;
    totalCount!: number;
    totalPages!: number;
    hasPreviousPage!: boolean;
    hasNextPage!: boolean;

    constructor(data?: IPaginatedListOfConsentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ConsentDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            this.totalPages = _data["totalPages"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfConsentDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfConsentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["totalPages"] = this.totalPages;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }

    clone(): PaginatedListOfConsentDto {
        const json = this.toJSON();
        let result = new PaginatedListOfConsentDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedListOfConsentDto {
    items: ConsentDto[];
    pageNumber: number;
    pageSize: number;
    totalCount: number;
    totalPages: number;
    hasPreviousPage: boolean;
    hasNextPage: boolean;
}

export class ConsentDto implements IConsentDto {
    id!: string;
    consentTemplateVersionId!: string;
    consentTemplateVersion!: number;
    consentTemplateId!: string;
    consentTemplateName!: string;
    clientId?: string | undefined;
    clientName?: string | undefined;
    projectId?: string | undefined;
    projectName?: string | undefined;
    owner?: UserDto | undefined;
    created!: Date;
    lastModified!: Date;
    given!: Date;
    withdrawn?: Date | undefined;
    moduleDecisions!: ConsentModuleDecisionDto[];

    constructor(data?: IConsentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.moduleDecisions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.consentTemplateVersionId = _data["consentTemplateVersionId"];
            this.consentTemplateVersion = _data["consentTemplateVersion"];
            this.consentTemplateId = _data["consentTemplateId"];
            this.consentTemplateName = _data["consentTemplateName"];
            this.clientId = _data["clientId"];
            this.clientName = _data["clientName"];
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.owner = _data["owner"] ? UserDto.fromJS(_data["owner"]) : undefined as any;
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : undefined as any;
            this.given = _data["given"] ? new Date(_data["given"].toString()) : undefined as any;
            this.withdrawn = _data["withdrawn"] ? new Date(_data["withdrawn"].toString()) : undefined as any;
            if (Array.isArray(_data["moduleDecisions"])) {
                this.moduleDecisions = [] as any;
                for (let item of _data["moduleDecisions"])
                    this.moduleDecisions!.push(ConsentModuleDecisionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ConsentDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConsentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["consentTemplateVersionId"] = this.consentTemplateVersionId;
        data["consentTemplateVersion"] = this.consentTemplateVersion;
        data["consentTemplateId"] = this.consentTemplateId;
        data["consentTemplateName"] = this.consentTemplateName;
        data["clientId"] = this.clientId;
        data["clientName"] = this.clientName;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["owner"] = this.owner ? this.owner.toJSON() : undefined as any;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : undefined as any;
        data["given"] = this.given ? this.given.toISOString() : undefined as any;
        data["withdrawn"] = this.withdrawn ? this.withdrawn.toISOString() : undefined as any;
        if (Array.isArray(this.moduleDecisions)) {
            data["moduleDecisions"] = [];
            for (let item of this.moduleDecisions)
                data["moduleDecisions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): ConsentDto {
        const json = this.toJSON();
        let result = new ConsentDto();
        result.init(json);
        return result;
    }
}

export interface IConsentDto {
    id: string;
    consentTemplateVersionId: string;
    consentTemplateVersion: number;
    consentTemplateId: string;
    consentTemplateName: string;
    clientId?: string | undefined;
    clientName?: string | undefined;
    projectId?: string | undefined;
    projectName?: string | undefined;
    owner?: UserDto | undefined;
    created: Date;
    lastModified: Date;
    given: Date;
    withdrawn?: Date | undefined;
    moduleDecisions: ConsentModuleDecisionDto[];
}

export class ConsentModuleDecisionDto implements IConsentModuleDecisionDto {
    consentModuleId!: string;
    consentModuleName!: string;
    decision!: ConsentModuleDecisionType;
    withdrawn?: Date | undefined;

    constructor(data?: IConsentModuleDecisionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.consentModuleId = _data["consentModuleId"];
            this.consentModuleName = _data["consentModuleName"];
            this.decision = _data["decision"];
            this.withdrawn = _data["withdrawn"] ? new Date(_data["withdrawn"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ConsentModuleDecisionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConsentModuleDecisionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["consentModuleId"] = this.consentModuleId;
        data["consentModuleName"] = this.consentModuleName;
        data["decision"] = this.decision;
        data["withdrawn"] = this.withdrawn ? this.withdrawn.toISOString() : undefined as any;
        return data;
    }

    clone(): ConsentModuleDecisionDto {
        const json = this.toJSON();
        let result = new ConsentModuleDecisionDto();
        result.init(json);
        return result;
    }
}

export interface IConsentModuleDecisionDto {
    consentModuleId: string;
    consentModuleName: string;
    decision: ConsentModuleDecisionType;
    withdrawn?: Date | undefined;
}

export enum ConsentModuleDecisionType {
    None = "none",
    Declined = "declined",
    Accepted = "accepted",
}

export class PaginatedListOfContainerGroupDto implements IPaginatedListOfContainerGroupDto {
    items!: ContainerGroupDto[];
    pageNumber!: number;
    pageSize!: number;
    totalCount!: number;
    totalPages!: number;
    hasPreviousPage!: boolean;
    hasNextPage!: boolean;

    constructor(data?: IPaginatedListOfContainerGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ContainerGroupDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            this.totalPages = _data["totalPages"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfContainerGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfContainerGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["totalPages"] = this.totalPages;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }

    clone(): PaginatedListOfContainerGroupDto {
        const json = this.toJSON();
        let result = new PaginatedListOfContainerGroupDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedListOfContainerGroupDto {
    items: ContainerGroupDto[];
    pageNumber: number;
    pageSize: number;
    totalCount: number;
    totalPages: number;
    hasPreviousPage: boolean;
    hasNextPage: boolean;
}

export class ContainerGroupDto extends ContainerDto implements IContainerGroupDto {
    containerIds!: string[];
    containerGroupType!: ContainerGroupType;

    constructor(data?: IContainerGroupDto) {
        super(data);
        if (!data) {
            this.containerIds = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["containerIds"])) {
                this.containerIds = [] as any;
                for (let item of _data["containerIds"])
                    this.containerIds!.push(item);
            }
            this.containerGroupType = _data["containerGroupType"];
        }
    }

    static override fromJS(data: any): ContainerGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContainerGroupDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.containerIds)) {
            data["containerIds"] = [];
            for (let item of this.containerIds)
                data["containerIds"].push(item);
        }
        data["containerGroupType"] = this.containerGroupType;
        super.toJSON(data);
        return data;
    }

    clone(): ContainerGroupDto {
        const json = this.toJSON();
        let result = new ContainerGroupDto();
        result.init(json);
        return result;
    }
}

export interface IContainerGroupDto extends IContainerDto {
    containerIds: string[];
    containerGroupType: ContainerGroupType;
}

export enum ContainerGroupType {
    Generic = "generic",
    Intervention = "intervention",
    Chapter = "chapter",
}

export class ContainerGroupDetailsDto extends ContainerDetailsDto implements IContainerGroupDetailsDto {
    containers!: ContainerListItemDto[];
    containerGroupType!: ContainerGroupType;
    tags?: string[] | undefined;

    constructor(data?: IContainerGroupDetailsDto) {
        super(data);
        if (!data) {
            this.containers = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["containers"])) {
                this.containers = [] as any;
                for (let item of _data["containers"])
                    this.containers!.push(ContainerListItemDto.fromJS(item));
            }
            this.containerGroupType = _data["containerGroupType"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
        }
    }

    static override fromJS(data: any): ContainerGroupDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContainerGroupDetailsDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.containers)) {
            data["containers"] = [];
            for (let item of this.containers)
                data["containers"].push(item ? item.toJSON() : undefined as any);
        }
        data["containerGroupType"] = this.containerGroupType;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        super.toJSON(data);
        return data;
    }

    clone(): ContainerGroupDetailsDto {
        const json = this.toJSON();
        let result = new ContainerGroupDetailsDto();
        result.init(json);
        return result;
    }
}

export interface IContainerGroupDetailsDto extends IContainerDetailsDto {
    containers: ContainerListItemDto[];
    containerGroupType: ContainerGroupType;
    tags?: string[] | undefined;
}

export class ContainerListItemDto implements IContainerListItemDto {
    id!: string;
    projectId?: string | undefined;
    name!: string;
    uniqueLabel!: string;
    containerType!: ContainerType;
    version!: number;
    defaultLanguageId?: string | undefined;
    tags?: string[] | undefined;
    hidden?: Date | undefined;
    published?: Date | undefined;
    created!: Date;
    lastModified!: Date;

    constructor(data?: IContainerListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.projectId = _data["projectId"];
            this.name = _data["name"];
            this.uniqueLabel = _data["uniqueLabel"];
            this.containerType = _data["containerType"];
            this.version = _data["version"];
            this.defaultLanguageId = _data["defaultLanguageId"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            this.hidden = _data["hidden"] ? new Date(_data["hidden"].toString()) : undefined as any;
            this.published = _data["published"] ? new Date(_data["published"].toString()) : undefined as any;
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ContainerListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContainerListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectId"] = this.projectId;
        data["name"] = this.name;
        data["uniqueLabel"] = this.uniqueLabel;
        data["containerType"] = this.containerType;
        data["version"] = this.version;
        data["defaultLanguageId"] = this.defaultLanguageId;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["hidden"] = this.hidden ? this.hidden.toISOString() : undefined as any;
        data["published"] = this.published ? this.published.toISOString() : undefined as any;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : undefined as any;
        return data;
    }

    clone(): ContainerListItemDto {
        const json = this.toJSON();
        let result = new ContainerListItemDto();
        result.init(json);
        return result;
    }
}

export interface IContainerListItemDto {
    id: string;
    projectId?: string | undefined;
    name: string;
    uniqueLabel: string;
    containerType: ContainerType;
    version: number;
    defaultLanguageId?: string | undefined;
    tags?: string[] | undefined;
    hidden?: Date | undefined;
    published?: Date | undefined;
    created: Date;
    lastModified: Date;
}

export class CreateContainerGroupCommand implements ICreateContainerGroupCommand {
    name!: string;
    projectId!: string;

    constructor(data?: ICreateContainerGroupCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.projectId = _data["projectId"];
        }
    }

    static fromJS(data: any): CreateContainerGroupCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateContainerGroupCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["projectId"] = this.projectId;
        return data;
    }

    clone(): CreateContainerGroupCommand {
        const json = this.toJSON();
        let result = new CreateContainerGroupCommand();
        result.init(json);
        return result;
    }
}

export interface ICreateContainerGroupCommand {
    name: string;
    projectId: string;
}

export class CreateInterventionCommand implements ICreateInterventionCommand {
    name!: string;
    projectId!: string;

    constructor(data?: ICreateInterventionCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.projectId = _data["projectId"];
        }
    }

    static fromJS(data: any): CreateInterventionCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateInterventionCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["projectId"] = this.projectId;
        return data;
    }

    clone(): CreateInterventionCommand {
        const json = this.toJSON();
        let result = new CreateInterventionCommand();
        result.init(json);
        return result;
    }
}

export interface ICreateInterventionCommand {
    name: string;
    projectId: string;
}

export class CreateChapterCommand implements ICreateChapterCommand {
    name!: string;
    projectId!: string;

    constructor(data?: ICreateChapterCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.projectId = _data["projectId"];
        }
    }

    static fromJS(data: any): CreateChapterCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateChapterCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["projectId"] = this.projectId;
        return data;
    }

    clone(): CreateChapterCommand {
        const json = this.toJSON();
        let result = new CreateChapterCommand();
        result.init(json);
        return result;
    }
}

export interface ICreateChapterCommand {
    name: string;
    projectId: string;
}

export class UpdateContainerGroupCommand implements IUpdateContainerGroupCommand {
    containerGroupId!: string;
    name!: string;
    uniqueLabel!: string;
    title!: InternationalizedString;
    description!: InternationalizedDocument;
    containerIds!: string[];
    tags?: string[] | undefined;

    constructor(data?: IUpdateContainerGroupCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.title = new InternationalizedString();
            this.description = new InternationalizedDocument();
            this.containerIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.containerGroupId = _data["containerGroupId"];
            this.name = _data["name"];
            this.uniqueLabel = _data["uniqueLabel"];
            this.title = _data["title"] ? InternationalizedString.fromJS(_data["title"]) : new InternationalizedString();
            this.description = _data["description"] ? InternationalizedDocument.fromJS(_data["description"]) : new InternationalizedDocument();
            if (Array.isArray(_data["containerIds"])) {
                this.containerIds = [] as any;
                for (let item of _data["containerIds"])
                    this.containerIds!.push(item);
            }
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateContainerGroupCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateContainerGroupCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["containerGroupId"] = this.containerGroupId;
        data["name"] = this.name;
        data["uniqueLabel"] = this.uniqueLabel;
        data["title"] = this.title ? this.title.toJSON() : undefined as any;
        data["description"] = this.description ? this.description.toJSON() : undefined as any;
        if (Array.isArray(this.containerIds)) {
            data["containerIds"] = [];
            for (let item of this.containerIds)
                data["containerIds"].push(item);
        }
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        return data;
    }

    clone(): UpdateContainerGroupCommand {
        const json = this.toJSON();
        let result = new UpdateContainerGroupCommand();
        result.init(json);
        return result;
    }
}

export interface IUpdateContainerGroupCommand {
    containerGroupId: string;
    name: string;
    uniqueLabel: string;
    title: InternationalizedString;
    description: InternationalizedDocument;
    containerIds: string[];
    tags?: string[] | undefined;
}

export enum ContainerInstanceState {
    NotStarted = "notStarted",
    InProgress = "inProgress",
    Completed = "completed",
}

export enum ExportFileFormatParameter {
    Xlsx = "xlsx",
    Csv = "csv",
}

export class PaginatedListOfContainerListItemDto implements IPaginatedListOfContainerListItemDto {
    items!: ContainerListItemDto[];
    pageNumber!: number;
    pageSize!: number;
    totalCount!: number;
    totalPages!: number;
    hasPreviousPage!: boolean;
    hasNextPage!: boolean;

    constructor(data?: IPaginatedListOfContainerListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ContainerListItemDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            this.totalPages = _data["totalPages"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfContainerListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfContainerListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["totalPages"] = this.totalPages;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }

    clone(): PaginatedListOfContainerListItemDto {
        const json = this.toJSON();
        let result = new PaginatedListOfContainerListItemDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedListOfContainerListItemDto {
    items: ContainerListItemDto[];
    pageNumber: number;
    pageSize: number;
    totalCount: number;
    totalPages: number;
    hasPreviousPage: boolean;
    hasNextPage: boolean;
}

export class ContainerListItemDetailsDto implements IContainerListItemDetailsDto {
    id!: string;
    projectId?: string | undefined;
    name!: string;
    uniqueLabel!: string;
    containerType!: ContainerType;
    version!: number;
    defaultLanguageId?: string | undefined;
    languages!: TenantLanguageDto[];
    tags?: string[] | undefined;
    hidden?: Date | undefined;
    published?: Date | undefined;
    created!: Date;
    lastModified!: Date;

    constructor(data?: IContainerListItemDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.languages = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.projectId = _data["projectId"];
            this.name = _data["name"];
            this.uniqueLabel = _data["uniqueLabel"];
            this.containerType = _data["containerType"];
            this.version = _data["version"];
            this.defaultLanguageId = _data["defaultLanguageId"];
            if (Array.isArray(_data["languages"])) {
                this.languages = [] as any;
                for (let item of _data["languages"])
                    this.languages!.push(TenantLanguageDto.fromJS(item));
            }
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            this.hidden = _data["hidden"] ? new Date(_data["hidden"].toString()) : undefined as any;
            this.published = _data["published"] ? new Date(_data["published"].toString()) : undefined as any;
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ContainerListItemDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContainerListItemDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectId"] = this.projectId;
        data["name"] = this.name;
        data["uniqueLabel"] = this.uniqueLabel;
        data["containerType"] = this.containerType;
        data["version"] = this.version;
        data["defaultLanguageId"] = this.defaultLanguageId;
        if (Array.isArray(this.languages)) {
            data["languages"] = [];
            for (let item of this.languages)
                data["languages"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["hidden"] = this.hidden ? this.hidden.toISOString() : undefined as any;
        data["published"] = this.published ? this.published.toISOString() : undefined as any;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : undefined as any;
        return data;
    }

    clone(): ContainerListItemDetailsDto {
        const json = this.toJSON();
        let result = new ContainerListItemDetailsDto();
        result.init(json);
        return result;
    }
}

export interface IContainerListItemDetailsDto {
    id: string;
    projectId?: string | undefined;
    name: string;
    uniqueLabel: string;
    containerType: ContainerType;
    version: number;
    defaultLanguageId?: string | undefined;
    languages: TenantLanguageDto[];
    tags?: string[] | undefined;
    hidden?: Date | undefined;
    published?: Date | undefined;
    created: Date;
    lastModified: Date;
}

export class CopyContainerCommand implements ICopyContainerCommand {
    sourceId!: string;
    targetType?: ContainerType | undefined;
    name!: string;
    title?: InternationalizedString | undefined;
    description?: InternationalizedDocument | undefined;
    targetProjectId!: string;
    defaultLanguageId?: string | undefined;
    includeInstances!: boolean;
    targetProperties?: CopyTargetProperties | undefined;

    constructor(data?: ICopyContainerCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceId = _data["sourceId"];
            this.targetType = _data["targetType"];
            this.name = _data["name"];
            this.title = _data["title"] ? InternationalizedString.fromJS(_data["title"]) : undefined as any;
            this.description = _data["description"] ? InternationalizedDocument.fromJS(_data["description"]) : undefined as any;
            this.targetProjectId = _data["targetProjectId"];
            this.defaultLanguageId = _data["defaultLanguageId"];
            this.includeInstances = _data["includeInstances"];
            this.targetProperties = _data["targetProperties"] ? CopyTargetProperties.fromJS(_data["targetProperties"]) : undefined as any;
        }
    }

    static fromJS(data: any): CopyContainerCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CopyContainerCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceId"] = this.sourceId;
        data["targetType"] = this.targetType;
        data["name"] = this.name;
        data["title"] = this.title ? this.title.toJSON() : undefined as any;
        data["description"] = this.description ? this.description.toJSON() : undefined as any;
        data["targetProjectId"] = this.targetProjectId;
        data["defaultLanguageId"] = this.defaultLanguageId;
        data["includeInstances"] = this.includeInstances;
        data["targetProperties"] = this.targetProperties ? this.targetProperties.toJSON() : undefined as any;
        return data;
    }

    clone(): CopyContainerCommand {
        const json = this.toJSON();
        let result = new CopyContainerCommand();
        result.init(json);
        return result;
    }
}

export interface ICopyContainerCommand {
    sourceId: string;
    targetType?: ContainerType | undefined;
    name: string;
    title?: InternationalizedString | undefined;
    description?: InternationalizedDocument | undefined;
    targetProjectId: string;
    defaultLanguageId?: string | undefined;
    includeInstances: boolean;
    targetProperties?: CopyTargetProperties | undefined;
}

export abstract class CopyTargetProperties implements ICopyTargetProperties {

    protected _discriminator: string;

    constructor(data?: ICopyTargetProperties) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        this._discriminator = "CopyTargetProperties";
    }

    init(_data?: any) {
    }

    static fromJS(data: any): CopyTargetProperties {
        data = typeof data === 'object' ? data : {};
        if (data["$type"] === "QuestionnaireTargetProperties") {
            let result = new QuestionnaireTargetProperties();
            result.init(data);
            return result;
        }
        if (data["$type"] === "AppPageTargetProperties") {
            let result = new AppPageTargetProperties();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'CopyTargetProperties' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["$type"] = this._discriminator;
        return data;
    }

    clone(): CopyTargetProperties {
        throw new Error("The abstract class 'CopyTargetProperties' cannot be instantiated.");
    }
}

export interface ICopyTargetProperties {
}

export class QuestionnaireTargetProperties extends CopyTargetProperties implements IQuestionnaireTargetProperties {
    instantiationMode!: QuestionnaireInstantiationMode;
    editingMode!: QuestionnaireEditingMode;

    constructor(data?: IQuestionnaireTargetProperties) {
        super(data);
        this._discriminator = "QuestionnaireTargetProperties";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.instantiationMode = _data["instantiationMode"];
            this.editingMode = _data["editingMode"];
        }
    }

    static override fromJS(data: any): QuestionnaireTargetProperties {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionnaireTargetProperties();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["instantiationMode"] = this.instantiationMode;
        data["editingMode"] = this.editingMode;
        super.toJSON(data);
        return data;
    }

    clone(): QuestionnaireTargetProperties {
        const json = this.toJSON();
        let result = new QuestionnaireTargetProperties();
        result.init(json);
        return result;
    }
}

export interface IQuestionnaireTargetProperties extends ICopyTargetProperties {
    instantiationMode: QuestionnaireInstantiationMode;
    editingMode: QuestionnaireEditingMode;
}

export enum QuestionnaireInstantiationMode {
    None = "none",
    Manual = "manual",
    Auto = "auto",
    Both = "both",
}

export enum QuestionnaireEditingMode {
    Anytime = "anytime",
    UntilCompleted = "untilCompleted",
}

export class AppPageTargetProperties extends CopyTargetProperties implements IAppPageTargetProperties {
    visibility!: ContainerVisibility;
    parentPageId?: string | undefined;
    index!: number;

    constructor(data?: IAppPageTargetProperties) {
        super(data);
        this._discriminator = "AppPageTargetProperties";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.visibility = _data["visibility"];
            this.parentPageId = _data["parentPageId"];
            this.index = _data["index"];
        }
    }

    static override fromJS(data: any): AppPageTargetProperties {
        data = typeof data === 'object' ? data : {};
        let result = new AppPageTargetProperties();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["visibility"] = this.visibility;
        data["parentPageId"] = this.parentPageId;
        data["index"] = this.index;
        super.toJSON(data);
        return data;
    }

    clone(): AppPageTargetProperties {
        const json = this.toJSON();
        let result = new AppPageTargetProperties();
        result.init(json);
        return result;
    }
}

export interface IAppPageTargetProperties extends ICopyTargetProperties {
    visibility: ContainerVisibility;
    parentPageId?: string | undefined;
    index: number;
}

export class ContainerConversionPreviewDto implements IContainerConversionPreviewDto {
    sourceId!: string;
    sourceType!: ContainerType;
    targetType!: ContainerType;
    droppedQuestionCount!: number;
    droppedPropertyCount!: number;
    emptySectionCount!: number;
    willBeEmpty!: boolean;
    willHaveOnlyHeadings!: boolean;

    constructor(data?: IContainerConversionPreviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceId = _data["sourceId"];
            this.sourceType = _data["sourceType"];
            this.targetType = _data["targetType"];
            this.droppedQuestionCount = _data["droppedQuestionCount"];
            this.droppedPropertyCount = _data["droppedPropertyCount"];
            this.emptySectionCount = _data["emptySectionCount"];
            this.willBeEmpty = _data["willBeEmpty"];
            this.willHaveOnlyHeadings = _data["willHaveOnlyHeadings"];
        }
    }

    static fromJS(data: any): ContainerConversionPreviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContainerConversionPreviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceId"] = this.sourceId;
        data["sourceType"] = this.sourceType;
        data["targetType"] = this.targetType;
        data["droppedQuestionCount"] = this.droppedQuestionCount;
        data["droppedPropertyCount"] = this.droppedPropertyCount;
        data["emptySectionCount"] = this.emptySectionCount;
        data["willBeEmpty"] = this.willBeEmpty;
        data["willHaveOnlyHeadings"] = this.willHaveOnlyHeadings;
        return data;
    }

    clone(): ContainerConversionPreviewDto {
        const json = this.toJSON();
        let result = new ContainerConversionPreviewDto();
        result.init(json);
        return result;
    }
}

export interface IContainerConversionPreviewDto {
    sourceId: string;
    sourceType: ContainerType;
    targetType: ContainerType;
    droppedQuestionCount: number;
    droppedPropertyCount: number;
    emptySectionCount: number;
    willBeEmpty: boolean;
    willHaveOnlyHeadings: boolean;
}

export class PaginatedListOfContextObjectDto implements IPaginatedListOfContextObjectDto {
    items!: ContextObjectDto[];
    pageNumber!: number;
    pageSize!: number;
    totalCount!: number;
    totalPages!: number;
    hasPreviousPage!: boolean;
    hasNextPage!: boolean;

    constructor(data?: IPaginatedListOfContextObjectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ContextObjectDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            this.totalPages = _data["totalPages"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfContextObjectDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfContextObjectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["totalPages"] = this.totalPages;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }

    clone(): PaginatedListOfContextObjectDto {
        const json = this.toJSON();
        let result = new PaginatedListOfContextObjectDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedListOfContextObjectDto {
    items: ContextObjectDto[];
    pageNumber: number;
    pageSize: number;
    totalCount: number;
    totalPages: number;
    hasPreviousPage: boolean;
    hasNextPage: boolean;
}

export class ContextObjectDto extends ContainerDto implements IContextObjectDto {

    constructor(data?: IContextObjectDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ContextObjectDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContextObjectDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): ContextObjectDto {
        const json = this.toJSON();
        let result = new ContextObjectDto();
        result.init(json);
        return result;
    }
}

export interface IContextObjectDto extends IContainerDto {
}

export class ContextObjectDetailsDto extends ContainerDetailsDto implements IContextObjectDetailsDto {
    contents!: ContentDto[];

    constructor(data?: IContextObjectDetailsDto) {
        super(data);
        if (!data) {
            this.contents = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["contents"])) {
                this.contents = [] as any;
                for (let item of _data["contents"])
                    this.contents!.push(ContentDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ContextObjectDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContextObjectDetailsDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.contents)) {
            data["contents"] = [];
            for (let item of this.contents)
                data["contents"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): ContextObjectDetailsDto {
        const json = this.toJSON();
        let result = new ContextObjectDetailsDto();
        result.init(json);
        return result;
    }
}

export interface IContextObjectDetailsDto extends IContainerDetailsDto {
    contents: ContentDto[];
}

export class CreateContextObjectCommand implements ICreateContextObjectCommand {
    name!: string;
    projectId!: string;

    constructor(data?: ICreateContextObjectCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.projectId = _data["projectId"];
        }
    }

    static fromJS(data: any): CreateContextObjectCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateContextObjectCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["projectId"] = this.projectId;
        return data;
    }

    clone(): CreateContextObjectCommand {
        const json = this.toJSON();
        let result = new CreateContextObjectCommand();
        result.init(json);
        return result;
    }
}

export interface ICreateContextObjectCommand {
    name: string;
    projectId: string;
}

export class UpdateContextObjectCommand implements IUpdateContextObjectCommand {
    contextObjectId!: string;
    name!: string;
    uniqueLabel!: string;
    title!: InternationalizedString;
    description!: InternationalizedDocument;
    defaultLanguageId!: string;
    languageIds!: string[];
    contents!: ContentDto[];
    condition?: ContainerCondition | undefined;
    sharingOptions!: ContainerSharingOptionDto[];

    constructor(data?: IUpdateContextObjectCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.title = new InternationalizedString();
            this.description = new InternationalizedDocument();
            this.languageIds = [];
            this.contents = [];
            this.sharingOptions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contextObjectId = _data["contextObjectId"];
            this.name = _data["name"];
            this.uniqueLabel = _data["uniqueLabel"];
            this.title = _data["title"] ? InternationalizedString.fromJS(_data["title"]) : new InternationalizedString();
            this.description = _data["description"] ? InternationalizedDocument.fromJS(_data["description"]) : new InternationalizedDocument();
            this.defaultLanguageId = _data["defaultLanguageId"];
            if (Array.isArray(_data["languageIds"])) {
                this.languageIds = [] as any;
                for (let item of _data["languageIds"])
                    this.languageIds!.push(item);
            }
            if (Array.isArray(_data["contents"])) {
                this.contents = [] as any;
                for (let item of _data["contents"])
                    this.contents!.push(ContentDto.fromJS(item));
            }
            this.condition = _data["condition"] ? ContainerCondition.fromJS(_data["condition"]) : undefined as any;
            if (Array.isArray(_data["sharingOptions"])) {
                this.sharingOptions = [] as any;
                for (let item of _data["sharingOptions"])
                    this.sharingOptions!.push(ContainerSharingOptionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateContextObjectCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateContextObjectCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contextObjectId"] = this.contextObjectId;
        data["name"] = this.name;
        data["uniqueLabel"] = this.uniqueLabel;
        data["title"] = this.title ? this.title.toJSON() : undefined as any;
        data["description"] = this.description ? this.description.toJSON() : undefined as any;
        data["defaultLanguageId"] = this.defaultLanguageId;
        if (Array.isArray(this.languageIds)) {
            data["languageIds"] = [];
            for (let item of this.languageIds)
                data["languageIds"].push(item);
        }
        if (Array.isArray(this.contents)) {
            data["contents"] = [];
            for (let item of this.contents)
                data["contents"].push(item ? item.toJSON() : undefined as any);
        }
        data["condition"] = this.condition ? this.condition.toJSON() : undefined as any;
        if (Array.isArray(this.sharingOptions)) {
            data["sharingOptions"] = [];
            for (let item of this.sharingOptions)
                data["sharingOptions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): UpdateContextObjectCommand {
        const json = this.toJSON();
        let result = new UpdateContextObjectCommand();
        result.init(json);
        return result;
    }
}

export interface IUpdateContextObjectCommand {
    contextObjectId: string;
    name: string;
    uniqueLabel: string;
    title: InternationalizedString;
    description: InternationalizedDocument;
    defaultLanguageId: string;
    languageIds: string[];
    contents: ContentDto[];
    condition?: ContainerCondition | undefined;
    sharingOptions: ContainerSharingOptionDto[];
}

export class PaginatedListOfContextObjectInstanceDto implements IPaginatedListOfContextObjectInstanceDto {
    items!: ContextObjectInstanceDto[];
    pageNumber!: number;
    pageSize!: number;
    totalCount!: number;
    totalPages!: number;
    hasPreviousPage!: boolean;
    hasNextPage!: boolean;

    constructor(data?: IPaginatedListOfContextObjectInstanceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ContextObjectInstanceDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            this.totalPages = _data["totalPages"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfContextObjectInstanceDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfContextObjectInstanceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["totalPages"] = this.totalPages;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }

    clone(): PaginatedListOfContextObjectInstanceDto {
        const json = this.toJSON();
        let result = new PaginatedListOfContextObjectInstanceDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedListOfContextObjectInstanceDto {
    items: ContextObjectInstanceDto[];
    pageNumber: number;
    pageSize: number;
    totalCount: number;
    totalPages: number;
    hasPreviousPage: boolean;
    hasNextPage: boolean;
}

export class ContextObjectInstanceDto extends TenantEntityDto implements IContextObjectInstanceDto {
    name!: string;
    contextObjectId!: string;
    contextObjectName!: string;
    created!: Date;
    lastModified!: Date;
    hidden?: Date | undefined;
    owner?: ProjectParticipantDto | undefined;
    sharingState!: SharingState;
    shared!: boolean;

    constructor(data?: IContextObjectInstanceDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.contextObjectId = _data["contextObjectId"];
            this.contextObjectName = _data["contextObjectName"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : undefined as any;
            this.hidden = _data["hidden"] ? new Date(_data["hidden"].toString()) : undefined as any;
            this.owner = _data["owner"] ? ProjectParticipantDto.fromJS(_data["owner"]) : undefined as any;
            this.sharingState = _data["sharingState"];
            this.shared = _data["shared"];
        }
    }

    static override fromJS(data: any): ContextObjectInstanceDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContextObjectInstanceDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["contextObjectId"] = this.contextObjectId;
        data["contextObjectName"] = this.contextObjectName;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : undefined as any;
        data["hidden"] = this.hidden ? this.hidden.toISOString() : undefined as any;
        data["owner"] = this.owner ? this.owner.toJSON() : undefined as any;
        data["sharingState"] = this.sharingState;
        data["shared"] = this.shared;
        super.toJSON(data);
        return data;
    }

    clone(): ContextObjectInstanceDto {
        const json = this.toJSON();
        let result = new ContextObjectInstanceDto();
        result.init(json);
        return result;
    }
}

export interface IContextObjectInstanceDto extends ITenantEntityDto {
    name: string;
    contextObjectId: string;
    contextObjectName: string;
    created: Date;
    lastModified: Date;
    hidden?: Date | undefined;
    owner?: ProjectParticipantDto | undefined;
    sharingState: SharingState;
    shared: boolean;
}

export class ProjectParticipantDto implements IProjectParticipantDto {
    user!: UserDto;
    chiffre!: string;
    created?: Date | undefined;
    invited?: Date | undefined;
    enrolled?: Date | undefined;
    withdrawn?: Date | undefined;
    status!: ProjectParticipantStatus;

    constructor(data?: IProjectParticipantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.user = new UserDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? UserDto.fromJS(_data["user"]) : new UserDto();
            this.chiffre = _data["chiffre"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.invited = _data["invited"] ? new Date(_data["invited"].toString()) : undefined as any;
            this.enrolled = _data["enrolled"] ? new Date(_data["enrolled"].toString()) : undefined as any;
            this.withdrawn = _data["withdrawn"] ? new Date(_data["withdrawn"].toString()) : undefined as any;
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ProjectParticipantDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectParticipantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        data["chiffre"] = this.chiffre;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["invited"] = this.invited ? this.invited.toISOString() : undefined as any;
        data["enrolled"] = this.enrolled ? this.enrolled.toISOString() : undefined as any;
        data["withdrawn"] = this.withdrawn ? this.withdrawn.toISOString() : undefined as any;
        data["status"] = this.status;
        return data;
    }

    clone(): ProjectParticipantDto {
        const json = this.toJSON();
        let result = new ProjectParticipantDto();
        result.init(json);
        return result;
    }
}

export interface IProjectParticipantDto {
    user: UserDto;
    chiffre: string;
    created?: Date | undefined;
    invited?: Date | undefined;
    enrolled?: Date | undefined;
    withdrawn?: Date | undefined;
    status: ProjectParticipantStatus;
}

export enum ProjectParticipantStatus {
    Created = "created",
    Invited = "invited",
    Enrolled = "enrolled",
    Withdrawn = "withdrawn",
}

/** Represents the sharing state of a container instance relative to the current user. */
export enum SharingState {
    NotShared = "notShared",
    SharedByMe = "sharedByMe",
    SharedWithMe = "sharedWithMe",
}

export class ContextObjectInstanceDetailsDto extends TenantEntityDto implements IContextObjectInstanceDetailsDto {
    name!: string;
    contextObjectId!: string;
    contextObjectName!: string;
    created!: Date;
    lastModified!: Date;
    hidden?: Date | undefined;
    sharingOptions!: ContainerSharingOptionDto[];
    contents!: ContentDto[];
    owner?: ProjectParticipantDto | undefined;
    sharingState!: SharingState;
    sharingPartners!: SharingPartnerDto[];

    constructor(data?: IContextObjectInstanceDetailsDto) {
        super(data);
        if (!data) {
            this.sharingOptions = [];
            this.contents = [];
            this.sharingPartners = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.contextObjectId = _data["contextObjectId"];
            this.contextObjectName = _data["contextObjectName"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : undefined as any;
            this.hidden = _data["hidden"] ? new Date(_data["hidden"].toString()) : undefined as any;
            if (Array.isArray(_data["sharingOptions"])) {
                this.sharingOptions = [] as any;
                for (let item of _data["sharingOptions"])
                    this.sharingOptions!.push(ContainerSharingOptionDto.fromJS(item));
            }
            if (Array.isArray(_data["contents"])) {
                this.contents = [] as any;
                for (let item of _data["contents"])
                    this.contents!.push(ContentDto.fromJS(item));
            }
            this.owner = _data["owner"] ? ProjectParticipantDto.fromJS(_data["owner"]) : undefined as any;
            this.sharingState = _data["sharingState"];
            if (Array.isArray(_data["sharingPartners"])) {
                this.sharingPartners = [] as any;
                for (let item of _data["sharingPartners"])
                    this.sharingPartners!.push(SharingPartnerDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ContextObjectInstanceDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContextObjectInstanceDetailsDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["contextObjectId"] = this.contextObjectId;
        data["contextObjectName"] = this.contextObjectName;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : undefined as any;
        data["hidden"] = this.hidden ? this.hidden.toISOString() : undefined as any;
        if (Array.isArray(this.sharingOptions)) {
            data["sharingOptions"] = [];
            for (let item of this.sharingOptions)
                data["sharingOptions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.contents)) {
            data["contents"] = [];
            for (let item of this.contents)
                data["contents"].push(item ? item.toJSON() : undefined as any);
        }
        data["owner"] = this.owner ? this.owner.toJSON() : undefined as any;
        data["sharingState"] = this.sharingState;
        if (Array.isArray(this.sharingPartners)) {
            data["sharingPartners"] = [];
            for (let item of this.sharingPartners)
                data["sharingPartners"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): ContextObjectInstanceDetailsDto {
        const json = this.toJSON();
        let result = new ContextObjectInstanceDetailsDto();
        result.init(json);
        return result;
    }
}

export interface IContextObjectInstanceDetailsDto extends ITenantEntityDto {
    name: string;
    contextObjectId: string;
    contextObjectName: string;
    created: Date;
    lastModified: Date;
    hidden?: Date | undefined;
    sharingOptions: ContainerSharingOptionDto[];
    contents: ContentDto[];
    owner?: ProjectParticipantDto | undefined;
    sharingState: SharingState;
    sharingPartners: SharingPartnerDto[];
}

export class SharingPartnerDto implements ISharingPartnerDto {
    userId!: string;
    userGivenName?: string | undefined;
    userFamilyName?: string | undefined;
    userEmail?: string | undefined;

    constructor(data?: ISharingPartnerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.userGivenName = _data["userGivenName"];
            this.userFamilyName = _data["userFamilyName"];
            this.userEmail = _data["userEmail"];
        }
    }

    static fromJS(data: any): SharingPartnerDto {
        data = typeof data === 'object' ? data : {};
        let result = new SharingPartnerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userGivenName"] = this.userGivenName;
        data["userFamilyName"] = this.userFamilyName;
        data["userEmail"] = this.userEmail;
        return data;
    }

    clone(): SharingPartnerDto {
        const json = this.toJSON();
        let result = new SharingPartnerDto();
        result.init(json);
        return result;
    }
}

export interface ISharingPartnerDto {
    userId: string;
    userGivenName?: string | undefined;
    userFamilyName?: string | undefined;
    userEmail?: string | undefined;
}

export class PaginatedListOfDeviceDto implements IPaginatedListOfDeviceDto {
    items!: DeviceDto[];
    pageNumber!: number;
    pageSize!: number;
    totalCount!: number;
    totalPages!: number;
    hasPreviousPage!: boolean;
    hasNextPage!: boolean;

    constructor(data?: IPaginatedListOfDeviceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(DeviceDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            this.totalPages = _data["totalPages"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfDeviceDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfDeviceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["totalPages"] = this.totalPages;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }

    clone(): PaginatedListOfDeviceDto {
        const json = this.toJSON();
        let result = new PaginatedListOfDeviceDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedListOfDeviceDto {
    items: DeviceDto[];
    pageNumber: number;
    pageSize: number;
    totalCount: number;
    totalPages: number;
    hasPreviousPage: boolean;
    hasNextPage: boolean;
}

export abstract class DeviceDto extends TenantEntityDto implements IDeviceDto {
    name!: string;
    identifier!: string;
    owner!: UserDto;

    protected _discriminator: string;

    constructor(data?: IDeviceDto) {
        super(data);
        if (!data) {
            this.owner = new UserDto();
        }
        this._discriminator = "DeviceDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.identifier = _data["identifier"];
            this.owner = _data["owner"] ? UserDto.fromJS(_data["owner"]) : new UserDto();
        }
    }

    static override fromJS(data: any): DeviceDto {
        data = typeof data === 'object' ? data : {};
        if (data["$type"] === "MobilePhoneDto") {
            let result = new MobilePhoneDto();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'DeviceDto' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["$type"] = this._discriminator;
        data["name"] = this.name;
        data["identifier"] = this.identifier;
        data["owner"] = this.owner ? this.owner.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): DeviceDto {
        throw new Error("The abstract class 'DeviceDto' cannot be instantiated.");
    }
}

export interface IDeviceDto extends ITenantEntityDto {
    name: string;
    identifier: string;
    owner: UserDto;
}

export class MobilePhoneDto extends DeviceDto implements IMobilePhoneDto {
    model!: string;

    constructor(data?: IMobilePhoneDto) {
        super(data);
        this._discriminator = "MobilePhoneDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.model = _data["model"];
        }
    }

    static override fromJS(data: any): MobilePhoneDto {
        data = typeof data === 'object' ? data : {};
        let result = new MobilePhoneDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["model"] = this.model;
        super.toJSON(data);
        return data;
    }

    clone(): MobilePhoneDto {
        const json = this.toJSON();
        let result = new MobilePhoneDto();
        result.init(json);
        return result;
    }
}

export interface IMobilePhoneDto extends IDeviceDto {
    model: string;
}

export abstract class DeviceDetailsDto extends TenantEntityDto implements IDeviceDetailsDto {
    name!: string;
    identifier!: string;
    owner!: UserDto;

    protected _discriminator: string;

    constructor(data?: IDeviceDetailsDto) {
        super(data);
        if (!data) {
            this.owner = new UserDto();
        }
        this._discriminator = "DeviceDetailsDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.identifier = _data["identifier"];
            this.owner = _data["owner"] ? UserDto.fromJS(_data["owner"]) : new UserDto();
        }
    }

    static override fromJS(data: any): DeviceDetailsDto {
        data = typeof data === 'object' ? data : {};
        if (data["$type"] === "MobilePhoneDetailsDto") {
            let result = new MobilePhoneDetailsDto();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'DeviceDetailsDto' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["$type"] = this._discriminator;
        data["name"] = this.name;
        data["identifier"] = this.identifier;
        data["owner"] = this.owner ? this.owner.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): DeviceDetailsDto {
        throw new Error("The abstract class 'DeviceDetailsDto' cannot be instantiated.");
    }
}

export interface IDeviceDetailsDto extends ITenantEntityDto {
    name: string;
    identifier: string;
    owner: UserDto;
}

export class MobilePhoneDetailsDto extends DeviceDetailsDto implements IMobilePhoneDetailsDto {
    manufacturer!: string;
    model!: string;
    osVersion!: string;
    language!: string;
    timezone!: string;

    constructor(data?: IMobilePhoneDetailsDto) {
        super(data);
        this._discriminator = "MobilePhoneDetailsDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.manufacturer = _data["manufacturer"];
            this.model = _data["model"];
            this.osVersion = _data["osVersion"];
            this.language = _data["language"];
            this.timezone = _data["timezone"];
        }
    }

    static override fromJS(data: any): MobilePhoneDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new MobilePhoneDetailsDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["manufacturer"] = this.manufacturer;
        data["model"] = this.model;
        data["osVersion"] = this.osVersion;
        data["language"] = this.language;
        data["timezone"] = this.timezone;
        super.toJSON(data);
        return data;
    }

    clone(): MobilePhoneDetailsDto {
        const json = this.toJSON();
        let result = new MobilePhoneDetailsDto();
        result.init(json);
        return result;
    }
}

export interface IMobilePhoneDetailsDto extends IDeviceDetailsDto {
    manufacturer: string;
    model: string;
    osVersion: string;
    language: string;
    timezone: string;
}

export class CreateFileFromBase64Command implements ICreateFileFromBase64Command {
    base64String!: string;

    constructor(data?: ICreateFileFromBase64Command) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.base64String = _data["base64String"];
        }
    }

    static fromJS(data: any): CreateFileFromBase64Command {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFileFromBase64Command();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["base64String"] = this.base64String;
        return data;
    }

    clone(): CreateFileFromBase64Command {
        const json = this.toJSON();
        let result = new CreateFileFromBase64Command();
        result.init(json);
        return result;
    }
}

export interface ICreateFileFromBase64Command {
    base64String: string;
}

export class CreateFileFromUrlCommand implements ICreateFileFromUrlCommand {
    url!: string;

    constructor(data?: ICreateFileFromUrlCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): CreateFileFromUrlCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFileFromUrlCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        return data;
    }

    clone(): CreateFileFromUrlCommand {
        const json = this.toJSON();
        let result = new CreateFileFromUrlCommand();
        result.init(json);
        return result;
    }
}

export interface ICreateFileFromUrlCommand {
    url: string;
}

export class PaginatedListOfInterventionModuleDto implements IPaginatedListOfInterventionModuleDto {
    items!: InterventionModuleDto[];
    pageNumber!: number;
    pageSize!: number;
    totalCount!: number;
    totalPages!: number;
    hasPreviousPage!: boolean;
    hasNextPage!: boolean;

    constructor(data?: IPaginatedListOfInterventionModuleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(InterventionModuleDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            this.totalPages = _data["totalPages"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfInterventionModuleDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfInterventionModuleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["totalPages"] = this.totalPages;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }

    clone(): PaginatedListOfInterventionModuleDto {
        const json = this.toJSON();
        let result = new PaginatedListOfInterventionModuleDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedListOfInterventionModuleDto {
    items: InterventionModuleDto[];
    pageNumber: number;
    pageSize: number;
    totalCount: number;
    totalPages: number;
    hasPreviousPage: boolean;
    hasNextPage: boolean;
}

export class InterventionModuleDto extends ContainerDto implements IInterventionModuleDto {

    constructor(data?: IInterventionModuleDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): InterventionModuleDto {
        data = typeof data === 'object' ? data : {};
        let result = new InterventionModuleDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): InterventionModuleDto {
        const json = this.toJSON();
        let result = new InterventionModuleDto();
        result.init(json);
        return result;
    }
}

export interface IInterventionModuleDto extends IContainerDto {
}

export class InterventionModuleDetailsDto extends ContainerDetailsDto implements IInterventionModuleDetailsDto {
    pages!: ContentPageDto[];

    constructor(data?: IInterventionModuleDetailsDto) {
        super(data);
        if (!data) {
            this.pages = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["pages"])) {
                this.pages = [] as any;
                for (let item of _data["pages"])
                    this.pages!.push(ContentPageDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): InterventionModuleDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new InterventionModuleDetailsDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.pages)) {
            data["pages"] = [];
            for (let item of this.pages)
                data["pages"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): InterventionModuleDetailsDto {
        const json = this.toJSON();
        let result = new InterventionModuleDetailsDto();
        result.init(json);
        return result;
    }
}

export interface IInterventionModuleDetailsDto extends IContainerDetailsDto {
    pages: ContentPageDto[];
}

export class CreateInterventionModuleCommand implements ICreateInterventionModuleCommand {
    name!: string;
    projectId!: string;

    constructor(data?: ICreateInterventionModuleCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.projectId = _data["projectId"];
        }
    }

    static fromJS(data: any): CreateInterventionModuleCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateInterventionModuleCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["projectId"] = this.projectId;
        return data;
    }

    clone(): CreateInterventionModuleCommand {
        const json = this.toJSON();
        let result = new CreateInterventionModuleCommand();
        result.init(json);
        return result;
    }
}

export interface ICreateInterventionModuleCommand {
    name: string;
    projectId: string;
}

export class UpdateInterventionModuleCommand implements IUpdateInterventionModuleCommand {
    interventionModuleId!: string;
    name!: string;
    uniqueLabel!: string;
    title!: InternationalizedString;
    description!: InternationalizedDocument;
    defaultLanguageId!: string;
    languageIds!: string[];
    pages!: ContentPageDto[];
    condition?: ContainerCondition | undefined;
    sharingOptions!: ContainerSharingOptionDto[];

    constructor(data?: IUpdateInterventionModuleCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.title = new InternationalizedString();
            this.description = new InternationalizedDocument();
            this.languageIds = [];
            this.pages = [];
            this.sharingOptions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.interventionModuleId = _data["interventionModuleId"];
            this.name = _data["name"];
            this.uniqueLabel = _data["uniqueLabel"];
            this.title = _data["title"] ? InternationalizedString.fromJS(_data["title"]) : new InternationalizedString();
            this.description = _data["description"] ? InternationalizedDocument.fromJS(_data["description"]) : new InternationalizedDocument();
            this.defaultLanguageId = _data["defaultLanguageId"];
            if (Array.isArray(_data["languageIds"])) {
                this.languageIds = [] as any;
                for (let item of _data["languageIds"])
                    this.languageIds!.push(item);
            }
            if (Array.isArray(_data["pages"])) {
                this.pages = [] as any;
                for (let item of _data["pages"])
                    this.pages!.push(ContentPageDto.fromJS(item));
            }
            this.condition = _data["condition"] ? ContainerCondition.fromJS(_data["condition"]) : undefined as any;
            if (Array.isArray(_data["sharingOptions"])) {
                this.sharingOptions = [] as any;
                for (let item of _data["sharingOptions"])
                    this.sharingOptions!.push(ContainerSharingOptionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateInterventionModuleCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateInterventionModuleCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["interventionModuleId"] = this.interventionModuleId;
        data["name"] = this.name;
        data["uniqueLabel"] = this.uniqueLabel;
        data["title"] = this.title ? this.title.toJSON() : undefined as any;
        data["description"] = this.description ? this.description.toJSON() : undefined as any;
        data["defaultLanguageId"] = this.defaultLanguageId;
        if (Array.isArray(this.languageIds)) {
            data["languageIds"] = [];
            for (let item of this.languageIds)
                data["languageIds"].push(item);
        }
        if (Array.isArray(this.pages)) {
            data["pages"] = [];
            for (let item of this.pages)
                data["pages"].push(item ? item.toJSON() : undefined as any);
        }
        data["condition"] = this.condition ? this.condition.toJSON() : undefined as any;
        if (Array.isArray(this.sharingOptions)) {
            data["sharingOptions"] = [];
            for (let item of this.sharingOptions)
                data["sharingOptions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): UpdateInterventionModuleCommand {
        const json = this.toJSON();
        let result = new UpdateInterventionModuleCommand();
        result.init(json);
        return result;
    }
}

export interface IUpdateInterventionModuleCommand {
    interventionModuleId: string;
    name: string;
    uniqueLabel: string;
    title: InternationalizedString;
    description: InternationalizedDocument;
    defaultLanguageId: string;
    languageIds: string[];
    pages: ContentPageDto[];
    condition?: ContainerCondition | undefined;
    sharingOptions: ContainerSharingOptionDto[];
}

export class PaginatedListOfInterventionModuleInstanceDto implements IPaginatedListOfInterventionModuleInstanceDto {
    items!: InterventionModuleInstanceDto[];
    pageNumber!: number;
    pageSize!: number;
    totalCount!: number;
    totalPages!: number;
    hasPreviousPage!: boolean;
    hasNextPage!: boolean;

    constructor(data?: IPaginatedListOfInterventionModuleInstanceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(InterventionModuleInstanceDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            this.totalPages = _data["totalPages"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfInterventionModuleInstanceDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfInterventionModuleInstanceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["totalPages"] = this.totalPages;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }

    clone(): PaginatedListOfInterventionModuleInstanceDto {
        const json = this.toJSON();
        let result = new PaginatedListOfInterventionModuleInstanceDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedListOfInterventionModuleInstanceDto {
    items: InterventionModuleInstanceDto[];
    pageNumber: number;
    pageSize: number;
    totalCount: number;
    totalPages: number;
    hasPreviousPage: boolean;
    hasNextPage: boolean;
}

export class InterventionModuleInstanceDto extends TenantEntityDto implements IInterventionModuleInstanceDto {
    name!: string;
    interventionModuleId!: string;
    interventionModuleName!: string;
    interventionModuleVersion!: number;
    created!: Date;
    lastModified!: Date;
    started?: Date | undefined;
    completed?: Date | undefined;
    hidden?: Date | undefined;
    state!: ContainerInstanceState;
    owner?: ProjectParticipantDto | undefined;
    amountQuestions!: number;
    amountAnswers!: number;
    executionLanguage?: TenantLanguageDto | undefined;

    constructor(data?: IInterventionModuleInstanceDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.interventionModuleId = _data["interventionModuleId"];
            this.interventionModuleName = _data["interventionModuleName"];
            this.interventionModuleVersion = _data["interventionModuleVersion"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : undefined as any;
            this.started = _data["started"] ? new Date(_data["started"].toString()) : undefined as any;
            this.completed = _data["completed"] ? new Date(_data["completed"].toString()) : undefined as any;
            this.hidden = _data["hidden"] ? new Date(_data["hidden"].toString()) : undefined as any;
            this.state = _data["state"];
            this.owner = _data["owner"] ? ProjectParticipantDto.fromJS(_data["owner"]) : undefined as any;
            this.amountQuestions = _data["amountQuestions"];
            this.amountAnswers = _data["amountAnswers"];
            this.executionLanguage = _data["executionLanguage"] ? TenantLanguageDto.fromJS(_data["executionLanguage"]) : undefined as any;
        }
    }

    static override fromJS(data: any): InterventionModuleInstanceDto {
        data = typeof data === 'object' ? data : {};
        let result = new InterventionModuleInstanceDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["interventionModuleId"] = this.interventionModuleId;
        data["interventionModuleName"] = this.interventionModuleName;
        data["interventionModuleVersion"] = this.interventionModuleVersion;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : undefined as any;
        data["started"] = this.started ? this.started.toISOString() : undefined as any;
        data["completed"] = this.completed ? this.completed.toISOString() : undefined as any;
        data["hidden"] = this.hidden ? this.hidden.toISOString() : undefined as any;
        data["state"] = this.state;
        data["owner"] = this.owner ? this.owner.toJSON() : undefined as any;
        data["amountQuestions"] = this.amountQuestions;
        data["amountAnswers"] = this.amountAnswers;
        data["executionLanguage"] = this.executionLanguage ? this.executionLanguage.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): InterventionModuleInstanceDto {
        const json = this.toJSON();
        let result = new InterventionModuleInstanceDto();
        result.init(json);
        return result;
    }
}

export interface IInterventionModuleInstanceDto extends ITenantEntityDto {
    name: string;
    interventionModuleId: string;
    interventionModuleName: string;
    interventionModuleVersion: number;
    created: Date;
    lastModified: Date;
    started?: Date | undefined;
    completed?: Date | undefined;
    hidden?: Date | undefined;
    state: ContainerInstanceState;
    owner?: ProjectParticipantDto | undefined;
    amountQuestions: number;
    amountAnswers: number;
    executionLanguage?: TenantLanguageDto | undefined;
}

export class InterventionModuleInstanceDetailsDto extends TenantEntityDto implements IInterventionModuleInstanceDetailsDto {
    name!: string;
    interventionModuleId!: string;
    interventionModuleName!: string;
    interventionModuleVersion!: number;
    projectId!: string;
    projectName!: string;
    created!: Date;
    lastModified!: Date;
    started?: Date | undefined;
    completed?: Date | undefined;
    hidden?: Date | undefined;
    state!: ContainerInstanceState;
    pages!: ContentPageDto[];
    languages!: TenantLanguageDto[];
    defaultLanguage!: TenantLanguageDto;
    executionLanguage?: TenantLanguageDto | undefined;
    executionInfo?: ContainerInstanceExecutionInfoDto | undefined;
    owner?: ProjectParticipantDto | undefined;
    amountQuestions!: number;
    amountAnswers!: number;

    constructor(data?: IInterventionModuleInstanceDetailsDto) {
        super(data);
        if (!data) {
            this.pages = [];
            this.languages = [];
            this.defaultLanguage = new TenantLanguageDto();
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.interventionModuleId = _data["interventionModuleId"];
            this.interventionModuleName = _data["interventionModuleName"];
            this.interventionModuleVersion = _data["interventionModuleVersion"];
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : undefined as any;
            this.started = _data["started"] ? new Date(_data["started"].toString()) : undefined as any;
            this.completed = _data["completed"] ? new Date(_data["completed"].toString()) : undefined as any;
            this.hidden = _data["hidden"] ? new Date(_data["hidden"].toString()) : undefined as any;
            this.state = _data["state"];
            if (Array.isArray(_data["pages"])) {
                this.pages = [] as any;
                for (let item of _data["pages"])
                    this.pages!.push(ContentPageDto.fromJS(item));
            }
            if (Array.isArray(_data["languages"])) {
                this.languages = [] as any;
                for (let item of _data["languages"])
                    this.languages!.push(TenantLanguageDto.fromJS(item));
            }
            this.defaultLanguage = _data["defaultLanguage"] ? TenantLanguageDto.fromJS(_data["defaultLanguage"]) : new TenantLanguageDto();
            this.executionLanguage = _data["executionLanguage"] ? TenantLanguageDto.fromJS(_data["executionLanguage"]) : undefined as any;
            this.executionInfo = _data["executionInfo"] ? ContainerInstanceExecutionInfoDto.fromJS(_data["executionInfo"]) : undefined as any;
            this.owner = _data["owner"] ? ProjectParticipantDto.fromJS(_data["owner"]) : undefined as any;
            this.amountQuestions = _data["amountQuestions"];
            this.amountAnswers = _data["amountAnswers"];
        }
    }

    static override fromJS(data: any): InterventionModuleInstanceDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new InterventionModuleInstanceDetailsDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["interventionModuleId"] = this.interventionModuleId;
        data["interventionModuleName"] = this.interventionModuleName;
        data["interventionModuleVersion"] = this.interventionModuleVersion;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : undefined as any;
        data["started"] = this.started ? this.started.toISOString() : undefined as any;
        data["completed"] = this.completed ? this.completed.toISOString() : undefined as any;
        data["hidden"] = this.hidden ? this.hidden.toISOString() : undefined as any;
        data["state"] = this.state;
        if (Array.isArray(this.pages)) {
            data["pages"] = [];
            for (let item of this.pages)
                data["pages"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.languages)) {
            data["languages"] = [];
            for (let item of this.languages)
                data["languages"].push(item ? item.toJSON() : undefined as any);
        }
        data["defaultLanguage"] = this.defaultLanguage ? this.defaultLanguage.toJSON() : undefined as any;
        data["executionLanguage"] = this.executionLanguage ? this.executionLanguage.toJSON() : undefined as any;
        data["executionInfo"] = this.executionInfo ? this.executionInfo.toJSON() : undefined as any;
        data["owner"] = this.owner ? this.owner.toJSON() : undefined as any;
        data["amountQuestions"] = this.amountQuestions;
        data["amountAnswers"] = this.amountAnswers;
        super.toJSON(data);
        return data;
    }

    clone(): InterventionModuleInstanceDetailsDto {
        const json = this.toJSON();
        let result = new InterventionModuleInstanceDetailsDto();
        result.init(json);
        return result;
    }
}

export interface IInterventionModuleInstanceDetailsDto extends ITenantEntityDto {
    name: string;
    interventionModuleId: string;
    interventionModuleName: string;
    interventionModuleVersion: number;
    projectId: string;
    projectName: string;
    created: Date;
    lastModified: Date;
    started?: Date | undefined;
    completed?: Date | undefined;
    hidden?: Date | undefined;
    state: ContainerInstanceState;
    pages: ContentPageDto[];
    languages: TenantLanguageDto[];
    defaultLanguage: TenantLanguageDto;
    executionLanguage?: TenantLanguageDto | undefined;
    executionInfo?: ContainerInstanceExecutionInfoDto | undefined;
    owner?: ProjectParticipantDto | undefined;
    amountQuestions: number;
    amountAnswers: number;
}

export class ContainerInstanceExecutionInfoDto implements IContainerInstanceExecutionInfoDto {
    appId!: string;
    appIdentifier!: string;
    appVersion!: string;
    appBuild!: string;
    deviceId!: string;
    deviceManufacturer!: string;
    deviceModel!: string;
    deviceOsVersion!: string;
    deviceLanguage!: string;
    deviceTimezone!: string;

    constructor(data?: IContainerInstanceExecutionInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appId = _data["appId"];
            this.appIdentifier = _data["appIdentifier"];
            this.appVersion = _data["appVersion"];
            this.appBuild = _data["appBuild"];
            this.deviceId = _data["deviceId"];
            this.deviceManufacturer = _data["deviceManufacturer"];
            this.deviceModel = _data["deviceModel"];
            this.deviceOsVersion = _data["deviceOsVersion"];
            this.deviceLanguage = _data["deviceLanguage"];
            this.deviceTimezone = _data["deviceTimezone"];
        }
    }

    static fromJS(data: any): ContainerInstanceExecutionInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContainerInstanceExecutionInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appId"] = this.appId;
        data["appIdentifier"] = this.appIdentifier;
        data["appVersion"] = this.appVersion;
        data["appBuild"] = this.appBuild;
        data["deviceId"] = this.deviceId;
        data["deviceManufacturer"] = this.deviceManufacturer;
        data["deviceModel"] = this.deviceModel;
        data["deviceOsVersion"] = this.deviceOsVersion;
        data["deviceLanguage"] = this.deviceLanguage;
        data["deviceTimezone"] = this.deviceTimezone;
        return data;
    }

    clone(): ContainerInstanceExecutionInfoDto {
        const json = this.toJSON();
        let result = new ContainerInstanceExecutionInfoDto();
        result.init(json);
        return result;
    }
}

export interface IContainerInstanceExecutionInfoDto {
    appId: string;
    appIdentifier: string;
    appVersion: string;
    appBuild: string;
    deviceId: string;
    deviceManufacturer: string;
    deviceModel: string;
    deviceOsVersion: string;
    deviceLanguage: string;
    deviceTimezone: string;
}

export class PaginatedListOfTenantLanguageDto implements IPaginatedListOfTenantLanguageDto {
    items!: TenantLanguageDto[];
    pageNumber!: number;
    pageSize!: number;
    totalCount!: number;
    totalPages!: number;
    hasPreviousPage!: boolean;
    hasNextPage!: boolean;

    constructor(data?: IPaginatedListOfTenantLanguageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TenantLanguageDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            this.totalPages = _data["totalPages"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfTenantLanguageDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfTenantLanguageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["totalPages"] = this.totalPages;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }

    clone(): PaginatedListOfTenantLanguageDto {
        const json = this.toJSON();
        let result = new PaginatedListOfTenantLanguageDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedListOfTenantLanguageDto {
    items: TenantLanguageDto[];
    pageNumber: number;
    pageSize: number;
    totalCount: number;
    totalPages: number;
    hasPreviousPage: boolean;
    hasNextPage: boolean;
}

export class CreateLanguageCommand implements ICreateLanguageCommand {
    name!: string;
    code!: string;
    iconId?: string | undefined;

    constructor(data?: ICreateLanguageCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.code = _data["code"];
            this.iconId = _data["iconId"];
        }
    }

    static fromJS(data: any): CreateLanguageCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateLanguageCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["code"] = this.code;
        data["iconId"] = this.iconId;
        return data;
    }

    clone(): CreateLanguageCommand {
        const json = this.toJSON();
        let result = new CreateLanguageCommand();
        result.init(json);
        return result;
    }
}

export interface ICreateLanguageCommand {
    name: string;
    code: string;
    iconId?: string | undefined;
}

export class UpdateLanguageCommand implements IUpdateLanguageCommand {
    languageId!: string;
    name!: string;
    code!: string;
    iconId?: string | undefined;
    fallbackLanguageIds!: string[];

    constructor(data?: IUpdateLanguageCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.fallbackLanguageIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageId = _data["languageId"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.iconId = _data["iconId"];
            if (Array.isArray(_data["fallbackLanguageIds"])) {
                this.fallbackLanguageIds = [] as any;
                for (let item of _data["fallbackLanguageIds"])
                    this.fallbackLanguageIds!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateLanguageCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateLanguageCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageId"] = this.languageId;
        data["name"] = this.name;
        data["code"] = this.code;
        data["iconId"] = this.iconId;
        if (Array.isArray(this.fallbackLanguageIds)) {
            data["fallbackLanguageIds"] = [];
            for (let item of this.fallbackLanguageIds)
                data["fallbackLanguageIds"].push(item);
        }
        return data;
    }

    clone(): UpdateLanguageCommand {
        const json = this.toJSON();
        let result = new UpdateLanguageCommand();
        result.init(json);
        return result;
    }
}

export interface IUpdateLanguageCommand {
    languageId: string;
    name: string;
    code: string;
    iconId?: string | undefined;
    fallbackLanguageIds: string[];
}

export class SetDefaultLanguageCommand implements ISetDefaultLanguageCommand {
    languageId!: string;

    constructor(data?: ISetDefaultLanguageCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageId = _data["languageId"];
        }
    }

    static fromJS(data: any): SetDefaultLanguageCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SetDefaultLanguageCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageId"] = this.languageId;
        return data;
    }

    clone(): SetDefaultLanguageCommand {
        const json = this.toJSON();
        let result = new SetDefaultLanguageCommand();
        result.init(json);
        return result;
    }
}

export interface ISetDefaultLanguageCommand {
    languageId: string;
}

export class TranslateCommand implements ITranslateCommand {
    text!: string;
    sourceLanguageCode?: string | undefined;
    targetLanguageCode!: string;

    constructor(data?: ITranslateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.text = _data["text"];
            this.sourceLanguageCode = _data["sourceLanguageCode"];
            this.targetLanguageCode = _data["targetLanguageCode"];
        }
    }

    static fromJS(data: any): TranslateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new TranslateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text;
        data["sourceLanguageCode"] = this.sourceLanguageCode;
        data["targetLanguageCode"] = this.targetLanguageCode;
        return data;
    }

    clone(): TranslateCommand {
        const json = this.toJSON();
        let result = new TranslateCommand();
        result.init(json);
        return result;
    }
}

export interface ITranslateCommand {
    text: string;
    sourceLanguageCode?: string | undefined;
    targetLanguageCode: string;
}

export class PaginatedListOfLicenseDto implements IPaginatedListOfLicenseDto {
    items!: LicenseDto[];
    pageNumber!: number;
    pageSize!: number;
    totalCount!: number;
    totalPages!: number;
    hasPreviousPage!: boolean;
    hasNextPage!: boolean;

    constructor(data?: IPaginatedListOfLicenseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(LicenseDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            this.totalPages = _data["totalPages"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfLicenseDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfLicenseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["totalPages"] = this.totalPages;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }

    clone(): PaginatedListOfLicenseDto {
        const json = this.toJSON();
        let result = new PaginatedListOfLicenseDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedListOfLicenseDto {
    items: LicenseDto[];
    pageNumber: number;
    pageSize: number;
    totalCount: number;
    totalPages: number;
    hasPreviousPage: boolean;
    hasNextPage: boolean;
}

export class CreateLicenseCommand implements ICreateLicenseCommand {
    name!: string;
    appIds!: string[];
    activationServiceType!: LicenseActivationServiceType;
    validFromDate?: Date | undefined;
    validityInterval?: string | undefined;
    instanceValidityInterval?: string | undefined;
    licenseConfig?: LicenseConfig | undefined;
    tags?: string[] | undefined;
    metadata?: LicenseMetadata | undefined;

    constructor(data?: ICreateLicenseCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.appIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["appIds"])) {
                this.appIds = [] as any;
                for (let item of _data["appIds"])
                    this.appIds!.push(item);
            }
            this.activationServiceType = _data["activationServiceType"];
            this.validFromDate = _data["validFromDate"] ? new Date(_data["validFromDate"].toString()) : undefined as any;
            this.validityInterval = _data["validityInterval"];
            this.instanceValidityInterval = _data["instanceValidityInterval"];
            this.licenseConfig = _data["licenseConfig"] ? LicenseConfig.fromJS(_data["licenseConfig"]) : undefined as any;
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            this.metadata = _data["metadata"] ? LicenseMetadata.fromJS(_data["metadata"]) : undefined as any;
        }
    }

    static fromJS(data: any): CreateLicenseCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateLicenseCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.appIds)) {
            data["appIds"] = [];
            for (let item of this.appIds)
                data["appIds"].push(item);
        }
        data["activationServiceType"] = this.activationServiceType;
        data["validFromDate"] = this.validFromDate ? this.validFromDate.toISOString() : undefined as any;
        data["validityInterval"] = this.validityInterval;
        data["instanceValidityInterval"] = this.instanceValidityInterval;
        data["licenseConfig"] = this.licenseConfig ? this.licenseConfig.toJSON() : undefined as any;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["metadata"] = this.metadata ? this.metadata.toJSON() : undefined as any;
        return data;
    }

    clone(): CreateLicenseCommand {
        const json = this.toJSON();
        let result = new CreateLicenseCommand();
        result.init(json);
        return result;
    }
}

export interface ICreateLicenseCommand {
    name: string;
    appIds: string[];
    activationServiceType: LicenseActivationServiceType;
    validFromDate?: Date | undefined;
    validityInterval?: string | undefined;
    instanceValidityInterval?: string | undefined;
    licenseConfig?: LicenseConfig | undefined;
    tags?: string[] | undefined;
    metadata?: LicenseMetadata | undefined;
}

export class LicenseMetadata implements ILicenseMetadata {
    poNumber?: string | undefined;
    distributorName?: string | undefined;

    constructor(data?: ILicenseMetadata) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.poNumber = _data["poNumber"];
            this.distributorName = _data["distributorName"];
        }
    }

    static fromJS(data: any): LicenseMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new LicenseMetadata();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["poNumber"] = this.poNumber;
        data["distributorName"] = this.distributorName;
        return data;
    }

    clone(): LicenseMetadata {
        const json = this.toJSON();
        let result = new LicenseMetadata();
        result.init(json);
        return result;
    }
}

export interface ILicenseMetadata {
    poNumber?: string | undefined;
    distributorName?: string | undefined;
}

export class UpdateLicenseCommand implements IUpdateLicenseCommand {
    licenseId!: string;
    name?: string | undefined;
    appIds?: string[] | undefined;
    activationServiceType?: LicenseActivationServiceType | undefined;
    validFromDate?: Date | undefined;
    validityInterval?: string | undefined;
    instanceValidityInterval?: string | undefined;
    licenseConfig?: LicenseConfig | undefined;
    tags?: string[] | undefined;
    metadata?: LicenseMetadata | undefined;

    constructor(data?: IUpdateLicenseCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.licenseId = _data["licenseId"];
            this.name = _data["name"];
            if (Array.isArray(_data["appIds"])) {
                this.appIds = [] as any;
                for (let item of _data["appIds"])
                    this.appIds!.push(item);
            }
            this.activationServiceType = _data["activationServiceType"];
            this.validFromDate = _data["validFromDate"] ? new Date(_data["validFromDate"].toString()) : undefined as any;
            this.validityInterval = _data["validityInterval"];
            this.instanceValidityInterval = _data["instanceValidityInterval"];
            this.licenseConfig = _data["licenseConfig"] ? LicenseConfig.fromJS(_data["licenseConfig"]) : undefined as any;
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            this.metadata = _data["metadata"] ? LicenseMetadata.fromJS(_data["metadata"]) : undefined as any;
        }
    }

    static fromJS(data: any): UpdateLicenseCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateLicenseCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["licenseId"] = this.licenseId;
        data["name"] = this.name;
        if (Array.isArray(this.appIds)) {
            data["appIds"] = [];
            for (let item of this.appIds)
                data["appIds"].push(item);
        }
        data["activationServiceType"] = this.activationServiceType;
        data["validFromDate"] = this.validFromDate ? this.validFromDate.toISOString() : undefined as any;
        data["validityInterval"] = this.validityInterval;
        data["instanceValidityInterval"] = this.instanceValidityInterval;
        data["licenseConfig"] = this.licenseConfig ? this.licenseConfig.toJSON() : undefined as any;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["metadata"] = this.metadata ? this.metadata.toJSON() : undefined as any;
        return data;
    }

    clone(): UpdateLicenseCommand {
        const json = this.toJSON();
        let result = new UpdateLicenseCommand();
        result.init(json);
        return result;
    }
}

export interface IUpdateLicenseCommand {
    licenseId: string;
    name?: string | undefined;
    appIds?: string[] | undefined;
    activationServiceType?: LicenseActivationServiceType | undefined;
    validFromDate?: Date | undefined;
    validityInterval?: string | undefined;
    instanceValidityInterval?: string | undefined;
    licenseConfig?: LicenseConfig | undefined;
    tags?: string[] | undefined;
    metadata?: LicenseMetadata | undefined;
}

export class PaginatedListOfLicenseInstanceDto implements IPaginatedListOfLicenseInstanceDto {
    items!: LicenseInstanceDto[];
    pageNumber!: number;
    pageSize!: number;
    totalCount!: number;
    totalPages!: number;
    hasPreviousPage!: boolean;
    hasNextPage!: boolean;

    constructor(data?: IPaginatedListOfLicenseInstanceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(LicenseInstanceDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            this.totalPages = _data["totalPages"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfLicenseInstanceDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfLicenseInstanceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["totalPages"] = this.totalPages;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }

    clone(): PaginatedListOfLicenseInstanceDto {
        const json = this.toJSON();
        let result = new PaginatedListOfLicenseInstanceDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedListOfLicenseInstanceDto {
    items: LicenseInstanceDto[];
    pageNumber: number;
    pageSize: number;
    totalCount: number;
    totalPages: number;
    hasPreviousPage: boolean;
    hasNextPage: boolean;
}

export class LicenseInstanceDto implements ILicenseInstanceDto {
    id!: string;
    licenseId!: string;
    licenseKey?: string | undefined;
    expirationDate?: Date | undefined;
    activated?: Date | undefined;
    revoked?: Date | undefined;
    created?: Date | undefined;
    createdBy?: UserDto | undefined;
    lastModified?: Date | undefined;
    hidden?: Date | undefined;
    lastActivated?: Date | undefined;
    activatedBy?: UserDto | undefined;
    installationsCount!: number;
    tags!: string[];
    metadata!: LicenseMetadataDto;
    externalEntitlement?: ExternalEntitlementDto | undefined;
    externalPurchases!: ExternalPurchaseDto[];

    constructor(data?: ILicenseInstanceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.tags = [];
            this.metadata = new LicenseMetadataDto();
            this.externalPurchases = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.licenseId = _data["licenseId"];
            this.licenseKey = _data["licenseKey"];
            this.expirationDate = _data["expirationDate"] ? new Date(_data["expirationDate"].toString()) : undefined as any;
            this.activated = _data["activated"] ? new Date(_data["activated"].toString()) : undefined as any;
            this.revoked = _data["revoked"] ? new Date(_data["revoked"].toString()) : undefined as any;
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"] ? UserDto.fromJS(_data["createdBy"]) : undefined as any;
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : undefined as any;
            this.hidden = _data["hidden"] ? new Date(_data["hidden"].toString()) : undefined as any;
            this.lastActivated = _data["lastActivated"] ? new Date(_data["lastActivated"].toString()) : undefined as any;
            this.activatedBy = _data["activatedBy"] ? UserDto.fromJS(_data["activatedBy"]) : undefined as any;
            this.installationsCount = _data["installationsCount"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            this.metadata = _data["metadata"] ? LicenseMetadataDto.fromJS(_data["metadata"]) : new LicenseMetadataDto();
            this.externalEntitlement = _data["externalEntitlement"] ? ExternalEntitlementDto.fromJS(_data["externalEntitlement"]) : undefined as any;
            if (Array.isArray(_data["externalPurchases"])) {
                this.externalPurchases = [] as any;
                for (let item of _data["externalPurchases"])
                    this.externalPurchases!.push(ExternalPurchaseDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LicenseInstanceDto {
        data = typeof data === 'object' ? data : {};
        let result = new LicenseInstanceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["licenseId"] = this.licenseId;
        data["licenseKey"] = this.licenseKey;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : undefined as any;
        data["activated"] = this.activated ? this.activated.toISOString() : undefined as any;
        data["revoked"] = this.revoked ? this.revoked.toISOString() : undefined as any;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy ? this.createdBy.toJSON() : undefined as any;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : undefined as any;
        data["hidden"] = this.hidden ? this.hidden.toISOString() : undefined as any;
        data["lastActivated"] = this.lastActivated ? this.lastActivated.toISOString() : undefined as any;
        data["activatedBy"] = this.activatedBy ? this.activatedBy.toJSON() : undefined as any;
        data["installationsCount"] = this.installationsCount;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["metadata"] = this.metadata ? this.metadata.toJSON() : undefined as any;
        data["externalEntitlement"] = this.externalEntitlement ? this.externalEntitlement.toJSON() : undefined as any;
        if (Array.isArray(this.externalPurchases)) {
            data["externalPurchases"] = [];
            for (let item of this.externalPurchases)
                data["externalPurchases"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): LicenseInstanceDto {
        const json = this.toJSON();
        let result = new LicenseInstanceDto();
        result.init(json);
        return result;
    }
}

export interface ILicenseInstanceDto {
    id: string;
    licenseId: string;
    licenseKey?: string | undefined;
    expirationDate?: Date | undefined;
    activated?: Date | undefined;
    revoked?: Date | undefined;
    created?: Date | undefined;
    createdBy?: UserDto | undefined;
    lastModified?: Date | undefined;
    hidden?: Date | undefined;
    lastActivated?: Date | undefined;
    activatedBy?: UserDto | undefined;
    installationsCount: number;
    tags: string[];
    metadata: LicenseMetadataDto;
    externalEntitlement?: ExternalEntitlementDto | undefined;
    externalPurchases: ExternalPurchaseDto[];
}

export class ExternalEntitlementDto implements IExternalEntitlementDto {
    id!: string;
    provider!: ExternalEntitlementProvider;
    entitlementId!: string;
    store?: string | undefined;
    productId?: string | undefined;
    originalTransactionId?: string | undefined;
    periodType?: string | undefined;
    environment?: string | undefined;
    willRenew?: boolean | undefined;
    managementUrl?: string | undefined;
    expiresAt?: Date | undefined;
    unsubscribeDetectedAt?: Date | undefined;
    billingIssueDetectedAt?: Date | undefined;
    lastEventId?: string | undefined;
    lastEventType?: string | undefined;
    lastEventAt?: Date | undefined;
    lastSyncedAt?: Date | undefined;

    constructor(data?: IExternalEntitlementDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.provider = _data["provider"];
            this.entitlementId = _data["entitlementId"];
            this.store = _data["store"];
            this.productId = _data["productId"];
            this.originalTransactionId = _data["originalTransactionId"];
            this.periodType = _data["periodType"];
            this.environment = _data["environment"];
            this.willRenew = _data["willRenew"];
            this.managementUrl = _data["managementUrl"];
            this.expiresAt = _data["expiresAt"] ? new Date(_data["expiresAt"].toString()) : undefined as any;
            this.unsubscribeDetectedAt = _data["unsubscribeDetectedAt"] ? new Date(_data["unsubscribeDetectedAt"].toString()) : undefined as any;
            this.billingIssueDetectedAt = _data["billingIssueDetectedAt"] ? new Date(_data["billingIssueDetectedAt"].toString()) : undefined as any;
            this.lastEventId = _data["lastEventId"];
            this.lastEventType = _data["lastEventType"];
            this.lastEventAt = _data["lastEventAt"] ? new Date(_data["lastEventAt"].toString()) : undefined as any;
            this.lastSyncedAt = _data["lastSyncedAt"] ? new Date(_data["lastSyncedAt"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ExternalEntitlementDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalEntitlementDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["provider"] = this.provider;
        data["entitlementId"] = this.entitlementId;
        data["store"] = this.store;
        data["productId"] = this.productId;
        data["originalTransactionId"] = this.originalTransactionId;
        data["periodType"] = this.periodType;
        data["environment"] = this.environment;
        data["willRenew"] = this.willRenew;
        data["managementUrl"] = this.managementUrl;
        data["expiresAt"] = this.expiresAt ? this.expiresAt.toISOString() : undefined as any;
        data["unsubscribeDetectedAt"] = this.unsubscribeDetectedAt ? this.unsubscribeDetectedAt.toISOString() : undefined as any;
        data["billingIssueDetectedAt"] = this.billingIssueDetectedAt ? this.billingIssueDetectedAt.toISOString() : undefined as any;
        data["lastEventId"] = this.lastEventId;
        data["lastEventType"] = this.lastEventType;
        data["lastEventAt"] = this.lastEventAt ? this.lastEventAt.toISOString() : undefined as any;
        data["lastSyncedAt"] = this.lastSyncedAt ? this.lastSyncedAt.toISOString() : undefined as any;
        return data;
    }

    clone(): ExternalEntitlementDto {
        const json = this.toJSON();
        let result = new ExternalEntitlementDto();
        result.init(json);
        return result;
    }
}

export interface IExternalEntitlementDto {
    id: string;
    provider: ExternalEntitlementProvider;
    entitlementId: string;
    store?: string | undefined;
    productId?: string | undefined;
    originalTransactionId?: string | undefined;
    periodType?: string | undefined;
    environment?: string | undefined;
    willRenew?: boolean | undefined;
    managementUrl?: string | undefined;
    expiresAt?: Date | undefined;
    unsubscribeDetectedAt?: Date | undefined;
    billingIssueDetectedAt?: Date | undefined;
    lastEventId?: string | undefined;
    lastEventType?: string | undefined;
    lastEventAt?: Date | undefined;
    lastSyncedAt?: Date | undefined;
}

export enum ExternalEntitlementProvider {
    RevenueCat = "revenueCat",
}

export class ExternalPurchaseDto implements IExternalPurchaseDto {
    id!: string;
    provider!: ExternalPurchaseProvider;
    purchaseId!: string;
    storeTransactionId?: string | undefined;
    productId!: string;
    purchasedAt!: Date;
    validityInterval!: string;
    revokedAt?: Date | undefined;
    store?: string | undefined;
    environment?: string | undefined;
    lastEventId?: string | undefined;
    lastEventType?: string | undefined;
    lastEventAt?: Date | undefined;
    lastSyncedAt?: Date | undefined;

    constructor(data?: IExternalPurchaseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.provider = _data["provider"];
            this.purchaseId = _data["purchaseId"];
            this.storeTransactionId = _data["storeTransactionId"];
            this.productId = _data["productId"];
            this.purchasedAt = _data["purchasedAt"] ? new Date(_data["purchasedAt"].toString()) : undefined as any;
            this.validityInterval = _data["validityInterval"];
            this.revokedAt = _data["revokedAt"] ? new Date(_data["revokedAt"].toString()) : undefined as any;
            this.store = _data["store"];
            this.environment = _data["environment"];
            this.lastEventId = _data["lastEventId"];
            this.lastEventType = _data["lastEventType"];
            this.lastEventAt = _data["lastEventAt"] ? new Date(_data["lastEventAt"].toString()) : undefined as any;
            this.lastSyncedAt = _data["lastSyncedAt"] ? new Date(_data["lastSyncedAt"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ExternalPurchaseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalPurchaseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["provider"] = this.provider;
        data["purchaseId"] = this.purchaseId;
        data["storeTransactionId"] = this.storeTransactionId;
        data["productId"] = this.productId;
        data["purchasedAt"] = this.purchasedAt ? this.purchasedAt.toISOString() : undefined as any;
        data["validityInterval"] = this.validityInterval;
        data["revokedAt"] = this.revokedAt ? this.revokedAt.toISOString() : undefined as any;
        data["store"] = this.store;
        data["environment"] = this.environment;
        data["lastEventId"] = this.lastEventId;
        data["lastEventType"] = this.lastEventType;
        data["lastEventAt"] = this.lastEventAt ? this.lastEventAt.toISOString() : undefined as any;
        data["lastSyncedAt"] = this.lastSyncedAt ? this.lastSyncedAt.toISOString() : undefined as any;
        return data;
    }

    clone(): ExternalPurchaseDto {
        const json = this.toJSON();
        let result = new ExternalPurchaseDto();
        result.init(json);
        return result;
    }
}

export interface IExternalPurchaseDto {
    id: string;
    provider: ExternalPurchaseProvider;
    purchaseId: string;
    storeTransactionId?: string | undefined;
    productId: string;
    purchasedAt: Date;
    validityInterval: string;
    revokedAt?: Date | undefined;
    store?: string | undefined;
    environment?: string | undefined;
    lastEventId?: string | undefined;
    lastEventType?: string | undefined;
    lastEventAt?: Date | undefined;
    lastSyncedAt?: Date | undefined;
}

export enum ExternalPurchaseProvider {
    RevenueCat = "revenueCat",
}

export class CreateLicenseInstancesCommand implements ICreateLicenseInstancesCommand {
    licenseId!: string;
    count!: number;

    constructor(data?: ICreateLicenseInstancesCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.licenseId = _data["licenseId"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): CreateLicenseInstancesCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateLicenseInstancesCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["licenseId"] = this.licenseId;
        data["count"] = this.count;
        return data;
    }

    clone(): CreateLicenseInstancesCommand {
        const json = this.toJSON();
        let result = new CreateLicenseInstancesCommand();
        result.init(json);
        return result;
    }
}

export interface ICreateLicenseInstancesCommand {
    licenseId: string;
    count: number;
}

export class UpdateLicenseInstanceCommand implements IUpdateLicenseInstanceCommand {
    licenseInstanceId!: string;
    expirationDate?: Date | undefined;
    revocationDate?: Date | undefined;
    tags?: string[] | undefined;
    metadata?: LicenseMetadata | undefined;

    constructor(data?: IUpdateLicenseInstanceCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.licenseInstanceId = _data["licenseInstanceId"];
            this.expirationDate = _data["expirationDate"] ? new Date(_data["expirationDate"].toString()) : undefined as any;
            this.revocationDate = _data["revocationDate"] ? new Date(_data["revocationDate"].toString()) : undefined as any;
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            this.metadata = _data["metadata"] ? LicenseMetadata.fromJS(_data["metadata"]) : undefined as any;
        }
    }

    static fromJS(data: any): UpdateLicenseInstanceCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateLicenseInstanceCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["licenseInstanceId"] = this.licenseInstanceId;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : undefined as any;
        data["revocationDate"] = this.revocationDate ? this.revocationDate.toISOString() : undefined as any;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["metadata"] = this.metadata ? this.metadata.toJSON() : undefined as any;
        return data;
    }

    clone(): UpdateLicenseInstanceCommand {
        const json = this.toJSON();
        let result = new UpdateLicenseInstanceCommand();
        result.init(json);
        return result;
    }
}

export interface IUpdateLicenseInstanceCommand {
    licenseInstanceId: string;
    expirationDate?: Date | undefined;
    revocationDate?: Date | undefined;
    tags?: string[] | undefined;
    metadata?: LicenseMetadata | undefined;
}

export class PaginatedListOfQuestionnaireDto implements IPaginatedListOfQuestionnaireDto {
    items!: QuestionnaireDto[];
    pageNumber!: number;
    pageSize!: number;
    totalCount!: number;
    totalPages!: number;
    hasPreviousPage!: boolean;
    hasNextPage!: boolean;

    constructor(data?: IPaginatedListOfQuestionnaireDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(QuestionnaireDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            this.totalPages = _data["totalPages"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfQuestionnaireDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfQuestionnaireDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["totalPages"] = this.totalPages;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }

    clone(): PaginatedListOfQuestionnaireDto {
        const json = this.toJSON();
        let result = new PaginatedListOfQuestionnaireDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedListOfQuestionnaireDto {
    items: QuestionnaireDto[];
    pageNumber: number;
    pageSize: number;
    totalCount: number;
    totalPages: number;
    hasPreviousPage: boolean;
    hasNextPage: boolean;
}

export class QuestionnaireDto extends ContainerDto implements IQuestionnaireDto {
    instantiationMode!: QuestionnaireInstantiationMode;
    editingMode!: QuestionnaireEditingMode;

    constructor(data?: IQuestionnaireDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.instantiationMode = _data["instantiationMode"];
            this.editingMode = _data["editingMode"];
        }
    }

    static override fromJS(data: any): QuestionnaireDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionnaireDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["instantiationMode"] = this.instantiationMode;
        data["editingMode"] = this.editingMode;
        super.toJSON(data);
        return data;
    }

    clone(): QuestionnaireDto {
        const json = this.toJSON();
        let result = new QuestionnaireDto();
        result.init(json);
        return result;
    }
}

export interface IQuestionnaireDto extends IContainerDto {
    instantiationMode: QuestionnaireInstantiationMode;
    editingMode: QuestionnaireEditingMode;
}

export class QuestionnaireDetailsDto extends ContainerDetailsDto implements IQuestionnaireDetailsDto {
    pages!: ContentPageDto[];
    instantiationMode!: QuestionnaireInstantiationMode;
    editingMode!: QuestionnaireEditingMode;

    constructor(data?: IQuestionnaireDetailsDto) {
        super(data);
        if (!data) {
            this.pages = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["pages"])) {
                this.pages = [] as any;
                for (let item of _data["pages"])
                    this.pages!.push(ContentPageDto.fromJS(item));
            }
            this.instantiationMode = _data["instantiationMode"];
            this.editingMode = _data["editingMode"];
        }
    }

    static override fromJS(data: any): QuestionnaireDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionnaireDetailsDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.pages)) {
            data["pages"] = [];
            for (let item of this.pages)
                data["pages"].push(item ? item.toJSON() : undefined as any);
        }
        data["instantiationMode"] = this.instantiationMode;
        data["editingMode"] = this.editingMode;
        super.toJSON(data);
        return data;
    }

    clone(): QuestionnaireDetailsDto {
        const json = this.toJSON();
        let result = new QuestionnaireDetailsDto();
        result.init(json);
        return result;
    }
}

export interface IQuestionnaireDetailsDto extends IContainerDetailsDto {
    pages: ContentPageDto[];
    instantiationMode: QuestionnaireInstantiationMode;
    editingMode: QuestionnaireEditingMode;
}

export class CreateQuestionnaireCommand implements ICreateQuestionnaireCommand {
    name!: string;
    projectId!: string;

    constructor(data?: ICreateQuestionnaireCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.projectId = _data["projectId"];
        }
    }

    static fromJS(data: any): CreateQuestionnaireCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateQuestionnaireCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["projectId"] = this.projectId;
        return data;
    }

    clone(): CreateQuestionnaireCommand {
        const json = this.toJSON();
        let result = new CreateQuestionnaireCommand();
        result.init(json);
        return result;
    }
}

export interface ICreateQuestionnaireCommand {
    name: string;
    projectId: string;
}

export class UpdateQuestionnaireCommand implements IUpdateQuestionnaireCommand {
    questionnaireId!: string;
    name!: string;
    uniqueLabel!: string;
    title!: InternationalizedString;
    description!: InternationalizedDocument;
    defaultLanguageId!: string;
    languageIds!: string[];
    pages!: ContentPageDto[];
    instantiationMode!: QuestionnaireInstantiationMode;
    editingMode!: QuestionnaireEditingMode;
    condition?: ContainerCondition | undefined;
    sharingOptions!: ContainerSharingOptionDto[];

    constructor(data?: IUpdateQuestionnaireCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.title = new InternationalizedString();
            this.description = new InternationalizedDocument();
            this.languageIds = [];
            this.pages = [];
            this.sharingOptions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.questionnaireId = _data["questionnaireId"];
            this.name = _data["name"];
            this.uniqueLabel = _data["uniqueLabel"];
            this.title = _data["title"] ? InternationalizedString.fromJS(_data["title"]) : new InternationalizedString();
            this.description = _data["description"] ? InternationalizedDocument.fromJS(_data["description"]) : new InternationalizedDocument();
            this.defaultLanguageId = _data["defaultLanguageId"];
            if (Array.isArray(_data["languageIds"])) {
                this.languageIds = [] as any;
                for (let item of _data["languageIds"])
                    this.languageIds!.push(item);
            }
            if (Array.isArray(_data["pages"])) {
                this.pages = [] as any;
                for (let item of _data["pages"])
                    this.pages!.push(ContentPageDto.fromJS(item));
            }
            this.instantiationMode = _data["instantiationMode"];
            this.editingMode = _data["editingMode"];
            this.condition = _data["condition"] ? ContainerCondition.fromJS(_data["condition"]) : undefined as any;
            if (Array.isArray(_data["sharingOptions"])) {
                this.sharingOptions = [] as any;
                for (let item of _data["sharingOptions"])
                    this.sharingOptions!.push(ContainerSharingOptionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateQuestionnaireCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateQuestionnaireCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questionnaireId"] = this.questionnaireId;
        data["name"] = this.name;
        data["uniqueLabel"] = this.uniqueLabel;
        data["title"] = this.title ? this.title.toJSON() : undefined as any;
        data["description"] = this.description ? this.description.toJSON() : undefined as any;
        data["defaultLanguageId"] = this.defaultLanguageId;
        if (Array.isArray(this.languageIds)) {
            data["languageIds"] = [];
            for (let item of this.languageIds)
                data["languageIds"].push(item);
        }
        if (Array.isArray(this.pages)) {
            data["pages"] = [];
            for (let item of this.pages)
                data["pages"].push(item ? item.toJSON() : undefined as any);
        }
        data["instantiationMode"] = this.instantiationMode;
        data["editingMode"] = this.editingMode;
        data["condition"] = this.condition ? this.condition.toJSON() : undefined as any;
        if (Array.isArray(this.sharingOptions)) {
            data["sharingOptions"] = [];
            for (let item of this.sharingOptions)
                data["sharingOptions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): UpdateQuestionnaireCommand {
        const json = this.toJSON();
        let result = new UpdateQuestionnaireCommand();
        result.init(json);
        return result;
    }
}

export interface IUpdateQuestionnaireCommand {
    questionnaireId: string;
    name: string;
    uniqueLabel: string;
    title: InternationalizedString;
    description: InternationalizedDocument;
    defaultLanguageId: string;
    languageIds: string[];
    pages: ContentPageDto[];
    instantiationMode: QuestionnaireInstantiationMode;
    editingMode: QuestionnaireEditingMode;
    condition?: ContainerCondition | undefined;
    sharingOptions: ContainerSharingOptionDto[];
}

export class TranslateQuestionnaireCommand implements ITranslateQuestionnaireCommand {
    containerId!: string;
    fromLanguageId?: string | undefined;
    toLanguageId?: string | undefined;

    constructor(data?: ITranslateQuestionnaireCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.containerId = _data["containerId"];
            this.fromLanguageId = _data["fromLanguageId"];
            this.toLanguageId = _data["toLanguageId"];
        }
    }

    static fromJS(data: any): TranslateQuestionnaireCommand {
        data = typeof data === 'object' ? data : {};
        let result = new TranslateQuestionnaireCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["containerId"] = this.containerId;
        data["fromLanguageId"] = this.fromLanguageId;
        data["toLanguageId"] = this.toLanguageId;
        return data;
    }

    clone(): TranslateQuestionnaireCommand {
        const json = this.toJSON();
        let result = new TranslateQuestionnaireCommand();
        result.init(json);
        return result;
    }
}

export interface ITranslateQuestionnaireCommand {
    containerId: string;
    fromLanguageId?: string | undefined;
    toLanguageId?: string | undefined;
}

export class PaginatedListOfQuestionnaireInstanceDto implements IPaginatedListOfQuestionnaireInstanceDto {
    items!: QuestionnaireInstanceDto[];
    pageNumber!: number;
    pageSize!: number;
    totalCount!: number;
    totalPages!: number;
    hasPreviousPage!: boolean;
    hasNextPage!: boolean;

    constructor(data?: IPaginatedListOfQuestionnaireInstanceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(QuestionnaireInstanceDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            this.totalPages = _data["totalPages"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfQuestionnaireInstanceDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfQuestionnaireInstanceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["totalPages"] = this.totalPages;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }

    clone(): PaginatedListOfQuestionnaireInstanceDto {
        const json = this.toJSON();
        let result = new PaginatedListOfQuestionnaireInstanceDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedListOfQuestionnaireInstanceDto {
    items: QuestionnaireInstanceDto[];
    pageNumber: number;
    pageSize: number;
    totalCount: number;
    totalPages: number;
    hasPreviousPage: boolean;
    hasNextPage: boolean;
}

export class QuestionnaireInstanceDto extends TenantEntityDto implements IQuestionnaireInstanceDto {
    name!: string;
    questionnaireId!: string;
    questionnaireName!: string;
    questionnaireVersion!: number;
    created!: Date;
    lastModified!: Date;
    started?: Date | undefined;
    completed?: Date | undefined;
    hidden?: Date | undefined;
    state!: ContainerInstanceState;
    owner?: ProjectParticipantDto | undefined;
    amountQuestions!: number;
    amountAnswers!: number;
    executionLanguage?: TenantLanguageDto | undefined;

    constructor(data?: IQuestionnaireInstanceDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.questionnaireId = _data["questionnaireId"];
            this.questionnaireName = _data["questionnaireName"];
            this.questionnaireVersion = _data["questionnaireVersion"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : undefined as any;
            this.started = _data["started"] ? new Date(_data["started"].toString()) : undefined as any;
            this.completed = _data["completed"] ? new Date(_data["completed"].toString()) : undefined as any;
            this.hidden = _data["hidden"] ? new Date(_data["hidden"].toString()) : undefined as any;
            this.state = _data["state"];
            this.owner = _data["owner"] ? ProjectParticipantDto.fromJS(_data["owner"]) : undefined as any;
            this.amountQuestions = _data["amountQuestions"];
            this.amountAnswers = _data["amountAnswers"];
            this.executionLanguage = _data["executionLanguage"] ? TenantLanguageDto.fromJS(_data["executionLanguage"]) : undefined as any;
        }
    }

    static override fromJS(data: any): QuestionnaireInstanceDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionnaireInstanceDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["questionnaireId"] = this.questionnaireId;
        data["questionnaireName"] = this.questionnaireName;
        data["questionnaireVersion"] = this.questionnaireVersion;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : undefined as any;
        data["started"] = this.started ? this.started.toISOString() : undefined as any;
        data["completed"] = this.completed ? this.completed.toISOString() : undefined as any;
        data["hidden"] = this.hidden ? this.hidden.toISOString() : undefined as any;
        data["state"] = this.state;
        data["owner"] = this.owner ? this.owner.toJSON() : undefined as any;
        data["amountQuestions"] = this.amountQuestions;
        data["amountAnswers"] = this.amountAnswers;
        data["executionLanguage"] = this.executionLanguage ? this.executionLanguage.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): QuestionnaireInstanceDto {
        const json = this.toJSON();
        let result = new QuestionnaireInstanceDto();
        result.init(json);
        return result;
    }
}

export interface IQuestionnaireInstanceDto extends ITenantEntityDto {
    name: string;
    questionnaireId: string;
    questionnaireName: string;
    questionnaireVersion: number;
    created: Date;
    lastModified: Date;
    started?: Date | undefined;
    completed?: Date | undefined;
    hidden?: Date | undefined;
    state: ContainerInstanceState;
    owner?: ProjectParticipantDto | undefined;
    amountQuestions: number;
    amountAnswers: number;
    executionLanguage?: TenantLanguageDto | undefined;
}

export class QuestionnaireInstanceDetailsDto extends TenantEntityDto implements IQuestionnaireInstanceDetailsDto {
    name!: string;
    questionnaireId!: string;
    questionnaireName!: string;
    questionnaireVersion!: number;
    projectId!: string;
    projectName!: string;
    created!: Date;
    lastModified!: Date;
    started?: Date | undefined;
    completed?: Date | undefined;
    hidden?: Date | undefined;
    state!: ContainerInstanceState;
    pages!: ContentPageDto[];
    languages!: TenantLanguageDto[];
    defaultLanguage!: TenantLanguageDto;
    executionLanguage?: TenantLanguageDto | undefined;
    executionInfo?: ContainerInstanceExecutionInfoDto | undefined;
    owner?: ProjectParticipantDto | undefined;
    amountQuestions!: number;
    amountAnswers!: number;

    constructor(data?: IQuestionnaireInstanceDetailsDto) {
        super(data);
        if (!data) {
            this.pages = [];
            this.languages = [];
            this.defaultLanguage = new TenantLanguageDto();
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.questionnaireId = _data["questionnaireId"];
            this.questionnaireName = _data["questionnaireName"];
            this.questionnaireVersion = _data["questionnaireVersion"];
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : undefined as any;
            this.started = _data["started"] ? new Date(_data["started"].toString()) : undefined as any;
            this.completed = _data["completed"] ? new Date(_data["completed"].toString()) : undefined as any;
            this.hidden = _data["hidden"] ? new Date(_data["hidden"].toString()) : undefined as any;
            this.state = _data["state"];
            if (Array.isArray(_data["pages"])) {
                this.pages = [] as any;
                for (let item of _data["pages"])
                    this.pages!.push(ContentPageDto.fromJS(item));
            }
            if (Array.isArray(_data["languages"])) {
                this.languages = [] as any;
                for (let item of _data["languages"])
                    this.languages!.push(TenantLanguageDto.fromJS(item));
            }
            this.defaultLanguage = _data["defaultLanguage"] ? TenantLanguageDto.fromJS(_data["defaultLanguage"]) : new TenantLanguageDto();
            this.executionLanguage = _data["executionLanguage"] ? TenantLanguageDto.fromJS(_data["executionLanguage"]) : undefined as any;
            this.executionInfo = _data["executionInfo"] ? ContainerInstanceExecutionInfoDto.fromJS(_data["executionInfo"]) : undefined as any;
            this.owner = _data["owner"] ? ProjectParticipantDto.fromJS(_data["owner"]) : undefined as any;
            this.amountQuestions = _data["amountQuestions"];
            this.amountAnswers = _data["amountAnswers"];
        }
    }

    static override fromJS(data: any): QuestionnaireInstanceDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionnaireInstanceDetailsDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["questionnaireId"] = this.questionnaireId;
        data["questionnaireName"] = this.questionnaireName;
        data["questionnaireVersion"] = this.questionnaireVersion;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : undefined as any;
        data["started"] = this.started ? this.started.toISOString() : undefined as any;
        data["completed"] = this.completed ? this.completed.toISOString() : undefined as any;
        data["hidden"] = this.hidden ? this.hidden.toISOString() : undefined as any;
        data["state"] = this.state;
        if (Array.isArray(this.pages)) {
            data["pages"] = [];
            for (let item of this.pages)
                data["pages"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.languages)) {
            data["languages"] = [];
            for (let item of this.languages)
                data["languages"].push(item ? item.toJSON() : undefined as any);
        }
        data["defaultLanguage"] = this.defaultLanguage ? this.defaultLanguage.toJSON() : undefined as any;
        data["executionLanguage"] = this.executionLanguage ? this.executionLanguage.toJSON() : undefined as any;
        data["executionInfo"] = this.executionInfo ? this.executionInfo.toJSON() : undefined as any;
        data["owner"] = this.owner ? this.owner.toJSON() : undefined as any;
        data["amountQuestions"] = this.amountQuestions;
        data["amountAnswers"] = this.amountAnswers;
        super.toJSON(data);
        return data;
    }

    clone(): QuestionnaireInstanceDetailsDto {
        const json = this.toJSON();
        let result = new QuestionnaireInstanceDetailsDto();
        result.init(json);
        return result;
    }
}

export interface IQuestionnaireInstanceDetailsDto extends ITenantEntityDto {
    name: string;
    questionnaireId: string;
    questionnaireName: string;
    questionnaireVersion: number;
    projectId: string;
    projectName: string;
    created: Date;
    lastModified: Date;
    started?: Date | undefined;
    completed?: Date | undefined;
    hidden?: Date | undefined;
    state: ContainerInstanceState;
    pages: ContentPageDto[];
    languages: TenantLanguageDto[];
    defaultLanguage: TenantLanguageDto;
    executionLanguage?: TenantLanguageDto | undefined;
    executionInfo?: ContainerInstanceExecutionInfoDto | undefined;
    owner?: ProjectParticipantDto | undefined;
    amountQuestions: number;
    amountAnswers: number;
}

export class PaginatedListOfScheduleDto implements IPaginatedListOfScheduleDto {
    items!: ScheduleDto[];
    pageNumber!: number;
    pageSize!: number;
    totalCount!: number;
    totalPages!: number;
    hasPreviousPage!: boolean;
    hasNextPage!: boolean;

    constructor(data?: IPaginatedListOfScheduleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ScheduleDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            this.totalPages = _data["totalPages"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfScheduleDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfScheduleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["totalPages"] = this.totalPages;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }

    clone(): PaginatedListOfScheduleDto {
        const json = this.toJSON();
        let result = new PaginatedListOfScheduleDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedListOfScheduleDto {
    items: ScheduleDto[];
    pageNumber: number;
    pageSize: number;
    totalCount: number;
    totalPages: number;
    hasPreviousPage: boolean;
    hasNextPage: boolean;
}

export class ScheduleDto implements IScheduleDto {
    id!: string;
    name!: string;
    activated?: Date | undefined;

    constructor(data?: IScheduleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.activated = _data["activated"] ? new Date(_data["activated"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ScheduleDto {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["activated"] = this.activated ? this.activated.toISOString() : undefined as any;
        return data;
    }

    clone(): ScheduleDto {
        const json = this.toJSON();
        let result = new ScheduleDto();
        result.init(json);
        return result;
    }
}

export interface IScheduleDto {
    id: string;
    name: string;
    activated?: Date | undefined;
}

export class ScheduleDetailsDto implements IScheduleDetailsDto {
    id!: string;
    name!: string;
    activated?: Date | undefined;
    processModel!: ProcessModelDto;

    constructor(data?: IScheduleDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.processModel = new ProcessModelDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.activated = _data["activated"] ? new Date(_data["activated"].toString()) : undefined as any;
            this.processModel = _data["processModel"] ? ProcessModelDto.fromJS(_data["processModel"]) : new ProcessModelDto();
        }
    }

    static fromJS(data: any): ScheduleDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduleDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["activated"] = this.activated ? this.activated.toISOString() : undefined as any;
        data["processModel"] = this.processModel ? this.processModel.toJSON() : undefined as any;
        return data;
    }

    clone(): ScheduleDetailsDto {
        const json = this.toJSON();
        let result = new ScheduleDetailsDto();
        result.init(json);
        return result;
    }
}

export interface IScheduleDetailsDto {
    id: string;
    name: string;
    activated?: Date | undefined;
    processModel: ProcessModelDto;
}

export class ProcessModelDto implements IProcessModelDto {
    steps!: StepDto[];
    transitions!: TransitionDto[];

    constructor(data?: IProcessModelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.steps = [];
            this.transitions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["steps"])) {
                this.steps = [] as any;
                for (let item of _data["steps"])
                    this.steps!.push(StepDto.fromJS(item));
            }
            if (Array.isArray(_data["transitions"])) {
                this.transitions = [] as any;
                for (let item of _data["transitions"])
                    this.transitions!.push(TransitionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProcessModelDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessModelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.steps)) {
            data["steps"] = [];
            for (let item of this.steps)
                data["steps"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.transitions)) {
            data["transitions"] = [];
            for (let item of this.transitions)
                data["transitions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): ProcessModelDto {
        const json = this.toJSON();
        let result = new ProcessModelDto();
        result.init(json);
        return result;
    }
}

export interface IProcessModelDto {
    steps: StepDto[];
    transitions: TransitionDto[];
}

export class StepDto implements IStepDto {
    name!: string;
    identifier!: string;
    action!: StepAction;
    rRule?: string | undefined;
    condition?: StepCondition | undefined;
    questionnaireId?: string | undefined;

    constructor(data?: IStepDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.identifier = _data["identifier"];
            this.action = _data["action"];
            this.rRule = _data["rRule"];
            this.condition = _data["condition"] ? StepCondition.fromJS(_data["condition"]) : undefined as any;
            this.questionnaireId = _data["questionnaireId"];
        }
    }

    static fromJS(data: any): StepDto {
        data = typeof data === 'object' ? data : {};
        let result = new StepDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["identifier"] = this.identifier;
        data["action"] = this.action;
        data["rRule"] = this.rRule;
        data["condition"] = this.condition ? this.condition.toJSON() : undefined as any;
        data["questionnaireId"] = this.questionnaireId;
        return data;
    }

    clone(): StepDto {
        const json = this.toJSON();
        let result = new StepDto();
        result.init(json);
        return result;
    }
}

export interface IStepDto {
    name: string;
    identifier: string;
    action: StepAction;
    rRule?: string | undefined;
    condition?: StepCondition | undefined;
    questionnaireId?: string | undefined;
}

export enum StepAction {
    None = "none",
    InstantiateQuestionnaire = "instantiateQuestionnaire",
}

export class StepCondition extends Condition implements IStepCondition {

    constructor(data?: IStepCondition) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): StepCondition {
        data = typeof data === 'object' ? data : {};
        let result = new StepCondition();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): StepCondition {
        const json = this.toJSON();
        let result = new StepCondition();
        result.init(json);
        return result;
    }
}

export interface IStepCondition extends ICondition {
}

export class TransitionDto implements ITransitionDto {
    sourceIdentifier!: string;
    targetIdentifier!: string;
    delay?: string | undefined;

    constructor(data?: ITransitionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceIdentifier = _data["sourceIdentifier"];
            this.targetIdentifier = _data["targetIdentifier"];
            this.delay = _data["delay"];
        }
    }

    static fromJS(data: any): TransitionDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransitionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceIdentifier"] = this.sourceIdentifier;
        data["targetIdentifier"] = this.targetIdentifier;
        data["delay"] = this.delay;
        return data;
    }

    clone(): TransitionDto {
        const json = this.toJSON();
        let result = new TransitionDto();
        result.init(json);
        return result;
    }
}

export interface ITransitionDto {
    sourceIdentifier: string;
    targetIdentifier: string;
    delay?: string | undefined;
}

export class CreateScheduleCommand implements ICreateScheduleCommand {
    name!: string;
    projectId!: string;

    constructor(data?: ICreateScheduleCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.projectId = _data["projectId"];
        }
    }

    static fromJS(data: any): CreateScheduleCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateScheduleCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["projectId"] = this.projectId;
        return data;
    }

    clone(): CreateScheduleCommand {
        const json = this.toJSON();
        let result = new CreateScheduleCommand();
        result.init(json);
        return result;
    }
}

export interface ICreateScheduleCommand {
    name: string;
    projectId: string;
}

export class UpdateScheduleCommand implements IUpdateScheduleCommand {
    scheduleId!: string;
    name!: string;
    steps!: StepDto[];
    transitions!: TransitionDto[];

    constructor(data?: IUpdateScheduleCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.steps = [];
            this.transitions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.scheduleId = _data["scheduleId"];
            this.name = _data["name"];
            if (Array.isArray(_data["steps"])) {
                this.steps = [] as any;
                for (let item of _data["steps"])
                    this.steps!.push(StepDto.fromJS(item));
            }
            if (Array.isArray(_data["transitions"])) {
                this.transitions = [] as any;
                for (let item of _data["transitions"])
                    this.transitions!.push(TransitionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateScheduleCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateScheduleCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scheduleId"] = this.scheduleId;
        data["name"] = this.name;
        if (Array.isArray(this.steps)) {
            data["steps"] = [];
            for (let item of this.steps)
                data["steps"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.transitions)) {
            data["transitions"] = [];
            for (let item of this.transitions)
                data["transitions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): UpdateScheduleCommand {
        const json = this.toJSON();
        let result = new UpdateScheduleCommand();
        result.init(json);
        return result;
    }
}

export interface IUpdateScheduleCommand {
    scheduleId: string;
    name: string;
    steps: StepDto[];
    transitions: TransitionDto[];
}

export class StudyStatisticsDto implements IStudyStatisticsDto {
    amount!: number;

    constructor(data?: IStudyStatisticsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amount = _data["amount"];
        }
    }

    static fromJS(data: any): StudyStatisticsDto {
        data = typeof data === 'object' ? data : {};
        let result = new StudyStatisticsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        return data;
    }

    clone(): StudyStatisticsDto {
        const json = this.toJSON();
        let result = new StudyStatisticsDto();
        result.init(json);
        return result;
    }
}

export interface IStudyStatisticsDto {
    amount: number;
}

export class QuestionnaireStatisticsDto implements IQuestionnaireStatisticsDto {
    amount!: number;
    averageAmountInstances!: number;
    averageAmountCompletedInstances!: number;

    constructor(data?: IQuestionnaireStatisticsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amount = _data["amount"];
            this.averageAmountInstances = _data["averageAmountInstances"];
            this.averageAmountCompletedInstances = _data["averageAmountCompletedInstances"];
        }
    }

    static fromJS(data: any): QuestionnaireStatisticsDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionnaireStatisticsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["averageAmountInstances"] = this.averageAmountInstances;
        data["averageAmountCompletedInstances"] = this.averageAmountCompletedInstances;
        return data;
    }

    clone(): QuestionnaireStatisticsDto {
        const json = this.toJSON();
        let result = new QuestionnaireStatisticsDto();
        result.init(json);
        return result;
    }
}

export interface IQuestionnaireStatisticsDto {
    amount: number;
    averageAmountInstances: number;
    averageAmountCompletedInstances: number;
}

export class ParticipantStatisticsDto implements IParticipantStatisticsDto {
    amount!: number;
    averageAmountStudies!: number;
    averageAmountQuestionnaireInstances!: number;
    averageAmountCompletedQuestionnaireInstances!: number;
    averageAmountAnsweredAnswers!: number;

    constructor(data?: IParticipantStatisticsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amount = _data["amount"];
            this.averageAmountStudies = _data["averageAmountStudies"];
            this.averageAmountQuestionnaireInstances = _data["averageAmountQuestionnaireInstances"];
            this.averageAmountCompletedQuestionnaireInstances = _data["averageAmountCompletedQuestionnaireInstances"];
            this.averageAmountAnsweredAnswers = _data["averageAmountAnsweredAnswers"];
        }
    }

    static fromJS(data: any): ParticipantStatisticsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ParticipantStatisticsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["averageAmountStudies"] = this.averageAmountStudies;
        data["averageAmountQuestionnaireInstances"] = this.averageAmountQuestionnaireInstances;
        data["averageAmountCompletedQuestionnaireInstances"] = this.averageAmountCompletedQuestionnaireInstances;
        data["averageAmountAnsweredAnswers"] = this.averageAmountAnsweredAnswers;
        return data;
    }

    clone(): ParticipantStatisticsDto {
        const json = this.toJSON();
        let result = new ParticipantStatisticsDto();
        result.init(json);
        return result;
    }
}

export interface IParticipantStatisticsDto {
    amount: number;
    averageAmountStudies: number;
    averageAmountQuestionnaireInstances: number;
    averageAmountCompletedQuestionnaireInstances: number;
    averageAmountAnsweredAnswers: number;
}

export class QuestionnaireInstanceStatisticsDto implements IQuestionnaireInstanceStatisticsDto {
    amountTotal!: number;
    amountCompleted!: number;
    interval!: string;
    averageAmountCompletedPerInterval!: number;
    questionnaireInstancesPerInterval!: QuestionnaireInstancesPerIntervalDto[];

    constructor(data?: IQuestionnaireInstanceStatisticsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.questionnaireInstancesPerInterval = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amountTotal = _data["amountTotal"];
            this.amountCompleted = _data["amountCompleted"];
            this.interval = _data["interval"];
            this.averageAmountCompletedPerInterval = _data["averageAmountCompletedPerInterval"];
            if (Array.isArray(_data["questionnaireInstancesPerInterval"])) {
                this.questionnaireInstancesPerInterval = [] as any;
                for (let item of _data["questionnaireInstancesPerInterval"])
                    this.questionnaireInstancesPerInterval!.push(QuestionnaireInstancesPerIntervalDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QuestionnaireInstanceStatisticsDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionnaireInstanceStatisticsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amountTotal"] = this.amountTotal;
        data["amountCompleted"] = this.amountCompleted;
        data["interval"] = this.interval;
        data["averageAmountCompletedPerInterval"] = this.averageAmountCompletedPerInterval;
        if (Array.isArray(this.questionnaireInstancesPerInterval)) {
            data["questionnaireInstancesPerInterval"] = [];
            for (let item of this.questionnaireInstancesPerInterval)
                data["questionnaireInstancesPerInterval"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): QuestionnaireInstanceStatisticsDto {
        const json = this.toJSON();
        let result = new QuestionnaireInstanceStatisticsDto();
        result.init(json);
        return result;
    }
}

export interface IQuestionnaireInstanceStatisticsDto {
    amountTotal: number;
    amountCompleted: number;
    interval: string;
    averageAmountCompletedPerInterval: number;
    questionnaireInstancesPerInterval: QuestionnaireInstancesPerIntervalDto[];
}

export class QuestionnaireInstancesPerIntervalDto implements IQuestionnaireInstancesPerIntervalDto {
    dateTime!: Date;
    amountTotal!: number;
    amountCompleted!: number;

    constructor(data?: IQuestionnaireInstancesPerIntervalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateTime = _data["dateTime"] ? new Date(_data["dateTime"].toString()) : undefined as any;
            this.amountTotal = _data["amountTotal"];
            this.amountCompleted = _data["amountCompleted"];
        }
    }

    static fromJS(data: any): QuestionnaireInstancesPerIntervalDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionnaireInstancesPerIntervalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateTime"] = this.dateTime ? this.dateTime.toISOString() : undefined as any;
        data["amountTotal"] = this.amountTotal;
        data["amountCompleted"] = this.amountCompleted;
        return data;
    }

    clone(): QuestionnaireInstancesPerIntervalDto {
        const json = this.toJSON();
        let result = new QuestionnaireInstancesPerIntervalDto();
        result.init(json);
        return result;
    }
}

export interface IQuestionnaireInstancesPerIntervalDto {
    dateTime: Date;
    amountTotal: number;
    amountCompleted: number;
}

export class GetQuestionnaireInstanceStatisticsQuery implements IGetQuestionnaireInstanceStatisticsQuery {
    projectIds?: string[] | undefined;
    questionnaireIds?: string[] | undefined;
    participantIds?: string[] | undefined;
    groupInterval?: string | undefined;
    from?: Date | undefined;
    until?: Date | undefined;
    anyOfFilterParameters?: QuestionFilterParameter[] | undefined;
    allOfFilterParameters?: QuestionFilterParameter[] | undefined;

    constructor(data?: IGetQuestionnaireInstanceStatisticsQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["projectIds"])) {
                this.projectIds = [] as any;
                for (let item of _data["projectIds"])
                    this.projectIds!.push(item);
            }
            if (Array.isArray(_data["questionnaireIds"])) {
                this.questionnaireIds = [] as any;
                for (let item of _data["questionnaireIds"])
                    this.questionnaireIds!.push(item);
            }
            if (Array.isArray(_data["participantIds"])) {
                this.participantIds = [] as any;
                for (let item of _data["participantIds"])
                    this.participantIds!.push(item);
            }
            this.groupInterval = _data["groupInterval"];
            this.from = _data["from"] ? new Date(_data["from"].toString()) : undefined as any;
            this.until = _data["until"] ? new Date(_data["until"].toString()) : undefined as any;
            if (Array.isArray(_data["anyOfFilterParameters"])) {
                this.anyOfFilterParameters = [] as any;
                for (let item of _data["anyOfFilterParameters"])
                    this.anyOfFilterParameters!.push(QuestionFilterParameter.fromJS(item));
            }
            if (Array.isArray(_data["allOfFilterParameters"])) {
                this.allOfFilterParameters = [] as any;
                for (let item of _data["allOfFilterParameters"])
                    this.allOfFilterParameters!.push(QuestionFilterParameter.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetQuestionnaireInstanceStatisticsQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetQuestionnaireInstanceStatisticsQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.projectIds)) {
            data["projectIds"] = [];
            for (let item of this.projectIds)
                data["projectIds"].push(item);
        }
        if (Array.isArray(this.questionnaireIds)) {
            data["questionnaireIds"] = [];
            for (let item of this.questionnaireIds)
                data["questionnaireIds"].push(item);
        }
        if (Array.isArray(this.participantIds)) {
            data["participantIds"] = [];
            for (let item of this.participantIds)
                data["participantIds"].push(item);
        }
        data["groupInterval"] = this.groupInterval;
        data["from"] = this.from ? this.from.toISOString() : undefined as any;
        data["until"] = this.until ? this.until.toISOString() : undefined as any;
        if (Array.isArray(this.anyOfFilterParameters)) {
            data["anyOfFilterParameters"] = [];
            for (let item of this.anyOfFilterParameters)
                data["anyOfFilterParameters"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.allOfFilterParameters)) {
            data["allOfFilterParameters"] = [];
            for (let item of this.allOfFilterParameters)
                data["allOfFilterParameters"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): GetQuestionnaireInstanceStatisticsQuery {
        const json = this.toJSON();
        let result = new GetQuestionnaireInstanceStatisticsQuery();
        result.init(json);
        return result;
    }
}

export interface IGetQuestionnaireInstanceStatisticsQuery {
    projectIds?: string[] | undefined;
    questionnaireIds?: string[] | undefined;
    participantIds?: string[] | undefined;
    groupInterval?: string | undefined;
    from?: Date | undefined;
    until?: Date | undefined;
    anyOfFilterParameters?: QuestionFilterParameter[] | undefined;
    allOfFilterParameters?: QuestionFilterParameter[] | undefined;
}

export class QuestionFilterParameter implements IQuestionFilterParameter {
    property!: string;
    comparator!: FilterComparator;
    value!: string;

    constructor(data?: IQuestionFilterParameter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.property = _data["property"];
            this.comparator = _data["comparator"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): QuestionFilterParameter {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionFilterParameter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["property"] = this.property;
        data["comparator"] = this.comparator;
        data["value"] = this.value;
        return data;
    }

    clone(): QuestionFilterParameter {
        const json = this.toJSON();
        let result = new QuestionFilterParameter();
        result.init(json);
        return result;
    }
}

export interface IQuestionFilterParameter {
    property: string;
    comparator: FilterComparator;
    value: string;
}

export enum FilterComparator {
    Equals = "equals",
    NotEquals = "notEquals",
    GreaterThan = "greaterThan",
    LessThan = "lessThan",
    GreaterThanOrEqual = "greaterThanOrEqual",
    LessThanOrEqual = "lessThanOrEqual",
    Like = "like",
}

export class QuestionStatisticsDto implements IQuestionStatisticsDto {
    questionId!: string;
    countTotal!: number;
    statistics?: AnswerStatisticsDto | undefined;

    constructor(data?: IQuestionStatisticsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.questionId = _data["questionId"];
            this.countTotal = _data["countTotal"];
            this.statistics = _data["statistics"] ? AnswerStatisticsDto.fromJS(_data["statistics"]) : undefined as any;
        }
    }

    static fromJS(data: any): QuestionStatisticsDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionStatisticsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questionId"] = this.questionId;
        data["countTotal"] = this.countTotal;
        data["statistics"] = this.statistics ? this.statistics.toJSON() : undefined as any;
        return data;
    }

    clone(): QuestionStatisticsDto {
        const json = this.toJSON();
        let result = new QuestionStatisticsDto();
        result.init(json);
        return result;
    }
}

export interface IQuestionStatisticsDto {
    questionId: string;
    countTotal: number;
    statistics?: AnswerStatisticsDto | undefined;
}

export abstract class AnswerStatisticsDto implements IAnswerStatisticsDto {

    protected _discriminator: string;

    constructor(data?: IAnswerStatisticsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        this._discriminator = "AnswerStatisticsDto";
    }

    init(_data?: any) {
    }

    static fromJS(data: any): AnswerStatisticsDto {
        data = typeof data === 'object' ? data : {};
        if (data["$type"] === "ChoiceAnswerStatisticsDto") {
            let result = new ChoiceAnswerStatisticsDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "SliderAnswerStatisticsDto") {
            let result = new SliderAnswerStatisticsDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "TextAnswerStatisticsDto") {
            let result = new TextAnswerStatisticsDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "NumberAnswerStatisticsDto") {
            let result = new NumberAnswerStatisticsDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "DateAnswerStatisticsDto") {
            let result = new DateAnswerStatisticsDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "TimeAnswerStatisticsDto") {
            let result = new TimeAnswerStatisticsDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "DateTimeAnswerStatisticsDto") {
            let result = new DateTimeAnswerStatisticsDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "LikertAnswerStatisticsDto") {
            let result = new LikertAnswerStatisticsDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "ContainerAnswerStatisticsDto") {
            let result = new ContainerAnswerStatisticsDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "BoolAnswerStatisticsDto") {
            let result = new BoolAnswerStatisticsDto();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'AnswerStatisticsDto' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["$type"] = this._discriminator;
        return data;
    }

    clone(): AnswerStatisticsDto {
        throw new Error("The abstract class 'AnswerStatisticsDto' cannot be instantiated.");
    }
}

export interface IAnswerStatisticsDto {
}

export class ChoiceAnswerStatisticsDto extends AnswerStatisticsDto implements IChoiceAnswerStatisticsDto {
    count!: { [key: string]: number; };
    series!: TimeSeriesDtoOfListOfGuid;

    constructor(data?: IChoiceAnswerStatisticsDto) {
        super(data);
        if (!data) {
            this.count = {};
            this.series = new TimeSeriesDtoOfListOfGuid();
        }
        this._discriminator = "ChoiceAnswerStatisticsDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (_data["count"]) {
                this.count = {} as any;
                for (let key in _data["count"]) {
                    if (_data["count"].hasOwnProperty(key))
                        (this.count as any)![key] = _data["count"][key];
                }
            }
            this.series = _data["series"] ? TimeSeriesDtoOfListOfGuid.fromJS(_data["series"]) : new TimeSeriesDtoOfListOfGuid();
        }
    }

    static override fromJS(data: any): ChoiceAnswerStatisticsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChoiceAnswerStatisticsDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.count) {
            data["count"] = {};
            for (let key in this.count) {
                if (this.count.hasOwnProperty(key))
                    (data["count"] as any)[key] = (this.count as any)[key];
            }
        }
        data["series"] = this.series ? this.series.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): ChoiceAnswerStatisticsDto {
        const json = this.toJSON();
        let result = new ChoiceAnswerStatisticsDto();
        result.init(json);
        return result;
    }
}

export interface IChoiceAnswerStatisticsDto extends IAnswerStatisticsDto {
    count: { [key: string]: number; };
    series: TimeSeriesDtoOfListOfGuid;
}

export abstract class SeriesDto implements ISeriesDto {
    name!: string;

    constructor(data?: ISeriesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): SeriesDto {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'SeriesDto' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }

    clone(): SeriesDto {
        throw new Error("The abstract class 'SeriesDto' cannot be instantiated.");
    }
}

export interface ISeriesDto {
    name: string;
}

export class TimeSeriesDtoOfListOfGuid extends SeriesDto implements ITimeSeriesDtoOfListOfGuid {
    values!: TimeSeriesDataPointDtoOfListOfGuid[];

    constructor(data?: ITimeSeriesDtoOfListOfGuid) {
        super(data);
        if (!data) {
            this.values = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(TimeSeriesDataPointDtoOfListOfGuid.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): TimeSeriesDtoOfListOfGuid {
        data = typeof data === 'object' ? data : {};
        let result = new TimeSeriesDtoOfListOfGuid();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): TimeSeriesDtoOfListOfGuid {
        const json = this.toJSON();
        let result = new TimeSeriesDtoOfListOfGuid();
        result.init(json);
        return result;
    }
}

export interface ITimeSeriesDtoOfListOfGuid extends ISeriesDto {
    values: TimeSeriesDataPointDtoOfListOfGuid[];
}

export abstract class DataPointDto implements IDataPointDto {

    constructor(data?: IDataPointDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): DataPointDto {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'DataPointDto' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): DataPointDto {
        throw new Error("The abstract class 'DataPointDto' cannot be instantiated.");
    }
}

export interface IDataPointDto {
}

export class TimeSeriesDataPointDtoOfListOfGuid extends DataPointDto implements ITimeSeriesDataPointDtoOfListOfGuid {
    x!: Date;
    y!: string[];

    constructor(data?: ITimeSeriesDataPointDtoOfListOfGuid) {
        super(data);
        if (!data) {
            this.y = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.x = _data["x"] ? new Date(_data["x"].toString()) : undefined as any;
            if (Array.isArray(_data["y"])) {
                this.y = [] as any;
                for (let item of _data["y"])
                    this.y!.push(item);
            }
        }
    }

    static override fromJS(data: any): TimeSeriesDataPointDtoOfListOfGuid {
        data = typeof data === 'object' ? data : {};
        let result = new TimeSeriesDataPointDtoOfListOfGuid();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["x"] = this.x ? this.x.toISOString() : undefined as any;
        if (Array.isArray(this.y)) {
            data["y"] = [];
            for (let item of this.y)
                data["y"].push(item);
        }
        super.toJSON(data);
        return data;
    }

    clone(): TimeSeriesDataPointDtoOfListOfGuid {
        const json = this.toJSON();
        let result = new TimeSeriesDataPointDtoOfListOfGuid();
        result.init(json);
        return result;
    }
}

export interface ITimeSeriesDataPointDtoOfListOfGuid extends IDataPointDto {
    x: Date;
    y: string[];
}

export class SliderAnswerStatisticsDto extends AnswerStatisticsDto implements ISliderAnswerStatisticsDto {
    min!: number;
    max!: number;
    average!: number;
    percentile25!: number;
    median!: number;
    percentile75!: number;
    count!: { [key: string]: number; };
    series!: TimeSeriesDtoOfDouble;

    constructor(data?: ISliderAnswerStatisticsDto) {
        super(data);
        if (!data) {
            this.count = {};
            this.series = new TimeSeriesDtoOfDouble();
        }
        this._discriminator = "SliderAnswerStatisticsDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.min = _data["min"];
            this.max = _data["max"];
            this.average = _data["average"];
            this.percentile25 = _data["percentile25"];
            this.median = _data["median"];
            this.percentile75 = _data["percentile75"];
            if (_data["count"]) {
                this.count = {} as any;
                for (let key in _data["count"]) {
                    if (_data["count"].hasOwnProperty(key))
                        (this.count as any)![key] = _data["count"][key];
                }
            }
            this.series = _data["series"] ? TimeSeriesDtoOfDouble.fromJS(_data["series"]) : new TimeSeriesDtoOfDouble();
        }
    }

    static override fromJS(data: any): SliderAnswerStatisticsDto {
        data = typeof data === 'object' ? data : {};
        let result = new SliderAnswerStatisticsDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["min"] = this.min;
        data["max"] = this.max;
        data["average"] = this.average;
        data["percentile25"] = this.percentile25;
        data["median"] = this.median;
        data["percentile75"] = this.percentile75;
        if (this.count) {
            data["count"] = {};
            for (let key in this.count) {
                if (this.count.hasOwnProperty(key))
                    (data["count"] as any)[key] = (this.count as any)[key];
            }
        }
        data["series"] = this.series ? this.series.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): SliderAnswerStatisticsDto {
        const json = this.toJSON();
        let result = new SliderAnswerStatisticsDto();
        result.init(json);
        return result;
    }
}

export interface ISliderAnswerStatisticsDto extends IAnswerStatisticsDto {
    min: number;
    max: number;
    average: number;
    percentile25: number;
    median: number;
    percentile75: number;
    count: { [key: string]: number; };
    series: TimeSeriesDtoOfDouble;
}

export class TimeSeriesDtoOfDouble extends SeriesDto implements ITimeSeriesDtoOfDouble {
    values!: TimeSeriesDataPointDtoOfDouble[];

    constructor(data?: ITimeSeriesDtoOfDouble) {
        super(data);
        if (!data) {
            this.values = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(TimeSeriesDataPointDtoOfDouble.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): TimeSeriesDtoOfDouble {
        data = typeof data === 'object' ? data : {};
        let result = new TimeSeriesDtoOfDouble();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): TimeSeriesDtoOfDouble {
        const json = this.toJSON();
        let result = new TimeSeriesDtoOfDouble();
        result.init(json);
        return result;
    }
}

export interface ITimeSeriesDtoOfDouble extends ISeriesDto {
    values: TimeSeriesDataPointDtoOfDouble[];
}

export class TimeSeriesDataPointDtoOfDouble extends DataPointDto implements ITimeSeriesDataPointDtoOfDouble {
    x!: Date;
    y!: number;

    constructor(data?: ITimeSeriesDataPointDtoOfDouble) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.x = _data["x"] ? new Date(_data["x"].toString()) : undefined as any;
            this.y = _data["y"];
        }
    }

    static override fromJS(data: any): TimeSeriesDataPointDtoOfDouble {
        data = typeof data === 'object' ? data : {};
        let result = new TimeSeriesDataPointDtoOfDouble();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["x"] = this.x ? this.x.toISOString() : undefined as any;
        data["y"] = this.y;
        super.toJSON(data);
        return data;
    }

    clone(): TimeSeriesDataPointDtoOfDouble {
        const json = this.toJSON();
        let result = new TimeSeriesDataPointDtoOfDouble();
        result.init(json);
        return result;
    }
}

export interface ITimeSeriesDataPointDtoOfDouble extends IDataPointDto {
    x: Date;
    y: number;
}

export class TextAnswerStatisticsDto extends AnswerStatisticsDto implements ITextAnswerStatisticsDto {
    min!: number;
    max!: number;
    averageChars?: number | undefined;
    averageWords?: number | undefined;
    lengthDistribution?: { [key: string]: number; } | undefined;

    constructor(data?: ITextAnswerStatisticsDto) {
        super(data);
        this._discriminator = "TextAnswerStatisticsDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.min = _data["min"];
            this.max = _data["max"];
            this.averageChars = _data["averageChars"];
            this.averageWords = _data["averageWords"];
            if (_data["lengthDistribution"]) {
                this.lengthDistribution = {} as any;
                for (let key in _data["lengthDistribution"]) {
                    if (_data["lengthDistribution"].hasOwnProperty(key))
                        (this.lengthDistribution as any)![key] = _data["lengthDistribution"][key];
                }
            }
        }
    }

    static override fromJS(data: any): TextAnswerStatisticsDto {
        data = typeof data === 'object' ? data : {};
        let result = new TextAnswerStatisticsDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["min"] = this.min;
        data["max"] = this.max;
        data["averageChars"] = this.averageChars;
        data["averageWords"] = this.averageWords;
        if (this.lengthDistribution) {
            data["lengthDistribution"] = {};
            for (let key in this.lengthDistribution) {
                if (this.lengthDistribution.hasOwnProperty(key))
                    (data["lengthDistribution"] as any)[key] = (this.lengthDistribution as any)[key];
            }
        }
        super.toJSON(data);
        return data;
    }

    clone(): TextAnswerStatisticsDto {
        const json = this.toJSON();
        let result = new TextAnswerStatisticsDto();
        result.init(json);
        return result;
    }
}

export interface ITextAnswerStatisticsDto extends IAnswerStatisticsDto {
    min: number;
    max: number;
    averageChars?: number | undefined;
    averageWords?: number | undefined;
    lengthDistribution?: { [key: string]: number; } | undefined;
}

export class NumberAnswerStatisticsDto extends AnswerStatisticsDto implements INumberAnswerStatisticsDto {
    min!: number;
    max!: number;
    average!: number;
    percentile25!: number;
    median!: number;
    percentile75!: number;

    constructor(data?: INumberAnswerStatisticsDto) {
        super(data);
        this._discriminator = "NumberAnswerStatisticsDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.min = _data["min"];
            this.max = _data["max"];
            this.average = _data["average"];
            this.percentile25 = _data["percentile25"];
            this.median = _data["median"];
            this.percentile75 = _data["percentile75"];
        }
    }

    static override fromJS(data: any): NumberAnswerStatisticsDto {
        data = typeof data === 'object' ? data : {};
        let result = new NumberAnswerStatisticsDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["min"] = this.min;
        data["max"] = this.max;
        data["average"] = this.average;
        data["percentile25"] = this.percentile25;
        data["median"] = this.median;
        data["percentile75"] = this.percentile75;
        super.toJSON(data);
        return data;
    }

    clone(): NumberAnswerStatisticsDto {
        const json = this.toJSON();
        let result = new NumberAnswerStatisticsDto();
        result.init(json);
        return result;
    }
}

export interface INumberAnswerStatisticsDto extends IAnswerStatisticsDto {
    min: number;
    max: number;
    average: number;
    percentile25: number;
    median: number;
    percentile75: number;
}

export class DateAnswerStatisticsDto extends AnswerStatisticsDto implements IDateAnswerStatisticsDto {
    min!: Date;
    max!: Date;
    average?: Date | undefined;
    percentile25?: Date | undefined;
    median?: Date | undefined;
    percentile75?: Date | undefined;
    count?: { [key: string]: number; } | undefined;

    constructor(data?: IDateAnswerStatisticsDto) {
        super(data);
        this._discriminator = "DateAnswerStatisticsDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.min = _data["min"] ? new Date(_data["min"].toString()) : undefined as any;
            this.max = _data["max"] ? new Date(_data["max"].toString()) : undefined as any;
            this.average = _data["average"] ? new Date(_data["average"].toString()) : undefined as any;
            this.percentile25 = _data["percentile25"] ? new Date(_data["percentile25"].toString()) : undefined as any;
            this.median = _data["median"] ? new Date(_data["median"].toString()) : undefined as any;
            this.percentile75 = _data["percentile75"] ? new Date(_data["percentile75"].toString()) : undefined as any;
            if (_data["count"]) {
                this.count = {} as any;
                for (let key in _data["count"]) {
                    if (_data["count"].hasOwnProperty(key))
                        (this.count as any)![key] = _data["count"][key];
                }
            }
        }
    }

    static override fromJS(data: any): DateAnswerStatisticsDto {
        data = typeof data === 'object' ? data : {};
        let result = new DateAnswerStatisticsDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["min"] = this.min ? formatDate(this.min) : undefined as any;
        data["max"] = this.max ? formatDate(this.max) : undefined as any;
        data["average"] = this.average ? formatDate(this.average) : undefined as any;
        data["percentile25"] = this.percentile25 ? formatDate(this.percentile25) : undefined as any;
        data["median"] = this.median ? formatDate(this.median) : undefined as any;
        data["percentile75"] = this.percentile75 ? formatDate(this.percentile75) : undefined as any;
        if (this.count) {
            data["count"] = {};
            for (let key in this.count) {
                if (this.count.hasOwnProperty(key))
                    (data["count"] as any)[key] = (this.count as any)[key];
            }
        }
        super.toJSON(data);
        return data;
    }

    clone(): DateAnswerStatisticsDto {
        const json = this.toJSON();
        let result = new DateAnswerStatisticsDto();
        result.init(json);
        return result;
    }
}

export interface IDateAnswerStatisticsDto extends IAnswerStatisticsDto {
    min: Date;
    max: Date;
    average?: Date | undefined;
    percentile25?: Date | undefined;
    median?: Date | undefined;
    percentile75?: Date | undefined;
    count?: { [key: string]: number; } | undefined;
}

export class TimeAnswerStatisticsDto extends AnswerStatisticsDto implements ITimeAnswerStatisticsDto {
    min!: string;
    max!: string;
    average?: string | undefined;
    percentile25?: string | undefined;
    median?: string | undefined;
    percentile75?: string | undefined;
    count?: { [key: string]: number; } | undefined;

    constructor(data?: ITimeAnswerStatisticsDto) {
        super(data);
        this._discriminator = "TimeAnswerStatisticsDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.min = _data["min"];
            this.max = _data["max"];
            this.average = _data["average"];
            this.percentile25 = _data["percentile25"];
            this.median = _data["median"];
            this.percentile75 = _data["percentile75"];
            if (_data["count"]) {
                this.count = {} as any;
                for (let key in _data["count"]) {
                    if (_data["count"].hasOwnProperty(key))
                        (this.count as any)![key] = _data["count"][key];
                }
            }
        }
    }

    static override fromJS(data: any): TimeAnswerStatisticsDto {
        data = typeof data === 'object' ? data : {};
        let result = new TimeAnswerStatisticsDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["min"] = this.min;
        data["max"] = this.max;
        data["average"] = this.average;
        data["percentile25"] = this.percentile25;
        data["median"] = this.median;
        data["percentile75"] = this.percentile75;
        if (this.count) {
            data["count"] = {};
            for (let key in this.count) {
                if (this.count.hasOwnProperty(key))
                    (data["count"] as any)[key] = (this.count as any)[key];
            }
        }
        super.toJSON(data);
        return data;
    }

    clone(): TimeAnswerStatisticsDto {
        const json = this.toJSON();
        let result = new TimeAnswerStatisticsDto();
        result.init(json);
        return result;
    }
}

export interface ITimeAnswerStatisticsDto extends IAnswerStatisticsDto {
    min: string;
    max: string;
    average?: string | undefined;
    percentile25?: string | undefined;
    median?: string | undefined;
    percentile75?: string | undefined;
    count?: { [key: string]: number; } | undefined;
}

export class DateTimeAnswerStatisticsDto extends AnswerStatisticsDto implements IDateTimeAnswerStatisticsDto {
    min!: Date;
    max!: Date;
    average?: Date | undefined;
    percentile25?: Date | undefined;
    median?: Date | undefined;
    percentile75?: Date | undefined;
    count?: { [key: string]: number; } | undefined;

    constructor(data?: IDateTimeAnswerStatisticsDto) {
        super(data);
        this._discriminator = "DateTimeAnswerStatisticsDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.min = _data["min"] ? new Date(_data["min"].toString()) : undefined as any;
            this.max = _data["max"] ? new Date(_data["max"].toString()) : undefined as any;
            this.average = _data["average"] ? new Date(_data["average"].toString()) : undefined as any;
            this.percentile25 = _data["percentile25"] ? new Date(_data["percentile25"].toString()) : undefined as any;
            this.median = _data["median"] ? new Date(_data["median"].toString()) : undefined as any;
            this.percentile75 = _data["percentile75"] ? new Date(_data["percentile75"].toString()) : undefined as any;
            if (_data["count"]) {
                this.count = {} as any;
                for (let key in _data["count"]) {
                    if (_data["count"].hasOwnProperty(key))
                        (this.count as any)![key] = _data["count"][key];
                }
            }
        }
    }

    static override fromJS(data: any): DateTimeAnswerStatisticsDto {
        data = typeof data === 'object' ? data : {};
        let result = new DateTimeAnswerStatisticsDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["min"] = this.min ? this.min.toISOString() : undefined as any;
        data["max"] = this.max ? this.max.toISOString() : undefined as any;
        data["average"] = this.average ? this.average.toISOString() : undefined as any;
        data["percentile25"] = this.percentile25 ? this.percentile25.toISOString() : undefined as any;
        data["median"] = this.median ? this.median.toISOString() : undefined as any;
        data["percentile75"] = this.percentile75 ? this.percentile75.toISOString() : undefined as any;
        if (this.count) {
            data["count"] = {};
            for (let key in this.count) {
                if (this.count.hasOwnProperty(key))
                    (data["count"] as any)[key] = (this.count as any)[key];
            }
        }
        super.toJSON(data);
        return data;
    }

    clone(): DateTimeAnswerStatisticsDto {
        const json = this.toJSON();
        let result = new DateTimeAnswerStatisticsDto();
        result.init(json);
        return result;
    }
}

export interface IDateTimeAnswerStatisticsDto extends IAnswerStatisticsDto {
    min: Date;
    max: Date;
    average?: Date | undefined;
    percentile25?: Date | undefined;
    median?: Date | undefined;
    percentile75?: Date | undefined;
    count?: { [key: string]: number; } | undefined;
}

export class LikertAnswerStatisticsDto extends AnswerStatisticsDto implements ILikertAnswerStatisticsDto {
    count!: { [key: string]: number; };

    constructor(data?: ILikertAnswerStatisticsDto) {
        super(data);
        if (!data) {
            this.count = {};
        }
        this._discriminator = "LikertAnswerStatisticsDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (_data["count"]) {
                this.count = {} as any;
                for (let key in _data["count"]) {
                    if (_data["count"].hasOwnProperty(key))
                        (this.count as any)![key] = _data["count"][key];
                }
            }
        }
    }

    static override fromJS(data: any): LikertAnswerStatisticsDto {
        data = typeof data === 'object' ? data : {};
        let result = new LikertAnswerStatisticsDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.count) {
            data["count"] = {};
            for (let key in this.count) {
                if (this.count.hasOwnProperty(key))
                    (data["count"] as any)[key] = (this.count as any)[key];
            }
        }
        super.toJSON(data);
        return data;
    }

    clone(): LikertAnswerStatisticsDto {
        const json = this.toJSON();
        let result = new LikertAnswerStatisticsDto();
        result.init(json);
        return result;
    }
}

export interface ILikertAnswerStatisticsDto extends IAnswerStatisticsDto {
    count: { [key: string]: number; };
}

export class ContainerAnswerStatisticsDto extends AnswerStatisticsDto implements IContainerAnswerStatisticsDto {
    count!: { [key: string]: number; };
    containers!: { [key: string]: TenantEntityDto; };

    constructor(data?: IContainerAnswerStatisticsDto) {
        super(data);
        if (!data) {
            this.count = {};
            this.containers = {};
        }
        this._discriminator = "ContainerAnswerStatisticsDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (_data["count"]) {
                this.count = {} as any;
                for (let key in _data["count"]) {
                    if (_data["count"].hasOwnProperty(key))
                        (this.count as any)![key] = _data["count"][key];
                }
            }
            if (_data["containers"]) {
                this.containers = {} as any;
                for (let key in _data["containers"]) {
                    if (_data["containers"].hasOwnProperty(key))
                        (this.containers as any)![key] = _data["containers"][key] ? TenantEntityDto.fromJS(_data["containers"][key]) : new TenantEntityDto();
                }
            }
        }
    }

    static override fromJS(data: any): ContainerAnswerStatisticsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContainerAnswerStatisticsDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.count) {
            data["count"] = {};
            for (let key in this.count) {
                if (this.count.hasOwnProperty(key))
                    (data["count"] as any)[key] = (this.count as any)[key];
            }
        }
        if (this.containers) {
            data["containers"] = {};
            for (let key in this.containers) {
                if (this.containers.hasOwnProperty(key))
                    (data["containers"] as any)[key] = this.containers[key] ? this.containers[key].toJSON() : undefined as any;
            }
        }
        super.toJSON(data);
        return data;
    }

    clone(): ContainerAnswerStatisticsDto {
        const json = this.toJSON();
        let result = new ContainerAnswerStatisticsDto();
        result.init(json);
        return result;
    }
}

export interface IContainerAnswerStatisticsDto extends IAnswerStatisticsDto {
    count: { [key: string]: number; };
    containers: { [key: string]: TenantEntityDto; };
}

export class BoolAnswerStatisticsDto extends AnswerStatisticsDto implements IBoolAnswerStatisticsDto {
    trueCount!: number;
    falseCount!: number;

    constructor(data?: IBoolAnswerStatisticsDto) {
        super(data);
        this._discriminator = "BoolAnswerStatisticsDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.trueCount = _data["trueCount"];
            this.falseCount = _data["falseCount"];
        }
    }

    static override fromJS(data: any): BoolAnswerStatisticsDto {
        data = typeof data === 'object' ? data : {};
        let result = new BoolAnswerStatisticsDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["trueCount"] = this.trueCount;
        data["falseCount"] = this.falseCount;
        super.toJSON(data);
        return data;
    }

    clone(): BoolAnswerStatisticsDto {
        const json = this.toJSON();
        let result = new BoolAnswerStatisticsDto();
        result.init(json);
        return result;
    }
}

export interface IBoolAnswerStatisticsDto extends IAnswerStatisticsDto {
    trueCount: number;
    falseCount: number;
}

export class GetQuestionStatisticsQuery implements IGetQuestionStatisticsQuery {
    questionId!: string;
    participantIds?: string[] | undefined;
    from?: Date | undefined;
    until?: Date | undefined;
    anyOfFilterParameters?: QuestionFilterParameter[] | undefined;
    allOfFilterParameters?: QuestionFilterParameter[] | undefined;

    constructor(data?: IGetQuestionStatisticsQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.questionId = _data["questionId"];
            if (Array.isArray(_data["participantIds"])) {
                this.participantIds = [] as any;
                for (let item of _data["participantIds"])
                    this.participantIds!.push(item);
            }
            this.from = _data["from"] ? new Date(_data["from"].toString()) : undefined as any;
            this.until = _data["until"] ? new Date(_data["until"].toString()) : undefined as any;
            if (Array.isArray(_data["anyOfFilterParameters"])) {
                this.anyOfFilterParameters = [] as any;
                for (let item of _data["anyOfFilterParameters"])
                    this.anyOfFilterParameters!.push(QuestionFilterParameter.fromJS(item));
            }
            if (Array.isArray(_data["allOfFilterParameters"])) {
                this.allOfFilterParameters = [] as any;
                for (let item of _data["allOfFilterParameters"])
                    this.allOfFilterParameters!.push(QuestionFilterParameter.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetQuestionStatisticsQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetQuestionStatisticsQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questionId"] = this.questionId;
        if (Array.isArray(this.participantIds)) {
            data["participantIds"] = [];
            for (let item of this.participantIds)
                data["participantIds"].push(item);
        }
        data["from"] = this.from ? this.from.toISOString() : undefined as any;
        data["until"] = this.until ? this.until.toISOString() : undefined as any;
        if (Array.isArray(this.anyOfFilterParameters)) {
            data["anyOfFilterParameters"] = [];
            for (let item of this.anyOfFilterParameters)
                data["anyOfFilterParameters"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.allOfFilterParameters)) {
            data["allOfFilterParameters"] = [];
            for (let item of this.allOfFilterParameters)
                data["allOfFilterParameters"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): GetQuestionStatisticsQuery {
        const json = this.toJSON();
        let result = new GetQuestionStatisticsQuery();
        result.init(json);
        return result;
    }
}

export interface IGetQuestionStatisticsQuery {
    questionId: string;
    participantIds?: string[] | undefined;
    from?: Date | undefined;
    until?: Date | undefined;
    anyOfFilterParameters?: QuestionFilterParameter[] | undefined;
    allOfFilterParameters?: QuestionFilterParameter[] | undefined;
}

export class PaginatedListOfStudyDto implements IPaginatedListOfStudyDto {
    items!: StudyDto[];
    pageNumber!: number;
    pageSize!: number;
    totalCount!: number;
    totalPages!: number;
    hasPreviousPage!: boolean;
    hasNextPage!: boolean;

    constructor(data?: IPaginatedListOfStudyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(StudyDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            this.totalPages = _data["totalPages"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfStudyDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfStudyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["totalPages"] = this.totalPages;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }

    clone(): PaginatedListOfStudyDto {
        const json = this.toJSON();
        let result = new PaginatedListOfStudyDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedListOfStudyDto {
    items: StudyDto[];
    pageNumber: number;
    pageSize: number;
    totalCount: number;
    totalPages: number;
    hasPreviousPage: boolean;
    hasNextPage: boolean;
}

export abstract class ProjectDto extends TenantEntityDto implements IProjectDto {
    name!: string;
    title!: InternationalizedString;
    shortDescription!: InternationalizedString;
    asset?: AssetDto | undefined;
    published?: Date | undefined;
    visibility!: ProjectVisibility;
    languages!: TenantLanguageDto[];

    constructor(data?: IProjectDto) {
        super(data);
        if (!data) {
            this.title = new InternationalizedString();
            this.shortDescription = new InternationalizedString();
            this.languages = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.title = _data["title"] ? InternationalizedString.fromJS(_data["title"]) : new InternationalizedString();
            this.shortDescription = _data["shortDescription"] ? InternationalizedString.fromJS(_data["shortDescription"]) : new InternationalizedString();
            this.asset = _data["asset"] ? AssetDto.fromJS(_data["asset"]) : undefined as any;
            this.published = _data["published"] ? new Date(_data["published"].toString()) : undefined as any;
            this.visibility = _data["visibility"];
            if (Array.isArray(_data["languages"])) {
                this.languages = [] as any;
                for (let item of _data["languages"])
                    this.languages!.push(TenantLanguageDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ProjectDto {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ProjectDto' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["title"] = this.title ? this.title.toJSON() : undefined as any;
        data["shortDescription"] = this.shortDescription ? this.shortDescription.toJSON() : undefined as any;
        data["asset"] = this.asset ? this.asset.toJSON() : undefined as any;
        data["published"] = this.published ? this.published.toISOString() : undefined as any;
        data["visibility"] = this.visibility;
        if (Array.isArray(this.languages)) {
            data["languages"] = [];
            for (let item of this.languages)
                data["languages"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): ProjectDto {
        throw new Error("The abstract class 'ProjectDto' cannot be instantiated.");
    }
}

export interface IProjectDto extends ITenantEntityDto {
    name: string;
    title: InternationalizedString;
    shortDescription: InternationalizedString;
    asset?: AssetDto | undefined;
    published?: Date | undefined;
    visibility: ProjectVisibility;
    languages: TenantLanguageDto[];
}

export class StudyDto extends ProjectDto implements IStudyDto {

    constructor(data?: IStudyDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): StudyDto {
        data = typeof data === 'object' ? data : {};
        let result = new StudyDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): StudyDto {
        const json = this.toJSON();
        let result = new StudyDto();
        result.init(json);
        return result;
    }
}

export interface IStudyDto extends IProjectDto {
}

export enum ProjectVisibility {
    Private = "private",
    Internal = "internal",
    Public = "public",
}

export abstract class ProjectDetailsDto implements IProjectDetailsDto {
    id!: string;
    name!: string;
    title!: InternationalizedString;
    shortDescription!: InternationalizedString;
    description!: InternationalizedDocument;
    defaultLanguage!: TenantLanguageDto;
    languages!: TenantLanguageDto[];
    asset?: AssetDto | undefined;
    assetFolder?: AssetFolderDto | undefined;
    published?: Date | undefined;
    visibility!: ProjectVisibility;
    permissions!: Permission[];
    consentTemplate?: ConsentTemplateDto | undefined;

    constructor(data?: IProjectDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.title = new InternationalizedString();
            this.shortDescription = new InternationalizedString();
            this.description = new InternationalizedDocument();
            this.defaultLanguage = new TenantLanguageDto();
            this.languages = [];
            this.permissions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.title = _data["title"] ? InternationalizedString.fromJS(_data["title"]) : new InternationalizedString();
            this.shortDescription = _data["shortDescription"] ? InternationalizedString.fromJS(_data["shortDescription"]) : new InternationalizedString();
            this.description = _data["description"] ? InternationalizedDocument.fromJS(_data["description"]) : new InternationalizedDocument();
            this.defaultLanguage = _data["defaultLanguage"] ? TenantLanguageDto.fromJS(_data["defaultLanguage"]) : new TenantLanguageDto();
            if (Array.isArray(_data["languages"])) {
                this.languages = [] as any;
                for (let item of _data["languages"])
                    this.languages!.push(TenantLanguageDto.fromJS(item));
            }
            this.asset = _data["asset"] ? AssetDto.fromJS(_data["asset"]) : undefined as any;
            this.assetFolder = _data["assetFolder"] ? AssetFolderDto.fromJS(_data["assetFolder"]) : undefined as any;
            this.published = _data["published"] ? new Date(_data["published"].toString()) : undefined as any;
            this.visibility = _data["visibility"];
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(item);
            }
            this.consentTemplate = _data["consentTemplate"] ? ConsentTemplateDto.fromJS(_data["consentTemplate"]) : undefined as any;
        }
    }

    static fromJS(data: any): ProjectDetailsDto {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ProjectDetailsDto' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["title"] = this.title ? this.title.toJSON() : undefined as any;
        data["shortDescription"] = this.shortDescription ? this.shortDescription.toJSON() : undefined as any;
        data["description"] = this.description ? this.description.toJSON() : undefined as any;
        data["defaultLanguage"] = this.defaultLanguage ? this.defaultLanguage.toJSON() : undefined as any;
        if (Array.isArray(this.languages)) {
            data["languages"] = [];
            for (let item of this.languages)
                data["languages"].push(item ? item.toJSON() : undefined as any);
        }
        data["asset"] = this.asset ? this.asset.toJSON() : undefined as any;
        data["assetFolder"] = this.assetFolder ? this.assetFolder.toJSON() : undefined as any;
        data["published"] = this.published ? this.published.toISOString() : undefined as any;
        data["visibility"] = this.visibility;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item);
        }
        data["consentTemplate"] = this.consentTemplate ? this.consentTemplate.toJSON() : undefined as any;
        return data;
    }

    clone(): ProjectDetailsDto {
        throw new Error("The abstract class 'ProjectDetailsDto' cannot be instantiated.");
    }
}

export interface IProjectDetailsDto {
    id: string;
    name: string;
    title: InternationalizedString;
    shortDescription: InternationalizedString;
    description: InternationalizedDocument;
    defaultLanguage: TenantLanguageDto;
    languages: TenantLanguageDto[];
    asset?: AssetDto | undefined;
    assetFolder?: AssetFolderDto | undefined;
    published?: Date | undefined;
    visibility: ProjectVisibility;
    permissions: Permission[];
    consentTemplate?: ConsentTemplateDto | undefined;
}

export class StudyDetailsDto extends ProjectDetailsDto implements IStudyDetailsDto {

    constructor(data?: IStudyDetailsDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): StudyDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new StudyDetailsDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): StudyDetailsDto {
        const json = this.toJSON();
        let result = new StudyDetailsDto();
        result.init(json);
        return result;
    }
}

export interface IStudyDetailsDto extends IProjectDetailsDto {
}

export enum Permission {
    CanEditPages = "canEditPages",
    CanEditContainers = "canEditContainers",
    CanEditSchedules = "canEditSchedules",
    CanEditAssets = "canEditAssets",
    CanEditParticipants = "canEditParticipants",
    CanEditAdministrators = "canEditAdministrators",
    CanEditSettings = "canEditSettings",
    CanReadContainerInstances = "canReadContainerInstances",
    CanEditContainerInstances = "canEditContainerInstances",
    CanReadLicenses = "canReadLicenses",
    CanEditLicenses = "canEditLicenses",
    CanEditConsentTemplates = "canEditConsentTemplates",
    CanReadConsents = "canReadConsents",
}

export class CreateStudyCommand implements ICreateStudyCommand {
    name!: string;

    constructor(data?: ICreateStudyCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreateStudyCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateStudyCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }

    clone(): CreateStudyCommand {
        const json = this.toJSON();
        let result = new CreateStudyCommand();
        result.init(json);
        return result;
    }
}

export interface ICreateStudyCommand {
    name: string;
}

export class UpdateStudyCommand implements IUpdateStudyCommand {
    studyId!: string;
    name!: string;
    title!: InternationalizedString;
    shortDescription!: InternationalizedString;
    description!: InternationalizedDocument;
    defaultLanguageId!: string;
    languageIds!: string[];
    visibility!: ProjectVisibility;
    assetId?: string | undefined;

    constructor(data?: IUpdateStudyCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.title = new InternationalizedString();
            this.shortDescription = new InternationalizedString();
            this.description = new InternationalizedDocument();
            this.languageIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.studyId = _data["studyId"];
            this.name = _data["name"];
            this.title = _data["title"] ? InternationalizedString.fromJS(_data["title"]) : new InternationalizedString();
            this.shortDescription = _data["shortDescription"] ? InternationalizedString.fromJS(_data["shortDescription"]) : new InternationalizedString();
            this.description = _data["description"] ? InternationalizedDocument.fromJS(_data["description"]) : new InternationalizedDocument();
            this.defaultLanguageId = _data["defaultLanguageId"];
            if (Array.isArray(_data["languageIds"])) {
                this.languageIds = [] as any;
                for (let item of _data["languageIds"])
                    this.languageIds!.push(item);
            }
            this.visibility = _data["visibility"];
            this.assetId = _data["assetId"];
        }
    }

    static fromJS(data: any): UpdateStudyCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateStudyCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studyId"] = this.studyId;
        data["name"] = this.name;
        data["title"] = this.title ? this.title.toJSON() : undefined as any;
        data["shortDescription"] = this.shortDescription ? this.shortDescription.toJSON() : undefined as any;
        data["description"] = this.description ? this.description.toJSON() : undefined as any;
        data["defaultLanguageId"] = this.defaultLanguageId;
        if (Array.isArray(this.languageIds)) {
            data["languageIds"] = [];
            for (let item of this.languageIds)
                data["languageIds"].push(item);
        }
        data["visibility"] = this.visibility;
        data["assetId"] = this.assetId;
        return data;
    }

    clone(): UpdateStudyCommand {
        const json = this.toJSON();
        let result = new UpdateStudyCommand();
        result.init(json);
        return result;
    }
}

export interface IUpdateStudyCommand {
    studyId: string;
    name: string;
    title: InternationalizedString;
    shortDescription: InternationalizedString;
    description: InternationalizedDocument;
    defaultLanguageId: string;
    languageIds: string[];
    visibility: ProjectVisibility;
    assetId?: string | undefined;
}

export class QrCodeDto implements IQrCodeDto {
    base64QrCode!: string;
    qrCodeUrl!: string;

    constructor(data?: IQrCodeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.base64QrCode = _data["base64QrCode"];
            this.qrCodeUrl = _data["qrCodeUrl"];
        }
    }

    static fromJS(data: any): QrCodeDto {
        data = typeof data === 'object' ? data : {};
        let result = new QrCodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["base64QrCode"] = this.base64QrCode;
        data["qrCodeUrl"] = this.qrCodeUrl;
        return data;
    }

    clone(): QrCodeDto {
        const json = this.toJSON();
        let result = new QrCodeDto();
        result.init(json);
        return result;
    }
}

export interface IQrCodeDto {
    base64QrCode: string;
    qrCodeUrl: string;
}

export class PaginatedListOfProjectParticipantDto implements IPaginatedListOfProjectParticipantDto {
    items!: ProjectParticipantDto[];
    pageNumber!: number;
    pageSize!: number;
    totalCount!: number;
    totalPages!: number;
    hasPreviousPage!: boolean;
    hasNextPage!: boolean;

    constructor(data?: IPaginatedListOfProjectParticipantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ProjectParticipantDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            this.totalPages = _data["totalPages"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfProjectParticipantDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfProjectParticipantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["totalPages"] = this.totalPages;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }

    clone(): PaginatedListOfProjectParticipantDto {
        const json = this.toJSON();
        let result = new PaginatedListOfProjectParticipantDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedListOfProjectParticipantDto {
    items: ProjectParticipantDto[];
    pageNumber: number;
    pageSize: number;
    totalCount: number;
    totalPages: number;
    hasPreviousPage: boolean;
    hasNextPage: boolean;
}

export class PaginatedListOfProjectAdministratorDto implements IPaginatedListOfProjectAdministratorDto {
    items!: ProjectAdministratorDto[];
    pageNumber!: number;
    pageSize!: number;
    totalCount!: number;
    totalPages!: number;
    hasPreviousPage!: boolean;
    hasNextPage!: boolean;

    constructor(data?: IPaginatedListOfProjectAdministratorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ProjectAdministratorDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            this.totalPages = _data["totalPages"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfProjectAdministratorDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfProjectAdministratorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["totalPages"] = this.totalPages;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }

    clone(): PaginatedListOfProjectAdministratorDto {
        const json = this.toJSON();
        let result = new PaginatedListOfProjectAdministratorDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedListOfProjectAdministratorDto {
    items: ProjectAdministratorDto[];
    pageNumber: number;
    pageSize: number;
    totalCount: number;
    totalPages: number;
    hasPreviousPage: boolean;
    hasNextPage: boolean;
}

export class ProjectAdministratorDto implements IProjectAdministratorDto {
    user!: UserDto;
    projectId!: string;
    permissions!: Permission[];

    constructor(data?: IProjectAdministratorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.user = new UserDto();
            this.permissions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? UserDto.fromJS(_data["user"]) : new UserDto();
            this.projectId = _data["projectId"];
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(item);
            }
        }
    }

    static fromJS(data: any): ProjectAdministratorDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectAdministratorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        data["projectId"] = this.projectId;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item);
        }
        return data;
    }

    clone(): ProjectAdministratorDto {
        const json = this.toJSON();
        let result = new ProjectAdministratorDto();
        result.init(json);
        return result;
    }
}

export interface IProjectAdministratorDto {
    user: UserDto;
    projectId: string;
    permissions: Permission[];
}

export class CreateProjectConsentTemplateCommand implements ICreateProjectConsentTemplateCommand {
    name!: string;
    projectId!: string;

    constructor(data?: ICreateProjectConsentTemplateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.projectId = _data["projectId"];
        }
    }

    static fromJS(data: any): CreateProjectConsentTemplateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateProjectConsentTemplateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["projectId"] = this.projectId;
        return data;
    }

    clone(): CreateProjectConsentTemplateCommand {
        const json = this.toJSON();
        let result = new CreateProjectConsentTemplateCommand();
        result.init(json);
        return result;
    }
}

export interface ICreateProjectConsentTemplateCommand {
    name: string;
    projectId: string;
}

export class TenantDetailsDto implements ITenantDetailsDto {
    id!: string;
    title!: InternationalizedString;
    shortDescription!: InternationalizedString;
    description!: InternationalizedDocument;
    defaultLanguage!: TenantLanguageDto;
    languages!: TenantLanguageDto[];
    asset?: AssetDto | undefined;
    permissions!: Permission[];
    iosLinksConfiguration?: string | undefined;
    androidLinksConfiguration?: string | undefined;

    constructor(data?: ITenantDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.title = new InternationalizedString();
            this.shortDescription = new InternationalizedString();
            this.description = new InternationalizedDocument();
            this.defaultLanguage = new TenantLanguageDto();
            this.languages = [];
            this.permissions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"] ? InternationalizedString.fromJS(_data["title"]) : new InternationalizedString();
            this.shortDescription = _data["shortDescription"] ? InternationalizedString.fromJS(_data["shortDescription"]) : new InternationalizedString();
            this.description = _data["description"] ? InternationalizedDocument.fromJS(_data["description"]) : new InternationalizedDocument();
            this.defaultLanguage = _data["defaultLanguage"] ? TenantLanguageDto.fromJS(_data["defaultLanguage"]) : new TenantLanguageDto();
            if (Array.isArray(_data["languages"])) {
                this.languages = [] as any;
                for (let item of _data["languages"])
                    this.languages!.push(TenantLanguageDto.fromJS(item));
            }
            this.asset = _data["asset"] ? AssetDto.fromJS(_data["asset"]) : undefined as any;
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(item);
            }
            this.iosLinksConfiguration = _data["iosLinksConfiguration"];
            this.androidLinksConfiguration = _data["androidLinksConfiguration"];
        }
    }

    static fromJS(data: any): TenantDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title ? this.title.toJSON() : undefined as any;
        data["shortDescription"] = this.shortDescription ? this.shortDescription.toJSON() : undefined as any;
        data["description"] = this.description ? this.description.toJSON() : undefined as any;
        data["defaultLanguage"] = this.defaultLanguage ? this.defaultLanguage.toJSON() : undefined as any;
        if (Array.isArray(this.languages)) {
            data["languages"] = [];
            for (let item of this.languages)
                data["languages"].push(item ? item.toJSON() : undefined as any);
        }
        data["asset"] = this.asset ? this.asset.toJSON() : undefined as any;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item);
        }
        data["iosLinksConfiguration"] = this.iosLinksConfiguration;
        data["androidLinksConfiguration"] = this.androidLinksConfiguration;
        return data;
    }

    clone(): TenantDetailsDto {
        const json = this.toJSON();
        let result = new TenantDetailsDto();
        result.init(json);
        return result;
    }
}

export interface ITenantDetailsDto {
    id: string;
    title: InternationalizedString;
    shortDescription: InternationalizedString;
    description: InternationalizedDocument;
    defaultLanguage: TenantLanguageDto;
    languages: TenantLanguageDto[];
    asset?: AssetDto | undefined;
    permissions: Permission[];
    iosLinksConfiguration?: string | undefined;
    androidLinksConfiguration?: string | undefined;
}

export class DeploymentInformation implements IDeploymentInformation {
    databaseActualSizeBytes!: number;

    constructor(data?: IDeploymentInformation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.databaseActualSizeBytes = _data["databaseActualSizeBytes"];
        }
    }

    static fromJS(data: any): DeploymentInformation {
        data = typeof data === 'object' ? data : {};
        let result = new DeploymentInformation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["databaseActualSizeBytes"] = this.databaseActualSizeBytes;
        return data;
    }

    clone(): DeploymentInformation {
        const json = this.toJSON();
        let result = new DeploymentInformation();
        result.init(json);
        return result;
    }
}

export interface IDeploymentInformation {
    databaseActualSizeBytes: number;
}

export class UpdateTenantCommand implements IUpdateTenantCommand {
    title!: InternationalizedString;
    shortDescription!: InternationalizedString;
    description!: InternationalizedDocument;
    iosLinksConfiguration?: string | undefined;
    androidLinksConfiguration?: string | undefined;
    assetId?: string | undefined;

    constructor(data?: IUpdateTenantCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.title = new InternationalizedString();
            this.shortDescription = new InternationalizedString();
            this.description = new InternationalizedDocument();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"] ? InternationalizedString.fromJS(_data["title"]) : new InternationalizedString();
            this.shortDescription = _data["shortDescription"] ? InternationalizedString.fromJS(_data["shortDescription"]) : new InternationalizedString();
            this.description = _data["description"] ? InternationalizedDocument.fromJS(_data["description"]) : new InternationalizedDocument();
            this.iosLinksConfiguration = _data["iosLinksConfiguration"];
            this.androidLinksConfiguration = _data["androidLinksConfiguration"];
            this.assetId = _data["assetId"];
        }
    }

    static fromJS(data: any): UpdateTenantCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTenantCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title ? this.title.toJSON() : undefined as any;
        data["shortDescription"] = this.shortDescription ? this.shortDescription.toJSON() : undefined as any;
        data["description"] = this.description ? this.description.toJSON() : undefined as any;
        data["iosLinksConfiguration"] = this.iosLinksConfiguration;
        data["androidLinksConfiguration"] = this.androidLinksConfiguration;
        data["assetId"] = this.assetId;
        return data;
    }

    clone(): UpdateTenantCommand {
        const json = this.toJSON();
        let result = new UpdateTenantCommand();
        result.init(json);
        return result;
    }
}

export interface IUpdateTenantCommand {
    title: InternationalizedString;
    shortDescription: InternationalizedString;
    description: InternationalizedDocument;
    iosLinksConfiguration?: string | undefined;
    androidLinksConfiguration?: string | undefined;
    assetId?: string | undefined;
}

export class PaginatedListOfTenantAdministratorDto implements IPaginatedListOfTenantAdministratorDto {
    items!: TenantAdministratorDto[];
    pageNumber!: number;
    pageSize!: number;
    totalCount!: number;
    totalPages!: number;
    hasPreviousPage!: boolean;
    hasNextPage!: boolean;

    constructor(data?: IPaginatedListOfTenantAdministratorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TenantAdministratorDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            this.totalPages = _data["totalPages"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfTenantAdministratorDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfTenantAdministratorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["totalPages"] = this.totalPages;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }

    clone(): PaginatedListOfTenantAdministratorDto {
        const json = this.toJSON();
        let result = new PaginatedListOfTenantAdministratorDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedListOfTenantAdministratorDto {
    items: TenantAdministratorDto[];
    pageNumber: number;
    pageSize: number;
    totalCount: number;
    totalPages: number;
    hasPreviousPage: boolean;
    hasNextPage: boolean;
}

export class TenantAdministratorDto implements ITenantAdministratorDto {
    user!: UserDto;
    tenantId!: string;
    permissions!: Permission[];

    constructor(data?: ITenantAdministratorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.user = new UserDto();
            this.permissions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? UserDto.fromJS(_data["user"]) : new UserDto();
            this.tenantId = _data["tenantId"];
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(item);
            }
        }
    }

    static fromJS(data: any): TenantAdministratorDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantAdministratorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        data["tenantId"] = this.tenantId;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item);
        }
        return data;
    }

    clone(): TenantAdministratorDto {
        const json = this.toJSON();
        let result = new TenantAdministratorDto();
        result.init(json);
        return result;
    }
}

export interface ITenantAdministratorDto {
    user: UserDto;
    tenantId: string;
    permissions: Permission[];
}

export class PaginatedListOfTenantParticipantDto implements IPaginatedListOfTenantParticipantDto {
    items!: TenantParticipantDto[];
    pageNumber!: number;
    pageSize!: number;
    totalCount!: number;
    totalPages!: number;
    hasPreviousPage!: boolean;
    hasNextPage!: boolean;

    constructor(data?: IPaginatedListOfTenantParticipantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TenantParticipantDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            this.totalPages = _data["totalPages"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfTenantParticipantDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfTenantParticipantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["totalPages"] = this.totalPages;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }

    clone(): PaginatedListOfTenantParticipantDto {
        const json = this.toJSON();
        let result = new PaginatedListOfTenantParticipantDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedListOfTenantParticipantDto {
    items: TenantParticipantDto[];
    pageNumber: number;
    pageSize: number;
    totalCount: number;
    totalPages: number;
    hasPreviousPage: boolean;
    hasNextPage: boolean;
}

export class TenantParticipantDto implements ITenantParticipantDto {
    user!: UserDto;
    tenantId!: string;
    created?: Date | undefined;
    invited?: Date | undefined;
    enrolled?: Date | undefined;
    withdrawn?: Date | undefined;
    status!: TenantParticipantStatus;

    constructor(data?: ITenantParticipantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.user = new UserDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? UserDto.fromJS(_data["user"]) : new UserDto();
            this.tenantId = _data["tenantId"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.invited = _data["invited"] ? new Date(_data["invited"].toString()) : undefined as any;
            this.enrolled = _data["enrolled"] ? new Date(_data["enrolled"].toString()) : undefined as any;
            this.withdrawn = _data["withdrawn"] ? new Date(_data["withdrawn"].toString()) : undefined as any;
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): TenantParticipantDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantParticipantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        data["tenantId"] = this.tenantId;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["invited"] = this.invited ? this.invited.toISOString() : undefined as any;
        data["enrolled"] = this.enrolled ? this.enrolled.toISOString() : undefined as any;
        data["withdrawn"] = this.withdrawn ? this.withdrawn.toISOString() : undefined as any;
        data["status"] = this.status;
        return data;
    }

    clone(): TenantParticipantDto {
        const json = this.toJSON();
        let result = new TenantParticipantDto();
        result.init(json);
        return result;
    }
}

export interface ITenantParticipantDto {
    user: UserDto;
    tenantId: string;
    created?: Date | undefined;
    invited?: Date | undefined;
    enrolled?: Date | undefined;
    withdrawn?: Date | undefined;
    status: TenantParticipantStatus;
}

export enum TenantParticipantStatus {
    Created = "created",
    Invited = "invited",
    Enrolled = "enrolled",
    Withdrawn = "withdrawn",
}

export class TenantLicensingStatusDto implements ITenantLicensingStatusDto {
    licensingEnabled!: boolean;

    constructor(data?: ITenantLicensingStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.licensingEnabled = _data["licensingEnabled"];
        }
    }

    static fromJS(data: any): TenantLicensingStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantLicensingStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["licensingEnabled"] = this.licensingEnabled;
        return data;
    }

    clone(): TenantLicensingStatusDto {
        const json = this.toJSON();
        let result = new TenantLicensingStatusDto();
        result.init(json);
        return result;
    }
}

export interface ITenantLicensingStatusDto {
    licensingEnabled: boolean;
}

export class PaginatedListOfTenantParticipantLicenseInstanceDto implements IPaginatedListOfTenantParticipantLicenseInstanceDto {
    items!: TenantParticipantLicenseInstanceDto[];
    pageNumber!: number;
    pageSize!: number;
    totalCount!: number;
    totalPages!: number;
    hasPreviousPage!: boolean;
    hasNextPage!: boolean;

    constructor(data?: IPaginatedListOfTenantParticipantLicenseInstanceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TenantParticipantLicenseInstanceDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            this.totalPages = _data["totalPages"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfTenantParticipantLicenseInstanceDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfTenantParticipantLicenseInstanceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["totalPages"] = this.totalPages;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }

    clone(): PaginatedListOfTenantParticipantLicenseInstanceDto {
        const json = this.toJSON();
        let result = new PaginatedListOfTenantParticipantLicenseInstanceDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedListOfTenantParticipantLicenseInstanceDto {
    items: TenantParticipantLicenseInstanceDto[];
    pageNumber: number;
    pageSize: number;
    totalCount: number;
    totalPages: number;
    hasPreviousPage: boolean;
    hasNextPage: boolean;
}

export class TenantParticipantLicenseInstanceDto implements ITenantParticipantLicenseInstanceDto {
    id!: string;
    licenseId!: string;
    licenseName!: string;
    activationServiceType!: LicenseActivationServiceType;
    appNames!: string[];
    licenseKey?: string | undefined;
    activated?: Date | undefined;
    expirationDate?: Date | undefined;
    revoked?: Date | undefined;
    installationsCount!: number;
    isActive!: boolean;
    externalEntitlement?: ExternalEntitlementDto | undefined;
    externalPurchases!: ExternalPurchaseDto[];

    constructor(data?: ITenantParticipantLicenseInstanceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.appNames = [];
            this.externalPurchases = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.licenseId = _data["licenseId"];
            this.licenseName = _data["licenseName"];
            this.activationServiceType = _data["activationServiceType"];
            if (Array.isArray(_data["appNames"])) {
                this.appNames = [] as any;
                for (let item of _data["appNames"])
                    this.appNames!.push(item);
            }
            this.licenseKey = _data["licenseKey"];
            this.activated = _data["activated"] ? new Date(_data["activated"].toString()) : undefined as any;
            this.expirationDate = _data["expirationDate"] ? new Date(_data["expirationDate"].toString()) : undefined as any;
            this.revoked = _data["revoked"] ? new Date(_data["revoked"].toString()) : undefined as any;
            this.installationsCount = _data["installationsCount"];
            this.isActive = _data["isActive"];
            this.externalEntitlement = _data["externalEntitlement"] ? ExternalEntitlementDto.fromJS(_data["externalEntitlement"]) : undefined as any;
            if (Array.isArray(_data["externalPurchases"])) {
                this.externalPurchases = [] as any;
                for (let item of _data["externalPurchases"])
                    this.externalPurchases!.push(ExternalPurchaseDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TenantParticipantLicenseInstanceDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantParticipantLicenseInstanceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["licenseId"] = this.licenseId;
        data["licenseName"] = this.licenseName;
        data["activationServiceType"] = this.activationServiceType;
        if (Array.isArray(this.appNames)) {
            data["appNames"] = [];
            for (let item of this.appNames)
                data["appNames"].push(item);
        }
        data["licenseKey"] = this.licenseKey;
        data["activated"] = this.activated ? this.activated.toISOString() : undefined as any;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : undefined as any;
        data["revoked"] = this.revoked ? this.revoked.toISOString() : undefined as any;
        data["installationsCount"] = this.installationsCount;
        data["isActive"] = this.isActive;
        data["externalEntitlement"] = this.externalEntitlement ? this.externalEntitlement.toJSON() : undefined as any;
        if (Array.isArray(this.externalPurchases)) {
            data["externalPurchases"] = [];
            for (let item of this.externalPurchases)
                data["externalPurchases"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): TenantParticipantLicenseInstanceDto {
        const json = this.toJSON();
        let result = new TenantParticipantLicenseInstanceDto();
        result.init(json);
        return result;
    }
}

export interface ITenantParticipantLicenseInstanceDto {
    id: string;
    licenseId: string;
    licenseName: string;
    activationServiceType: LicenseActivationServiceType;
    appNames: string[];
    licenseKey?: string | undefined;
    activated?: Date | undefined;
    expirationDate?: Date | undefined;
    revoked?: Date | undefined;
    installationsCount: number;
    isActive: boolean;
    externalEntitlement?: ExternalEntitlementDto | undefined;
    externalPurchases: ExternalPurchaseDto[];
}

export class PaginatedListOfTenantParticipantPurchaseEventDto implements IPaginatedListOfTenantParticipantPurchaseEventDto {
    items!: TenantParticipantPurchaseEventDto[];
    pageNumber!: number;
    pageSize!: number;
    totalCount!: number;
    totalPages!: number;
    hasPreviousPage!: boolean;
    hasNextPage!: boolean;

    constructor(data?: IPaginatedListOfTenantParticipantPurchaseEventDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TenantParticipantPurchaseEventDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            this.totalPages = _data["totalPages"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfTenantParticipantPurchaseEventDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfTenantParticipantPurchaseEventDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["totalPages"] = this.totalPages;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }

    clone(): PaginatedListOfTenantParticipantPurchaseEventDto {
        const json = this.toJSON();
        let result = new PaginatedListOfTenantParticipantPurchaseEventDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedListOfTenantParticipantPurchaseEventDto {
    items: TenantParticipantPurchaseEventDto[];
    pageNumber: number;
    pageSize: number;
    totalCount: number;
    totalPages: number;
    hasPreviousPage: boolean;
    hasNextPage: boolean;
}

export class TenantParticipantPurchaseEventDto implements ITenantParticipantPurchaseEventDto {
    eventId!: string;
    eventType!: string;
    eventTimestamp?: Date | undefined;
    appId!: string;
    appName?: string | undefined;
    productId?: string | undefined;
    newProductId?: string | undefined;
    entitlementIds!: string[];
    store?: string | undefined;
    environment?: string | undefined;
    periodType?: string | undefined;
    cancelReason?: string | undefined;
    expirationReason?: string | undefined;
    originalTransactionId?: string | undefined;
    purchasedAt?: Date | undefined;
    expirationAt?: Date | undefined;
    gracePeriodExpirationAt?: Date | undefined;
    processed?: Date | undefined;
    processingError?: string | undefined;

    constructor(data?: ITenantParticipantPurchaseEventDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.entitlementIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.eventId = _data["eventId"];
            this.eventType = _data["eventType"];
            this.eventTimestamp = _data["eventTimestamp"] ? new Date(_data["eventTimestamp"].toString()) : undefined as any;
            this.appId = _data["appId"];
            this.appName = _data["appName"];
            this.productId = _data["productId"];
            this.newProductId = _data["newProductId"];
            if (Array.isArray(_data["entitlementIds"])) {
                this.entitlementIds = [] as any;
                for (let item of _data["entitlementIds"])
                    this.entitlementIds!.push(item);
            }
            this.store = _data["store"];
            this.environment = _data["environment"];
            this.periodType = _data["periodType"];
            this.cancelReason = _data["cancelReason"];
            this.expirationReason = _data["expirationReason"];
            this.originalTransactionId = _data["originalTransactionId"];
            this.purchasedAt = _data["purchasedAt"] ? new Date(_data["purchasedAt"].toString()) : undefined as any;
            this.expirationAt = _data["expirationAt"] ? new Date(_data["expirationAt"].toString()) : undefined as any;
            this.gracePeriodExpirationAt = _data["gracePeriodExpirationAt"] ? new Date(_data["gracePeriodExpirationAt"].toString()) : undefined as any;
            this.processed = _data["processed"] ? new Date(_data["processed"].toString()) : undefined as any;
            this.processingError = _data["processingError"];
        }
    }

    static fromJS(data: any): TenantParticipantPurchaseEventDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantParticipantPurchaseEventDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eventId"] = this.eventId;
        data["eventType"] = this.eventType;
        data["eventTimestamp"] = this.eventTimestamp ? this.eventTimestamp.toISOString() : undefined as any;
        data["appId"] = this.appId;
        data["appName"] = this.appName;
        data["productId"] = this.productId;
        data["newProductId"] = this.newProductId;
        if (Array.isArray(this.entitlementIds)) {
            data["entitlementIds"] = [];
            for (let item of this.entitlementIds)
                data["entitlementIds"].push(item);
        }
        data["store"] = this.store;
        data["environment"] = this.environment;
        data["periodType"] = this.periodType;
        data["cancelReason"] = this.cancelReason;
        data["expirationReason"] = this.expirationReason;
        data["originalTransactionId"] = this.originalTransactionId;
        data["purchasedAt"] = this.purchasedAt ? this.purchasedAt.toISOString() : undefined as any;
        data["expirationAt"] = this.expirationAt ? this.expirationAt.toISOString() : undefined as any;
        data["gracePeriodExpirationAt"] = this.gracePeriodExpirationAt ? this.gracePeriodExpirationAt.toISOString() : undefined as any;
        data["processed"] = this.processed ? this.processed.toISOString() : undefined as any;
        data["processingError"] = this.processingError;
        return data;
    }

    clone(): TenantParticipantPurchaseEventDto {
        const json = this.toJSON();
        let result = new TenantParticipantPurchaseEventDto();
        result.init(json);
        return result;
    }
}

export interface ITenantParticipantPurchaseEventDto {
    eventId: string;
    eventType: string;
    eventTimestamp?: Date | undefined;
    appId: string;
    appName?: string | undefined;
    productId?: string | undefined;
    newProductId?: string | undefined;
    entitlementIds: string[];
    store?: string | undefined;
    environment?: string | undefined;
    periodType?: string | undefined;
    cancelReason?: string | undefined;
    expirationReason?: string | undefined;
    originalTransactionId?: string | undefined;
    purchasedAt?: Date | undefined;
    expirationAt?: Date | undefined;
    gracePeriodExpirationAt?: Date | undefined;
    processed?: Date | undefined;
    processingError?: string | undefined;
}

export class TenantParticipantStudyDto implements ITenantParticipantStudyDto {
    projectId!: string;
    projectName!: string;
    chiffre!: string;
    status!: ProjectParticipantStatus;
    enrolled?: Date | undefined;

    constructor(data?: ITenantParticipantStudyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.chiffre = _data["chiffre"];
            this.status = _data["status"];
            this.enrolled = _data["enrolled"] ? new Date(_data["enrolled"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): TenantParticipantStudyDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantParticipantStudyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["chiffre"] = this.chiffre;
        data["status"] = this.status;
        data["enrolled"] = this.enrolled ? this.enrolled.toISOString() : undefined as any;
        return data;
    }

    clone(): TenantParticipantStudyDto {
        const json = this.toJSON();
        let result = new TenantParticipantStudyDto();
        result.init(json);
        return result;
    }
}

export interface ITenantParticipantStudyDto {
    projectId: string;
    projectName: string;
    chiffre: string;
    status: ProjectParticipantStatus;
    enrolled?: Date | undefined;
}

export class PaginatedListOfTerminologyDto implements IPaginatedListOfTerminologyDto {
    items!: TerminologyDto[];
    pageNumber!: number;
    pageSize!: number;
    totalCount!: number;
    totalPages!: number;
    hasPreviousPage!: boolean;
    hasNextPage!: boolean;

    constructor(data?: IPaginatedListOfTerminologyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TerminologyDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            this.totalPages = _data["totalPages"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfTerminologyDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfTerminologyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["totalPages"] = this.totalPages;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }

    clone(): PaginatedListOfTerminologyDto {
        const json = this.toJSON();
        let result = new PaginatedListOfTerminologyDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedListOfTerminologyDto {
    items: TerminologyDto[];
    pageNumber: number;
    pageSize: number;
    totalCount: number;
    totalPages: number;
    hasPreviousPage: boolean;
    hasNextPage: boolean;
}

export class TerminologyDto extends ContainerDto implements ITerminologyDto {

    constructor(data?: ITerminologyDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): TerminologyDto {
        data = typeof data === 'object' ? data : {};
        let result = new TerminologyDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): TerminologyDto {
        const json = this.toJSON();
        let result = new TerminologyDto();
        result.init(json);
        return result;
    }
}

export interface ITerminologyDto extends IContainerDto {
}

export class TerminologyDetailsDto extends ContainerDetailsDto implements ITerminologyDetailsDto {
    contents!: ContentDto[];

    constructor(data?: ITerminologyDetailsDto) {
        super(data);
        if (!data) {
            this.contents = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["contents"])) {
                this.contents = [] as any;
                for (let item of _data["contents"])
                    this.contents!.push(ContentDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): TerminologyDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new TerminologyDetailsDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.contents)) {
            data["contents"] = [];
            for (let item of this.contents)
                data["contents"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): TerminologyDetailsDto {
        const json = this.toJSON();
        let result = new TerminologyDetailsDto();
        result.init(json);
        return result;
    }
}

export interface ITerminologyDetailsDto extends IContainerDetailsDto {
    contents: ContentDto[];
}

export class CreateTerminologyCommand implements ICreateTerminologyCommand {
    name!: string;
    projectId!: string;

    constructor(data?: ICreateTerminologyCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.projectId = _data["projectId"];
        }
    }

    static fromJS(data: any): CreateTerminologyCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTerminologyCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["projectId"] = this.projectId;
        return data;
    }

    clone(): CreateTerminologyCommand {
        const json = this.toJSON();
        let result = new CreateTerminologyCommand();
        result.init(json);
        return result;
    }
}

export interface ICreateTerminologyCommand {
    name: string;
    projectId: string;
}

export class UpdateTerminologyCommand implements IUpdateTerminologyCommand {
    terminologyId!: string;
    name!: string;
    uniqueLabel!: string;
    title!: InternationalizedString;
    description!: InternationalizedDocument;
    defaultLanguageId!: string;
    languageIds!: string[];
    contents!: ContentDto[];
    condition?: ContainerCondition | undefined;
    sharingOptions!: ContainerSharingOptionDto[];

    constructor(data?: IUpdateTerminologyCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.title = new InternationalizedString();
            this.description = new InternationalizedDocument();
            this.languageIds = [];
            this.contents = [];
            this.sharingOptions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.terminologyId = _data["terminologyId"];
            this.name = _data["name"];
            this.uniqueLabel = _data["uniqueLabel"];
            this.title = _data["title"] ? InternationalizedString.fromJS(_data["title"]) : new InternationalizedString();
            this.description = _data["description"] ? InternationalizedDocument.fromJS(_data["description"]) : new InternationalizedDocument();
            this.defaultLanguageId = _data["defaultLanguageId"];
            if (Array.isArray(_data["languageIds"])) {
                this.languageIds = [] as any;
                for (let item of _data["languageIds"])
                    this.languageIds!.push(item);
            }
            if (Array.isArray(_data["contents"])) {
                this.contents = [] as any;
                for (let item of _data["contents"])
                    this.contents!.push(ContentDto.fromJS(item));
            }
            this.condition = _data["condition"] ? ContainerCondition.fromJS(_data["condition"]) : undefined as any;
            if (Array.isArray(_data["sharingOptions"])) {
                this.sharingOptions = [] as any;
                for (let item of _data["sharingOptions"])
                    this.sharingOptions!.push(ContainerSharingOptionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateTerminologyCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTerminologyCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["terminologyId"] = this.terminologyId;
        data["name"] = this.name;
        data["uniqueLabel"] = this.uniqueLabel;
        data["title"] = this.title ? this.title.toJSON() : undefined as any;
        data["description"] = this.description ? this.description.toJSON() : undefined as any;
        data["defaultLanguageId"] = this.defaultLanguageId;
        if (Array.isArray(this.languageIds)) {
            data["languageIds"] = [];
            for (let item of this.languageIds)
                data["languageIds"].push(item);
        }
        if (Array.isArray(this.contents)) {
            data["contents"] = [];
            for (let item of this.contents)
                data["contents"].push(item ? item.toJSON() : undefined as any);
        }
        data["condition"] = this.condition ? this.condition.toJSON() : undefined as any;
        if (Array.isArray(this.sharingOptions)) {
            data["sharingOptions"] = [];
            for (let item of this.sharingOptions)
                data["sharingOptions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): UpdateTerminologyCommand {
        const json = this.toJSON();
        let result = new UpdateTerminologyCommand();
        result.init(json);
        return result;
    }
}

export interface IUpdateTerminologyCommand {
    terminologyId: string;
    name: string;
    uniqueLabel: string;
    title: InternationalizedString;
    description: InternationalizedDocument;
    defaultLanguageId: string;
    languageIds: string[];
    contents: ContentDto[];
    condition?: ContainerCondition | undefined;
    sharingOptions: ContainerSharingOptionDto[];
}

export class PaginatedListOfTerminologyInstanceDetailsDto implements IPaginatedListOfTerminologyInstanceDetailsDto {
    items!: TerminologyInstanceDetailsDto[];
    pageNumber!: number;
    pageSize!: number;
    totalCount!: number;
    totalPages!: number;
    hasPreviousPage!: boolean;
    hasNextPage!: boolean;

    constructor(data?: IPaginatedListOfTerminologyInstanceDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TerminologyInstanceDetailsDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            this.totalPages = _data["totalPages"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfTerminologyInstanceDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfTerminologyInstanceDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["totalPages"] = this.totalPages;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }

    clone(): PaginatedListOfTerminologyInstanceDetailsDto {
        const json = this.toJSON();
        let result = new PaginatedListOfTerminologyInstanceDetailsDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedListOfTerminologyInstanceDetailsDto {
    items: TerminologyInstanceDetailsDto[];
    pageNumber: number;
    pageSize: number;
    totalCount: number;
    totalPages: number;
    hasPreviousPage: boolean;
    hasNextPage: boolean;
}

/** Data transfer object containing detailed information about a terminology instance. Used in backend API responses. */
export class TerminologyInstanceDetailsDto extends TenantEntityDto implements ITerminologyInstanceDetailsDto {
    /** The unique name identifier for this instance. */
    name!: string;
    /** The internationalized display label for this instance. */
    label!: InternationalizedString;
    /** The content structure (properties) from the terminology with instance values assigned. */
    contents!: ContentDto[];
    /** Timestamp when the instance was created. */
    created!: Date;
    /** Timestamp when the instance was last modified. */
    lastModified!: Date;
    /** Timestamp when the instance was hidden (soft-deleted). Null if the instance is active. */
    hidden?: Date | undefined;

    constructor(data?: ITerminologyInstanceDetailsDto) {
        super(data);
        if (!data) {
            this.label = new InternationalizedString();
            this.contents = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.label = _data["label"] ? InternationalizedString.fromJS(_data["label"]) : new InternationalizedString();
            if (Array.isArray(_data["contents"])) {
                this.contents = [] as any;
                for (let item of _data["contents"])
                    this.contents!.push(ContentDto.fromJS(item));
            }
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : undefined as any;
            this.hidden = _data["hidden"] ? new Date(_data["hidden"].toString()) : undefined as any;
        }
    }

    static override fromJS(data: any): TerminologyInstanceDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new TerminologyInstanceDetailsDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["label"] = this.label ? this.label.toJSON() : undefined as any;
        if (Array.isArray(this.contents)) {
            data["contents"] = [];
            for (let item of this.contents)
                data["contents"].push(item ? item.toJSON() : undefined as any);
        }
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : undefined as any;
        data["hidden"] = this.hidden ? this.hidden.toISOString() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): TerminologyInstanceDetailsDto {
        const json = this.toJSON();
        let result = new TerminologyInstanceDetailsDto();
        result.init(json);
        return result;
    }
}

/** Data transfer object containing detailed information about a terminology instance. Used in backend API responses. */
export interface ITerminologyInstanceDetailsDto extends ITenantEntityDto {
    /** The unique name identifier for this instance. */
    name: string;
    /** The internationalized display label for this instance. */
    label: InternationalizedString;
    /** The content structure (properties) from the terminology with instance values assigned. */
    contents: ContentDto[];
    /** Timestamp when the instance was created. */
    created: Date;
    /** Timestamp when the instance was last modified. */
    lastModified: Date;
    /** Timestamp when the instance was hidden (soft-deleted). Null if the instance is active. */
    hidden?: Date | undefined;
}

/** Command to update an existing terminology instance. */
export class UpdateTerminologyInstanceCommand implements IUpdateTerminologyInstanceCommand {
    /** The ID of the terminology the instance belongs to. */
    terminologyId!: string;
    /** The ID of the terminology instance to update. */
    terminologyInstanceId!: string;
    /** Optional new name for the instance. */
    name?: string | undefined;
    /** The internationalized label for the instance. */
    label!: InternationalizedString;
    /** List of property values to update. */
    values!: ValueDto[];

    constructor(data?: IUpdateTerminologyInstanceCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.label = new InternationalizedString();
            this.values = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.terminologyId = _data["terminologyId"];
            this.terminologyInstanceId = _data["terminologyInstanceId"];
            this.name = _data["name"];
            this.label = _data["label"] ? InternationalizedString.fromJS(_data["label"]) : new InternationalizedString();
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(ValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateTerminologyInstanceCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTerminologyInstanceCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["terminologyId"] = this.terminologyId;
        data["terminologyInstanceId"] = this.terminologyInstanceId;
        data["name"] = this.name;
        data["label"] = this.label ? this.label.toJSON() : undefined as any;
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): UpdateTerminologyInstanceCommand {
        const json = this.toJSON();
        let result = new UpdateTerminologyInstanceCommand();
        result.init(json);
        return result;
    }
}

/** Command to update an existing terminology instance. */
export interface IUpdateTerminologyInstanceCommand {
    /** The ID of the terminology the instance belongs to. */
    terminologyId: string;
    /** The ID of the terminology instance to update. */
    terminologyInstanceId: string;
    /** Optional new name for the instance. */
    name?: string | undefined;
    /** The internationalized label for the instance. */
    label: InternationalizedString;
    /** List of property values to update. */
    values: ValueDto[];
}

/** Result of a terminology instance import operation. */
export class ImportTerminologyInstancesResult implements IImportTerminologyInstancesResult {
    /** Number of new instances created. */
    created!: number;
    /** Number of existing instances updated (Overwrite mode only). */
    updated!: number;
    /** Number of hidden instances that were restored. */
    restored!: number;
    /** Number of instances skipped (Skip mode, instance already exists and not hidden). */
    skipped!: number;
    /** Number of rows that failed to import. */
    errors!: number;
    /** Detailed error messages for failed rows. */
    errorMessages!: string[];

    constructor(data?: IImportTerminologyInstancesResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.errorMessages = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"];
            this.updated = _data["updated"];
            this.restored = _data["restored"];
            this.skipped = _data["skipped"];
            this.errors = _data["errors"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [] as any;
                for (let item of _data["errorMessages"])
                    this.errorMessages!.push(item);
            }
        }
    }

    static fromJS(data: any): ImportTerminologyInstancesResult {
        data = typeof data === 'object' ? data : {};
        let result = new ImportTerminologyInstancesResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created;
        data["updated"] = this.updated;
        data["restored"] = this.restored;
        data["skipped"] = this.skipped;
        data["errors"] = this.errors;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        return data;
    }

    clone(): ImportTerminologyInstancesResult {
        const json = this.toJSON();
        let result = new ImportTerminologyInstancesResult();
        result.init(json);
        return result;
    }
}

/** Result of a terminology instance import operation. */
export interface IImportTerminologyInstancesResult {
    /** Number of new instances created. */
    created: number;
    /** Number of existing instances updated (Overwrite mode only). */
    updated: number;
    /** Number of hidden instances that were restored. */
    restored: number;
    /** Number of instances skipped (Skip mode, instance already exists and not hidden). */
    skipped: number;
    /** Number of rows that failed to import. */
    errors: number;
    /** Detailed error messages for failed rows. */
    errorMessages: string[];
}

/** Specifies how to handle existing instances during import. */
export enum ImportMode {
    Skip = "skip",
    Overwrite = "overwrite",
}

export class PaginatedListOfUserDto implements IPaginatedListOfUserDto {
    items!: UserDto[];
    pageNumber!: number;
    pageSize!: number;
    totalCount!: number;
    totalPages!: number;
    hasPreviousPage!: boolean;
    hasNextPage!: boolean;

    constructor(data?: IPaginatedListOfUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            this.totalPages = _data["totalPages"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["totalPages"] = this.totalPages;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }

    clone(): PaginatedListOfUserDto {
        const json = this.toJSON();
        let result = new PaginatedListOfUserDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedListOfUserDto {
    items: UserDto[];
    pageNumber: number;
    pageSize: number;
    totalCount: number;
    totalPages: number;
    hasPreviousPage: boolean;
    hasNextPage: boolean;
}

export class CreateUserCommand implements ICreateUserCommand {
    email!: string;

    constructor(data?: ICreateUserCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): CreateUserCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        return data;
    }

    clone(): CreateUserCommand {
        const json = this.toJSON();
        let result = new CreateUserCommand();
        result.init(json);
        return result;
    }
}

export interface ICreateUserCommand {
    email: string;
}

export class SendNotificationCommand implements ISendNotificationCommand {
    userId!: string;
    title!: string;
    body!: string;
    encrypted!: boolean;

    constructor(data?: ISendNotificationCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.title = _data["title"];
            this.body = _data["body"];
            this.encrypted = _data["encrypted"];
        }
    }

    static fromJS(data: any): SendNotificationCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SendNotificationCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["title"] = this.title;
        data["body"] = this.body;
        data["encrypted"] = this.encrypted;
        return data;
    }

    clone(): SendNotificationCommand {
        const json = this.toJSON();
        let result = new SendNotificationCommand();
        result.init(json);
        return result;
    }
}

export interface ISendNotificationCommand {
    userId: string;
    title: string;
    body: string;
    encrypted: boolean;
}

export class UpdateUserCommand implements IUpdateUserCommand {
    userId!: string;
    email!: string;
    firstName!: string;
    lastName!: string;

    constructor(data?: IUpdateUserCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.email = _data["email"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
        }
    }

    static fromJS(data: any): UpdateUserCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["email"] = this.email;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        return data;
    }

    clone(): UpdateUserCommand {
        const json = this.toJSON();
        let result = new UpdateUserCommand();
        result.init(json);
        return result;
    }
}

export interface IUpdateUserCommand {
    userId: string;
    email: string;
    firstName: string;
    lastName: string;
}

function formatDate(d: Date) {
    return d.getFullYear() + '-' + 
        (d.getMonth() < 9 ? ('0' + (d.getMonth()+1)) : (d.getMonth()+1)) + '-' +
        (d.getDate() < 10 ? ('0' + d.getDate()) : d.getDate());
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}